import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar type represents date data, represented as an ISO-8601 encoded UTC date string Y-m-d - e.g. "2020-11-20" */
  Date: any;
  /** The `DateTime` scalar type represents time data, represented as an ISO-8601 encoded UTC date string Y-m-d H:i:s - e.g. "2020-11-20 14:00:23" */
  DateTime: any;
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: any;
};

export type SocialProfileInterface = {
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
};

export type SocialProfile = SocialProfileInterface & {
  __typename?: 'SocialProfile';
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
};

export type TikTokSocialProfile = SocialProfileInterface & {
  __typename?: 'TikTokSocialProfile';
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
  tikTokId: Scalars['ID'];
  privacy: TikTokPrivacy;
  commentDisabled: Scalars['Boolean'];
  duetDisabled: Scalars['Boolean'];
  stitchDisabled: Scalars['Boolean'];
  maxVideoDuration: Scalars['Int'];
};

export type TwitterSocialProfile = SocialProfileInterface & {
  __typename?: 'TwitterSocialProfile';
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
  twitterId: Scalars['ID'];
  handle: Scalars['String'];
};

export type FacebookSocialProfile = SocialProfileInterface & {
  __typename?: 'FacebookSocialProfile';
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
  facebookId: Scalars['ID'];
  groupAppInstalled?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type GoogleSocialProfile = SocialProfileInterface & {
  __typename?: 'GoogleSocialProfile';
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
  googleId: Scalars['ID'];
};

export type PinterestSocialProfile = SocialProfileInterface & {
  __typename?: 'PinterestSocialProfile';
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
  pinterestId: Scalars['ID'];
  boards: Array<PinterestBoard>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type LinkedInSocialProfile = SocialProfileInterface & {
  __typename?: 'LinkedInSocialProfile';
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
  linkedInId: Scalars['ID'];
  type: Scalars['String'];
  publicUrl?: Maybe<Scalars['String']>;
};

export type InstagramSocialProfile = SocialProfileInterface & {
  __typename?: 'InstagramSocialProfile';
  photoUrlFetched?: Maybe<Scalars['Boolean']>;
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
  instagramId?: Maybe<Scalars['ID']>;
  facebookPageId?: Maybe<Scalars['ID']>;
  apiType: InstagramApiType;
  type: Scalars['String'];
  directPublishEnabled: Scalars['Boolean'];
};

export type GenericSocialProfile = SocialProfileInterface & {
  __typename?: 'GenericSocialProfile';
  photoUrlFetched: Scalars['Boolean'];
  photoUrl: Scalars['String'];
  id: Scalars['ID'];
  connected: Scalars['Boolean'];
  network: Network;
  tokenOwner?: Maybe<SocialProfileTokenOwner>;
  username: Scalars['String'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  workspace: Workspace;
  customBitly?: Maybe<CustomBitly>;
  onboardingContent: Scalars['Boolean'];
  /** Hex color code, e.g. '#46dd46' */
  colour: Scalars['String'];
  platformName: Scalars['String'];
  type: GenericProfileType;
};

export type Query = {
  __typename?: 'Query';
  instagramGridPosts: InstagramGridType;
  isPasswordResetTokenValid: Scalars['Boolean'];
  organization: Organization;
  bitly: Bitly;
  unreadNotificationCount: Scalars['Int'];
  notifications: PorpaginasResult_Notification;
  allSiteNews: Array<SiteNews>;
  unreadSiteNews: Array<SiteNews>;
  searchPixabay: Array<ThirdPartyMediaItem>;
  searchGiphy: Array<ThirdPartyMediaItem>;
  searchUnsplash: Array<ThirdPartyMediaItem>;
  workspace: Workspace;
  me?: Maybe<User>;
  helpscoutMetadata?: Maybe<HelpscoutBeaconMetadata>;
  category: Category;
  snippet: Snippet;
  linkMetadata: Array<LinkMetadata>;
  socialProfile: SocialProfileInterface;
  externalSecondaryProfiles: Array<ExternalSecondaryProfileData>;
  socialAuthToken: SocialAuthToken;
  admin_users: Array<User>;
  admin_user: User;
  registerEmailAvailable: Scalars['Boolean'];
  captions: AiCaptionGenerationType;
  timeslot: Timeslot;
  autoImport: AutoImport;
  searchPinterestFollowedBoards: Array<PinterestBoard>;
  searchRssPosts: RssPostSearchResultType;
  searchFacebookLikedPages: Array<ThirdPartyProfile>;
  searchTwitterLists: Array<TwitterList>;
  searchTwitterPosts: ThirdPartyPostSearchResult;
  searchPinterestPosts: ThirdPartyPostSearchResult;
  searchLinkedInPosts: ThirdPartyPostSearchResult;
  searchFacebookPosts: ThirdPartyPostSearchResult;
  searchInstagramPosts: ThirdPartyPostSearchResult;
  importFolder: ImportFolder;
  importSource: ImportSource;
  analyticsFollowers: Array<ProfileFollowersStats>;
  analyticsPostStats: PostStatsResult;
  analyticsBestTimeToPostStats: BestTimeToPostStatsResult;
  post: Post;
  latestFamilyMembersOfPost: Array<Post>;
  postIterations: Array<Post>;
  searchThirdPartyProfiles: Array<ThirdPartyProfile>;
  getInvitationDetails: InvitationDetails;
};

export type Query_InstagramGridPostsArgs = {
  socialProfileId: Scalars['ID'];
  futureCount?: InputMaybe<Scalars['Int']>;
};

export type Query_IsPasswordResetTokenValidArgs = {
  resetToken: Scalars['String'];
};

export type Query_OrganizationArgs = {
  organizationId: Scalars['ID'];
};

export type Query_BitlyArgs = {
  bitlyId: Scalars['ID'];
};

export type Query_UnreadNotificationCountArgs = {
  organizationId: Scalars['ID'];
};

export type Query_NotificationsArgs = {
  organizationId: Scalars['ID'];
};

export type Query_SearchPixabayArgs = {
  input: PixabaySearchInput;
};

export type Query_SearchGiphyArgs = {
  input: GiphySearchInput;
};

export type Query_SearchUnsplashArgs = {
  input: UnsplashSearchInput;
};

export type Query_WorkspaceArgs = {
  workspaceId: Scalars['ID'];
};

export type Query_CategoryArgs = {
  categoryId: Scalars['ID'];
};

export type Query_SnippetArgs = {
  snippetId: Scalars['ID'];
};

export type Query_LinkMetadataArgs = {
  urls: Array<Scalars['String']>;
};

export type Query_SocialProfileArgs = {
  socialProfileId: Scalars['ID'];
};

export type Query_ExternalSecondaryProfilesArgs = {
  socialAuthToken: Scalars['String'];
  type: SecondaryProfileType;
  profileNetwork: Network;
  workspaceId: Scalars['ID'];
};

export type Query_SocialAuthTokenArgs = {
  socialAuthToken: Scalars['String'];
};

export type Query_Admin_UserArgs = {
  userId: Scalars['ID'];
};

export type Query_RegisterEmailAvailableArgs = {
  email: Scalars['String'];
};

export type Query_CaptionsArgs = {
  cacheKey: Scalars['String'];
};

export type Query_TimeslotArgs = {
  timeslotId: Scalars['ID'];
};

export type Query_AutoImportArgs = {
  autoImportId: Scalars['ID'];
};

export type Query_SearchPinterestFollowedBoardsArgs = {
  socialProfileId: Scalars['ID'];
};

export type Query_SearchRssPostsArgs = {
  workspaceId: Scalars['ID'];
  url: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
};

export type Query_SearchFacebookLikedPagesArgs = {
  socialProfileId: Scalars['ID'];
};

export type Query_SearchTwitterListsArgs = {
  socialProfileId: Scalars['ID'];
};

export type Query_SearchTwitterPostsArgs = {
  socialProfileId: Scalars['ID'];
  searchType: TwitterSearchType;
  contentType: TwitterSearchContentType;
  sortType: TwitterSearchSortType;
  includeRetweets?: InputMaybe<Scalars['Boolean']>;
  includeReplies?: InputMaybe<Scalars['Boolean']>;
  term?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
};

export type Query_SearchPinterestPostsArgs = {
  socialProfileId: Scalars['ID'];
  searchType: PinterestSearchType;
  contentType: PinterestSearchContentType;
  sortType: PinterestSearchSortType;
  externalId: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
};

export type Query_SearchLinkedInPostsArgs = {
  socialProfileId: Scalars['ID'];
  searchType: LinkedInSearchType;
  contentType: LinkedInSearchContentType;
  sortType: LinkedInSearchSortType;
  externalId: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
};

export type Query_SearchFacebookPostsArgs = {
  socialProfileId: Scalars['ID'];
  searchType: FacebookSearchType;
  contentType: FacebookSearchContentType;
  sortType: FacebookSearchSortType;
  externalId: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
};

export type Query_SearchInstagramPostsArgs = {
  socialProfileId: Scalars['ID'];
  searchType: InstagramSearchType;
  sortType: InstagramSearchSortType;
  externalId: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
};

export type Query_ImportFolderArgs = {
  importFolderId: Scalars['ID'];
};

export type Query_ImportSourceArgs = {
  importSourceId: Scalars['ID'];
};

export type Query_AnalyticsFollowersArgs = {
  socialProfileIds: Array<Scalars['ID']>;
  rangeStartDate: Scalars['String'];
  rangeEndDate: Scalars['String'];
  groupByDate?: InputMaybe<Scalars['Boolean']>;
  prefill?: InputMaybe<Scalars['Boolean']>;
  postfill?: InputMaybe<Scalars['Boolean']>;
  previousPeriod?: InputMaybe<Scalars['Boolean']>;
};

export type Query_AnalyticsPostStatsArgs = {
  socialProfileIds: Array<Scalars['ID']>;
  rangeStartDate: Scalars['String'];
  rangeEndDate: Scalars['String'];
  groupByType: AnalyticsPostStatsGroupType;
  groupByDate?: InputMaybe<Scalars['Boolean']>;
  prefill?: InputMaybe<Scalars['Boolean']>;
  postfill?: InputMaybe<Scalars['Boolean']>;
  previousPeriod?: InputMaybe<Scalars['Boolean']>;
};

export type Query_AnalyticsBestTimeToPostStatsArgs = {
  socialProfileId: Scalars['ID'];
};

export type Query_PostArgs = {
  postId: Scalars['ID'];
};

export type Query_LatestFamilyMembersOfPostArgs = {
  postId: Scalars['ID'];
};

export type Query_PostIterationsArgs = {
  postId: Scalars['ID'];
};

export type Query_SearchThirdPartyProfilesArgs = {
  socialProfileId: Scalars['ID'];
  method: ThirdPartyProfileSearchType;
  term: Scalars['String'];
};

export type Query_GetInvitationDetailsArgs = {
  invitationToken: Scalars['String'];
};

export type InstagramGridType = {
  __typename?: 'InstagramGridType';
  /**
   *
   *
   *
   */
  futurePosts: Array<Post>;
  /**
   *
   *
   *
   */
  pastPosts?: Maybe<Array<ThirdPartyPost>>;
  thirdPartyPostSearchError?: Maybe<Scalars['String']>;
};

export type Post = {
  __typename?: 'Post';
  id: Scalars['ID'];
  parentId?: Maybe<Scalars['ID']>;
  familyUuid?: Maybe<Scalars['String']>;
  expiryLocalDate?: Maybe<Scalars['Date']>;
  calculatedLocalDateTime?: Maybe<Scalars['DateTime']>;
  publishedUtcDateTimes: Array<Scalars['DateTime']>;
  futureScheduledLocalDateTimes: Array<Scalars['DateTime']>;
  futureScheduledUtcDateTimes: Array<Scalars['DateTime']>;
  scheduledTimezone?: Maybe<TimezoneSetting>;
  recurringInterval?: Maybe<PostRecurringInterval>;
  feedType: PostFeedType;
  texts: Array<Scalars['String']>;
  photos: Array<Photo>;
  videos: Array<Video>;
  variationMeta?: Maybe<PostVariationMeta>;
  socialProfile: SocialProfileInterface;
  pinterestBoardId?: Maybe<Scalars['String']>;
  publishedStats?: Maybe<PostPublishedStats>;
  publishedUrl?: Maybe<Scalars['String']>;
  mentions: Array<ThirdPartyProfile>;
  tikTok?: Maybe<PostTikTok>;
  dateAdded?: Maybe<Scalars['DateTime']>;
  category: Category;
  isEvergreen?: Maybe<Scalars['Boolean']>;
  maxRepeats?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  firstComment?: Maybe<Scalars['String']>;
  calculatedUtcDatetime?: Maybe<Scalars['DateTime']>;
  delayedUtcOriginalDatetime?: Maybe<Scalars['DateTime']>;
  order?: Maybe<Scalars['Int']>;
  datePosted?: Maybe<Scalars['DateTime']>;
  recurringValue?: Maybe<Scalars['Int']>;
  link?: Maybe<Link>;
  prevPostedCount?: Maybe<Scalars['Int']>;
  iterationAggregations?: Maybe<PostIterationAggregations>;
  dateFailed?: Maybe<Scalars['DateTime']>;
  failedMessage?: Maybe<Scalars['String']>;
  status: PostStatus;
  timing: PostTiming;
  draftQueuePosition?: Maybe<PostQueuePosition>;
  siblingId: Scalars['String'];
  publishMethod: PostPublishMethod;
  src: Scalars['String'];
  actualPublishMethod?: Maybe<PostPublishMethod>;
  publishedVia?: Maybe<Array<PostPublishedVia>>;
  onboardingContent: Scalars['Boolean'];
};

export enum TimezoneSetting {
  AFRICA_ABIDJAN = 'AFRICA_ABIDJAN',
  AFRICA_ACCRA = 'AFRICA_ACCRA',
  AFRICA_ADDIS_ABABA = 'AFRICA_ADDIS_ABABA',
  AFRICA_ALGIERS = 'AFRICA_ALGIERS',
  AFRICA_ASMARA = 'AFRICA_ASMARA',
  AFRICA_BAMAKO = 'AFRICA_BAMAKO',
  AFRICA_BANGUI = 'AFRICA_BANGUI',
  AFRICA_BANJUL = 'AFRICA_BANJUL',
  AFRICA_BISSAU = 'AFRICA_BISSAU',
  AFRICA_BLANTYRE = 'AFRICA_BLANTYRE',
  AFRICA_BRAZZAVILLE = 'AFRICA_BRAZZAVILLE',
  AFRICA_BUJUMBURA = 'AFRICA_BUJUMBURA',
  AFRICA_CAIRO = 'AFRICA_CAIRO',
  AFRICA_CASABLANCA = 'AFRICA_CASABLANCA',
  AFRICA_CEUTA = 'AFRICA_CEUTA',
  AFRICA_CONAKRY = 'AFRICA_CONAKRY',
  AFRICA_DAKAR = 'AFRICA_DAKAR',
  AFRICA_DAR_ES_SALAAM = 'AFRICA_DAR_ES_SALAAM',
  AFRICA_DJIBOUTI = 'AFRICA_DJIBOUTI',
  AFRICA_DOUALA = 'AFRICA_DOUALA',
  AFRICA_EL_AAIUN = 'AFRICA_EL_AAIUN',
  AFRICA_FREETOWN = 'AFRICA_FREETOWN',
  AFRICA_GABORONE = 'AFRICA_GABORONE',
  AFRICA_HARARE = 'AFRICA_HARARE',
  AFRICA_JOHANNESBURG = 'AFRICA_JOHANNESBURG',
  AFRICA_JUBA = 'AFRICA_JUBA',
  AFRICA_KAMPALA = 'AFRICA_KAMPALA',
  AFRICA_KHARTOUM = 'AFRICA_KHARTOUM',
  AFRICA_KIGALI = 'AFRICA_KIGALI',
  AFRICA_KINSHASA = 'AFRICA_KINSHASA',
  AFRICA_LAGOS = 'AFRICA_LAGOS',
  AFRICA_LIBREVILLE = 'AFRICA_LIBREVILLE',
  AFRICA_LOME = 'AFRICA_LOME',
  AFRICA_LUANDA = 'AFRICA_LUANDA',
  AFRICA_LUBUMBASHI = 'AFRICA_LUBUMBASHI',
  AFRICA_LUSAKA = 'AFRICA_LUSAKA',
  AFRICA_MALABO = 'AFRICA_MALABO',
  AFRICA_MAPUTO = 'AFRICA_MAPUTO',
  AFRICA_MASERU = 'AFRICA_MASERU',
  AFRICA_MBABANE = 'AFRICA_MBABANE',
  AFRICA_MOGADISHU = 'AFRICA_MOGADISHU',
  AFRICA_MONROVIA = 'AFRICA_MONROVIA',
  AFRICA_NAIROBI = 'AFRICA_NAIROBI',
  AFRICA_NDJAMENA = 'AFRICA_NDJAMENA',
  AFRICA_NIAMEY = 'AFRICA_NIAMEY',
  AFRICA_NOUAKCHOTT = 'AFRICA_NOUAKCHOTT',
  AFRICA_OUAGADOUGOU = 'AFRICA_OUAGADOUGOU',
  AFRICA_PORTO_NOVO = 'AFRICA_PORTO_NOVO',
  AFRICA_SAO_TOME = 'AFRICA_SAO_TOME',
  AFRICA_TRIPOLI = 'AFRICA_TRIPOLI',
  AFRICA_TUNIS = 'AFRICA_TUNIS',
  AFRICA_WINDHOEK = 'AFRICA_WINDHOEK',
  AMERICA_ADAK = 'AMERICA_ADAK',
  AMERICA_ANCHORAGE = 'AMERICA_ANCHORAGE',
  AMERICA_ANGUILLA = 'AMERICA_ANGUILLA',
  AMERICA_ANTIGUA = 'AMERICA_ANTIGUA',
  AMERICA_ARAGUAINA = 'AMERICA_ARAGUAINA',
  AMERICA_ARGENTINA_BUENOS_AIRES = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  AMERICA_ARGENTINA_CATAMARCA = 'AMERICA_ARGENTINA_CATAMARCA',
  AMERICA_ARGENTINA_CORDOBA = 'AMERICA_ARGENTINA_CORDOBA',
  AMERICA_ARGENTINA_JUJUY = 'AMERICA_ARGENTINA_JUJUY',
  AMERICA_ARGENTINA_LA_RIOJA = 'AMERICA_ARGENTINA_LA_RIOJA',
  AMERICA_ARGENTINA_MENDOZA = 'AMERICA_ARGENTINA_MENDOZA',
  AMERICA_ARGENTINA_RIO_GALLEGOS = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  AMERICA_ARGENTINA_SALTA = 'AMERICA_ARGENTINA_SALTA',
  AMERICA_ARGENTINA_SAN_JUAN = 'AMERICA_ARGENTINA_SAN_JUAN',
  AMERICA_ARGENTINA_SAN_LUIS = 'AMERICA_ARGENTINA_SAN_LUIS',
  AMERICA_ARGENTINA_TUCUMAN = 'AMERICA_ARGENTINA_TUCUMAN',
  AMERICA_ARGENTINA_USHUAIA = 'AMERICA_ARGENTINA_USHUAIA',
  AMERICA_ARUBA = 'AMERICA_ARUBA',
  AMERICA_ASUNCION = 'AMERICA_ASUNCION',
  AMERICA_ATIKOKAN = 'AMERICA_ATIKOKAN',
  AMERICA_BAHIA = 'AMERICA_BAHIA',
  AMERICA_BAHIA_BANDERAS = 'AMERICA_BAHIA_BANDERAS',
  AMERICA_BARBADOS = 'AMERICA_BARBADOS',
  AMERICA_BELEM = 'AMERICA_BELEM',
  AMERICA_BELIZE = 'AMERICA_BELIZE',
  AMERICA_BLANC_SABLON = 'AMERICA_BLANC_SABLON',
  AMERICA_BOA_VISTA = 'AMERICA_BOA_VISTA',
  AMERICA_BOGOTA = 'AMERICA_BOGOTA',
  AMERICA_BOISE = 'AMERICA_BOISE',
  AMERICA_CAMBRIDGE_BAY = 'AMERICA_CAMBRIDGE_BAY',
  AMERICA_CAMPO_GRANDE = 'AMERICA_CAMPO_GRANDE',
  AMERICA_CANCUN = 'AMERICA_CANCUN',
  AMERICA_CARACAS = 'AMERICA_CARACAS',
  AMERICA_CAYENNE = 'AMERICA_CAYENNE',
  AMERICA_CAYMAN = 'AMERICA_CAYMAN',
  AMERICA_CHICAGO = 'AMERICA_CHICAGO',
  AMERICA_CHIHUAHUA = 'AMERICA_CHIHUAHUA',
  AMERICA_COSTA_RICA = 'AMERICA_COSTA_RICA',
  AMERICA_CRESTON = 'AMERICA_CRESTON',
  AMERICA_CUIABA = 'AMERICA_CUIABA',
  AMERICA_CURACAO = 'AMERICA_CURACAO',
  AMERICA_DANMARKSHAVN = 'AMERICA_DANMARKSHAVN',
  AMERICA_DAWSON = 'AMERICA_DAWSON',
  AMERICA_DAWSON_CREEK = 'AMERICA_DAWSON_CREEK',
  AMERICA_DENVER = 'AMERICA_DENVER',
  AMERICA_DETROIT = 'AMERICA_DETROIT',
  AMERICA_DOMINICA = 'AMERICA_DOMINICA',
  AMERICA_EDMONTON = 'AMERICA_EDMONTON',
  AMERICA_EIRUNEPE = 'AMERICA_EIRUNEPE',
  AMERICA_EL_SALVADOR = 'AMERICA_EL_SALVADOR',
  AMERICA_FORTALEZA = 'AMERICA_FORTALEZA',
  AMERICA_FORT_NELSON = 'AMERICA_FORT_NELSON',
  AMERICA_GLACE_BAY = 'AMERICA_GLACE_BAY',
  AMERICA_GOOSE_BAY = 'AMERICA_GOOSE_BAY',
  AMERICA_GRAND_TURK = 'AMERICA_GRAND_TURK',
  AMERICA_GRENADA = 'AMERICA_GRENADA',
  AMERICA_GUADELOUPE = 'AMERICA_GUADELOUPE',
  AMERICA_GUATEMALA = 'AMERICA_GUATEMALA',
  AMERICA_GUAYAQUIL = 'AMERICA_GUAYAQUIL',
  AMERICA_GUYANA = 'AMERICA_GUYANA',
  AMERICA_HALIFAX = 'AMERICA_HALIFAX',
  AMERICA_HAVANA = 'AMERICA_HAVANA',
  AMERICA_HERMOSILLO = 'AMERICA_HERMOSILLO',
  AMERICA_INDIANA_INDIANAPOLIS = 'AMERICA_INDIANA_INDIANAPOLIS',
  AMERICA_INDIANA_KNOX = 'AMERICA_INDIANA_KNOX',
  AMERICA_INDIANA_MARENGO = 'AMERICA_INDIANA_MARENGO',
  AMERICA_INDIANA_PETERSBURG = 'AMERICA_INDIANA_PETERSBURG',
  AMERICA_INDIANA_TELL_CITY = 'AMERICA_INDIANA_TELL_CITY',
  AMERICA_INDIANA_VEVAY = 'AMERICA_INDIANA_VEVAY',
  AMERICA_INDIANA_VINCENNES = 'AMERICA_INDIANA_VINCENNES',
  AMERICA_INDIANA_WINAMAC = 'AMERICA_INDIANA_WINAMAC',
  AMERICA_INUVIK = 'AMERICA_INUVIK',
  AMERICA_IQALUIT = 'AMERICA_IQALUIT',
  AMERICA_JAMAICA = 'AMERICA_JAMAICA',
  AMERICA_JUNEAU = 'AMERICA_JUNEAU',
  AMERICA_KENTUCKY_LOUISVILLE = 'AMERICA_KENTUCKY_LOUISVILLE',
  AMERICA_KENTUCKY_MONTICELLO = 'AMERICA_KENTUCKY_MONTICELLO',
  AMERICA_KRALENDIJK = 'AMERICA_KRALENDIJK',
  AMERICA_LA_PAZ = 'AMERICA_LA_PAZ',
  AMERICA_LIMA = 'AMERICA_LIMA',
  AMERICA_LOS_ANGELES = 'AMERICA_LOS_ANGELES',
  AMERICA_LOWER_PRINCES = 'AMERICA_LOWER_PRINCES',
  AMERICA_MACEIO = 'AMERICA_MACEIO',
  AMERICA_MANAGUA = 'AMERICA_MANAGUA',
  AMERICA_MANAUS = 'AMERICA_MANAUS',
  AMERICA_MARIGOT = 'AMERICA_MARIGOT',
  AMERICA_MARTINIQUE = 'AMERICA_MARTINIQUE',
  AMERICA_MATAMOROS = 'AMERICA_MATAMOROS',
  AMERICA_MAZATLAN = 'AMERICA_MAZATLAN',
  AMERICA_MENOMINEE = 'AMERICA_MENOMINEE',
  AMERICA_MERIDA = 'AMERICA_MERIDA',
  AMERICA_METLAKATLA = 'AMERICA_METLAKATLA',
  AMERICA_MEXICO_CITY = 'AMERICA_MEXICO_CITY',
  AMERICA_MIQUELON = 'AMERICA_MIQUELON',
  AMERICA_MONCTON = 'AMERICA_MONCTON',
  AMERICA_MONTERREY = 'AMERICA_MONTERREY',
  AMERICA_MONTEVIDEO = 'AMERICA_MONTEVIDEO',
  AMERICA_MONTSERRAT = 'AMERICA_MONTSERRAT',
  AMERICA_NASSAU = 'AMERICA_NASSAU',
  AMERICA_NEW_YORK = 'AMERICA_NEW_YORK',
  AMERICA_NIPIGON = 'AMERICA_NIPIGON',
  AMERICA_NOME = 'AMERICA_NOME',
  AMERICA_NORONHA = 'AMERICA_NORONHA',
  AMERICA_NORTH_DAKOTA_BEULAH = 'AMERICA_NORTH_DAKOTA_BEULAH',
  AMERICA_NORTH_DAKOTA_CENTER = 'AMERICA_NORTH_DAKOTA_CENTER',
  AMERICA_NORTH_DAKOTA_NEW_SALEM = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  AMERICA_NUUK = 'AMERICA_NUUK',
  AMERICA_OJINAGA = 'AMERICA_OJINAGA',
  AMERICA_PANAMA = 'AMERICA_PANAMA',
  AMERICA_PANGNIRTUNG = 'AMERICA_PANGNIRTUNG',
  AMERICA_PARAMARIBO = 'AMERICA_PARAMARIBO',
  AMERICA_PHOENIX = 'AMERICA_PHOENIX',
  AMERICA_PORTO_VELHO = 'AMERICA_PORTO_VELHO',
  AMERICA_PORT_AU_PRINCE = 'AMERICA_PORT_AU_PRINCE',
  AMERICA_PORT_OF_SPAIN = 'AMERICA_PORT_OF_SPAIN',
  AMERICA_PUERTO_RICO = 'AMERICA_PUERTO_RICO',
  AMERICA_PUNTA_ARENAS = 'AMERICA_PUNTA_ARENAS',
  AMERICA_RAINY_RIVER = 'AMERICA_RAINY_RIVER',
  AMERICA_RANKIN_INLET = 'AMERICA_RANKIN_INLET',
  AMERICA_RECIFE = 'AMERICA_RECIFE',
  AMERICA_REGINA = 'AMERICA_REGINA',
  AMERICA_RESOLUTE = 'AMERICA_RESOLUTE',
  AMERICA_RIO_BRANCO = 'AMERICA_RIO_BRANCO',
  AMERICA_SANTAREM = 'AMERICA_SANTAREM',
  AMERICA_SANTIAGO = 'AMERICA_SANTIAGO',
  AMERICA_SANTO_DOMINGO = 'AMERICA_SANTO_DOMINGO',
  AMERICA_SAO_PAULO = 'AMERICA_SAO_PAULO',
  AMERICA_SCORESBYSUND = 'AMERICA_SCORESBYSUND',
  AMERICA_SITKA = 'AMERICA_SITKA',
  AMERICA_ST_BARTHELEMY = 'AMERICA_ST_BARTHELEMY',
  AMERICA_ST_JOHNS = 'AMERICA_ST_JOHNS',
  AMERICA_ST_KITTS = 'AMERICA_ST_KITTS',
  AMERICA_ST_LUCIA = 'AMERICA_ST_LUCIA',
  AMERICA_ST_THOMAS = 'AMERICA_ST_THOMAS',
  AMERICA_ST_VINCENT = 'AMERICA_ST_VINCENT',
  AMERICA_SWIFT_CURRENT = 'AMERICA_SWIFT_CURRENT',
  AMERICA_TEGUCIGALPA = 'AMERICA_TEGUCIGALPA',
  AMERICA_THULE = 'AMERICA_THULE',
  AMERICA_THUNDER_BAY = 'AMERICA_THUNDER_BAY',
  AMERICA_TIJUANA = 'AMERICA_TIJUANA',
  AMERICA_TORONTO = 'AMERICA_TORONTO',
  AMERICA_TORTOLA = 'AMERICA_TORTOLA',
  AMERICA_VANCOUVER = 'AMERICA_VANCOUVER',
  AMERICA_WHITEHORSE = 'AMERICA_WHITEHORSE',
  AMERICA_WINNIPEG = 'AMERICA_WINNIPEG',
  AMERICA_YAKUTAT = 'AMERICA_YAKUTAT',
  AMERICA_YELLOWKNIFE = 'AMERICA_YELLOWKNIFE',
  ANTARCTICA_CASEY = 'ANTARCTICA_CASEY',
  ANTARCTICA_DAVIS = 'ANTARCTICA_DAVIS',
  ANTARCTICA_DUMONTDURVILLE = 'ANTARCTICA_DUMONTDURVILLE',
  ANTARCTICA_MACQUARIE = 'ANTARCTICA_MACQUARIE',
  ANTARCTICA_MAWSON = 'ANTARCTICA_MAWSON',
  ANTARCTICA_MCMURDO = 'ANTARCTICA_MCMURDO',
  ANTARCTICA_PALMER = 'ANTARCTICA_PALMER',
  ANTARCTICA_ROTHERA = 'ANTARCTICA_ROTHERA',
  ANTARCTICA_SYOWA = 'ANTARCTICA_SYOWA',
  ANTARCTICA_TROLL = 'ANTARCTICA_TROLL',
  ANTARCTICA_VOSTOK = 'ANTARCTICA_VOSTOK',
  ARCTIC_LONGYEARBYEN = 'ARCTIC_LONGYEARBYEN',
  ASIA_ADEN = 'ASIA_ADEN',
  ASIA_ALMATY = 'ASIA_ALMATY',
  ASIA_AMMAN = 'ASIA_AMMAN',
  ASIA_ANADYR = 'ASIA_ANADYR',
  ASIA_AQTAU = 'ASIA_AQTAU',
  ASIA_AQTOBE = 'ASIA_AQTOBE',
  ASIA_ASHGABAT = 'ASIA_ASHGABAT',
  ASIA_ATYRAU = 'ASIA_ATYRAU',
  ASIA_BAGHDAD = 'ASIA_BAGHDAD',
  ASIA_BAHRAIN = 'ASIA_BAHRAIN',
  ASIA_BAKU = 'ASIA_BAKU',
  ASIA_BANGKOK = 'ASIA_BANGKOK',
  ASIA_BARNAUL = 'ASIA_BARNAUL',
  ASIA_BEIRUT = 'ASIA_BEIRUT',
  ASIA_BISHKEK = 'ASIA_BISHKEK',
  ASIA_BRUNEI = 'ASIA_BRUNEI',
  ASIA_CHITA = 'ASIA_CHITA',
  ASIA_CHOIBALSAN = 'ASIA_CHOIBALSAN',
  ASIA_COLOMBO = 'ASIA_COLOMBO',
  ASIA_DAMASCUS = 'ASIA_DAMASCUS',
  ASIA_DHAKA = 'ASIA_DHAKA',
  ASIA_DILI = 'ASIA_DILI',
  ASIA_DUBAI = 'ASIA_DUBAI',
  ASIA_DUSHANBE = 'ASIA_DUSHANBE',
  ASIA_FAMAGUSTA = 'ASIA_FAMAGUSTA',
  ASIA_GAZA = 'ASIA_GAZA',
  ASIA_HEBRON = 'ASIA_HEBRON',
  ASIA_HONG_KONG = 'ASIA_HONG_KONG',
  ASIA_HOVD = 'ASIA_HOVD',
  ASIA_HO_CHI_MINH = 'ASIA_HO_CHI_MINH',
  ASIA_IRKUTSK = 'ASIA_IRKUTSK',
  ASIA_JAKARTA = 'ASIA_JAKARTA',
  ASIA_JAYAPURA = 'ASIA_JAYAPURA',
  ASIA_JERUSALEM = 'ASIA_JERUSALEM',
  ASIA_KABUL = 'ASIA_KABUL',
  ASIA_KAMCHATKA = 'ASIA_KAMCHATKA',
  ASIA_KARACHI = 'ASIA_KARACHI',
  ASIA_KATHMANDU = 'ASIA_KATHMANDU',
  ASIA_KHANDYGA = 'ASIA_KHANDYGA',
  ASIA_KOLKATA = 'ASIA_KOLKATA',
  ASIA_KRASNOYARSK = 'ASIA_KRASNOYARSK',
  ASIA_KUALA_LUMPUR = 'ASIA_KUALA_LUMPUR',
  ASIA_KUCHING = 'ASIA_KUCHING',
  ASIA_KUWAIT = 'ASIA_KUWAIT',
  ASIA_MACAU = 'ASIA_MACAU',
  ASIA_MAGADAN = 'ASIA_MAGADAN',
  ASIA_MAKASSAR = 'ASIA_MAKASSAR',
  ASIA_MANILA = 'ASIA_MANILA',
  ASIA_MUSCAT = 'ASIA_MUSCAT',
  ASIA_NICOSIA = 'ASIA_NICOSIA',
  ASIA_NOVOKUZNETSK = 'ASIA_NOVOKUZNETSK',
  ASIA_NOVOSIBIRSK = 'ASIA_NOVOSIBIRSK',
  ASIA_OMSK = 'ASIA_OMSK',
  ASIA_ORAL = 'ASIA_ORAL',
  ASIA_PHNOM_PENH = 'ASIA_PHNOM_PENH',
  ASIA_PONTIANAK = 'ASIA_PONTIANAK',
  ASIA_PYONGYANG = 'ASIA_PYONGYANG',
  ASIA_QATAR = 'ASIA_QATAR',
  ASIA_QOSTANAY = 'ASIA_QOSTANAY',
  ASIA_QYZYLORDA = 'ASIA_QYZYLORDA',
  ASIA_RIYADH = 'ASIA_RIYADH',
  ASIA_SAKHALIN = 'ASIA_SAKHALIN',
  ASIA_SAMARKAND = 'ASIA_SAMARKAND',
  ASIA_SEOUL = 'ASIA_SEOUL',
  ASIA_SHANGHAI = 'ASIA_SHANGHAI',
  ASIA_SINGAPORE = 'ASIA_SINGAPORE',
  ASIA_SREDNEKOLYMSK = 'ASIA_SREDNEKOLYMSK',
  ASIA_TAIPEI = 'ASIA_TAIPEI',
  ASIA_TASHKENT = 'ASIA_TASHKENT',
  ASIA_TBILISI = 'ASIA_TBILISI',
  ASIA_TEHRAN = 'ASIA_TEHRAN',
  ASIA_THIMPHU = 'ASIA_THIMPHU',
  ASIA_TOKYO = 'ASIA_TOKYO',
  ASIA_TOMSK = 'ASIA_TOMSK',
  ASIA_ULAANBAATAR = 'ASIA_ULAANBAATAR',
  ASIA_URUMQI = 'ASIA_URUMQI',
  ASIA_UST_NERA = 'ASIA_UST_NERA',
  ASIA_VIENTIANE = 'ASIA_VIENTIANE',
  ASIA_VLADIVOSTOK = 'ASIA_VLADIVOSTOK',
  ASIA_YAKUTSK = 'ASIA_YAKUTSK',
  ASIA_YANGON = 'ASIA_YANGON',
  ASIA_YEKATERINBURG = 'ASIA_YEKATERINBURG',
  ASIA_YEREVAN = 'ASIA_YEREVAN',
  ATLANTIC_AZORES = 'ATLANTIC_AZORES',
  ATLANTIC_BERMUDA = 'ATLANTIC_BERMUDA',
  ATLANTIC_CANARY = 'ATLANTIC_CANARY',
  ATLANTIC_CAPE_VERDE = 'ATLANTIC_CAPE_VERDE',
  ATLANTIC_FAROE = 'ATLANTIC_FAROE',
  ATLANTIC_MADEIRA = 'ATLANTIC_MADEIRA',
  ATLANTIC_REYKJAVIK = 'ATLANTIC_REYKJAVIK',
  ATLANTIC_SOUTH_GEORGIA = 'ATLANTIC_SOUTH_GEORGIA',
  ATLANTIC_STANLEY = 'ATLANTIC_STANLEY',
  ATLANTIC_ST_HELENA = 'ATLANTIC_ST_HELENA',
  AUSTRALIA_ADELAIDE = 'AUSTRALIA_ADELAIDE',
  AUSTRALIA_BRISBANE = 'AUSTRALIA_BRISBANE',
  AUSTRALIA_BROKEN_HILL = 'AUSTRALIA_BROKEN_HILL',
  AUSTRALIA_CURRIE = 'AUSTRALIA_CURRIE',
  AUSTRALIA_DARWIN = 'AUSTRALIA_DARWIN',
  AUSTRALIA_EUCLA = 'AUSTRALIA_EUCLA',
  AUSTRALIA_HOBART = 'AUSTRALIA_HOBART',
  AUSTRALIA_LINDEMAN = 'AUSTRALIA_LINDEMAN',
  AUSTRALIA_LORD_HOWE = 'AUSTRALIA_LORD_HOWE',
  AUSTRALIA_MELBOURNE = 'AUSTRALIA_MELBOURNE',
  AUSTRALIA_PERTH = 'AUSTRALIA_PERTH',
  AUSTRALIA_SYDNEY = 'AUSTRALIA_SYDNEY',
  EUROPE_AMSTERDAM = 'EUROPE_AMSTERDAM',
  EUROPE_ANDORRA = 'EUROPE_ANDORRA',
  EUROPE_ASTRAKHAN = 'EUROPE_ASTRAKHAN',
  EUROPE_ATHENS = 'EUROPE_ATHENS',
  EUROPE_BELGRADE = 'EUROPE_BELGRADE',
  EUROPE_BERLIN = 'EUROPE_BERLIN',
  EUROPE_BRATISLAVA = 'EUROPE_BRATISLAVA',
  EUROPE_BRUSSELS = 'EUROPE_BRUSSELS',
  EUROPE_BUCHAREST = 'EUROPE_BUCHAREST',
  EUROPE_BUDAPEST = 'EUROPE_BUDAPEST',
  EUROPE_BUSINGEN = 'EUROPE_BUSINGEN',
  EUROPE_CHISINAU = 'EUROPE_CHISINAU',
  EUROPE_COPENHAGEN = 'EUROPE_COPENHAGEN',
  EUROPE_DUBLIN = 'EUROPE_DUBLIN',
  EUROPE_GIBRALTAR = 'EUROPE_GIBRALTAR',
  EUROPE_GUERNSEY = 'EUROPE_GUERNSEY',
  EUROPE_HELSINKI = 'EUROPE_HELSINKI',
  EUROPE_ISLE_OF_MAN = 'EUROPE_ISLE_OF_MAN',
  EUROPE_ISTANBUL = 'EUROPE_ISTANBUL',
  EUROPE_JERSEY = 'EUROPE_JERSEY',
  EUROPE_KALININGRAD = 'EUROPE_KALININGRAD',
  EUROPE_KIEV = 'EUROPE_KIEV',
  EUROPE_KIROV = 'EUROPE_KIROV',
  EUROPE_LISBON = 'EUROPE_LISBON',
  EUROPE_LJUBLJANA = 'EUROPE_LJUBLJANA',
  EUROPE_LONDON = 'EUROPE_LONDON',
  EUROPE_LUXEMBOURG = 'EUROPE_LUXEMBOURG',
  EUROPE_MADRID = 'EUROPE_MADRID',
  EUROPE_MALTA = 'EUROPE_MALTA',
  EUROPE_MARIEHAMN = 'EUROPE_MARIEHAMN',
  EUROPE_MINSK = 'EUROPE_MINSK',
  EUROPE_MONACO = 'EUROPE_MONACO',
  EUROPE_MOSCOW = 'EUROPE_MOSCOW',
  EUROPE_OSLO = 'EUROPE_OSLO',
  EUROPE_PARIS = 'EUROPE_PARIS',
  EUROPE_PODGORICA = 'EUROPE_PODGORICA',
  EUROPE_PRAGUE = 'EUROPE_PRAGUE',
  EUROPE_RIGA = 'EUROPE_RIGA',
  EUROPE_ROME = 'EUROPE_ROME',
  EUROPE_SAMARA = 'EUROPE_SAMARA',
  EUROPE_SAN_MARINO = 'EUROPE_SAN_MARINO',
  EUROPE_SARAJEVO = 'EUROPE_SARAJEVO',
  EUROPE_SARATOV = 'EUROPE_SARATOV',
  EUROPE_SIMFEROPOL = 'EUROPE_SIMFEROPOL',
  EUROPE_SKOPJE = 'EUROPE_SKOPJE',
  EUROPE_SOFIA = 'EUROPE_SOFIA',
  EUROPE_STOCKHOLM = 'EUROPE_STOCKHOLM',
  EUROPE_TALLINN = 'EUROPE_TALLINN',
  EUROPE_TIRANE = 'EUROPE_TIRANE',
  EUROPE_ULYANOVSK = 'EUROPE_ULYANOVSK',
  EUROPE_UZHGOROD = 'EUROPE_UZHGOROD',
  EUROPE_VADUZ = 'EUROPE_VADUZ',
  EUROPE_VATICAN = 'EUROPE_VATICAN',
  EUROPE_VIENNA = 'EUROPE_VIENNA',
  EUROPE_VILNIUS = 'EUROPE_VILNIUS',
  EUROPE_VOLGOGRAD = 'EUROPE_VOLGOGRAD',
  EUROPE_WARSAW = 'EUROPE_WARSAW',
  EUROPE_ZAGREB = 'EUROPE_ZAGREB',
  EUROPE_ZAPOROZHYE = 'EUROPE_ZAPOROZHYE',
  EUROPE_ZURICH = 'EUROPE_ZURICH',
  INDIAN_ANTANANARIVO = 'INDIAN_ANTANANARIVO',
  INDIAN_CHAGOS = 'INDIAN_CHAGOS',
  INDIAN_CHRISTMAS = 'INDIAN_CHRISTMAS',
  INDIAN_COCOS = 'INDIAN_COCOS',
  INDIAN_COMORO = 'INDIAN_COMORO',
  INDIAN_KERGUELEN = 'INDIAN_KERGUELEN',
  INDIAN_MAHE = 'INDIAN_MAHE',
  INDIAN_MALDIVES = 'INDIAN_MALDIVES',
  INDIAN_MAURITIUS = 'INDIAN_MAURITIUS',
  INDIAN_MAYOTTE = 'INDIAN_MAYOTTE',
  INDIAN_REUNION = 'INDIAN_REUNION',
  PACIFIC_APIA = 'PACIFIC_APIA',
  PACIFIC_AUCKLAND = 'PACIFIC_AUCKLAND',
  PACIFIC_BOUGAINVILLE = 'PACIFIC_BOUGAINVILLE',
  PACIFIC_CHATHAM = 'PACIFIC_CHATHAM',
  PACIFIC_CHUUK = 'PACIFIC_CHUUK',
  PACIFIC_EASTER = 'PACIFIC_EASTER',
  PACIFIC_EFATE = 'PACIFIC_EFATE',
  PACIFIC_ENDERBURY = 'PACIFIC_ENDERBURY',
  PACIFIC_FAKAOFO = 'PACIFIC_FAKAOFO',
  PACIFIC_FIJI = 'PACIFIC_FIJI',
  PACIFIC_FUNAFUTI = 'PACIFIC_FUNAFUTI',
  PACIFIC_GALAPAGOS = 'PACIFIC_GALAPAGOS',
  PACIFIC_GAMBIER = 'PACIFIC_GAMBIER',
  PACIFIC_GUADALCANAL = 'PACIFIC_GUADALCANAL',
  PACIFIC_GUAM = 'PACIFIC_GUAM',
  PACIFIC_HONOLULU = 'PACIFIC_HONOLULU',
  PACIFIC_KIRITIMATI = 'PACIFIC_KIRITIMATI',
  PACIFIC_KOSRAE = 'PACIFIC_KOSRAE',
  PACIFIC_KWAJALEIN = 'PACIFIC_KWAJALEIN',
  PACIFIC_MAJURO = 'PACIFIC_MAJURO',
  PACIFIC_MARQUESAS = 'PACIFIC_MARQUESAS',
  PACIFIC_MIDWAY = 'PACIFIC_MIDWAY',
  PACIFIC_NAURU = 'PACIFIC_NAURU',
  PACIFIC_NIUE = 'PACIFIC_NIUE',
  PACIFIC_NORFOLK = 'PACIFIC_NORFOLK',
  PACIFIC_NOUMEA = 'PACIFIC_NOUMEA',
  PACIFIC_PAGO_PAGO = 'PACIFIC_PAGO_PAGO',
  PACIFIC_PALAU = 'PACIFIC_PALAU',
  PACIFIC_PITCAIRN = 'PACIFIC_PITCAIRN',
  PACIFIC_POHNPEI = 'PACIFIC_POHNPEI',
  PACIFIC_PORT_MORESBY = 'PACIFIC_PORT_MORESBY',
  PACIFIC_RAROTONGA = 'PACIFIC_RAROTONGA',
  PACIFIC_SAIPAN = 'PACIFIC_SAIPAN',
  PACIFIC_TAHITI = 'PACIFIC_TAHITI',
  PACIFIC_TARAWA = 'PACIFIC_TARAWA',
  PACIFIC_TONGATAPU = 'PACIFIC_TONGATAPU',
  PACIFIC_WAKE = 'PACIFIC_WAKE',
  PACIFIC_WALLIS = 'PACIFIC_WALLIS',
  UTC = 'UTC'
}

export enum PostRecurringInterval {
  DAY = 'DAY',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export enum PostFeedType {
  FEED = 'FEED',
  REEL = 'REEL',
  STORY = 'STORY'
}

export type Photo = MediaInterface & {
  __typename?: 'Photo';
  url: Scalars['String'];
  filesize?: Maybe<Scalars['Int']>;
  thumbnailUrl: Scalars['String'];
  id: Scalars['ID'];
  proportions: MediaProportions;
  origin: MediaOrigin;
  source?: Maybe<Scalars['String']>;
  type: MediaType;
  archived: Scalars['Boolean'];
  workspace: Workspace;
  width: Scalars['Int'];
  height: Scalars['Int'];
  dateUploaded?: Maybe<Scalars['DateTime']>;
  filename?: Maybe<Scalars['String']>;
  gif: Scalars['Boolean'];
  /** Return the Canva Design ID, or null if it's not a Canva Design. */
  canvaDesignId?: Maybe<Scalars['String']>;
};

export type MediaInterface = {
  url: Scalars['String'];
  filesize?: Maybe<Scalars['Int']>;
  thumbnailUrl: Scalars['String'];
  id: Scalars['ID'];
  proportions: MediaProportions;
  origin: MediaOrigin;
  source?: Maybe<Scalars['String']>;
  type: MediaType;
  archived: Scalars['Boolean'];
  workspace: Workspace;
  width: Scalars['Int'];
  height: Scalars['Int'];
  dateUploaded?: Maybe<Scalars['DateTime']>;
};

export enum MediaProportions {
  WIDE = 'WIDE',
  SQUARE = 'SQUARE',
  TALL = 'TALL'
}

export enum MediaOrigin {
  UPLOAD = 'UPLOAD',
  WEB = 'WEB',
  CANVA = 'CANVA'
}

export enum MediaType {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO'
}

export type Workspace = {
  __typename?: 'Workspace';
  id: Scalars['ID'];
  timezone: TimezoneSetting;
  /** AutoImports for a Workspace. */
  autoImports: Array<AutoImport>;
  importSources: Array<ImportSource>;
  /** Categories for a workspace. If the categoryStatusFilter is not passed in, only returns active categories. */
  categories: Array<Category>;
  /** Timeslots for a workspace. If the categoryStatusFilter is not passed in, only returns timeslots for active categories. */
  timeslots: Array<Timeslot>;
  mediaLibrary: MediaItemsPagination;
  queueMeta: Array<QueueMetadata>;
  existingThirdPartyPhotos: Array<Scalars['String']>;
  queueCounts: PostQueueCountResult;
  /** Possible Errors: [PAGINATION_CURSOR_INVALID, QUEUE_STILL_CALCULATING] */
  queue: QueueItemsPagination;
  bitlyAccounts: Array<Bitly>;
  name: Scalars['String'];
  organization: Organization;
  settings: WorkspaceSettings;
  snippets: Array<Snippet>;
  socialProfiles: Array<SocialProfileInterface>;
  users: Array<User>;
  importFolders: Array<ImportFolder>;
};

export type Workspace_CategoriesArgs = {
  statusFilter?: InputMaybe<CategoryArchiveFilter>;
};

export type Workspace_TimeslotsArgs = {
  categoryStatusFilter?: InputMaybe<CategoryArchiveFilter>;
};

export type Workspace_MediaLibraryArgs = {
  input?: InputMaybe<MediaLibraryInput>;
};

export type Workspace_QueueCountsArgs = {
  filterInput: QueueFilterInput;
  queueContext: QueueContext;
};

export type Workspace_QueueArgs = {
  input: QueueInput;
};

export type Workspace_SocialProfilesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type AutoImport = {
  __typename?: 'AutoImport';
  id: Scalars['ID'];
  name: Scalars['String'];
  url: Scalars['String'];
  refineByTerm: Scalars['String'];
  category: Category;
  socialProfiles: Array<SocialProfileInterface>;
  pinterestBoards: Array<AutoImportPinterestBoard>;
  utmTracking?: Maybe<Utm>;
  prefixText?: Maybe<Scalars['String']>;
  suffixText?: Maybe<Scalars['String']>;
  recycle: Scalars['Boolean'];
  recycleMaxRepeats: Scalars['Int'];
  bitlyTracking: Scalars['Boolean'];
  removeLinks: Scalars['Boolean'];
  importSource: ImportSource;
  firstImportedPost: Scalars['DateTime'];
  lastImportedPost: Scalars['DateTime'];
  status: AutoImportStatus;
  postTiming: AutoImportPostTiming;
};

export type Category = {
  __typename?: 'Category';
  defaultSocialProfiles: Array<SocialProfileInterface>;
  id: Scalars['ID'];
  seasonal: Scalars['Boolean'];
  seasonalStartDate?: Maybe<Scalars['String']>;
  seasonalEndDate?: Maybe<Scalars['String']>;
  color: CategoryColor;
  name: Scalars['String'];
  seasonallyPaused: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  workspace: Workspace;
  archivedAttachedPostCount?: Maybe<Scalars['Int']>;
  archivedDate?: Maybe<Scalars['DateTime']>;
  onboardingContent: Scalars['Boolean'];
};

export enum Network {
  FACEBOOK = 'FACEBOOK',
  GENERIC_PROFILE = 'GENERIC_PROFILE',
  GOOGLE = 'GOOGLE',
  INSTAGRAM = 'INSTAGRAM',
  LINKEDIN = 'LINKEDIN',
  PINTEREST = 'PINTEREST',
  THREADS = 'THREADS',
  TIKTOK = 'TIKTOK',
  TWITTER = 'TWITTER',
  YOUTUBE = 'YOUTUBE'
}

export type SocialProfileTokenOwner = {
  __typename?: 'SocialProfileTokenOwner';
  id: Scalars['ID'];
  externalId: Scalars['String'];
  displayName: Scalars['String'];
};

export type CustomBitly = {
  __typename?: 'CustomBitly';
  id: Scalars['ID'];
  socialProfile: SocialProfileInterface;
  bitly?: Maybe<Bitly>;
  domain?: Maybe<Scalars['String']>;
};

export type Bitly = {
  __typename?: 'Bitly';
  id: Scalars['ID'];
  displayName: Scalars['String'];
  domains: Array<Scalars['String']>;
  connected: Scalars['Boolean'];
};

export enum CategoryColor {
  RED = 'RED',
  ORANGE = 'ORANGE',
  YELLOW = 'YELLOW',
  LIGHT_GREEN = 'LIGHT_GREEN',
  DARK_GREEN = 'DARK_GREEN',
  TEAL = 'TEAL',
  TURQUOISE = 'TURQUOISE',
  LIGHT_BLUE = 'LIGHT_BLUE',
  DARK_BLUE = 'DARK_BLUE',
  VIOLET = 'VIOLET',
  PURPLE = 'PURPLE',
  PINK = 'PINK',
  MAROON = 'MAROON',
  BROWN = 'BROWN',
  KHAKI = 'KHAKI',
  NAVY_BLUE = 'NAVY_BLUE',
  LIGHT_GREY = 'LIGHT_GREY',
  DARK_GREY = 'DARK_GREY'
}

export type AutoImportPinterestBoard = {
  __typename?: 'AutoImportPinterestBoard';
  socialProfileId: Scalars['ID'];
  pinterestBoardId: Scalars['String'];
};

export type Utm = {
  __typename?: 'UTM';
  source: Scalars['String'];
  medium: Scalars['String'];
  campaign: Scalars['String'];
  term: Scalars['String'];
  content: Scalars['String'];
};

export type ImportSource = {
  __typename?: 'ImportSource';
  type: ImportSourceType;
  args: ImportSourceArgsInterface;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  workspace: Workspace;
  autoImport?: Maybe<AutoImport>;
  folder?: Maybe<ImportFolder>;
};

export enum ImportSourceType {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  TWITTER = 'TWITTER',
  LINKEDIN = 'LINKEDIN',
  PINTEREST = 'PINTEREST',
  RSS = 'RSS'
}

export type ImportSourceArgsInterface = { term?: Maybe<Scalars['String']> };

export type ImportFolder = {
  __typename?: 'ImportFolder';
  importSources: Array<ImportSource>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
};

export enum AutoImportStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED'
}

export enum AutoImportPostTiming {
  QUEUE_TOP = 'QUEUE_TOP',
  QUEUE_BOTTOM = 'QUEUE_BOTTOM',
  DRAFT = 'DRAFT',
  NOW = 'NOW'
}

export enum CategoryArchiveFilter {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  ALL = 'ALL'
}

export type Timeslot = {
  __typename?: 'Timeslot';
  id: Scalars['ID'];
  time: Scalars['String'];
  socialProfiles: Array<SocialProfileInterface>;
  category: Category;
  day: TimeslotDay;
  onboardingContent: Scalars['Boolean'];
};

export enum TimeslotDay {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export type MediaLibraryInput = {
  filters?: InputMaybe<MediaFilterInput>;
  cursor?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type MediaFilterInput = {
  type?: InputMaybe<MediaTypeFilter>;
  origin?: InputMaybe<MediaOrigin>;
  proportions?: InputMaybe<MediaProportions>;
};

export enum MediaTypeFilter {
  IMAGES = 'IMAGES',
  VIDEOS = 'VIDEOS',
  GIFS = 'GIFS'
}

export type MediaItemsPagination = {
  __typename?: 'MediaItemsPagination';
  /**
   *
   *
   *
   */
  items: Array<MediaInterface>;
  cursor?: Maybe<Scalars['Int']>;
  count: Scalars['Int'];
};

export type QueueMetadata = {
  __typename?: 'QueueMetadata';
  socialProfile: SocialProfileInterface;
  category: Category;
  paused: Scalars['Boolean'];
  isCalculatingTimings?: Maybe<Scalars['Boolean']>;
  calculationStartedDatetime?: Maybe<Scalars['DateTime']>;
  isQueueTooLong: Scalars['Boolean'];
};

export type QueueFilterInput = {
  searchTerm?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<QueueFilterPostStatus>;
  socialProfileId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  timing?: InputMaybe<QueueFilterPostTiming>;
  evergreen?: InputMaybe<QueueFilterPostEvergreen>;
  feedType?: InputMaybe<QueueFilterPostFeedType>;
  source?: InputMaybe<QueueFilterPostSource>;
  content?: InputMaybe<QueueFilterPostContent>;
};

export enum QueueFilterPostStatus {
  SCHEDULED = 'SCHEDULED',
  PAST = 'PAST',
  FAILED = 'FAILED',
  PAUSED = 'PAUSED',
  DRAFT = 'DRAFT',
  UNQUEUED = 'UNQUEUED',
  DELETED = 'DELETED'
}

export enum QueueFilterPostTiming {
  SET_DATES = 'SET_DATES',
  RECURRING = 'RECURRING',
  QUEUED = 'QUEUED'
}

export enum QueueFilterPostEvergreen {
  EVERGREEN_ONLY = 'EVERGREEN_ONLY'
}

export enum QueueFilterPostFeedType {
  FEED = 'FEED',
  STORY = 'STORY',
  REEL = 'REEL'
}

export enum QueueFilterPostSource {
  POST_EDITOR = 'POST_EDITOR',
  CSV_UPLOAD = 'CSV_UPLOAD',
  SOCIAL_IMPORT = 'SOCIAL_IMPORT',
  AUTO_RSS = 'AUTO_RSS'
}

export enum QueueFilterPostContent {
  IMAGE = 'IMAGE',
  IMAGE_LINK = 'IMAGE_LINK',
  LINK = 'LINK',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  VIDEO_LINK = 'VIDEO_LINK'
}

export enum QueueContext {
  SCHEDULE = 'SCHEDULE',
  LIBRARY = 'LIBRARY'
}

export type PostQueueCountResult = {
  __typename?: 'PostQueueCountResult';
  /**
   *
   *
   *
   */
  categories: Array<PostQueueCountCategory>;
  /**
   *
   *
   *
   */
  socialProfiles: Array<PostQueueCountSocialProfile>;
  status: PostQueueCountStatus;
  content: PostQueueCountContent;
  timing: PostQueueCountTiming;
  evergreen: PostQueueCountEvergreen;
  source: PostQueueCountSource;
};

export type PostQueueCountCategory = {
  __typename?: 'PostQueueCountCategory';
  categoryId: Scalars['Int'];
  count: Scalars['Int'];
};

export type PostQueueCountSocialProfile = {
  __typename?: 'PostQueueCountSocialProfile';
  socialProfileId: Scalars['Int'];
  count: Scalars['Int'];
};

export type PostQueueCountStatus = {
  __typename?: 'PostQueueCountStatus';
  scheduled: Scalars['Int'];
  past: Scalars['Int'];
  failed: Scalars['Int'];
  paused: Scalars['Int'];
  draft: Scalars['Int'];
  unqueued: Scalars['Int'];
  deleted: Scalars['Int'];
};

export type PostQueueCountContent = {
  __typename?: 'PostQueueCountContent';
  image: Scalars['Int'];
  imageLink: Scalars['Int'];
  link: Scalars['Int'];
  text: Scalars['Int'];
  video: Scalars['Int'];
  videoLink: Scalars['Int'];
};

export type PostQueueCountTiming = {
  __typename?: 'PostQueueCountTiming';
  setDates: Scalars['Int'];
  recurring: Scalars['Int'];
  queued: Scalars['Int'];
};

export type PostQueueCountEvergreen = {
  __typename?: 'PostQueueCountEvergreen';
  evergreenOnly: Scalars['Int'];
};

export type PostQueueCountSource = {
  __typename?: 'PostQueueCountSource';
  autoRss: Scalars['Int'];
  csvUpload: Scalars['Int'];
  postEditor: Scalars['Int'];
  socialImport: Scalars['Int'];
};

export type QueueInput = {
  filters: QueueFilterInput;
  pagination: QueuePaginationInput;
  context: QueueContext;
};

export type QueuePaginationInput = {
  cursorPagination?: InputMaybe<QueueCursorPaginationInput>;
  dateRangePagination?: InputMaybe<QueueDateRangePaginationInput>;
};

export type QueueCursorPaginationInput = {
  cursor?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  sortType: QueueSortType;
  sortOrder: QueueSortOrder;
};

export enum QueueSortType {
  POST_ID = 'POST_ID',
  CALCULATED_POST_TIME = 'CALCULATED_POST_TIME',
  PUBLISHED_TIME = 'PUBLISHED_TIME',
  FAILED_TIME = 'FAILED_TIME',
  ORIGINAL_POST_CREATED_TIME = 'ORIGINAL_POST_CREATED_TIME',
  COUNT_ITERATIONS_PUBLISHED = 'COUNT_ITERATIONS_PUBLISHED',
  SUM_ITERATIONS_ENGAGEMENT = 'SUM_ITERATIONS_ENGAGEMENT'
}

export enum QueueSortOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type QueueDateRangePaginationInput = {
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
};

export type QueueItemsPagination = {
  __typename?: 'QueueItemsPagination';
  cursorPagination?: Maybe<QueueItemsCursorPagination>;
  dateRangePagination?: Maybe<QueueItemsDateRangePagination>;
};

export type QueueItemsCursorPagination = {
  __typename?: 'QueueItemsCursorPagination';
  /**
   *
   *
   *
   */
  items: Array<Post>;
  cursor?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
};

export type QueueItemsDateRangePagination = {
  __typename?: 'QueueItemsDateRangePagination';
  /**
   *
   *
   *
   */
  items: Array<Post>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  count: Scalars['Int'];
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['ID'];
  userAssignments: Array<UserOrganizationAssignment>;
  myUserAssignment?: Maybe<UserOrganizationAssignment>;
  userInvitations: Array<UserInvitation>;
  mobileApps: Array<MobileApp>;
  invoices: Array<Invoice>;
  plan: OrganizationPlanType;
  subscription: OrganizationSubscriptionType;
  spamLocked: Scalars['Boolean'];
  suspended: Scalars['Boolean'];
  legacyMemberId: Scalars['ID'];
  /** If the Organization is a migrated member that came from the legacy product */
  fromLegacy: Scalars['Boolean'];
  name: Scalars['String'];
  workspaces: Array<Workspace>;
  users: Array<User>;
  settings: OrganizationSettings;
};

export type UserOrganizationAssignment = {
  __typename?: 'UserOrganizationAssignment';
  id: Scalars['ID'];
  role: UserOrganizationRole;
  settings: UserOrganizationSettings;
  user: User;
  organization: Organization;
};

export enum UserOrganizationRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR'
}

export type UserOrganizationSettings = {
  __typename?: 'UserOrganizationSettings';
  id: Scalars['ID'];
  dateFormat: DateFormatSetting;
  timeFormat: TimeFormatSetting;
  assignment: UserOrganizationAssignment;
  notifyWeeklyStatsEnabled: Scalars['Boolean'];
  notifyQueueEmptyEnabled: Scalars['Boolean'];
  notifyPostProfileErrorEnabled: Scalars['Boolean'];
  notifyInstagramPostEnabled: Scalars['Boolean'];
  notifyAutoRssEnabled: Scalars['Boolean'];
  startOfWeekFormat: StartOfWeekFormatSetting;
};

export enum DateFormatSetting {
  MONTH_DAY_YEAR = 'MONTH_DAY_YEAR',
  DAY_MONTH_YEAR = 'DAY_MONTH_YEAR'
}

export enum TimeFormatSetting {
  HOUR_12 = 'HOUR_12',
  HOUR_24 = 'HOUR_24'
}

export enum StartOfWeekFormatSetting {
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY'
}

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  appRole: UserAppRole;
  organizations: Array<Organization>;
  settings: UserSettings;
  passwordSet: Scalars['Boolean'];
  timezone: TimezoneSetting;
  /** If the user came from the legacy product */
  fromLegacy: Scalars['Boolean'];
  /** If the user is a legacy Member that is currently migrated in the Overhaul */
  migratedToOverhaul: Scalars['Boolean'];
  onboarding: UserOnboardingType;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastSeenSiteNews?: Maybe<SiteNews>;
  onboardingCompleted: Scalars['Boolean'];
  onboardingCompletedDatetime?: Maybe<Scalars['DateTime']>;
  onboardingVersion: Scalars['Int'];
};

export enum UserAppRole {
  ADMIN = 'ADMIN',
  MODERATOR = 'MODERATOR',
  USER = 'USER'
}

export type UserSettings = {
  __typename?: 'UserSettings';
  id: Scalars['ID'];
  onlineMarketing: Scalars['Boolean'];
  user: User;
  notifyProductUpdatesEnabled: Scalars['Boolean'];
  notifyMailingListEnabled: Scalars['Boolean'];
  notifyFeatureAddedEnabled: Scalars['Boolean'];
  notifyReferralCreditsEnabled: Scalars['Boolean'];
};

export type UserOnboardingType = {
  __typename?: 'UserOnboardingType';
  version: Scalars['Int'];
  completed: Scalars['Boolean'];
  completedDatetime?: Maybe<Scalars['DateTime']>;
  /**
   *
   *
   *
   */
  stepsSeen: Array<UserOnboardingStep>;
};

export type UserOnboardingStep = {
  __typename?: 'UserOnboardingStep';
  name: Scalars['String'];
  datetime: Scalars['DateTime'];
};

export type SiteNews = {
  __typename?: 'SiteNews';
  text: Scalars['String'];
  title: Scalars['String'];
  id: Scalars['ID'];
  date: Scalars['DateTime'];
  sent?: Maybe<Scalars['Boolean']>;
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  id: Scalars['ID'];
  workspaceIds: Array<Scalars['ID']>;
  role: UserOrganizationRole;
  organization: Organization;
  email: Scalars['String'];
  token: Scalars['String'];
  createdAt: Scalars['DateTime'];
};

export type MobileApp = {
  id: Scalars['ID'];
  owner: MobileAppOwnerType;
  connected: Scalars['Boolean'];
  videoCarouselSupported: Scalars['Boolean'];
  deviceType?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  buildNumber: Scalars['Int'];
  firstConnectedTime: Scalars['DateTime'];
  lastConnectedTime: Scalars['DateTime'];
};

export type MobileAppOwnerType = {
  __typename?: 'MobileAppOwnerType';
  id: Scalars['ID'];
  firstName: Scalars['String'];
};

export type Invoice = {
  __typename?: 'Invoice';
  id: Scalars['ID'];
  status?: Maybe<InvoiceStatus>;
  failureMessage?: Maybe<Scalars['String']>;
  creditCard?: Maybe<BraintreeCreditCardType>;
  planAmount: Scalars['String'];
  preVatAmount: Scalars['String'];
  billingAddressDetails: InvoiceBillingAddressDetailsType;
  businessAddressDetails: InvoiceBusinessAddressDetailsType;
  vatBusinessDetails?: Maybe<InvoiceVatBusinessDetailsType>;
  planType: PlanType;
  accountNumber: Scalars['String'];
  invoiceNumber: Scalars['String'];
  vatReverseCharge: Scalars['Boolean'];
  date: Scalars['DateTime'];
  billingPeriodStartDate: Scalars['DateTime'];
  billingPeriodEndDate: Scalars['DateTime'];
  amount: Scalars['String'];
  amountGbp: Scalars['String'];
  addonsAmount: Scalars['String'];
  discountAmount: Scalars['String'];
  discountPercentage?: Maybe<Scalars['String']>;
  discountType?: Maybe<Scalars['String']>;
  vatAmount?: Maybe<Scalars['String']>;
  currencyCode: CurrencyCode;
  paypalEmail?: Maybe<Scalars['String']>;
  type: InvoiceTransactionType;
  paymentMethod: InvoicePaymentMethod;
  renewalType: InvoiceRenewalType;
};

export enum InvoiceStatus {
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  FAILED = 'FAILED'
}

export type BraintreeCreditCardType = {
  __typename?: 'BraintreeCreditCardType';
  type: Scalars['String'];
  last4Digits: Scalars['String'];
  expiryMonth: Scalars['Int'];
  expiryYear: Scalars['Int'];
  countryCode: Scalars['String'];
};

export type InvoiceBillingAddressDetailsType = {
  __typename?: 'InvoiceBillingAddressDetailsType';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  countryCode: Scalars['String'];
};

export type InvoiceBusinessAddressDetailsType = {
  __typename?: 'InvoiceBusinessAddressDetailsType';
  companyName: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  region: Scalars['String'];
  postCode: Scalars['String'];
  countryCode: Scalars['String'];
};

export type InvoiceVatBusinessDetailsType = {
  __typename?: 'InvoiceVatBusinessDetailsType';
  numberCountryCode: Scalars['String'];
  number: Scalars['String'];
  rateCharged: Scalars['String'];
  countryChargedCode: Scalars['String'];
  countryChargedDisplayName: Scalars['String'];
};

export enum PlanType {
  SOLO = 'SOLO',
  BUSINESS = 'BUSINESS',
  AGENCY = 'AGENCY',
  LITE = 'LITE'
}

export enum CurrencyCode {
  GBP = 'GBP',
  USD = 'USD',
  EUR = 'EUR'
}

export enum InvoiceTransactionType {
  CREDIT = 'CREDIT',
  SALE = 'SALE'
}

export enum InvoicePaymentMethod {
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL_ACCOUNT = 'PAYPAL_ACCOUNT',
  APPLE_PAY_CARD = 'APPLE_PAY_CARD'
}

export enum InvoiceRenewalType {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export type OrganizationPlanType = {
  __typename?: 'OrganizationPlanType';
  id: Scalars['ID'];
  name: Scalars['String'];
  limits: PlanLimitsType;
  usage: PlanUsageType;
  analyticsType: PlanAnalyticsType;
  importerType: PlanImporterType;
  /**
   *
   *
   *
   */
  featureFlags: Array<FeatureFlag>;
};

export type PlanLimitsType = {
  __typename?: 'PlanLimitsType';
  workspaces: Scalars['Int'];
  users: Scalars['Int'];
  posts: Scalars['Int'];
  socialProfiles: Scalars['Int'];
  activeCategories: Scalars['Int'];
  autoImports: Scalars['Int'];
  importSources: Scalars['Int'];
  timeslotsPerWeekdayPerProfile: Scalars['Int'];
  aiCredits: Scalars['Int'];
};

export type PlanUsageType = {
  __typename?: 'PlanUsageType';
  workspaces: Scalars['Int'];
  users: Scalars['Int'];
  posts: Scalars['Int'];
  socialProfiles: Scalars['Int'];
  activeCategories: Scalars['Int'];
  autoImports: Scalars['Int'];
  importSources: Scalars['Int'];
  aiCredits: Scalars['Int'];
};

export enum PlanAnalyticsType {
  BASIC_ANALYTICS = 'BASIC_ANALYTICS',
  INTERMEDIATE_ANALYTICS = 'INTERMEDIATE_ANALYTICS',
  ADVANCED_ANALYTICS = 'ADVANCED_ANALYTICS'
}

export enum PlanImporterType {
  BASIC_IMPORTER = 'BASIC_IMPORTER',
  INTERMEDIATE_IMPORTER = 'INTERMEDIATE_IMPORTER',
  ADVANCED_IMPORTER = 'ADVANCED_IMPORTER'
}

export enum FeatureFlag {
  AI_CAPTION_WRITER = 'AI_CAPTION_WRITER'
}

export type OrganizationSubscriptionType = {
  __typename?: 'OrganizationSubscriptionType';
  status: SubscriptionStatus;
  billingCycle: BillingCycle;
  nextBillingDateUtc?: Maybe<Scalars['DateTime']>;
  trialExpiryDateUtc: Scalars['DateTime'];
  upgradedDateUtc?: Maybe<Scalars['DateTime']>;
};

export enum SubscriptionStatus {
  TRIAL = 'TRIAL',
  PAID = 'PAID',
  PAST_DUE = 'PAST_DUE',
  EXPIRED = 'EXPIRED'
}

export enum BillingCycle {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  id: Scalars['ID'];
  organization: Organization;
  productAnalyticsEnabled: Scalars['Boolean'];
  notifySubscriptionEnabled: Scalars['Boolean'];
};

export type WorkspaceSettings = {
  __typename?: 'WorkspaceSettings';
  id: Scalars['ID'];
  campaignTracking: Scalars['Boolean'];
  shouldRemoveUtm: Scalars['Boolean'];
  utm?: Maybe<Utm>;
  defaultBitly?: Maybe<DefaultBitly>;
  workspace: Workspace;
  evergreenRecycling: Scalars['Boolean'];
  attributionTwitter: Scalars['Boolean'];
  attributionInstagram: Scalars['Boolean'];
  minimumRecycleTime: MinimumRecycleTime;
  multiMediaAttachMode: PostMultiMediaAttachMode;
  defaultQueuePosition: PostQueuePosition;
  fbLinkPreview: FbLinkPreview;
  importMediaBehavior: ImportMediaBehavior;
  queuesPaused: Scalars['Boolean'];
  autoImportsPaused: Scalars['Boolean'];
};

export type DefaultBitly = {
  __typename?: 'DefaultBitly';
  bitly: Bitly;
  domain: Scalars['String'];
};

export enum MinimumRecycleTime {
  WEEKS_1 = 'WEEKS_1',
  WEEKS_2 = 'WEEKS_2'
}

export enum PostMultiMediaAttachMode {
  MULTIPLE = 'MULTIPLE',
  ALTERNATE = 'ALTERNATE'
}

export enum PostQueuePosition {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM'
}

export enum FbLinkPreview {
  USE = 'USE',
  REMOVE = 'REMOVE'
}

export enum ImportMediaBehavior {
  USE = 'USE',
  REMOVE = 'REMOVE',
  USE_FROM_LINK = 'USE_FROM_LINK'
}

export type Snippet = {
  __typename?: 'Snippet';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  workspace: Workspace;
};

export type Video = MediaInterface & {
  __typename?: 'Video';
  url: Scalars['String'];
  filesize?: Maybe<Scalars['Int']>;
  thumbnailUrl: Scalars['String'];
  id: Scalars['ID'];
  proportions: MediaProportions;
  origin: MediaOrigin;
  source?: Maybe<Scalars['String']>;
  type: MediaType;
  archived: Scalars['Boolean'];
  workspace: Workspace;
  width: Scalars['Int'];
  height: Scalars['Int'];
  dateUploaded?: Maybe<Scalars['DateTime']>;
  length?: Maybe<Scalars['Int']>;
  transcoded: Scalars['Boolean'];
  transcodingStatus: VideoTranscodingStatus;
};

export enum VideoTranscodingStatus {
  NOT_STARTED = 'NOT_STARTED',
  TRANSCODING = 'TRANSCODING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED'
}

export type PostVariationMeta = {
  __typename?: 'PostVariationMeta';
  postedCount: Scalars['Int'];
  currentIndex: Scalars['Int'];
  total: Scalars['Int'];
  hasMultiple: Scalars['Boolean'];
  multiMediaAttachMode: PostMultiMediaAttachMode;
  currentVariation: PostCurrentVariation;
};

export type PostCurrentVariation = {
  __typename?: 'PostCurrentVariation';
  text?: Maybe<Scalars['String']>;
  /**
   *
   *
   *
   */
  media: Array<MediaInterface>;
};

export type PostPublishedStats = {
  __typename?: 'PostPublishedStats';
  clicks?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['Int']>;
  dislikes?: Maybe<Scalars['Int']>;
  impressions?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  quotes?: Maybe<Scalars['Int']>;
  saves?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['Int']>;
  uniqueImpressions?: Maybe<Scalars['Int']>;
  videoViews?: Maybe<Scalars['Int']>;
  boost?: Maybe<Scalars['Int']>;
};

export type ThirdPartyProfile = {
  __typename?: 'ThirdPartyProfile';
  displayName: Scalars['String'];
  username: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  profileUrl?: Maybe<Scalars['String']>;
};

export type PostTikTok = {
  __typename?: 'PostTikTok';
  privacy?: Maybe<PostTikTokPrivacy>;
  disableComment?: Maybe<Scalars['Boolean']>;
  disableDuet?: Maybe<Scalars['Boolean']>;
  disableStitch?: Maybe<Scalars['Boolean']>;
  brandSelf?: Maybe<Scalars['Boolean']>;
  brandOther?: Maybe<Scalars['Boolean']>;
  autoAddMusic?: Maybe<Scalars['Boolean']>;
};

export enum PostTikTokPrivacy {
  ASK = 'ASK',
  PUBLIC_TO_EVERYONE = 'PUBLIC_TO_EVERYONE',
  MUTUAL_FOLLOW_FRIENDS = 'MUTUAL_FOLLOW_FRIENDS',
  FOLLOWER_OF_CREATOR = 'FOLLOWER_OF_CREATOR',
  SELF_ONLY = 'SELF_ONLY'
}

export type Link = {
  __typename?: 'Link';
  id: Scalars['ID'];
  urlBitlink: Scalars['Boolean'];
  initialUrlBitlink: Scalars['Boolean'];
  destination: LinkDestination;
  clickTracking: LinkClickTracking;
  utm?: Maybe<Utm>;
  pictureSize?: Maybe<LinkPictureSize>;
  openGraph?: Maybe<OpenGraph>;
  twitterCard?: Maybe<TwitterCard>;
  url: Scalars['String'];
  initialUrl: Scalars['String'];
  expandedUrl: Scalars['String'];
  bitlyDestinationUrl?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  previewRemoved: Scalars['Boolean'];
  googleCallToAction: LinkGoogleCallToAction;
  /** Whether the Link should be converted to a Bitlink. */
  attemptToUseBitly: Scalars['Boolean'];
  bitlyPreference: BitlyPreference;
};

export enum LinkDestination {
  INITIAL = 'INITIAL',
  EXPANDED = 'EXPANDED'
}

export enum LinkClickTracking {
  NONE = 'NONE',
  BITLY = 'BITLY'
}

export enum LinkPictureSize {
  WIDE_IMAGE = 'WIDE_IMAGE',
  SQUARE_IMAGE = 'SQUARE_IMAGE',
  TALL_IMAGE = 'TALL_IMAGE'
}

export type OpenGraph = SocialLinkDescriptionInterface & {
  __typename?: 'OpenGraph';
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type SocialLinkDescriptionInterface = {
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type TwitterCard = SocialLinkDescriptionInterface & {
  __typename?: 'TwitterCard';
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  card?: Maybe<LinkTwitterCard>;
};

export enum LinkTwitterCard {
  SUMMARY = 'SUMMARY',
  SUMMARY_LARGE_IMAGE = 'SUMMARY_LARGE_IMAGE',
  PLAYER = 'PLAYER',
  AUDIO = 'AUDIO',
  APP = 'APP'
}

export enum LinkGoogleCallToAction {
  NONE = 'NONE',
  BOOK = 'BOOK',
  ORDER_ONLINE = 'ORDER_ONLINE',
  BUY = 'BUY',
  LEARN_MORE = 'LEARN_MORE',
  SIGN_UP = 'SIGN_UP'
}

export enum BitlyPreference {
  OFF = 'OFF',
  DEFAULT = 'DEFAULT'
}

export type PostIterationAggregations = {
  __typename?: 'PostIterationAggregations';
  id: Scalars['ID'];
  oldestPost?: Maybe<Post>;
  newestPost?: Maybe<Post>;
  sumClicks: Scalars['Int'];
  sumComments: Scalars['Int'];
  sumDislikes: Scalars['Int'];
  sumImpressions: Scalars['Int'];
  sumLikes: Scalars['Int'];
  sumQuotes: Scalars['Int'];
  sumSaves: Scalars['Int'];
  sumShares: Scalars['Int'];
  sumVideoViews: Scalars['Int'];
  maxClicks: Scalars['Int'];
  maxComments: Scalars['Int'];
  maxDislikes: Scalars['Int'];
  maxImpressions: Scalars['Int'];
  maxLikes: Scalars['Int'];
  maxQuotes: Scalars['Int'];
  maxSaves: Scalars['Int'];
  maxShares: Scalars['Int'];
  maxUniqueImpressions: Scalars['Int'];
  maxVideoViews: Scalars['Int'];
  boost: Scalars['Float'];
  countTimesPosted: Scalars['Int'];
  actualPublishMethods?: Maybe<Array<PostPublishMethod>>;
};

export enum PostPublishMethod {
  DIRECT = 'DIRECT',
  MANUAL = 'MANUAL'
}

export enum PostStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PUBLISHED = 'PUBLISHED',
  FAILED = 'FAILED',
  TRASH = 'TRASH'
}

export enum PostTiming {
  QUEUE = 'QUEUE',
  RECURRING = 'RECURRING',
  SCHEDULE = 'SCHEDULE',
  NOW = 'NOW'
}

export enum PostPublishedVia {
  DIRECT = 'DIRECT',
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  EMAIL = 'EMAIL',
  UNKNOWN_MANUAL = 'UNKNOWN_MANUAL'
}

export type ThirdPartyPost = {
  __typename?: 'ThirdPartyPost';
  externalId: Scalars['String'];
  externalProfile: ThirdPartyProfile;
  platform: Scalars['String'];
  createdAt: Scalars['DateTime'];
  text: Scalars['String'];
  media: Array<ThirdPartyPostMedia>;
  textMentions: Array<ThirdPartyPostMention>;
  attachmentTypes: Array<ThirdPartyPostAttachmentType>;
  title?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  linkName?: Maybe<Scalars['String']>;
  linkDescription?: Maybe<Scalars['String']>;
  linkImageUrl?: Maybe<Scalars['String']>;
  postUrl: Scalars['String'];
  comments?: Maybe<Scalars['Int']>;
  dislikes?: Maybe<Scalars['Int']>;
  impressions?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  quotes?: Maybe<Scalars['Int']>;
  saves?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['Int']>;
  uniqueImpressions?: Maybe<Scalars['Int']>;
  videoViews?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  tweetType?: Maybe<ThirdPartyPostTweetType>;
};

export type ThirdPartyPostMedia = {
  __typename?: 'ThirdPartyPostMedia';
  type: ThirdPartyPostMediaType;
  url?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export enum ThirdPartyPostMediaType {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO'
}

export type ThirdPartyPostMention = {
  __typename?: 'ThirdPartyPostMention';
  externalId?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
};

export enum ThirdPartyPostAttachmentType {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
  LINK = 'LINK'
}

export enum ThirdPartyPostTweetType {
  TWEET = 'TWEET',
  RETWEET = 'RETWEET',
  REPLY = 'REPLY'
}

export type PorpaginasResult_Notification = {
  __typename?: 'PorpaginasResult_Notification';
  items: Array<Notification>;
  /** The total count of items. */
  count?: Maybe<Scalars['Int']>;
};

export type PorpaginasResult_Notification_ItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  timestamp: Scalars['Int'];
  name: NotificationName;
  message: Scalars['String'];
  isRead: Scalars['Boolean'];
  organization?: Maybe<Organization>;
  user: User;
  workspace?: Maybe<Workspace>;
};

export enum NotificationName {
  LEGACY = 'LEGACY',
  INFO = 'INFO',
  POST_FAILED = 'POST_FAILED',
  POST_FAILED_PROFILE_DISCONNECTED = 'POST_FAILED_PROFILE_DISCONNECTED',
  POST_REQUEUED_PROFILE_DISCONNECTED = 'POST_REQUEUED_PROFILE_DISCONNECTED',
  FIRST_COMMENT_FAILED = 'FIRST_COMMENT_FAILED',
  PROFILE_DISCONNECTED = 'PROFILE_DISCONNECTED',
  FACEBOOK_USER_DEAUTHORIZED = 'FACEBOOK_USER_DEAUTHORIZED',
  POST_STATS_FAILED = 'POST_STATS_FAILED',
  FOLLOWER_COUNTS_FAILED = 'FOLLOWER_COUNTS_FAILED',
  ACCOUNT_SPAM_LOCKED = 'ACCOUNT_SPAM_LOCKED',
  ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED',
  ACCOUNT_UNLOCKED = 'ACCOUNT_UNLOCKED',
  BULK_IMPORT_COMPLETED = 'BULK_IMPORT_COMPLETED',
  BULK_IMPORT_PARTIALLY_FAILED = 'BULK_IMPORT_PARTIALLY_FAILED',
  BULK_IMPORT_FAILED = 'BULK_IMPORT_FAILED',
  AUTO_IMPORTER_INVALID_SOURCE = 'AUTO_IMPORTER_INVALID_SOURCE',
  AUTO_IMPORTER_PROFILES_REMOVED = 'AUTO_IMPORTER_PROFILES_REMOVED',
  AUTO_IMPORTER_CATEGORY_ARCHIVED = 'AUTO_IMPORTER_CATEGORY_ARCHIVED',
  AUTO_IMPORTER_QUEUE_FULL = 'AUTO_IMPORTER_QUEUE_FULL',
  BITLY_FAILED = 'BITLY_FAILED',
  VIDEO_PROCESSING_FAILED = 'VIDEO_PROCESSING_FAILED',
  TWITTER_VIDEO_TOO_LONG = 'TWITTER_VIDEO_TOO_LONG',
  FACEBOOK_VIDEO_TOO_LONG = 'FACEBOOK_VIDEO_TOO_LONG',
  INSTAGRAM_REEL_TOO_LONG = 'INSTAGRAM_REEL_TOO_LONG',
  INSTAGRAM_STORY_VIDEO_TOO_LONG = 'INSTAGRAM_STORY_VIDEO_TOO_LONG',
  TIKTOK_VIDEO_TOO_LONG = 'TIKTOK_VIDEO_TOO_LONG',
  LINKEDIN_VIDEO_TOO_SHORT = 'LINKEDIN_VIDEO_TOO_SHORT',
  TIKTOK_VIDEO_TOO_SHORT = 'TIKTOK_VIDEO_TOO_SHORT',
  TIKTOK_VIDEO_TOO_SMALL = 'TIKTOK_VIDEO_TOO_SMALL',
  FACEBOOK_VIDEO_ASPECT_UNSUPPORTED = 'FACEBOOK_VIDEO_ASPECT_UNSUPPORTED',
  TWITTER_VIDEO_ASPECT_UNSUPPORTED = 'TWITTER_VIDEO_ASPECT_UNSUPPORTED',
  LINKEDIN_TOKEN_EXPIRING_2_DAYS = 'LINKEDIN_TOKEN_EXPIRING_2_DAYS',
  LINKEDIN_TOKEN_EXPIRING_7_DAYS = 'LINKEDIN_TOKEN_EXPIRING_7_DAYS',
  REFRESH_INSTAGRAM_TOKEN = 'REFRESH_INSTAGRAM_TOKEN',
  REFRESH_THREADS_TOKEN = 'REFRESH_THREADS_TOKEN',
  DAILY_TWEET_CAP_EXCEEDED = 'DAILY_TWEET_CAP_EXCEEDED',
  WEEKLY_TWEET_CAP_EXCEEDED = 'WEEKLY_TWEET_CAP_EXCEEDED'
}

export type PixabaySearchInput = {
  term?: InputMaybe<Scalars['String']>;
  orientation?: InputMaybe<Orientation>;
  imageType?: InputMaybe<ImageType>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export enum Orientation {
  ALL = 'ALL',
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL'
}

export enum ImageType {
  ALL = 'ALL',
  PHOTO = 'PHOTO',
  ILLUSTRATION = 'ILLUSTRATION',
  VECTOR = 'VECTOR'
}

export type ThirdPartyMediaItem = {
  __typename?: 'ThirdPartyMediaItem';
  mediaType: MediaType;
  url: Scalars['String'];
  previewUrl: Scalars['String'];
  proportions: MediaProportions;
  gif: Scalars['Boolean'];
  createdBy?: Maybe<Scalars['String']>;
  createdByUsername?: Maybe<Scalars['String']>;
};

export type GiphySearchInput = {
  term?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type UnsplashSearchInput = {
  term?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type HelpscoutBeaconMetadata = {
  __typename?: 'HelpscoutBeaconMetadata';
  beaconId: Scalars['String'];
  email: Scalars['String'];
  signature: Scalars['String'];
};

export type LinkMetadata = {
  __typename?: 'LinkMetadata';
  error?: Maybe<Scalars['String']>;
  initialUrl: Scalars['String'];
  expandedUrl: Scalars['String'];
  domain: Scalars['String'];
  /**
   *
   *
   *
   */
  images: Array<Scalars['String']>;
  isBitlink: Scalars['Boolean'];
  openGraph?: Maybe<OpenGraph>;
  twitterCard?: Maybe<TwitterCard>;
};

export enum SecondaryProfileType {
  PAGE = 'PAGE',
  GROUP = 'GROUP',
  COMPANY = 'COMPANY'
}

export type ExternalSecondaryProfileData = {
  __typename?: 'ExternalSecondaryProfileData';
  externalId: Scalars['String'];
  displayName: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  workspaceId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  /**
   *
   *
   *
   */
  availablePostAsProfiles?: Maybe<Array<PostAsProfile>>;
};

export type PostAsProfile = {
  __typename?: 'PostAsProfile';
  externalId: Scalars['ID'];
  displayName: Scalars['String'];
};

export type SocialAuthToken = {
  __typename?: 'SocialAuthToken';
  network: Network;
  externalId: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  photoUrl: Scalars['String'];
};

export type AiCaptionGenerationType = {
  __typename?: 'AiCaptionGenerationType';
  /**
   *
   *
   *
   */
  captions: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  lastUpdated: Scalars['DateTime'];
  status: AiCaptionStatus;
};

export enum AiCaptionStatus {
  PENDING = 'PENDING',
  WORKING = 'WORKING',
  STOPPED = 'STOPPED',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export type PinterestBoard = {
  __typename?: 'PinterestBoard';
  externalId: Scalars['String'];
  name: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
};

export type RssPostSearchResultType = {
  __typename?: 'RssPostSearchResultType';
  items: Array<ExternalRssPost>;
  cursor?: Maybe<Scalars['String']>;
};

export type ExternalRssPost = {
  __typename?: 'ExternalRssPost';
  createdAt?: Maybe<Scalars['DateTime']>;
  content: Scalars['String'];
  postUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type TwitterList = {
  __typename?: 'TwitterList';
  externalId: Scalars['String'];
  name: Scalars['String'];
  memberCount: Scalars['Int'];
};

export enum TwitterSearchType {
  TWEETS = 'TWEETS',
  PROFILE_FEED = 'PROFILE_FEED',
  HOME_TIMELINE = 'HOME_TIMELINE',
  MENTIONS = 'MENTIONS',
  LIST = 'LIST'
}

export enum TwitterSearchContentType {
  ALL = 'ALL',
  LINKS = 'LINKS',
  PHOTOS = 'PHOTOS',
  VIDEOS = 'VIDEOS'
}

export enum TwitterSearchSortType {
  LATEST = 'LATEST',
  MOST_LIKED = 'MOST_LIKED',
  MOST_RETWEETED = 'MOST_RETWEETED'
}

export type ThirdPartyPostSearchResult = {
  __typename?: 'ThirdPartyPostSearchResult';
  items: Array<ThirdPartyPost>;
  cursor?: Maybe<Scalars['String']>;
};

export enum PinterestSearchType {
  PROFILE = 'PROFILE',
  BOARD = 'BOARD'
}

export enum PinterestSearchContentType {
  ALL = 'ALL',
  LINKS = 'LINKS'
}

export enum PinterestSearchSortType {
  LATEST = 'LATEST'
}

export enum LinkedInSearchType {
  PROFILE = 'PROFILE'
}

export enum LinkedInSearchContentType {
  ALL = 'ALL',
  LINKS = 'LINKS',
  PHOTOS = 'PHOTOS'
}

export enum LinkedInSearchSortType {
  LATEST = 'LATEST',
  MOST_LIKED = 'MOST_LIKED',
  MOST_COMMENTED = 'MOST_COMMENTED'
}

export enum FacebookSearchType {
  GROUP = 'GROUP',
  PAGE = 'PAGE'
}

export enum FacebookSearchContentType {
  ALL = 'ALL',
  LINKS = 'LINKS',
  PHOTOS = 'PHOTOS',
  VIDEOS = 'VIDEOS'
}

export enum FacebookSearchSortType {
  LATEST = 'LATEST',
  MOST_LIKED = 'MOST_LIKED',
  MOST_SHARED = 'MOST_SHARED',
  MOST_COMMENTED = 'MOST_COMMENTED'
}

export enum InstagramSearchType {
  PROFILE = 'PROFILE',
  MENTIONS = 'MENTIONS'
}

export enum InstagramSearchSortType {
  LATEST = 'LATEST',
  MOST_LIKED = 'MOST_LIKED',
  MOST_COMMENTED = 'MOST_COMMENTED'
}

export type ProfileFollowersStats = {
  __typename?: 'ProfileFollowersStats';
  socialProfileId: Scalars['ID'];
  previousPeriodStats?: Maybe<FollowersStats>;
  /**
   *
   *
   *
   */
  followersStats: Array<FollowersStats>;
};

export type FollowersStats = {
  __typename?: 'FollowersStats';
  rangeStartDate: Scalars['String'];
  rangeEndDate: Scalars['String'];
  followers?: Maybe<Scalars['Int']>;
};

export enum AnalyticsPostStatsGroupType {
  PROFILE = 'PROFILE',
  CATEGORY = 'CATEGORY',
  CONTENT_TYPE = 'CONTENT_TYPE'
}

export type PostStatsResult = {
  __typename?: 'PostStatsResult';
  /**
   *
   *
   *
   */
  postStatsByProfile?: Maybe<Array<PostStatsByProfile>>;
  /**
   *
   *
   *
   */
  postStatsByCategory?: Maybe<Array<PostStatsByCategory>>;
  /**
   *
   *
   *
   */
  postStatsByContentType?: Maybe<Array<PostStatsByContentType>>;
};

export type PostStatsByProfile = {
  __typename?: 'PostStatsByProfile';
  socialProfileId: Scalars['ID'];
  previousPeriodStats?: Maybe<PostStats>;
  /**
   *
   *
   *
   */
  postStats: Array<PostStats>;
};

export type PostStats = {
  __typename?: 'PostStats';
  postCount: Scalars['Int'];
  rangeStartDate: Scalars['String'];
  rangeEndDate: Scalars['String'];
  clicks?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['Int']>;
  dislikes?: Maybe<Scalars['Int']>;
  impressions?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  quotes?: Maybe<Scalars['Int']>;
  saves?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['Int']>;
  uniqueImpressions?: Maybe<Scalars['Int']>;
  videoViews?: Maybe<Scalars['Int']>;
};

export type PostStatsByCategory = {
  __typename?: 'PostStatsByCategory';
  categoryId: Scalars['ID'];
  previousPeriodStats?: Maybe<PostStats>;
  /**
   *
   *
   *
   */
  postStats: Array<PostStats>;
};

export type PostStatsByContentType = {
  __typename?: 'PostStatsByContentType';
  contentType: AnalyticsContentType;
  previousPeriodStats?: Maybe<PostStats>;
  /**
   *
   *
   *
   */
  postStats: Array<PostStats>;
};

export enum AnalyticsContentType {
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
  LINK = 'LINK'
}

export type BestTimeToPostStatsResult = {
  __typename?: 'BestTimeToPostStatsResult';
  postEngagementByDayOfWeek: PostEngagementByDayOfWeek;
  postEngagementByHourOfDay: PostEngagementByHourOfDay;
};

export type PostEngagementByDayOfWeek = {
  __typename?: 'PostEngagementByDayOfWeek';
  monday?: Maybe<Scalars['Int']>;
  tuesday?: Maybe<Scalars['Int']>;
  wednesday?: Maybe<Scalars['Int']>;
  thursday?: Maybe<Scalars['Int']>;
  friday?: Maybe<Scalars['Int']>;
  saturday?: Maybe<Scalars['Int']>;
  sunday?: Maybe<Scalars['Int']>;
};

export type PostEngagementByHourOfDay = {
  __typename?: 'PostEngagementByHourOfDay';
  hour0?: Maybe<Scalars['Int']>;
  hour1?: Maybe<Scalars['Int']>;
  hour2?: Maybe<Scalars['Int']>;
  hour3?: Maybe<Scalars['Int']>;
  hour4?: Maybe<Scalars['Int']>;
  hour5?: Maybe<Scalars['Int']>;
  hour6?: Maybe<Scalars['Int']>;
  hour7?: Maybe<Scalars['Int']>;
  hour8?: Maybe<Scalars['Int']>;
  hour9?: Maybe<Scalars['Int']>;
  hour10?: Maybe<Scalars['Int']>;
  hour11?: Maybe<Scalars['Int']>;
  hour12?: Maybe<Scalars['Int']>;
  hour13?: Maybe<Scalars['Int']>;
  hour14?: Maybe<Scalars['Int']>;
  hour15?: Maybe<Scalars['Int']>;
  hour16?: Maybe<Scalars['Int']>;
  hour17?: Maybe<Scalars['Int']>;
  hour18?: Maybe<Scalars['Int']>;
  hour19?: Maybe<Scalars['Int']>;
  hour20?: Maybe<Scalars['Int']>;
  hour21?: Maybe<Scalars['Int']>;
  hour22?: Maybe<Scalars['Int']>;
  hour23?: Maybe<Scalars['Int']>;
};

export enum ThirdPartyProfileSearchType {
  FACEBOOK_PAGE = 'FACEBOOK_PAGE',
  LINKEDIN_COMPANY = 'LINKEDIN_COMPANY',
  TWITTER_USER = 'TWITTER_USER',
  INSTAGRAM_BUSINESS_PROFILE = 'INSTAGRAM_BUSINESS_PROFILE'
}

export type InvitationDetails = {
  __typename?: 'InvitationDetails';
  email: Scalars['String'];
  organizationName: Scalars['String'];
  organizationID: Scalars['ID'];
  invitedAt: Scalars['DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  startSocialOAuth: SocialOAuth;
  loginWithSocial: LoginSuccess;
  shuffleQueue: Scalars['Boolean'];
  bulkUpdateQueueMeta: Array<QueueMetadata>;
  sendPasswordResetEmail: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  updateOrganization: Organization;
  updateOrganizationSettings: CombinedOrganizationSettings;
  updateUserOrganizationAssignment: UserOrganizationAssignment;
  removeUserOrganizationAssignment: Scalars['Boolean'];
  connectBitly: Bitly;
  reconnectBitly: Bitly;
  removeBitly: Scalars['Boolean'];
  bulkUpdateCustomBitlySettings: Array<SocialProfileInterface>;
  markAllNotificationsAsRead: Scalars['Boolean'];
  updateLastReadSiteNews: Scalars['Boolean'];
  markNotificationAsRead: Notification;
  bulkMarkNotificationsAsRead: Array<Notification>;
  registerMediaItemUpload: UploadInstructions;
  bulkRegisterMediaItemUploads: Array<UploadInstructions>;
  completeMediaUpload: MediaInterface;
  bulkCompleteMediaUploads: Array<BulkMediaUploadResult>;
  addExternalPhoto: Photo;
  bulkAddExternalPhotos: Array<BulkMediaUploadResult>;
  bulkArchiveMedia: Scalars['Boolean'];
  createWorkspace: Workspace;
  updateWorkspace: Workspace;
  deleteWorkspace: Scalars['Boolean'];
  updateWorkspaceSettings: WorkspaceSettings;
  createUserWorkspaceAssignment: Workspace;
  removeUserWorkspaceAssignment: Scalars['Boolean'];
  updateUserSettings: UserSettings;
  updateUser: User;
  createCategory: Category;
  updateCategory: Category;
  deleteCategory: Scalars['Boolean'];
  createSnippet: Snippet;
  updateSnippet: Snippet;
  deleteSnippet: Scalars['Boolean'];
  markOnboardingStepSeen: UserOnboardingStep;
  completeOnboarding: User;
  connectMainSocialProfile: Array<SocialProfileConnectionResult>;
  reconnectSocialProfile: Array<SocialProfileConnectionResult>;
  removeSocialProfile: Scalars['Boolean'];
  connectSecondarySocialProfiles: Array<SocialProfileConnectionResult>;
  updateSocialProfileDirectPublishing: InstagramSocialProfile;
  refreshTikTokSocialProfileSettings: TikTokSocialProfile;
  refreshPinterestBoards: PinterestSocialProfile;
  refreshSocialProfilePhotoUrl: SocialProfileInterface;
  register: LoginSuccess;
  loginWithEmail: LoginSuccess;
  logout: Scalars['Boolean'];
  refreshAccessToken: Token;
  revokeAllTokens: Scalars['Boolean'];
  initiateCaptions: AiCaptionInitiateType;
  stopCaptions: AiCaptionGenerationType;
  shareExternalPost: Scalars['Boolean'];
  likeExternalPost: Scalars['Boolean'];
  commentOnExternalPost: Scalars['Boolean'];
  createTimeslot: Timeslot;
  updateTimeslot: Timeslot;
  deleteTimeslot: Scalars['Boolean'];
  bulkDeleteTimeslots: Scalars['Boolean'];
  deleteAutoImport: Scalars['Boolean'];
  deleteAllAutoImports: Scalars['Boolean'];
  pauseAllAutoImports: Array<AutoImport>;
  activateAllAutoImports: Array<AutoImport>;
  createAutoImport: AutoImport;
  updateAutoImport: AutoImport;
  createImportFolder: ImportFolder;
  updateImportFolder: ImportFolder;
  deleteImportFolder: Scalars['Boolean'];
  createImportSource: ImportSource;
  updateImportSource: ImportSource;
  deleteImportSource: Scalars['Boolean'];
  rssOpmlUpload: RssOpmlUploadResult;
  createPost: Array<Post>;
  bulkUpdatePosts: Array<Post>;
  updatePost: Post;
  deletePost: Scalars['Boolean'];
  bulkDeletePosts: Scalars['Boolean'];
  updatePostOrder: Post;
  startBulkCreatePosts: Scalars['String'];
  joinOrganizationFromInvitation: Organization;
  createUserInvitation: UserInvitation;
  resendUserInvitation: Scalars['Boolean'];
  updateUserInvitation: UserInvitation;
  deleteUserInvitation: Scalars['Boolean'];
  logError: Scalars['Boolean'];
  devAnalyticsCreateFollowers: Scalars['String'];
  devAnalyticsCreatePostStats: Scalars['String'];
  devGenerateQueueContent: Scalars['String'];
  devSocialProfileSetDisconnected: Scalars['String'];
  devSocialProfileSetConnected: Scalars['String'];
  createRandomTimeslots: Scalars['Boolean'];
  devClearThirdPartyPostCache: Scalars['String'];
  devChangeOrganizationPlan: Scalars['String'];
};

export type Mutation_StartSocialOAuthArgs = {
  oAuthProvider: SocialOAuthProvider;
  profileNetwork?: InputMaybe<Network>;
  context: SocialOAuthContext;
};

export type Mutation_LoginWithSocialArgs = {
  socialAuthToken: Scalars['String'];
};

export type Mutation_ShuffleQueueArgs = {
  workspaceId: Scalars['ID'];
  filters: QueueFilterInput;
};

export type Mutation_BulkUpdateQueueMetaArgs = {
  workspaceId: Scalars['ID'];
  input: Array<QueueMetaInput>;
};

export type Mutation_SendPasswordResetEmailArgs = {
  email: Scalars['String'];
};

export type Mutation_ResetPasswordArgs = {
  resetToken: Scalars['String'];
  newPassword: Scalars['String'];
};

export type Mutation_UpdateOrganizationArgs = {
  input: OrganizationInput;
};

export type Mutation_UpdateOrganizationSettingsArgs = {
  organizationId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
  input: CombinedOrganizationSettingsInput;
};

export type Mutation_UpdateUserOrganizationAssignmentArgs = {
  userId: Scalars['ID'];
  organizationId: Scalars['ID'];
  input: UserOrganizationAssignmentInput;
};

export type Mutation_RemoveUserOrganizationAssignmentArgs = {
  userId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type Mutation_ConnectBitlyArgs = {
  workspaceId: Scalars['ID'];
  socialAuthToken: Scalars['String'];
};

export type Mutation_ReconnectBitlyArgs = {
  bitlyId: Scalars['ID'];
  socialAuthToken: Scalars['String'];
};

export type Mutation_RemoveBitlyArgs = {
  bitlyId: Scalars['ID'];
};

export type Mutation_BulkUpdateCustomBitlySettingsArgs = {
  input: Array<UpdateCustomBitlySettingsInput>;
};

export type Mutation_MarkAllNotificationsAsReadArgs = {
  organizationId: Scalars['ID'];
};

export type Mutation_UpdateLastReadSiteNewsArgs = {
  siteNewsId: Scalars['ID'];
};

export type Mutation_MarkNotificationAsReadArgs = {
  notificationId: Scalars['ID'];
};

export type Mutation_BulkMarkNotificationsAsReadArgs = {
  notificationIds: Array<Scalars['ID']>;
};

export type Mutation_RegisterMediaItemUploadArgs = {
  workspaceId: Scalars['ID'];
  input: RegisterMediaInput;
};

export type Mutation_BulkRegisterMediaItemUploadsArgs = {
  workspaceId: Scalars['ID'];
  input: Array<RegisterMediaInput>;
};

export type Mutation_CompleteMediaUploadArgs = {
  workspaceId: Scalars['ID'];
  input: UploadMediaInput;
};

export type Mutation_BulkCompleteMediaUploadsArgs = {
  workspaceId: Scalars['ID'];
  input: Array<UploadMediaInput>;
};

export type Mutation_AddExternalPhotoArgs = {
  workspaceId: Scalars['ID'];
  input: ExternalMediaInput;
};

export type Mutation_BulkAddExternalPhotosArgs = {
  workspaceId: Scalars['ID'];
  input: Array<ExternalMediaInput>;
};

export type Mutation_BulkArchiveMediaArgs = {
  media: Array<MediaSelectionInput>;
};

export type Mutation_CreateWorkspaceArgs = {
  organizationId: Scalars['ID'];
  input: WorkspaceInput;
};

export type Mutation_UpdateWorkspaceArgs = {
  workspaceId: Scalars['ID'];
  input: WorkspaceInput;
};

export type Mutation_DeleteWorkspaceArgs = {
  workspaceId: Scalars['ID'];
};

export type Mutation_UpdateWorkspaceSettingsArgs = {
  workspaceId: Scalars['ID'];
  input: UpdateWorkspaceSettingsInput;
};

export type Mutation_CreateUserWorkspaceAssignmentArgs = {
  userId: Scalars['ID'];
  workspaceId: Scalars['ID'];
};

export type Mutation_RemoveUserWorkspaceAssignmentArgs = {
  userId: Scalars['ID'];
  workspaceId: Scalars['ID'];
};

export type Mutation_UpdateUserSettingsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
  input: UserSettingsInput;
};

export type Mutation_UpdateUserArgs = {
  userId?: InputMaybe<Scalars['ID']>;
  input: UserInput;
};

export type Mutation_CreateCategoryArgs = {
  workspaceId: Scalars['ID'];
  input: CreateCategoryInput;
};

export type Mutation_UpdateCategoryArgs = {
  categoryId: Scalars['ID'];
  input: UpdateCategoryInput;
};

export type Mutation_DeleteCategoryArgs = {
  categoryId: Scalars['ID'];
};

export type Mutation_CreateSnippetArgs = {
  workspaceId: Scalars['ID'];
  input: CreateSnippetInput;
};

export type Mutation_UpdateSnippetArgs = {
  snippetId: Scalars['ID'];
  input: UpdateSnippetInput;
};

export type Mutation_DeleteSnippetArgs = {
  snippetId: Scalars['ID'];
};

export type Mutation_MarkOnboardingStepSeenArgs = {
  input: UserOnboardingStepInput;
};

export type Mutation_ConnectMainSocialProfileArgs = {
  workspaceId: Scalars['ID'];
  socialAuthToken: Scalars['String'];
};

export type Mutation_ReconnectSocialProfileArgs = {
  socialAuthToken: Scalars['String'];
  profileId: Scalars['ID'];
};

export type Mutation_RemoveSocialProfileArgs = {
  socialProfileId: Scalars['ID'];
};

export type Mutation_ConnectSecondarySocialProfilesArgs = {
  workspaceId: Scalars['ID'];
  socialAuthToken: Scalars['String'];
  profiles: Array<SecondaryProfileConnectionInput>;
  profilesNetwork: Network;
};

export type Mutation_UpdateSocialProfileDirectPublishingArgs = {
  socialProfileId: Scalars['ID'];
  enabled: Scalars['Boolean'];
};

export type Mutation_RefreshTikTokSocialProfileSettingsArgs = {
  socialProfileId: Scalars['ID'];
};

export type Mutation_RefreshPinterestBoardsArgs = {
  socialProfileId: Scalars['ID'];
};

export type Mutation_RefreshSocialProfilePhotoUrlArgs = {
  socialProfileId: Scalars['ID'];
};

export type Mutation_RegisterArgs = {
  input: RegistrationInput;
};

export type Mutation_LoginWithEmailArgs = {
  input: LoginWithEmailInput;
};

export type Mutation_InitiateCaptionsArgs = {
  input: AiCaptionInitiateInput;
  organizationId: Scalars['ID'];
};

export type Mutation_StopCaptionsArgs = {
  cacheKey: Scalars['String'];
};

export type Mutation_ShareExternalPostArgs = {
  socialProfileId: Scalars['ID'];
  externalPostId: Scalars['String'];
  shareType: ShareType;
  text?: InputMaybe<Scalars['String']>;
};

export type Mutation_LikeExternalPostArgs = {
  socialProfileId: Scalars['ID'];
  externalPostId: Scalars['String'];
  likeType: LikeType;
  externalPostOwnerId?: InputMaybe<Scalars['String']>;
};

export type Mutation_CommentOnExternalPostArgs = {
  socialProfileId: Scalars['ID'];
  externalPostId: Scalars['String'];
  comment: Scalars['String'];
  externalPostOwnerId?: InputMaybe<Scalars['String']>;
};

export type Mutation_CreateTimeslotArgs = {
  workspaceId: Scalars['ID'];
  input: TimeslotInput;
};

export type Mutation_UpdateTimeslotArgs = {
  timeslotId: Scalars['ID'];
  input: TimeslotInput;
};

export type Mutation_DeleteTimeslotArgs = {
  timeslotId: Scalars['ID'];
};

export type Mutation_BulkDeleteTimeslotsArgs = {
  timeslotIds: Array<Scalars['ID']>;
};

export type Mutation_DeleteAutoImportArgs = {
  autoImportId: Scalars['ID'];
};

export type Mutation_DeleteAllAutoImportsArgs = {
  workspaceId: Scalars['ID'];
};

export type Mutation_PauseAllAutoImportsArgs = {
  workspaceId: Scalars['ID'];
};

export type Mutation_ActivateAllAutoImportsArgs = {
  workspaceId: Scalars['ID'];
};

export type Mutation_CreateAutoImportArgs = {
  workspaceId: Scalars['ID'];
  input: CreateAutoImportInput;
};

export type Mutation_UpdateAutoImportArgs = {
  autoImportId: Scalars['ID'];
  input: UpdateAutoImportInput;
};

export type Mutation_CreateImportFolderArgs = {
  workspaceId: Scalars['ID'];
  input: CreateImportFolderInput;
};

export type Mutation_UpdateImportFolderArgs = {
  importFolderId: Scalars['ID'];
  input: UpdateImportFolderInput;
};

export type Mutation_DeleteImportFolderArgs = {
  importFolderId: Scalars['ID'];
};

export type Mutation_CreateImportSourceArgs = {
  workspaceId: Scalars['ID'];
  input: CreateImportSourceInput;
};

export type Mutation_UpdateImportSourceArgs = {
  importSourceId: Scalars['ID'];
  input: UpdateImportSourceInput;
};

export type Mutation_DeleteImportSourceArgs = {
  importSourceId: Scalars['ID'];
};

export type Mutation_RssOpmlUploadArgs = {
  workspaceId: Scalars['ID'];
  file: Scalars['Upload'];
};

export type Mutation_CreatePostArgs = {
  workspaceId: Scalars['ID'];
  input: PostGroupInput;
};

export type Mutation_BulkUpdatePostsArgs = {
  input: Array<BulkUpdatePostInput>;
};

export type Mutation_UpdatePostArgs = {
  postId: Scalars['ID'];
  input: UpdatePostInput;
};

export type Mutation_DeletePostArgs = {
  postId: Scalars['ID'];
};

export type Mutation_BulkDeletePostsArgs = {
  postIds: Array<Scalars['ID']>;
};

export type Mutation_UpdatePostOrderArgs = {
  postId: Scalars['ID'];
  direction: PostOrderUpdateDirection;
  relativePostId: Scalars['ID'];
};

export type Mutation_StartBulkCreatePostsArgs = {
  workspaceId: Scalars['ID'];
  input: BulkCreatePostsInput;
};

export type Mutation_JoinOrganizationFromInvitationArgs = {
  invitationToken: Scalars['String'];
};

export type Mutation_CreateUserInvitationArgs = {
  organizationId: Scalars['ID'];
  input: UserInvitationInput;
};

export type Mutation_ResendUserInvitationArgs = {
  userInvitationId: Scalars['ID'];
};

export type Mutation_UpdateUserInvitationArgs = {
  userInvitationId: Scalars['ID'];
  input: UserInvitationInput;
};

export type Mutation_DeleteUserInvitationArgs = {
  userInvitationId: Scalars['ID'];
};

export type Mutation_LogErrorArgs = {
  workspaceId: Scalars['ID'];
  message: Scalars['String'];
  url: Scalars['String'];
  stackTrace: Scalars['String'];
  severity: ClientErrorLogSeverity;
};

export type Mutation_DevAnalyticsCreateFollowersArgs = {
  workspaceId: Scalars['ID'];
  socialProfileId?: InputMaybe<Scalars['ID']>;
};

export type Mutation_DevAnalyticsCreatePostStatsArgs = {
  workspaceId: Scalars['ID'];
  minPostsPerDay?: InputMaybe<Scalars['Int']>;
  maxPostsPerDay?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  socialProfileIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Mutation_DevGenerateQueueContentArgs = {
  workspaceId: Scalars['ID'];
};

export type Mutation_DevSocialProfileSetDisconnectedArgs = {
  socialProfileId: Scalars['ID'];
};

export type Mutation_DevSocialProfileSetConnectedArgs = {
  socialProfileId: Scalars['ID'];
};

export type Mutation_CreateRandomTimeslotsArgs = {
  workspaceId: Scalars['ID'];
  numberOfTimeslots: Scalars['Int'];
};

export type Mutation_DevChangeOrganizationPlanArgs = {
  organizationId: Scalars['ID'];
  planName: Scalars['String'];
};

export enum SocialOAuthProvider {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  INSTAGRAM = 'INSTAGRAM',
  LINKEDIN = 'LINKEDIN',
  PINTEREST = 'PINTEREST',
  THREADS = 'THREADS',
  TIKTOK = 'TIKTOK',
  TWITTER = 'TWITTER',
  BITLY = 'BITLY'
}

export enum SocialOAuthContext {
  SIGNUP = 'SIGNUP',
  LOGIN = 'LOGIN',
  CONNECT = 'CONNECT',
  RECONNECT = 'RECONNECT'
}

export type SocialOAuth = {
  __typename?: 'SocialOAuth';
  socialAuthToken: Scalars['String'];
  redirectUrl: Scalars['String'];
};

export type LoginSuccess = {
  __typename?: 'LoginSuccess';
  user: User;
  token: Token;
};

export type Token = {
  __typename?: 'Token';
  token: Scalars['String'];
  expiresIn: Scalars['Int'];
};

export type QueueMetaInput = {
  socialProfileId: Scalars['ID'];
  categoryId: Scalars['ID'];
  paused: Scalars['Boolean'];
};

export type OrganizationInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type CombinedOrganizationSettingsInput = {
  productAnalyticsEnabled?: InputMaybe<Scalars['Boolean']>;
  notifySubscriptionEnabled?: InputMaybe<Scalars['Boolean']>;
  timeFormat?: InputMaybe<TimeFormatSetting>;
  dateFormat?: InputMaybe<DateFormatSetting>;
  startOfWeekFormat?: InputMaybe<StartOfWeekFormatSetting>;
  notifyWeeklyStatsEnabled?: InputMaybe<Scalars['Boolean']>;
  notifyQueueEmptyEnabled?: InputMaybe<Scalars['Boolean']>;
  notifyPostProfileErrorEnabled?: InputMaybe<Scalars['Boolean']>;
  notifyInstagramPostEnabled?: InputMaybe<Scalars['Boolean']>;
  notifyAutoRssEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type CombinedOrganizationSettings = {
  __typename?: 'CombinedOrganizationSettings';
  organizationSettings: OrganizationSettings;
  userOrganizationSettings?: Maybe<UserOrganizationSettings>;
};

export type UserOrganizationAssignmentInput = {
  role?: InputMaybe<UserOrganizationRole>;
};

export type UpdateCustomBitlySettingsInput = {
  socialProfileId?: InputMaybe<Scalars['ID']>;
  bitly?: InputMaybe<CustomBitlySettingsValuesInput>;
};

export type CustomBitlySettingsValuesInput = {
  bitlyId?: InputMaybe<Scalars['ID']>;
  domain: Scalars['String'];
};

export type RegisterMediaInput = {
  suppliedUploadId: Scalars['ID'];
  type: MediaType;
  extension: Scalars['String'];
};

export type UploadInstructions = {
  __typename?: 'UploadInstructions';
  suppliedUploadId: Scalars['ID'];
  registrationKey: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type UploadMediaInput = {
  type: MediaType;
  registrationKey: Scalars['String'];
  originalFilename: Scalars['String'];
  startVideoTranscoding?: Scalars['Boolean'];
};

export type BulkMediaUploadResult = {
  __typename?: 'BulkMediaUploadResult';
  suppliedRegistrationKey: Scalars['String'];
  media?: Maybe<MediaInterface>;
  error?: Maybe<Scalars['String']>;
};

export type ExternalMediaInput = {
  type: MediaType;
  url: Scalars['String'];
  canvaId?: InputMaybe<Scalars['String']>;
};

export type MediaSelectionInput = {
  type: MediaType;
  mediaId: Scalars['ID'];
};

export type WorkspaceInput = {
  name?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<TimezoneSetting>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  userInvitationIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateWorkspaceSettingsInput = {
  evergreenRecycling?: InputMaybe<Scalars['Boolean']>;
  attributionTwitter?: InputMaybe<Scalars['Boolean']>;
  attributionInstagram?: InputMaybe<Scalars['Boolean']>;
  minimumRecycleTime?: InputMaybe<MinimumRecycleTime>;
  multiMediaAttachMode?: InputMaybe<PostMultiMediaAttachMode>;
  defaultQueuePosition?: InputMaybe<PostQueuePosition>;
  fbLinkPreview?: InputMaybe<FbLinkPreview>;
  importMediaBehavior?: InputMaybe<ImportMediaBehavior>;
  campaignTracking?: InputMaybe<Scalars['Boolean']>;
  removeUtm?: InputMaybe<Scalars['Boolean']>;
  utmTracking?: InputMaybe<UtmInput>;
  bitly?: InputMaybe<CustomBitlySettingsValuesInput>;
  pauseQueues?: InputMaybe<Scalars['Boolean']>;
  pauseAutoImports?: InputMaybe<Scalars['Boolean']>;
};

export type UtmInput = {
  source: Scalars['String'];
  medium: Scalars['String'];
  campaign: Scalars['String'];
  term: Scalars['String'];
  content: Scalars['String'];
};

export type UserSettingsInput = {
  onlineMarketing?: InputMaybe<Scalars['Boolean']>;
  notifyProductUpdates?: InputMaybe<Scalars['Boolean']>;
  notifyMailingList?: InputMaybe<Scalars['Boolean']>;
  notifyFeatureAdded?: InputMaybe<Scalars['Boolean']>;
  notifyReferralCredits?: InputMaybe<Scalars['Boolean']>;
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<TimezoneSetting>;
};

export type CreateCategoryInput = {
  name: Scalars['String'];
  color: CategoryColor;
  seasonalStartDate?: InputMaybe<Scalars['String']>;
  seasonalEndDate?: InputMaybe<Scalars['String']>;
  defaultSocialProfileIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateCategoryInput = {
  name?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<CategoryColor>;
  seasonalStartDate?: InputMaybe<Scalars['String']>;
  seasonalEndDate?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  defaultSocialProfileIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateSnippetInput = {
  name: Scalars['String'];
  content: Scalars['String'];
};

export type UpdateSnippetInput = {
  name?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
};

export type UserOnboardingStepInput = {
  name: Scalars['String'];
};

export type SocialProfileConnectionResult = {
  __typename?: 'SocialProfileConnectionResult';
  connected: Scalars['Boolean'];
  reconnected: Scalars['Boolean'];
  socialProfile?: Maybe<SocialProfileInterface>;
  additionalReconnection: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type SecondaryProfileConnectionInput = {
  externalId: Scalars['String'];
  profileType: SecondaryProfileType;
  postAsExternalId?: InputMaybe<Scalars['ID']>;
};

export enum InstagramApiType {
  LEGACY = 'LEGACY',
  BASIC_DISPLAY = 'BASIC_DISPLAY',
  INSTAGRAM_GRAPH = 'INSTAGRAM_GRAPH',
  FACEBOOK_GRAPH = 'FACEBOOK_GRAPH',
  NONE = 'NONE'
}

export enum TikTokPrivacy {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}

export type RegistrationInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<TimezoneSetting>;
  socialAuthToken?: InputMaybe<Scalars['String']>;
  invitationToken?: InputMaybe<Scalars['String']>;
};

export type LoginWithEmailInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AiCaptionInitiateInput = {
  prompt: Scalars['String'];
  variations?: Scalars['Int'];
  networks: Array<Network>;
  language?: Scalars['String'];
  toneOfVoice?: Scalars['String'];
  includeEmojis?: Scalars['Boolean'];
  hashtags?: Scalars['Int'];
};

export type AiCaptionInitiateType = {
  __typename?: 'AiCaptionInitiateType';
  cacheKey: Scalars['String'];
};

export enum ShareType {
  SHARE = 'SHARE',
  UNSHARE = 'UNSHARE'
}

export enum LikeType {
  LIKE = 'LIKE',
  UNLIKE = 'UNLIKE'
}

export type TimeslotInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
  socialProfileIds?: InputMaybe<Array<Scalars['ID']>>;
  day?: InputMaybe<TimeslotDay>;
  time?: InputMaybe<Scalars['String']>;
};

export type CreateAutoImportInput = {
  name: Scalars['String'];
  url: Scalars['String'];
  postTiming: AutoImportPostTiming;
  status: AutoImportStatus;
  refineByTerm?: InputMaybe<Scalars['String']>;
  prefixText?: InputMaybe<Scalars['String']>;
  suffixText?: InputMaybe<Scalars['String']>;
  recycle?: InputMaybe<Scalars['Boolean']>;
  recycleMaxRepeats?: InputMaybe<Scalars['Int']>;
  utmTracking?: InputMaybe<UtmInput>;
  bitlyTracking?: InputMaybe<Scalars['Boolean']>;
  removeLinks?: InputMaybe<Scalars['Boolean']>;
  pinterestBoards?: InputMaybe<Array<SocialProfilePinterestBoardInput>>;
  importOldPosts?: InputMaybe<AutoImportOldPostsInput>;
  categoryId: Scalars['ID'];
  socialProfileIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SocialProfilePinterestBoardInput = {
  socialProfileId: Scalars['ID'];
  pinterestBoardId: Scalars['ID'];
};

export type AutoImportOldPostsInput = {
  timing: AutoImportPostTimingOldPosts;
};

export enum AutoImportPostTimingOldPosts {
  QUEUE_TOP = 'QUEUE_TOP',
  QUEUE_BOTTOM = 'QUEUE_BOTTOM',
  DRAFT = 'DRAFT'
}

export type UpdateAutoImportInput = {
  name?: InputMaybe<Scalars['String']>;
  postTiming?: InputMaybe<AutoImportPostTiming>;
  status?: InputMaybe<AutoImportStatus>;
  refineByTerm?: InputMaybe<Scalars['String']>;
  prefixText?: InputMaybe<Scalars['String']>;
  suffixText?: InputMaybe<Scalars['String']>;
  recycle?: InputMaybe<Scalars['Boolean']>;
  recycleMaxRepeats?: InputMaybe<Scalars['Int']>;
  utmTracking?: InputMaybe<UtmInput>;
  bitlyTracking?: InputMaybe<Scalars['Boolean']>;
  removeLinks?: InputMaybe<Scalars['Boolean']>;
  pinterestBoards?: InputMaybe<Array<SocialProfilePinterestBoardInput>>;
  importOldPosts?: InputMaybe<AutoImportOldPostsInput>;
  categoryId?: InputMaybe<Scalars['ID']>;
  socialProfileIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateImportFolderInput = {
  name: Scalars['String'];
};

export type UpdateImportFolderInput = {
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type CreateImportSourceInput = {
  name: Scalars['String'];
  importFolderId?: InputMaybe<Scalars['ID']>;
  args: ImportSourceArgsGroupInput;
};

export type ImportSourceArgsGroupInput = {
  rss?: InputMaybe<ImportSourceArgsRssInput>;
  facebook?: InputMaybe<ImportSourceArgsFacebookInput>;
  twitter?: InputMaybe<ImportSourceArgsTwitterInput>;
  linkedIn?: InputMaybe<ImportSourceArgsLinkedInInput>;
  pinterest?: InputMaybe<ImportSourceArgsPinterestInput>;
  instagram?: InputMaybe<ImportSourceArgsInstagramInput>;
};

export type ImportSourceArgsRssInput = {
  url: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
};

export type ImportSourceArgsFacebookInput = {
  searchType: FacebookSearchType;
  contentType: FacebookSearchContentType;
  sortType: FacebookSearchSortType;
  externalId?: InputMaybe<Scalars['String']>;
  thirdPartyProfileDisplayName?: InputMaybe<Scalars['String']>;
  socialProfileId?: InputMaybe<Scalars['ID']>;
  term?: InputMaybe<Scalars['String']>;
};

export type ImportSourceArgsTwitterInput = {
  searchType: TwitterSearchType;
  contentType: TwitterSearchContentType;
  sortType: TwitterSearchSortType;
  includeRetweets?: Scalars['Boolean'];
  includeReplies?: Scalars['Boolean'];
  externalId?: InputMaybe<Scalars['String']>;
  thirdPartyProfileDisplayName?: InputMaybe<Scalars['String']>;
  socialProfileId?: InputMaybe<Scalars['ID']>;
  term?: InputMaybe<Scalars['String']>;
};

export type ImportSourceArgsLinkedInInput = {
  searchType: LinkedInSearchType;
  contentType: LinkedInSearchContentType;
  sortType: LinkedInSearchSortType;
  externalId?: InputMaybe<Scalars['String']>;
  thirdPartyProfileDisplayName?: InputMaybe<Scalars['String']>;
  socialProfileId?: InputMaybe<Scalars['ID']>;
  term?: InputMaybe<Scalars['String']>;
};

export type ImportSourceArgsPinterestInput = {
  searchType: PinterestSearchType;
  contentType: PinterestSearchContentType;
  sortType: PinterestSearchSortType;
  boardId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  thirdPartyProfileDisplayName?: InputMaybe<Scalars['String']>;
  socialProfileId?: InputMaybe<Scalars['ID']>;
  term?: InputMaybe<Scalars['String']>;
};

export type ImportSourceArgsInstagramInput = {
  searchType: InstagramSearchType;
  sortType: InstagramSearchSortType;
  externalId?: InputMaybe<Scalars['String']>;
  thirdPartyProfileDisplayName?: InputMaybe<Scalars['String']>;
  socialProfileId?: InputMaybe<Scalars['ID']>;
  term?: InputMaybe<Scalars['String']>;
};

export type UpdateImportSourceInput = {
  name?: InputMaybe<Scalars['String']>;
  importFolderId?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type RssOpmlUploadResult = {
  __typename?: 'RssOpmlUploadResult';
  /**
   *
   *
   *
   */
  errors: Array<Scalars['String']>;
  /**
   *
   *
   *
   */
  importSources: Array<ImportSource>;
  /**
   *
   *
   *
   */
  importFolders: Array<ImportFolder>;
};

export type PostGroupInput = {
  categoryId: Scalars['ID'];
  familyUuid?: InputMaybe<Scalars['String']>;
  posts: Array<CreatePostInput>;
};

export type CreatePostInput = {
  parentId?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<CreateLinkInput>;
  socialProfileId: Scalars['ID'];
  timing: PostTimingInput;
  status: PostInputStatus;
  title?: InputMaybe<Scalars['String']>;
  texts: Array<Scalars['String']>;
  firstComment?: InputMaybe<Scalars['String']>;
  evergreen: Scalars['Boolean'];
  expiry?: InputMaybe<PostExpiryInput>;
  media?: InputMaybe<Array<PostMediaInput>>;
  multiMediaAttachMode?: InputMaybe<PostMultiMediaAttachMode>;
  pinterestBoard?: InputMaybe<Scalars['String']>;
  feedType?: InputMaybe<PostFeedType>;
  instagramPreferredPublishMethod?: InputMaybe<PostPublishMethod>;
  src: PostSource;
  tikTok?: InputMaybe<PostTikTokInput>;
};

export type CreateLinkInput = {
  initialUrl: Scalars['String'];
  bitlyPreference: BitlyPreference;
  utmTracking?: InputMaybe<UtmInput>;
  destination: LinkDestination;
  removePreview?: Scalars['Boolean'];
  googleCallToAction?: InputMaybe<LinkGoogleCallToAction>;
};

export type PostTimingInput = {
  type: PostTiming;
  schedule?: InputMaybe<PostTimingScheduleInput>;
  recurring?: InputMaybe<PostTimingRecurringInput>;
  queue?: InputMaybe<PostTimingQueueInput>;
};

export type PostTimingScheduleInput = {
  localDatetimes: Array<Scalars['DateTime']>;
  /** The timezone for the scheduled post. If left null, will use Workspace default */
  timezone?: InputMaybe<TimezoneSetting>;
};

export type PostTimingRecurringInput = {
  localDatetime: Scalars['DateTime'];
  /** The timezone for the recurring post. If left null, will use Workspace default */
  timezone?: InputMaybe<TimezoneSetting>;
  interval: PostRecurringInterval;
  value: Scalars['Int'];
};

export type PostTimingQueueInput = {
  /**
   *
   * 	   When creating a post, if this is null, it will use the Workspace default.
   * 	   When updating a post, if this is null, it will keep it's current position.
   * 	 *
   */
  queuePosition?: InputMaybe<PostQueuePosition>;
};

export enum PostInputStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  TRASH = 'TRASH'
}

export type PostExpiryInput = {
  /** The local (relative to timezone) date the post will expire after. */
  localDate?: InputMaybe<Scalars['Date']>;
  maxRepeats?: InputMaybe<Scalars['Int']>;
};

export type PostMediaInput = {
  mediaId?: InputMaybe<Scalars['ID']>;
  type: MediaType;
  url?: InputMaybe<Scalars['String']>;
};

export enum PostSource {
  POST_EDITOR = 'POST_EDITOR',
  ADD_ANOTHER = 'ADD_ANOTHER',
  ADD_SIBLING_FROM_EDIT = 'ADD_SIBLING_FROM_EDIT',
  IMPORT_MEDIA = 'IMPORT_MEDIA',
  INSTAGRAM_GRID = 'INSTAGRAM_GRID',
  TN = 'TN',
  QUEUE = 'QUEUE',
  QUEUE_WEEK_SLOT_EMPTY = 'QUEUE_WEEK_SLOT_EMPTY',
  DUPLICATE = 'DUPLICATE',
  RESCHEDULE = 'RESCHEDULE',
  RESCHEDULE_SIBLING_FROM_EDIT = 'RESCHEDULE_SIBLING_FROM_EDIT',
  API = 'API',
  CHROME_EXTENSION = 'CHROME_EXTENSION',
  CSV_BULK = 'CSV_BULK',
  RSS = 'RSS',
  RSS_BULK = 'RSS_BULK',
  FACEBOOK_PAGE = 'FACEBOOK_PAGE',
  FACEBOOK_PAGE_BULK = 'FACEBOOK_PAGE_BULK',
  INSTAGRAM = 'INSTAGRAM',
  INSTAGRAM_BULK = 'INSTAGRAM_BULK',
  LINKEDIN = 'LINKEDIN',
  LINKEDIN_BULK = 'LINKEDIN_BULK',
  PINTEREST_BOARD = 'PINTEREST_BOARD',
  PINTEREST_BOARD_BULK = 'PINTEREST_BOARD_BULK',
  PINTEREST_USER = 'PINTEREST_USER',
  PINTEREST_USER_BULK = 'PINTEREST_USER_BULK',
  EVERGREEN = 'EVERGREEN',
  MULTIPLE_SCHEDULED = 'MULTIPLE_SCHEDULED',
  RECURRING = 'RECURRING',
  AUTO_RSS = 'AUTO_RSS'
}

export type PostTikTokInput = {
  privacy: PostTikTokPrivacy;
  disableComment: Scalars['Boolean'];
  disableDuet: Scalars['Boolean'];
  disableStitch: Scalars['Boolean'];
  brandSelf: Scalars['Boolean'];
  brandOther: Scalars['Boolean'];
  autoAddMusic: Scalars['Boolean'];
};

export type BulkUpdatePostInput = {
  postId: Scalars['ID'];
  postInput?: InputMaybe<UpdatePostInput>;
};

export type UpdatePostInput = {
  categoryId?: InputMaybe<Scalars['ID']>;
  link?: InputMaybe<UpdateLinkInput>;
  timing?: InputMaybe<PostTimingInput>;
  status?: InputMaybe<PostInputStatus>;
  title?: InputMaybe<Scalars['String']>;
  texts?: InputMaybe<Array<Scalars['String']>>;
  firstComment?: InputMaybe<Scalars['String']>;
  evergreen?: InputMaybe<Scalars['Boolean']>;
  expiry?: InputMaybe<PostExpiryInput>;
  media?: InputMaybe<Array<PostMediaInput>>;
  multiMediaAttachMode?: InputMaybe<PostMultiMediaAttachMode>;
  pinterestBoard?: InputMaybe<Scalars['String']>;
  feedType?: InputMaybe<PostFeedType>;
  instagramPreferredPublishMethod?: InputMaybe<PostPublishMethod>;
  tikTok?: InputMaybe<PostTikTokInput>;
};

export type UpdateLinkInput = {
  initialUrl?: InputMaybe<Scalars['String']>;
  bitlyPreference?: InputMaybe<BitlyPreference>;
  utmTracking?: InputMaybe<UtmInput>;
  destination?: InputMaybe<LinkDestination>;
  removePreview?: InputMaybe<Scalars['Boolean']>;
  googleCallToAction?: InputMaybe<LinkGoogleCallToAction>;
};

export enum PostOrderUpdateDirection {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW'
}

export type BulkCreatePostsInput = {
  postGroupInputs: Array<PostGroupInput>;
};

export type UserInvitationInput = {
  email?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserOrganizationRole>;
  workspaceIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ClientErrorLogSeverity {
  ERROR = 'ERROR',
  CRITICAL = 'CRITICAL'
}

export type AndroidApp = MobileApp & {
  __typename?: 'AndroidApp';
  id: Scalars['ID'];
  owner: MobileAppOwnerType;
  connected: Scalars['Boolean'];
  videoCarouselSupported: Scalars['Boolean'];
  deviceType?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  buildNumber: Scalars['Int'];
  firstConnectedTime: Scalars['DateTime'];
  lastConnectedTime: Scalars['DateTime'];
};

export type Test = {
  __typename?: 'Test';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CreditCardType = {
  __typename?: 'CreditCardType';
  brand: Scalars['String'];
  last4Digits: Scalars['String'];
  expiryMonth: Scalars['Int'];
  expiryYear: Scalars['Int'];
};

export type SocialLinkDescription = SocialLinkDescriptionInterface & {
  __typename?: 'SocialLinkDescription';
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type IosApp = MobileApp & {
  __typename?: 'IosApp';
  id: Scalars['ID'];
  owner: MobileAppOwnerType;
  connected: Scalars['Boolean'];
  videoCarouselSupported: Scalars['Boolean'];
  deviceType?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  buildNumber: Scalars['Int'];
  firstConnectedTime: Scalars['DateTime'];
  lastConnectedTime: Scalars['DateTime'];
};

export type ImportSourceArgsRss = ImportSourceArgsInterface & {
  __typename?: 'ImportSourceArgsRss';
  term?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum GenericProfileType {
  BLUESKY = 'BLUESKY',
  FACEBOOK_PERSONAL = 'FACEBOOK_PERSONAL',
  FACEBOOK_GROUP = 'FACEBOOK_GROUP',
  INSTAGRAM_PERSONAL = 'INSTAGRAM_PERSONAL',
  LINKEDIN_GROUP = 'LINKEDIN_GROUP',
  MASTODON = 'MASTODON',
  QUORA = 'QUORA',
  REDDIT = 'REDDIT',
  SNAPCHAT = 'SNAPCHAT',
  TELEGRAM = 'TELEGRAM',
  WHATSAPP = 'WHATSAPP',
  WORDPRESS = 'WORDPRESS',
  OTHER = 'OTHER'
}

export type MobileAppImpl = MobileApp & {
  __typename?: 'MobileAppImpl';
  id: Scalars['ID'];
  owner: MobileAppOwnerType;
  connected: Scalars['Boolean'];
  videoCarouselSupported: Scalars['Boolean'];
  deviceType?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  buildNumber: Scalars['Int'];
  firstConnectedTime: Scalars['DateTime'];
  lastConnectedTime: Scalars['DateTime'];
};

export type ImportSourceArgsTwitter = ImportSourceArgsSocialNetworkInterface &
  ImportSourceArgsInterface & {
    __typename?: 'ImportSourceArgsTwitter';
    term?: Maybe<Scalars['String']>;
    externalId?: Maybe<Scalars['String']>;
    thirdPartyProfileDisplayName?: Maybe<Scalars['String']>;
    socialProfileId?: Maybe<Scalars['Int']>;
    searchType: TwitterSearchType;
    contentType: TwitterSearchContentType;
    sortType: TwitterSearchSortType;
    includeRetweets: Scalars['Boolean'];
    includeReplies: Scalars['Boolean'];
  };

export type ImportSourceArgsSocialNetworkInterface = {
  term?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  thirdPartyProfileDisplayName?: Maybe<Scalars['String']>;
  socialProfileId?: Maybe<Scalars['Int']>;
};

export type ImportSourceArgsLinkedIn = ImportSourceArgsSocialNetworkInterface &
  ImportSourceArgsInterface & {
    __typename?: 'ImportSourceArgsLinkedIn';
    term?: Maybe<Scalars['String']>;
    externalId?: Maybe<Scalars['String']>;
    thirdPartyProfileDisplayName?: Maybe<Scalars['String']>;
    socialProfileId?: Maybe<Scalars['Int']>;
    searchType: LinkedInSearchType;
    contentType: LinkedInSearchContentType;
    sortType: LinkedInSearchSortType;
  };

export type ImportSourceArgsPinterest = ImportSourceArgsSocialNetworkInterface &
  ImportSourceArgsInterface & {
    __typename?: 'ImportSourceArgsPinterest';
    term?: Maybe<Scalars['String']>;
    externalId?: Maybe<Scalars['String']>;
    thirdPartyProfileDisplayName?: Maybe<Scalars['String']>;
    socialProfileId?: Maybe<Scalars['Int']>;
    searchType: PinterestSearchType;
    contentType: PinterestSearchContentType;
    sortType: PinterestSearchSortType;
    boardId?: Maybe<Scalars['String']>;
  };

export type Media = MediaInterface & {
  __typename?: 'Media';
  url: Scalars['String'];
  filesize?: Maybe<Scalars['Int']>;
  thumbnailUrl: Scalars['String'];
  id: Scalars['ID'];
  proportions: MediaProportions;
  origin: MediaOrigin;
  source?: Maybe<Scalars['String']>;
  type: MediaType;
  archived: Scalars['Boolean'];
  workspace: Workspace;
  width: Scalars['Int'];
  height: Scalars['Int'];
  dateUploaded?: Maybe<Scalars['DateTime']>;
};

export type ImportSourceArgsInstagram = ImportSourceArgsSocialNetworkInterface &
  ImportSourceArgsInterface & {
    __typename?: 'ImportSourceArgsInstagram';
    term?: Maybe<Scalars['String']>;
    externalId?: Maybe<Scalars['String']>;
    thirdPartyProfileDisplayName?: Maybe<Scalars['String']>;
    socialProfileId?: Maybe<Scalars['Int']>;
    searchType: InstagramSearchType;
    sortType: InstagramSearchSortType;
  };

export type ImportSourceArgsFacebook = ImportSourceArgsSocialNetworkInterface &
  ImportSourceArgsInterface & {
    __typename?: 'ImportSourceArgsFacebook';
    term?: Maybe<Scalars['String']>;
    externalId?: Maybe<Scalars['String']>;
    thirdPartyProfileDisplayName?: Maybe<Scalars['String']>;
    socialProfileId?: Maybe<Scalars['Int']>;
    searchType: FacebookSearchType;
    contentType: FacebookSearchContentType;
    sortType: FacebookSearchSortType;
  };

export type BillingDetails = {
  __typename?: 'BillingDetails';
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
};

export type ImportSourceArgsSocialNetwork = ImportSourceArgsSocialNetworkInterface &
  ImportSourceArgsInterface & {
    __typename?: 'ImportSourceArgsSocialNetwork';
    term?: Maybe<Scalars['String']>;
    externalId?: Maybe<Scalars['String']>;
    thirdPartyProfileDisplayName?: Maybe<Scalars['String']>;
    socialProfileId?: Maybe<Scalars['Int']>;
  };

export type ImportSourceArgs = ImportSourceArgsInterface & {
  __typename?: 'ImportSourceArgs';
  term?: Maybe<Scalars['String']>;
};

export type AutoImportFieldsFragment = {
  __typename?: 'AutoImport';
  id: string;
  name: string;
  url: string;
  refineByTerm: string;
  postTiming: AutoImportPostTiming;
  status: AutoImportStatus;
  prefixText?: string | null;
  suffixText?: string | null;
  recycle: boolean;
  recycleMaxRepeats: number;
  bitlyTracking: boolean;
  removeLinks: boolean;
  firstImportedPost: any;
  lastImportedPost: any;
  pinterestBoards: Array<{
    __typename?: 'AutoImportPinterestBoard';
    pinterestBoardId: string;
    socialProfileId: string;
  }>;
};

export type CategoryFieldsFragment = {
  __typename?: 'Category';
  id: string;
  name: string;
  color: CategoryColor;
  onboardingContent: boolean;
  defaultSocialProfiles: Array<
    | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    | { __typename?: 'FacebookSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    | { __typename?: 'PinterestSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    | { __typename?: 'LinkedInSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    | { __typename?: 'InstagramSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
  >;
};

export type CoreAiCaptionGenerationFieldsFragment = {
  __typename?: 'AiCaptionGenerationType';
  captions: Array<string>;
  createdAt: any;
  lastUpdated: any;
  status: AiCaptionStatus;
};

export type CoreAiCaptionInitiateTypeFragment = { __typename?: 'AiCaptionInitiateType'; cacheKey: string };

export type CoreAutoImportFieldsFragment = {
  __typename?: 'AutoImport';
  id: string;
  name: string;
  url: string;
  refineByTerm: string;
  postTiming: AutoImportPostTiming;
  status: AutoImportStatus;
  prefixText?: string | null;
  suffixText?: string | null;
  recycle: boolean;
  recycleMaxRepeats: number;
  bitlyTracking: boolean;
  removeLinks: boolean;
  firstImportedPost: any;
  lastImportedPost: any;
};

export type CoreBillingAddressDetailsFieldsFragment = {
  __typename?: 'InvoiceBillingAddressDetailsType';
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
};

export type CoreBitlyFieldsFragment = {
  __typename?: 'Bitly';
  id: string;
  displayName: string;
  connected: boolean;
  domains: Array<string>;
};

export type CoreBusinessAddressDetailsFieldsFragment = {
  __typename?: 'InvoiceBusinessAddressDetailsType';
  companyName: string;
  address1: string;
  address2?: string | null;
  city: string;
  region: string;
  postCode: string;
  countryCode: string;
};

export type CoreCategoryFieldsFragment = {
  __typename?: 'Category';
  id: string;
  name: string;
  color: CategoryColor;
  seasonal: boolean;
  seasonalStartDate?: string | null;
  seasonalEndDate?: string | null;
  seasonallyPaused: boolean;
  archived: boolean;
  archivedDate?: any | null;
};

export type CoreCreditCardFieldsFragment = {
  __typename?: 'BraintreeCreditCardType';
  type: string;
  last4Digits: string;
  expiryMonth: number;
  expiryYear: number;
  countryCode: string;
};

export type CoreCursorPaginationFragment = {
  __typename?: 'QueueItemsCursorPagination';
  cursor?: string | null;
  count: number;
  items: Array<{
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  }>;
};

export type CoreCustomBitlyFieldsFragment = { __typename?: 'CustomBitly'; id: string; domain?: string | null };

export type CoreDateRangePaginationFragment = {
  __typename?: 'QueueItemsDateRangePagination';
  count: number;
  startDate?: any | null;
  endDate?: any | null;
  items: Array<{
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  }>;
};

export type CoreDefaultProfilesFields_SocialProfile_Fragment = {
  __typename?: 'SocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFields_TikTokSocialProfile_Fragment = {
  __typename?: 'TikTokSocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFields_TwitterSocialProfile_Fragment = {
  __typename?: 'TwitterSocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFields_FacebookSocialProfile_Fragment = {
  __typename?: 'FacebookSocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFields_GoogleSocialProfile_Fragment = {
  __typename?: 'GoogleSocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFields_PinterestSocialProfile_Fragment = {
  __typename?: 'PinterestSocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFields_LinkedInSocialProfile_Fragment = {
  __typename?: 'LinkedInSocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFields_InstagramSocialProfile_Fragment = {
  __typename?: 'InstagramSocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFields_GenericSocialProfile_Fragment = {
  __typename?: 'GenericSocialProfile';
  id: string;
  displayName: string;
  photoUrl: string;
  connected: boolean;
};

export type CoreDefaultProfilesFieldsFragment =
  | CoreDefaultProfilesFields_SocialProfile_Fragment
  | CoreDefaultProfilesFields_TikTokSocialProfile_Fragment
  | CoreDefaultProfilesFields_TwitterSocialProfile_Fragment
  | CoreDefaultProfilesFields_FacebookSocialProfile_Fragment
  | CoreDefaultProfilesFields_GoogleSocialProfile_Fragment
  | CoreDefaultProfilesFields_PinterestSocialProfile_Fragment
  | CoreDefaultProfilesFields_LinkedInSocialProfile_Fragment
  | CoreDefaultProfilesFields_InstagramSocialProfile_Fragment
  | CoreDefaultProfilesFields_GenericSocialProfile_Fragment;

export type CoreImportFolderFieldsFragment = {
  __typename?: 'ImportFolder';
  id: string;
  name?: string | null;
  order: number;
};

export type CoreImportSourceFieldsFragment = {
  __typename?: 'ImportSource';
  id: string;
  type: ImportSourceType;
  name?: string | null;
  order: number;
};

export type CoreImportSourceFacebookArgFieldsFragment = {
  __typename?: 'ImportSourceArgsFacebook';
  socialProfileId?: number | null;
  externalId?: string | null;
  facebookSearchType: FacebookSearchType;
  facebookContentType: FacebookSearchContentType;
  facebookSortType: FacebookSearchSortType;
};

export type CoreImportSourceInstagramArgFieldsFragment = {
  __typename?: 'ImportSourceArgsInstagram';
  socialProfileId?: number | null;
  externalId?: string | null;
  instagramSearchType: InstagramSearchType;
  instagramSortType: InstagramSearchSortType;
};

export type CoreImportSourceLinkedInArgFieldsFragment = {
  __typename?: 'ImportSourceArgsLinkedIn';
  socialProfileId?: number | null;
  externalId?: string | null;
  linkedInSearchType: LinkedInSearchType;
  linkedInContentType: LinkedInSearchContentType;
  linkedInSortType: LinkedInSearchSortType;
};

export type CoreImportSourcePinterestArgFieldsFragment = {
  __typename?: 'ImportSourceArgsPinterest';
  socialProfileId?: number | null;
  externalId?: string | null;
  boardId?: string | null;
  pinterestSearchType: PinterestSearchType;
  pinterestContentType: PinterestSearchContentType;
  pinterestSortType: PinterestSearchSortType;
};

export type CoreImportSourceTwitterArgFieldsFragment = {
  __typename?: 'ImportSourceArgsTwitter';
  socialProfileId?: number | null;
  externalId?: string | null;
  includeReplies: boolean;
  includeRetweets: boolean;
  thirdPartyProfileDisplayName?: string | null;
  twitterSearchType: TwitterSearchType;
  twitterContentType: TwitterSearchContentType;
  twitterSortType: TwitterSearchSortType;
};

export type CoreInvoiceFieldsFragment = {
  __typename?: 'Invoice';
  id: string;
  status?: InvoiceStatus | null;
  failureMessage?: string | null;
  planAmount: string;
  planType: PlanType;
  accountNumber: string;
  invoiceNumber: string;
  date: any;
  billingPeriodStartDate: any;
  billingPeriodEndDate: any;
  amount: string;
  amountGbp: string;
  addonsAmount: string;
  discountAmount: string;
  discountPercentage?: string | null;
  discountType?: string | null;
  currencyCode: CurrencyCode;
  paypalEmail?: string | null;
  type: InvoiceTransactionType;
  paymentMethod: InvoicePaymentMethod;
  renewalType: InvoiceRenewalType;
  vatAmount?: string | null;
  preVatAmount: string;
  vatReverseCharge: boolean;
};

export type CoreLinkFieldsFragment = {
  __typename?: 'Link';
  id: string;
  caption?: string | null;
  url: string;
  initialUrl: string;
  expandedUrl: string;
  bitlyDestinationUrl?: string | null;
  urlBitlink: boolean;
  initialUrlBitlink: boolean;
  destination: LinkDestination;
  clickTracking: LinkClickTracking;
  previewRemoved: boolean;
  googleCallToAction: LinkGoogleCallToAction;
  bitlyPreference: BitlyPreference;
};

export type CoreLinkMetadataFieldsFragment = {
  __typename?: 'LinkMetadata';
  error?: string | null;
  initialUrl: string;
  expandedUrl: string;
  domain: string;
  images: Array<string>;
  isBitlink: boolean;
};

export type CoreMediaLibraryItemFields_Photo_Fragment = {
  __typename?: 'Photo';
  id: string;
  dateUploaded?: any | null;
  type: MediaType;
  archived: boolean;
  origin: MediaOrigin;
  proportions: MediaProportions;
  width: number;
  height: number;
  url: string;
  thumbnailUrl: string;
  source?: string | null;
  filesize?: number | null;
};

export type CoreMediaLibraryItemFields_Video_Fragment = {
  __typename?: 'Video';
  id: string;
  dateUploaded?: any | null;
  type: MediaType;
  archived: boolean;
  origin: MediaOrigin;
  proportions: MediaProportions;
  width: number;
  height: number;
  url: string;
  thumbnailUrl: string;
  source?: string | null;
  filesize?: number | null;
};

export type CoreMediaLibraryItemFields_Media_Fragment = {
  __typename?: 'Media';
  id: string;
  dateUploaded?: any | null;
  type: MediaType;
  archived: boolean;
  origin: MediaOrigin;
  proportions: MediaProportions;
  width: number;
  height: number;
  url: string;
  thumbnailUrl: string;
  source?: string | null;
  filesize?: number | null;
};

export type CoreMediaLibraryItemFieldsFragment =
  | CoreMediaLibraryItemFields_Photo_Fragment
  | CoreMediaLibraryItemFields_Video_Fragment
  | CoreMediaLibraryItemFields_Media_Fragment;

export type CoreMediaLibraryPhotoFieldsFragment = {
  __typename?: 'Photo';
  filename?: string | null;
  gif: boolean;
  filesize?: number | null;
};

export type CoreMediaLibraryVideoFieldsFragment = {
  __typename?: 'Video';
  dateUploaded?: any | null;
  transcoded: boolean;
  length?: number | null;
  filesize?: number | null;
};

export type CoreOnboardingFieldsFragment = {
  __typename?: 'UserOnboardingType';
  version: number;
  completed: boolean;
  stepsSeen: Array<{ __typename?: 'UserOnboardingStep'; name: string }>;
};

export type CoreOpenGraphFieldsFragment = {
  __typename?: 'OpenGraph';
  image?: string | null;
  title?: string | null;
  description?: string | null;
};

export type CorePhotoFieldsFragment = {
  __typename?: 'Photo';
  id: string;
  width: number;
  height: number;
  url: string;
  proportions: MediaProportions;
  filesize?: number | null;
  filename?: string | null;
  type: MediaType;
  thumbnailUrl: string;
  gif: boolean;
};

export type CorePinterestBoardFieldsFragment = {
  __typename?: 'PinterestBoard';
  externalId: string;
  name: string;
  photoUrl?: string | null;
};

export type CorePostFieldsFragment = {
  __typename?: 'Post';
  calculatedLocalDateTime?: any | null;
  calculatedUtcDatetime?: any | null;
  dateAdded?: any | null;
  dateFailed?: any | null;
  datePosted?: any | null;
  delayedUtcOriginalDatetime?: any | null;
  draftQueuePosition?: PostQueuePosition | null;
  expiryLocalDate?: any | null;
  failedMessage?: string | null;
  familyUuid?: string | null;
  feedType: PostFeedType;
  firstComment?: string | null;
  id: string;
  isEvergreen?: boolean | null;
  maxRepeats?: number | null;
  onboardingContent: boolean;
  order?: number | null;
  parentId?: string | null;
  pinterestBoardId?: string | null;
  prevPostedCount?: number | null;
  publishedUrl?: string | null;
  publishMethod: PostPublishMethod;
  actualPublishMethod?: PostPublishMethod | null;
  recurringInterval?: PostRecurringInterval | null;
  recurringValue?: number | null;
  futureScheduledLocalDateTimes: Array<any>;
  publishedUtcDateTimes: Array<any>;
  scheduledTimezone?: TimezoneSetting | null;
  siblingId: string;
  status: PostStatus;
  texts: Array<string>;
  timing: PostTiming;
  title?: string | null;
};

export type CorePostPublishedStatFieldsFragment = {
  __typename?: 'PostPublishedStats';
  clicks?: number | null;
  likes?: number | null;
  shares?: number | null;
  comments?: number | null;
  impressions?: number | null;
  videoViews?: number | null;
  saves?: number | null;
  boost?: number | null;
};

export type CoreSnippetFieldsFragment = {
  __typename?: 'Snippet';
  id: string;
  name?: string | null;
  content?: string | null;
};

export type CoreSocialProfileFields_SocialProfile_Fragment = {
  __typename?: 'SocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type CoreSocialProfileFields_TikTokSocialProfile_Fragment = {
  __typename?: 'TikTokSocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type CoreSocialProfileFields_TwitterSocialProfile_Fragment = {
  __typename?: 'TwitterSocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type CoreSocialProfileFields_FacebookSocialProfile_Fragment = {
  __typename?: 'FacebookSocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type CoreSocialProfileFields_GoogleSocialProfile_Fragment = {
  __typename?: 'GoogleSocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type CoreSocialProfileFields_PinterestSocialProfile_Fragment = {
  __typename?: 'PinterestSocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type CoreSocialProfileFields_LinkedInSocialProfile_Fragment = {
  __typename?: 'LinkedInSocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type CoreSocialProfileFields_InstagramSocialProfile_Fragment = {
  __typename?: 'InstagramSocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type CoreSocialProfileFields_GenericSocialProfile_Fragment = {
  __typename?: 'GenericSocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched: boolean;
};

export type CoreSocialProfileFieldsFragment =
  | CoreSocialProfileFields_SocialProfile_Fragment
  | CoreSocialProfileFields_TikTokSocialProfile_Fragment
  | CoreSocialProfileFields_TwitterSocialProfile_Fragment
  | CoreSocialProfileFields_FacebookSocialProfile_Fragment
  | CoreSocialProfileFields_GoogleSocialProfile_Fragment
  | CoreSocialProfileFields_PinterestSocialProfile_Fragment
  | CoreSocialProfileFields_LinkedInSocialProfile_Fragment
  | CoreSocialProfileFields_InstagramSocialProfile_Fragment
  | CoreSocialProfileFields_GenericSocialProfile_Fragment;

export type CoreStepsSeenFieldsFragment = { __typename?: 'UserOnboardingStep'; name: string };

export type CoreTikTokProfileFieldsFragment = {
  __typename?: 'TikTokSocialProfile';
  tikTokId: string;
  privacy: TikTokPrivacy;
  commentDisabled: boolean;
  duetDisabled: boolean;
  stitchDisabled: boolean;
  maxVideoDuration: number;
};

export type CoreThirdPartySearchFieldsFragment = {
  __typename?: 'ThirdPartyMediaItem';
  mediaType: MediaType;
  url: string;
  previewUrl: string;
  proportions: MediaProportions;
  gif: boolean;
  createdBy?: string | null;
  createdByUsername?: string | null;
};

export type CoreTimeslotFieldsFragment = {
  __typename?: 'Timeslot';
  id: string;
  day: TimeslotDay;
  time: string;
  onboardingContent: boolean;
};

export type CoreTokenFieldsFragment = { __typename?: 'Token'; token: string; expiresIn: number };

export type CoreTwitterCardFieldsFragment = {
  __typename?: 'TwitterCard';
  image?: string | null;
  title?: string | null;
  description?: string | null;
  card?: LinkTwitterCard | null;
};

export type CoreUtmFieldsFragment = {
  __typename?: 'UTM';
  campaign: string;
  content: string;
  medium: string;
  source: string;
  term: string;
};

export type CoreVideoFieldsFragment = {
  __typename?: 'Video';
  id: string;
  width: number;
  height: number;
  proportions: MediaProportions;
  url: string;
  source?: string | null;
  transcoded: boolean;
  length?: number | null;
  thumbnailUrl: string;
  type: MediaType;
  filesize?: number | null;
};

export type CoreVatBusinessDetailFieldsFragment = {
  __typename?: 'InvoiceVatBusinessDetailsType';
  numberCountryCode: string;
  number: string;
  rateCharged: string;
  countryChargedCode: string;
  countryChargedDisplayName: string;
};

export type CurrentVariationFieldsFragment = {
  __typename?: 'PostCurrentVariation';
  text?: string | null;
  media: Array<
    | {
        __typename?: 'Photo';
        id: string;
        dateUploaded?: any | null;
        type: MediaType;
        archived: boolean;
        origin: MediaOrigin;
        proportions: MediaProportions;
        width: number;
        height: number;
        url: string;
        thumbnailUrl: string;
        source?: string | null;
        filesize?: number | null;
      }
    | {
        __typename?: 'Video';
        id: string;
        dateUploaded?: any | null;
        type: MediaType;
        archived: boolean;
        origin: MediaOrigin;
        proportions: MediaProportions;
        width: number;
        height: number;
        url: string;
        thumbnailUrl: string;
        source?: string | null;
        filesize?: number | null;
      }
    | {
        __typename?: 'Media';
        id: string;
        dateUploaded?: any | null;
        type: MediaType;
        archived: boolean;
        origin: MediaOrigin;
        proportions: MediaProportions;
        width: number;
        height: number;
        url: string;
        thumbnailUrl: string;
        source?: string | null;
        filesize?: number | null;
      }
  >;
};

export type ExternalRssPostFieldsFragment = {
  __typename?: 'ExternalRssPost';
  createdAt?: any | null;
  content: string;
  postUrl?: string | null;
  imageUrl?: string | null;
};

export type ImportSourceFieldsFragment = {
  __typename?: 'ImportSource';
  id: string;
  type: ImportSourceType;
  name?: string | null;
  order: number;
  args:
    | { __typename?: 'ImportSourceArgsRss'; url?: string | null; term?: string | null }
    | {
        __typename: 'ImportSourceArgsTwitter';
        term?: string | null;
        socialProfileId?: number | null;
        externalId?: string | null;
        includeReplies: boolean;
        includeRetweets: boolean;
        thirdPartyProfileDisplayName?: string | null;
        twitterSearchType: TwitterSearchType;
        twitterContentType: TwitterSearchContentType;
        twitterSortType: TwitterSearchSortType;
      }
    | {
        __typename?: 'ImportSourceArgsLinkedIn';
        term?: string | null;
        socialProfileId?: number | null;
        externalId?: string | null;
        linkedInSearchType: LinkedInSearchType;
        linkedInContentType: LinkedInSearchContentType;
        linkedInSortType: LinkedInSearchSortType;
      }
    | {
        __typename?: 'ImportSourceArgsPinterest';
        term?: string | null;
        socialProfileId?: number | null;
        externalId?: string | null;
        boardId?: string | null;
        pinterestSearchType: PinterestSearchType;
        pinterestContentType: PinterestSearchContentType;
        pinterestSortType: PinterestSearchSortType;
      }
    | {
        __typename?: 'ImportSourceArgsInstagram';
        term?: string | null;
        socialProfileId?: number | null;
        externalId?: string | null;
        instagramSearchType: InstagramSearchType;
        instagramSortType: InstagramSearchSortType;
      }
    | {
        __typename?: 'ImportSourceArgsFacebook';
        term?: string | null;
        socialProfileId?: number | null;
        externalId?: string | null;
        facebookSearchType: FacebookSearchType;
        facebookContentType: FacebookSearchContentType;
        facebookSortType: FacebookSearchSortType;
      }
    | { __typename?: 'ImportSourceArgsSocialNetwork'; term?: string | null }
    | { __typename?: 'ImportSourceArgs'; term?: string | null };
  folder?: { __typename?: 'ImportFolder'; id: string } | null;
};

export type IterationsAggregationFieldsFragment = {
  __typename?: 'PostIterationAggregations';
  id: string;
  sumClicks: number;
  sumLikes: number;
  sumShares: number;
  sumImpressions: number;
  sumComments: number;
  sumVideoViews: number;
  maxClicks: number;
  maxLikes: number;
  maxShares: number;
  maxImpressions: number;
  maxComments: number;
  maxVideoViews: number;
  boost: number;
  countTimesPosted: number;
  actualPublishMethods?: Array<PostPublishMethod> | null;
  oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
  newestPost?: { __typename?: 'Post'; id: string } | null;
};

export type LinkFieldsFragment = {
  __typename?: 'Link';
  id: string;
  caption?: string | null;
  url: string;
  initialUrl: string;
  expandedUrl: string;
  bitlyDestinationUrl?: string | null;
  urlBitlink: boolean;
  initialUrlBitlink: boolean;
  destination: LinkDestination;
  clickTracking: LinkClickTracking;
  previewRemoved: boolean;
  googleCallToAction: LinkGoogleCallToAction;
  bitlyPreference: BitlyPreference;
  utm?: { __typename?: 'UTM'; campaign: string; content: string; medium: string; source: string; term: string } | null;
  openGraph?: {
    __typename?: 'OpenGraph';
    image?: string | null;
    title?: string | null;
    description?: string | null;
  } | null;
  twitterCard?: {
    __typename?: 'TwitterCard';
    image?: string | null;
    title?: string | null;
    description?: string | null;
    card?: LinkTwitterCard | null;
  } | null;
};

export type LinkMetadataFieldsFragment = {
  __typename?: 'LinkMetadata';
  error?: string | null;
  initialUrl: string;
  expandedUrl: string;
  domain: string;
  images: Array<string>;
  isBitlink: boolean;
  openGraph?: {
    __typename?: 'OpenGraph';
    image?: string | null;
    title?: string | null;
    description?: string | null;
  } | null;
  twitterCard?: {
    __typename?: 'TwitterCard';
    image?: string | null;
    title?: string | null;
    description?: string | null;
    card?: LinkTwitterCard | null;
  } | null;
};

export type MobileAppFields_AndroidApp_Fragment = {
  __typename?: 'AndroidApp';
  id: string;
  connected: boolean;
  deviceName?: string | null;
  deviceType?: string | null;
  firstConnectedTime: any;
  lastConnectedTime: any;
  owner: { __typename?: 'MobileAppOwnerType'; id: string; firstName: string };
};

export type MobileAppFields_IosApp_Fragment = {
  __typename?: 'IosApp';
  id: string;
  connected: boolean;
  deviceName?: string | null;
  deviceType?: string | null;
  firstConnectedTime: any;
  lastConnectedTime: any;
  owner: { __typename?: 'MobileAppOwnerType'; id: string; firstName: string };
};

export type MobileAppFields_MobileAppImpl_Fragment = {
  __typename?: 'MobileAppImpl';
  id: string;
  connected: boolean;
  deviceName?: string | null;
  deviceType?: string | null;
  firstConnectedTime: any;
  lastConnectedTime: any;
  owner: { __typename?: 'MobileAppOwnerType'; id: string; firstName: string };
};

export type MobileAppFieldsFragment =
  | MobileAppFields_AndroidApp_Fragment
  | MobileAppFields_IosApp_Fragment
  | MobileAppFields_MobileAppImpl_Fragment;

export type PostItemFragment = {
  __typename?: 'Post';
  calculatedLocalDateTime?: any | null;
  calculatedUtcDatetime?: any | null;
  dateAdded?: any | null;
  dateFailed?: any | null;
  datePosted?: any | null;
  delayedUtcOriginalDatetime?: any | null;
  draftQueuePosition?: PostQueuePosition | null;
  expiryLocalDate?: any | null;
  failedMessage?: string | null;
  familyUuid?: string | null;
  feedType: PostFeedType;
  firstComment?: string | null;
  id: string;
  isEvergreen?: boolean | null;
  maxRepeats?: number | null;
  onboardingContent: boolean;
  order?: number | null;
  parentId?: string | null;
  pinterestBoardId?: string | null;
  prevPostedCount?: number | null;
  publishedUrl?: string | null;
  publishMethod: PostPublishMethod;
  actualPublishMethod?: PostPublishMethod | null;
  recurringInterval?: PostRecurringInterval | null;
  recurringValue?: number | null;
  futureScheduledLocalDateTimes: Array<any>;
  publishedUtcDateTimes: Array<any>;
  scheduledTimezone?: TimezoneSetting | null;
  siblingId: string;
  status: PostStatus;
  texts: Array<string>;
  timing: PostTiming;
  title?: string | null;
  category: {
    __typename?: 'Category';
    id: string;
    name: string;
    color: CategoryColor;
    seasonal: boolean;
    seasonalStartDate?: string | null;
    seasonalEndDate?: string | null;
    seasonallyPaused: boolean;
    archived: boolean;
    archivedDate?: any | null;
  };
  iterationAggregations?: {
    __typename?: 'PostIterationAggregations';
    id: string;
    sumClicks: number;
    sumLikes: number;
    sumShares: number;
    sumImpressions: number;
    sumComments: number;
    sumVideoViews: number;
    maxClicks: number;
    maxLikes: number;
    maxShares: number;
    maxImpressions: number;
    maxComments: number;
    maxVideoViews: number;
    boost: number;
    countTimesPosted: number;
    actualPublishMethods?: Array<PostPublishMethod> | null;
    oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
    newestPost?: { __typename?: 'Post'; id: string } | null;
  } | null;
  link?: {
    __typename?: 'Link';
    id: string;
    caption?: string | null;
    url: string;
    initialUrl: string;
    expandedUrl: string;
    bitlyDestinationUrl?: string | null;
    urlBitlink: boolean;
    initialUrlBitlink: boolean;
    destination: LinkDestination;
    clickTracking: LinkClickTracking;
    previewRemoved: boolean;
    googleCallToAction: LinkGoogleCallToAction;
    bitlyPreference: BitlyPreference;
    utm?: {
      __typename?: 'UTM';
      campaign: string;
      content: string;
      medium: string;
      source: string;
      term: string;
    } | null;
    openGraph?: {
      __typename?: 'OpenGraph';
      image?: string | null;
      title?: string | null;
      description?: string | null;
    } | null;
    twitterCard?: {
      __typename?: 'TwitterCard';
      image?: string | null;
      title?: string | null;
      description?: string | null;
      card?: LinkTwitterCard | null;
    } | null;
  } | null;
  mentions: Array<{
    __typename?: 'ThirdPartyProfile';
    photoUrl?: string | null;
    displayName: string;
    username: string;
    externalId?: string | null;
    platform?: string | null;
    profileUrl?: string | null;
  }>;
  photos: Array<{
    __typename?: 'Photo';
    id: string;
    width: number;
    height: number;
    url: string;
    proportions: MediaProportions;
    filesize?: number | null;
    filename?: string | null;
    type: MediaType;
    thumbnailUrl: string;
    gif: boolean;
  }>;
  publishedStats?: {
    __typename?: 'PostPublishedStats';
    clicks?: number | null;
    likes?: number | null;
    shares?: number | null;
    comments?: number | null;
    impressions?: number | null;
    videoViews?: number | null;
    saves?: number | null;
    boost?: number | null;
  } | null;
  socialProfile:
    | {
        __typename?: 'SocialProfile';
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched?: boolean | null;
      }
    | {
        __typename?: 'TikTokSocialProfile';
        tikTokId: string;
        privacy: TikTokPrivacy;
        commentDisabled: boolean;
        duetDisabled: boolean;
        stitchDisabled: boolean;
        maxVideoDuration: number;
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched?: boolean | null;
      }
    | {
        __typename?: 'TwitterSocialProfile';
        twitterId: string;
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched?: boolean | null;
      }
    | {
        __typename?: 'FacebookSocialProfile';
        type: string;
        facebookId: string;
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched?: boolean | null;
        postAs?: { __typename?: 'SocialProfileTokenOwner'; displayName: string; id: string; externalId: string } | null;
      }
    | {
        __typename?: 'GoogleSocialProfile';
        googleId: string;
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched?: boolean | null;
      }
    | {
        __typename?: 'PinterestSocialProfile';
        pinterestId: string;
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched?: boolean | null;
        boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
      }
    | {
        __typename?: 'LinkedInSocialProfile';
        type: string;
        linkedInId: string;
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched?: boolean | null;
      }
    | {
        __typename?: 'InstagramSocialProfile';
        directPublishEnabled: boolean;
        type: string;
        apiType: InstagramApiType;
        instagramId?: string | null;
        username: string;
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched?: boolean | null;
      }
    | {
        __typename?: 'GenericSocialProfile';
        network: Network;
        username: string;
        colour: string;
        platformName: string;
        id: string;
        connected: boolean;
        displayName: string;
        photoUrl: string;
        onboardingContent: boolean;
        photoUrlFetched: boolean;
        genericProfile: GenericProfileType;
      };
  tikTok?: {
    __typename?: 'PostTikTok';
    privacy?: PostTikTokPrivacy | null;
    disableComment?: boolean | null;
    disableDuet?: boolean | null;
    disableStitch?: boolean | null;
    brandSelf?: boolean | null;
    brandOther?: boolean | null;
    autoAddMusic?: boolean | null;
  } | null;
  variationMeta?: {
    __typename?: 'PostVariationMeta';
    total: number;
    currentIndex: number;
    hasMultiple: boolean;
    multiMediaAttachMode: PostMultiMediaAttachMode;
    currentVariation: {
      __typename?: 'PostCurrentVariation';
      text?: string | null;
      media: Array<
        | {
            __typename?: 'Photo';
            id: string;
            dateUploaded?: any | null;
            type: MediaType;
            archived: boolean;
            origin: MediaOrigin;
            proportions: MediaProportions;
            width: number;
            height: number;
            url: string;
            thumbnailUrl: string;
            source?: string | null;
            filesize?: number | null;
          }
        | {
            __typename?: 'Video';
            id: string;
            dateUploaded?: any | null;
            type: MediaType;
            archived: boolean;
            origin: MediaOrigin;
            proportions: MediaProportions;
            width: number;
            height: number;
            url: string;
            thumbnailUrl: string;
            source?: string | null;
            filesize?: number | null;
          }
        | {
            __typename?: 'Media';
            id: string;
            dateUploaded?: any | null;
            type: MediaType;
            archived: boolean;
            origin: MediaOrigin;
            proportions: MediaProportions;
            width: number;
            height: number;
            url: string;
            thumbnailUrl: string;
            source?: string | null;
            filesize?: number | null;
          }
      >;
    };
  } | null;
  videos: Array<{
    __typename?: 'Video';
    id: string;
    width: number;
    height: number;
    proportions: MediaProportions;
    url: string;
    source?: string | null;
    transcoded: boolean;
    length?: number | null;
    thumbnailUrl: string;
    type: MediaType;
    filesize?: number | null;
  }>;
};

export type PostTikTokFieldsFragment = {
  __typename?: 'PostTikTok';
  privacy?: PostTikTokPrivacy | null;
  disableComment?: boolean | null;
  disableDuet?: boolean | null;
  disableStitch?: boolean | null;
  brandSelf?: boolean | null;
  brandOther?: boolean | null;
  autoAddMusic?: boolean | null;
};

export type QueueCountsFieldsFragment = {
  __typename?: 'PostQueueCountResult';
  categories: Array<{ __typename?: 'PostQueueCountCategory'; categoryId: number; count: number }>;
  socialProfiles: Array<{ __typename?: 'PostQueueCountSocialProfile'; socialProfileId: number; count: number }>;
  status: {
    __typename?: 'PostQueueCountStatus';
    scheduled: number;
    past: number;
    failed: number;
    paused: number;
    draft: number;
    unqueued: number;
    deleted: number;
  };
  content: {
    __typename?: 'PostQueueCountContent';
    image: number;
    imageLink: number;
    link: number;
    text: number;
    video: number;
    videoLink: number;
  };
  timing: { __typename?: 'PostQueueCountTiming'; setDates: number; recurring: number; queued: number };
  evergreen: { __typename?: 'PostQueueCountEvergreen'; evergreenOnly: number };
  source: {
    __typename?: 'PostQueueCountSource';
    autoRss: number;
    csvUpload: number;
    postEditor: number;
    socialImport: number;
  };
};

export type QueueMetaFieldsFragment = {
  __typename?: 'QueueMetadata';
  paused: boolean;
  socialProfile:
    | { __typename?: 'SocialProfile'; id: string }
    | { __typename?: 'TikTokSocialProfile'; id: string }
    | { __typename?: 'TwitterSocialProfile'; id: string }
    | { __typename?: 'FacebookSocialProfile'; id: string }
    | { __typename?: 'GoogleSocialProfile'; id: string }
    | { __typename?: 'PinterestSocialProfile'; id: string }
    | { __typename?: 'LinkedInSocialProfile'; id: string }
    | { __typename?: 'InstagramSocialProfile'; id: string }
    | { __typename?: 'GenericSocialProfile'; id: string };
  category: { __typename?: 'Category'; id: string };
};

export type SocialAuthTokenFieldsFragment = {
  __typename?: 'SocialAuthToken';
  network: Network;
  externalId: string;
  email?: string | null;
  firstName?: string | null;
  displayName: string;
  photoUrl: string;
};

export type SocialProfileFields_SocialProfile_Fragment = {
  __typename?: 'SocialProfile';
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type SocialProfileFields_TikTokSocialProfile_Fragment = {
  __typename?: 'TikTokSocialProfile';
  tikTokId: string;
  privacy: TikTokPrivacy;
  commentDisabled: boolean;
  duetDisabled: boolean;
  stitchDisabled: boolean;
  maxVideoDuration: number;
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type SocialProfileFields_TwitterSocialProfile_Fragment = {
  __typename?: 'TwitterSocialProfile';
  twitterId: string;
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type SocialProfileFields_FacebookSocialProfile_Fragment = {
  __typename?: 'FacebookSocialProfile';
  type: string;
  facebookId: string;
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
  postAs?: { __typename?: 'SocialProfileTokenOwner'; displayName: string; id: string; externalId: string } | null;
};

export type SocialProfileFields_GoogleSocialProfile_Fragment = {
  __typename?: 'GoogleSocialProfile';
  googleId: string;
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type SocialProfileFields_PinterestSocialProfile_Fragment = {
  __typename?: 'PinterestSocialProfile';
  pinterestId: string;
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
  boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
};

export type SocialProfileFields_LinkedInSocialProfile_Fragment = {
  __typename?: 'LinkedInSocialProfile';
  type: string;
  linkedInId: string;
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type SocialProfileFields_InstagramSocialProfile_Fragment = {
  __typename?: 'InstagramSocialProfile';
  directPublishEnabled: boolean;
  type: string;
  apiType: InstagramApiType;
  instagramId?: string | null;
  username: string;
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched?: boolean | null;
};

export type SocialProfileFields_GenericSocialProfile_Fragment = {
  __typename?: 'GenericSocialProfile';
  network: Network;
  username: string;
  colour: string;
  platformName: string;
  id: string;
  connected: boolean;
  displayName: string;
  photoUrl: string;
  onboardingContent: boolean;
  photoUrlFetched: boolean;
  genericProfile: GenericProfileType;
};

export type SocialProfileFieldsFragment =
  | SocialProfileFields_SocialProfile_Fragment
  | SocialProfileFields_TikTokSocialProfile_Fragment
  | SocialProfileFields_TwitterSocialProfile_Fragment
  | SocialProfileFields_FacebookSocialProfile_Fragment
  | SocialProfileFields_GoogleSocialProfile_Fragment
  | SocialProfileFields_PinterestSocialProfile_Fragment
  | SocialProfileFields_LinkedInSocialProfile_Fragment
  | SocialProfileFields_InstagramSocialProfile_Fragment
  | SocialProfileFields_GenericSocialProfile_Fragment;

export type ThirdPartyPostLinkFieldsFragment = {
  __typename?: 'ThirdPartyPost';
  linkDescription?: string | null;
  linkImageUrl?: string | null;
  linkName?: string | null;
  linkUrl?: string | null;
};

export type ThirdPartyPostFieldsFragment = {
  __typename?: 'ThirdPartyPost';
  attachmentTypes: Array<ThirdPartyPostAttachmentType>;
  comments?: number | null;
  createdAt: any;
  externalId: string;
  impressions?: number | null;
  likes?: number | null;
  platform: string;
  postUrl: string;
  saves?: number | null;
  shares?: number | null;
  source?: string | null;
  text: string;
  title?: string | null;
  tweetType?: ThirdPartyPostTweetType | null;
  linkDescription?: string | null;
  linkImageUrl?: string | null;
  linkName?: string | null;
  linkUrl?: string | null;
  externalProfile: {
    __typename?: 'ThirdPartyProfile';
    displayName: string;
    username: string;
    externalId?: string | null;
    platform?: string | null;
    profileUrl?: string | null;
  };
  media: Array<{
    __typename?: 'ThirdPartyPostMedia';
    type: ThirdPartyPostMediaType;
    url?: string | null;
    thumbnailUrl?: string | null;
  }>;
  textMentions: Array<{
    __typename?: 'ThirdPartyPostMention';
    externalId?: string | null;
    start?: number | null;
    length?: number | null;
  }>;
};

export type ThirdPartyPostMentionFieldsFragment = {
  __typename?: 'ThirdPartyPostMention';
  externalId?: string | null;
  start?: number | null;
  length?: number | null;
};

export type ThirdPartyProfileFieldsWithoutPhotoUrlFragment = {
  __typename?: 'ThirdPartyProfile';
  displayName: string;
  username: string;
  externalId?: string | null;
  platform?: string | null;
  profileUrl?: string | null;
};

export type ThirdPartyProfileFieldsFragment = {
  __typename?: 'ThirdPartyProfile';
  photoUrl?: string | null;
  displayName: string;
  username: string;
  externalId?: string | null;
  platform?: string | null;
  profileUrl?: string | null;
};

export type UserFieldsFragment = {
  __typename?: 'User';
  id: string;
  firstName: string;
  email: string;
  appRole: UserAppRole;
  timezone: TimezoneSetting;
  passwordSet: boolean;
};

export type VariationsMetaFieldsFragment = {
  __typename?: 'PostVariationMeta';
  total: number;
  currentIndex: number;
  hasMultiple: boolean;
  multiMediaAttachMode: PostMultiMediaAttachMode;
  currentVariation: {
    __typename?: 'PostCurrentVariation';
    text?: string | null;
    media: Array<
      | {
          __typename?: 'Photo';
          id: string;
          dateUploaded?: any | null;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
          filesize?: number | null;
        }
      | {
          __typename?: 'Video';
          id: string;
          dateUploaded?: any | null;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
          filesize?: number | null;
        }
      | {
          __typename?: 'Media';
          id: string;
          dateUploaded?: any | null;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
          filesize?: number | null;
        }
    >;
  };
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean };

export type RefreshAccessTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshAccessTokenMutation = {
  __typename?: 'Mutation';
  refreshAccessToken: { __typename?: 'Token'; token: string; expiresIn: number };
};

export type GetCategoriesProfilesWithBoardsQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetCategoriesProfilesWithBoardsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    categories: Array<{
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      onboardingContent: boolean;
      defaultSocialProfiles: Array<
        | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'FacebookSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'PinterestSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'InstagramSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      >;
    }>;
    socialProfiles: Array<
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
    >;
  };
};

export type LogErrorMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  message: Scalars['String'];
  url: Scalars['String'];
  stackTrace: Scalars['String'];
  severity: ClientErrorLogSeverity;
}>;

export type LogErrorMutation = { __typename?: 'Mutation'; logError: boolean };

export type BulkRegisterMediaUploadsMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: Array<RegisterMediaInput> | RegisterMediaInput;
}>;

export type BulkRegisterMediaUploadsMutation = {
  __typename?: 'Mutation';
  bulkRegisterMediaItemUploads: Array<{
    __typename?: 'UploadInstructions';
    suppliedUploadId: string;
    registrationKey: string;
    uploadUrl: string;
  }>;
};

export type BulkCompleteMediaUploadsMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: Array<UploadMediaInput> | UploadMediaInput;
}>;

export type BulkCompleteMediaUploadsMutation = {
  __typename?: 'Mutation';
  bulkCompleteMediaUploads: Array<{
    __typename?: 'BulkMediaUploadResult';
    suppliedRegistrationKey: string;
    error?: string | null;
    media?:
      | {
          __typename?: 'Photo';
          filename?: string | null;
          gif: boolean;
          filesize?: number | null;
          id: string;
          dateUploaded?: any | null;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
        }
      | {
          __typename?: 'Video';
          dateUploaded?: any | null;
          transcoded: boolean;
          length?: number | null;
          filesize?: number | null;
          id: string;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
        }
      | {
          __typename?: 'Media';
          id: string;
          dateUploaded?: any | null;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
          filesize?: number | null;
        }
      | null;
  }>;
};

export type BulkAddExternalPhotosMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: Array<ExternalMediaInput> | ExternalMediaInput;
}>;

export type BulkAddExternalPhotosMutation = {
  __typename?: 'Mutation';
  bulkAddExternalPhotos: Array<{
    __typename?: 'BulkMediaUploadResult';
    suppliedRegistrationKey: string;
    error?: string | null;
    media?:
      | {
          __typename?: 'Photo';
          filename?: string | null;
          gif: boolean;
          filesize?: number | null;
          id: string;
          dateUploaded?: any | null;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
        }
      | {
          __typename?: 'Video';
          dateUploaded?: any | null;
          transcoded: boolean;
          length?: number | null;
          filesize?: number | null;
          id: string;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
        }
      | {
          __typename?: 'Media';
          id: string;
          dateUploaded?: any | null;
          type: MediaType;
          archived: boolean;
          origin: MediaOrigin;
          proportions: MediaProportions;
          width: number;
          height: number;
          url: string;
          thumbnailUrl: string;
          source?: string | null;
          filesize?: number | null;
        }
      | null;
  }>;
};

export type UsageFieldsFragment = {
  __typename: 'PlanUsageType';
  posts: number;
  socialProfiles: number;
  activeCategories: number;
  autoImports: number;
  importSources: number;
  aiCredits: number;
  users: number;
};

export type GetUsageFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsageFieldsQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    organizations: Array<{
      __typename?: 'Organization';
      plan: {
        __typename?: 'OrganizationPlanType';
        usage: {
          __typename: 'PlanUsageType';
          posts: number;
          socialProfiles: number;
          activeCategories: number;
          autoImports: number;
          importSources: number;
          aiCredits: number;
          users: number;
        };
      };
    }>;
  } | null;
};

export type GetMeQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'User';
    id: string;
    firstName: string;
    email: string;
    appRole: UserAppRole;
    timezone: TimezoneSetting;
    passwordSet: boolean;
    settings: {
      __typename?: 'UserSettings';
      id: string;
      onlineMarketing: boolean;
      notifyFeatureAddedEnabled: boolean;
      notifyMailingListEnabled: boolean;
      notifyProductUpdatesEnabled: boolean;
      notifyReferralCreditsEnabled: boolean;
    };
    organizations: Array<{
      __typename?: 'Organization';
      id: string;
      name: string;
      legacyMemberId: string;
      fromLegacy: boolean;
      suspended: boolean;
      spamLocked: boolean;
      myUserAssignment?: {
        __typename?: 'UserOrganizationAssignment';
        role: UserOrganizationRole;
        settings: {
          __typename?: 'UserOrganizationSettings';
          id: string;
          dateFormat: DateFormatSetting;
          timeFormat: TimeFormatSetting;
          startOfWeekFormat: StartOfWeekFormatSetting;
        };
      } | null;
      subscription: {
        __typename?: 'OrganizationSubscriptionType';
        status: SubscriptionStatus;
        billingCycle: BillingCycle;
        nextBillingDateUtc?: any | null;
        trialExpiryDateUtc: any;
        upgradedDateUtc?: any | null;
      };
      plan: {
        __typename?: 'OrganizationPlanType';
        name: string;
        importerType: PlanImporterType;
        analyticsType: PlanAnalyticsType;
        featureFlags: Array<FeatureFlag>;
        limits: {
          __typename?: 'PlanLimitsType';
          activeCategories: number;
          posts: number;
          socialProfiles: number;
          timeslotsPerWeekdayPerProfile: number;
          autoImports: number;
          importSources: number;
          aiCredits: number;
          users: number;
        };
        usage: {
          __typename: 'PlanUsageType';
          posts: number;
          socialProfiles: number;
          activeCategories: number;
          autoImports: number;
          importSources: number;
          aiCredits: number;
          users: number;
        };
      };
      workspaces: Array<{
        __typename?: 'Workspace';
        id: string;
        name: string;
        timezone: TimezoneSetting;
        settings: {
          __typename?: 'WorkspaceSettings';
          id: string;
          evergreenRecycling: boolean;
          multiMediaAttachMode: PostMultiMediaAttachMode;
          defaultQueuePosition: PostQueuePosition;
          queuesPaused: boolean;
          autoImportsPaused: boolean;
          shouldRemoveUtm: boolean;
          campaignTracking: boolean;
          defaultBitly?: {
            __typename?: 'DefaultBitly';
            domain: string;
            bitly: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            };
          } | null;
          utm?: {
            __typename?: 'UTM';
            campaign: string;
            content: string;
            medium: string;
            source: string;
            term: string;
          } | null;
        };
      }>;
      settings: { __typename?: 'OrganizationSettings'; id: string; productAnalyticsEnabled: boolean };
      mobileApps: Array<
        | {
            __typename?: 'AndroidApp';
            id: string;
            connected: boolean;
            deviceName?: string | null;
            deviceType?: string | null;
            firstConnectedTime: any;
            lastConnectedTime: any;
            owner: { __typename?: 'MobileAppOwnerType'; id: string; firstName: string };
          }
        | {
            __typename?: 'IosApp';
            id: string;
            connected: boolean;
            deviceName?: string | null;
            deviceType?: string | null;
            firstConnectedTime: any;
            lastConnectedTime: any;
            owner: { __typename?: 'MobileAppOwnerType'; id: string; firstName: string };
          }
        | {
            __typename?: 'MobileAppImpl';
            id: string;
            connected: boolean;
            deviceName?: string | null;
            deviceType?: string | null;
            firstConnectedTime: any;
            lastConnectedTime: any;
            owner: { __typename?: 'MobileAppOwnerType'; id: string; firstName: string };
          }
      >;
    }>;
    onboarding: {
      __typename?: 'UserOnboardingType';
      version: number;
      completed: boolean;
      stepsSeen: Array<{ __typename?: 'UserOnboardingStep'; name: string }>;
    };
  } | null;
};

export type ChangeTimezoneMutationVariables = Exact<{
  newTimezone: TimezoneSetting;
  userId?: InputMaybe<Scalars['ID']>;
}>;

export type ChangeTimezoneMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    firstName: string;
    email: string;
    appRole: UserAppRole;
    timezone: TimezoneSetting;
    passwordSet: boolean;
  };
};

export type CreateFollowersMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type CreateFollowersMutation = { __typename?: 'Mutation'; devAnalyticsCreateFollowers: string };

export type GenerateQueueContentMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GenerateQueueContentMutation = { __typename?: 'Mutation'; devGenerateQueueContent: string };

export type CreatePostStatsMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  minPostsPerDay?: InputMaybe<Scalars['Int']>;
  maxPostsPerDay?: InputMaybe<Scalars['Int']>;
  socialProfileIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;

export type CreatePostStatsMutation = { __typename?: 'Mutation'; devAnalyticsCreatePostStats: string };

export type SetSocialProfileToDisconnectedMutationVariables = Exact<{
  socialProfileId: Scalars['ID'];
}>;

export type SetSocialProfileToDisconnectedMutation = {
  __typename?: 'Mutation';
  devSocialProfileSetDisconnected: string;
};

export type SetSocialProfileToConnectedMutationVariables = Exact<{
  socialProfileId: Scalars['ID'];
}>;

export type SetSocialProfileToConnectedMutation = { __typename?: 'Mutation'; devSocialProfileSetConnected: string };

export type ClearThirdPartyPostCacheMutationVariables = Exact<{ [key: string]: never }>;

export type ClearThirdPartyPostCacheMutation = { __typename?: 'Mutation'; devClearThirdPartyPostCache: string };

export type ChangeOrganizationPlanMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  planName: Scalars['String'];
}>;

export type ChangeOrganizationPlanMutation = { __typename?: 'Mutation'; devChangeOrganizationPlan: string };

export type RefreshPinterestBoardsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RefreshPinterestBoardsMutation = {
  __typename?: 'Mutation';
  refreshPinterestBoards: {
    __typename?: 'PinterestSocialProfile';
    id: string;
    boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
  };
};

export type RefreshSocialProfilePhotoUrlMutationVariables = Exact<{
  socialProfileId: Scalars['ID'];
}>;

export type RefreshSocialProfilePhotoUrlMutation = {
  __typename?: 'Mutation';
  refreshSocialProfilePhotoUrl:
    | { __typename?: 'SocialProfile'; photoUrl: string }
    | { __typename?: 'TikTokSocialProfile'; photoUrl: string }
    | { __typename?: 'TwitterSocialProfile'; photoUrl: string }
    | { __typename?: 'FacebookSocialProfile'; photoUrl: string }
    | { __typename?: 'GoogleSocialProfile'; photoUrl: string }
    | { __typename?: 'PinterestSocialProfile'; photoUrl: string }
    | { __typename?: 'LinkedInSocialProfile'; photoUrl: string }
    | { __typename?: 'InstagramSocialProfile'; photoUrl: string }
    | { __typename?: 'GenericSocialProfile'; photoUrl: string };
};

export type RefreshTikTokSocialProfileSettingsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type RefreshTikTokSocialProfileSettingsMutation = {
  __typename?: 'Mutation';
  refreshTikTokSocialProfileSettings: {
    __typename?: 'TikTokSocialProfile';
    id: string;
    connected: boolean;
    displayName: string;
    photoUrl: string;
    onboardingContent: boolean;
    photoUrlFetched?: boolean | null;
    tikTokId: string;
    privacy: TikTokPrivacy;
    commentDisabled: boolean;
    duetDisabled: boolean;
    stitchDisabled: boolean;
    maxVideoDuration: number;
  };
};

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;

export type SendPasswordResetEmailMutation = { __typename?: 'Mutation'; sendPasswordResetEmail: boolean };

export type GetInvitationDetailsQueryVariables = Exact<{
  invitationToken: Scalars['String'];
}>;

export type GetInvitationDetailsQuery = {
  __typename?: 'Query';
  getInvitationDetails: {
    __typename?: 'InvitationDetails';
    email: string;
    organizationName: string;
    organizationID: string;
  };
};

export type JoinOrganizationFromInvitationMutationVariables = Exact<{
  invitationToken: Scalars['String'];
}>;

export type JoinOrganizationFromInvitationMutation = {
  __typename?: 'Mutation';
  joinOrganizationFromInvitation: {
    __typename?: 'Organization';
    workspaces: Array<{ __typename?: 'Workspace'; id: string }>;
  };
};

export type LoginMutationVariables = Exact<{
  input: LoginWithEmailInput;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  loginWithEmail: {
    __typename?: 'LoginSuccess';
    user: {
      __typename?: 'User';
      id: string;
      organizations: Array<{
        __typename?: 'Organization';
        id: string;
        workspaces: Array<{ __typename?: 'Workspace'; id: string }>;
      }>;
    };
    token: { __typename?: 'Token'; token: string; expiresIn: number };
  };
};

export type LoginWithSocialMutationVariables = Exact<{
  socialAuthToken: Scalars['String'];
}>;

export type LoginWithSocialMutation = {
  __typename?: 'Mutation';
  loginWithSocial: {
    __typename?: 'LoginSuccess';
    user: {
      __typename?: 'User';
      id: string;
      organizations: Array<{
        __typename?: 'Organization';
        id: string;
        workspaces: Array<{ __typename?: 'Workspace'; id: string }>;
      }>;
    };
    token: { __typename?: 'Token'; token: string; expiresIn: number };
  };
};

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;

export type ResetPasswordMutation = { __typename?: 'Mutation'; resetPassword: boolean };

export type SocialAuthTokenQueryVariables = Exact<{
  clientToken: Scalars['String'];
}>;

export type SocialAuthTokenQuery = {
  __typename?: 'Query';
  socialAuthToken: {
    __typename?: 'SocialAuthToken';
    network: Network;
    externalId: string;
    email?: string | null;
    firstName?: string | null;
    displayName: string;
    photoUrl: string;
  };
};

export type RegisterEmailAvailableQueryVariables = Exact<{
  email: Scalars['String'];
}>;

export type RegisterEmailAvailableQuery = { __typename?: 'Query'; registerEmailAvailable: boolean };

export type StartSocialOAuthMutationVariables = Exact<{
  oAuthProvider: SocialOAuthProvider;
  profileNetwork?: InputMaybe<Network>;
  context: SocialOAuthContext;
}>;

export type StartSocialOAuthMutation = {
  __typename?: 'Mutation';
  startSocialOAuth: { __typename?: 'SocialOAuth'; socialAuthToken: string; redirectUrl: string };
};

export type RegisterMutationVariables = Exact<{
  input: RegistrationInput;
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  register: {
    __typename?: 'LoginSuccess';
    user: {
      __typename?: 'User';
      id: string;
      organizations: Array<{
        __typename?: 'Organization';
        id: string;
        workspaces: Array<{ __typename?: 'Workspace'; id: string }>;
      }>;
    };
    token: { __typename?: 'Token'; token: string; expiresIn: number };
  };
};

export type GetAutoImportsQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetAutoImportsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    socialProfiles: Array<
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
    >;
    categories: Array<{
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      onboardingContent: boolean;
      defaultSocialProfiles: Array<
        | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'FacebookSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'PinterestSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'InstagramSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      >;
    }>;
    autoImports: Array<{
      __typename?: 'AutoImport';
      id: string;
      name: string;
      url: string;
      refineByTerm: string;
      postTiming: AutoImportPostTiming;
      status: AutoImportStatus;
      prefixText?: string | null;
      suffixText?: string | null;
      recycle: boolean;
      recycleMaxRepeats: number;
      bitlyTracking: boolean;
      removeLinks: boolean;
      firstImportedPost: any;
      lastImportedPost: any;
      category: {
        __typename?: 'Category';
        id: string;
        name: string;
        color: CategoryColor;
        onboardingContent: boolean;
        defaultSocialProfiles: Array<
          | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
          | {
              __typename?: 'TikTokSocialProfile';
              id: string;
              displayName: string;
              photoUrl: string;
              connected: boolean;
            }
          | {
              __typename?: 'TwitterSocialProfile';
              id: string;
              displayName: string;
              photoUrl: string;
              connected: boolean;
            }
          | {
              __typename?: 'FacebookSocialProfile';
              id: string;
              displayName: string;
              photoUrl: string;
              connected: boolean;
            }
          | {
              __typename?: 'GoogleSocialProfile';
              id: string;
              displayName: string;
              photoUrl: string;
              connected: boolean;
            }
          | {
              __typename?: 'PinterestSocialProfile';
              id: string;
              displayName: string;
              photoUrl: string;
              connected: boolean;
            }
          | {
              __typename?: 'LinkedInSocialProfile';
              id: string;
              displayName: string;
              photoUrl: string;
              connected: boolean;
            }
          | {
              __typename?: 'InstagramSocialProfile';
              id: string;
              displayName: string;
              photoUrl: string;
              connected: boolean;
            }
          | {
              __typename?: 'GenericSocialProfile';
              id: string;
              displayName: string;
              photoUrl: string;
              connected: boolean;
            }
        >;
      };
      socialProfiles: Array<
        | {
            __typename?: 'SocialProfile';
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'TikTokSocialProfile';
            tikTokId: string;
            privacy: TikTokPrivacy;
            commentDisabled: boolean;
            duetDisabled: boolean;
            stitchDisabled: boolean;
            maxVideoDuration: number;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'TwitterSocialProfile';
            twitterId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'FacebookSocialProfile';
            type: string;
            facebookId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
            postAs?: {
              __typename?: 'SocialProfileTokenOwner';
              displayName: string;
              id: string;
              externalId: string;
            } | null;
          }
        | {
            __typename?: 'GoogleSocialProfile';
            googleId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'PinterestSocialProfile';
            pinterestId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
            boards: Array<{
              __typename?: 'PinterestBoard';
              externalId: string;
              name: string;
              photoUrl?: string | null;
            }>;
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            type: string;
            linkedInId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'InstagramSocialProfile';
            directPublishEnabled: boolean;
            type: string;
            apiType: InstagramApiType;
            instagramId?: string | null;
            username: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'GenericSocialProfile';
            network: Network;
            username: string;
            colour: string;
            platformName: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched: boolean;
            genericProfile: GenericProfileType;
          }
      >;
      pinterestBoards: Array<{
        __typename?: 'AutoImportPinterestBoard';
        pinterestBoardId: string;
        socialProfileId: string;
      }>;
    }>;
  };
};

export type GetWorkspaceSourcesQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetWorkspaceSourcesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    importFolders: Array<{ __typename?: 'ImportFolder'; id: string; name?: string | null; order: number }>;
    importSources: Array<{
      __typename?: 'ImportSource';
      id: string;
      type: ImportSourceType;
      name?: string | null;
      order: number;
      args:
        | { __typename?: 'ImportSourceArgsRss'; url?: string | null; term?: string | null }
        | {
            __typename: 'ImportSourceArgsTwitter';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            includeReplies: boolean;
            includeRetweets: boolean;
            thirdPartyProfileDisplayName?: string | null;
            twitterSearchType: TwitterSearchType;
            twitterContentType: TwitterSearchContentType;
            twitterSortType: TwitterSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsLinkedIn';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            linkedInSearchType: LinkedInSearchType;
            linkedInContentType: LinkedInSearchContentType;
            linkedInSortType: LinkedInSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsPinterest';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            boardId?: string | null;
            pinterestSearchType: PinterestSearchType;
            pinterestContentType: PinterestSearchContentType;
            pinterestSortType: PinterestSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsInstagram';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            instagramSearchType: InstagramSearchType;
            instagramSortType: InstagramSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsFacebook';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            facebookSearchType: FacebookSearchType;
            facebookContentType: FacebookSearchContentType;
            facebookSortType: FacebookSearchSortType;
          }
        | { __typename?: 'ImportSourceArgsSocialNetwork'; term?: string | null }
        | { __typename?: 'ImportSourceArgs'; term?: string | null };
      folder?: { __typename?: 'ImportFolder'; id: string } | null;
    }>;
    socialProfiles: Array<
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
    >;
  };
};

export type SearchThirdPartyProfilesQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
  method: ThirdPartyProfileSearchType;
  term: Scalars['String'];
}>;

export type SearchThirdPartyProfilesQuery = {
  __typename?: 'Query';
  searchThirdPartyProfiles: Array<{
    __typename?: 'ThirdPartyProfile';
    displayName: string;
    username: string;
    photoUrl?: string | null;
    externalId?: string | null;
    platform?: string | null;
    profileUrl?: string | null;
  }>;
};

export type CreateImportSourceMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: CreateImportSourceInput;
}>;

export type CreateImportSourceMutation = {
  __typename?: 'Mutation';
  createImportSource: {
    __typename?: 'ImportSource';
    id: string;
    type: ImportSourceType;
    name?: string | null;
    order: number;
    args:
      | { __typename?: 'ImportSourceArgsRss'; url?: string | null; term?: string | null }
      | {
          __typename: 'ImportSourceArgsTwitter';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          includeReplies: boolean;
          includeRetweets: boolean;
          thirdPartyProfileDisplayName?: string | null;
          twitterSearchType: TwitterSearchType;
          twitterContentType: TwitterSearchContentType;
          twitterSortType: TwitterSearchSortType;
        }
      | {
          __typename?: 'ImportSourceArgsLinkedIn';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          linkedInSearchType: LinkedInSearchType;
          linkedInContentType: LinkedInSearchContentType;
          linkedInSortType: LinkedInSearchSortType;
        }
      | {
          __typename?: 'ImportSourceArgsPinterest';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          boardId?: string | null;
          pinterestSearchType: PinterestSearchType;
          pinterestContentType: PinterestSearchContentType;
          pinterestSortType: PinterestSearchSortType;
        }
      | {
          __typename?: 'ImportSourceArgsInstagram';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          instagramSearchType: InstagramSearchType;
          instagramSortType: InstagramSearchSortType;
        }
      | {
          __typename?: 'ImportSourceArgsFacebook';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          facebookSearchType: FacebookSearchType;
          facebookContentType: FacebookSearchContentType;
          facebookSortType: FacebookSearchSortType;
        }
      | { __typename?: 'ImportSourceArgsSocialNetwork'; term?: string | null }
      | { __typename?: 'ImportSourceArgs'; term?: string | null };
    folder?: { __typename?: 'ImportFolder'; id: string } | null;
  };
};

export type CompleteOnboardingMutationVariables = Exact<{ [key: string]: never }>;

export type CompleteOnboardingMutation = {
  __typename?: 'Mutation';
  completeOnboarding: {
    __typename?: 'User';
    id: string;
    firstName: string;
    email: string;
    appRole: UserAppRole;
    timezone: TimezoneSetting;
    passwordSet: boolean;
    onboarding: {
      __typename?: 'UserOnboardingType';
      version: number;
      completed: boolean;
      stepsSeen: Array<{ __typename?: 'UserOnboardingStep'; name: string }>;
    };
  };
};

export type SeeOnboardingStepMutationVariables = Exact<{
  name: Scalars['String'];
}>;

export type SeeOnboardingStepMutation = {
  __typename?: 'Mutation';
  markOnboardingStepSeen: { __typename?: 'UserOnboardingStep'; name: string };
};

export type GetCaptionsQueryVariables = Exact<{
  cacheKey: Scalars['String'];
}>;

export type GetCaptionsQuery = {
  __typename?: 'Query';
  captions: {
    __typename?: 'AiCaptionGenerationType';
    captions: Array<string>;
    createdAt: any;
    lastUpdated: any;
    status: AiCaptionStatus;
  };
};

export type InitiateCaptionsMutationVariables = Exact<{
  input: AiCaptionInitiateInput;
  organizationId: Scalars['ID'];
}>;

export type InitiateCaptionsMutation = {
  __typename?: 'Mutation';
  initiateCaptions: { __typename?: 'AiCaptionInitiateType'; cacheKey: string };
};

export type StopCaptionsMutationVariables = Exact<{
  cacheKey: Scalars['String'];
}>;

export type StopCaptionsMutation = {
  __typename?: 'Mutation';
  stopCaptions: {
    __typename?: 'AiCaptionGenerationType';
    captions: Array<string>;
    createdAt: any;
    lastUpdated: any;
    status: AiCaptionStatus;
  };
};

export type GetLinkMetadataQueryVariables = Exact<{
  urls: Array<Scalars['String']> | Scalars['String'];
}>;

export type GetLinkMetadataQuery = {
  __typename?: 'Query';
  linkMetadata: Array<{
    __typename?: 'LinkMetadata';
    error?: string | null;
    initialUrl: string;
    expandedUrl: string;
    domain: string;
    images: Array<string>;
    isBitlink: boolean;
    openGraph?: {
      __typename?: 'OpenGraph';
      image?: string | null;
      title?: string | null;
      description?: string | null;
    } | null;
    twitterCard?: {
      __typename?: 'TwitterCard';
      image?: string | null;
      title?: string | null;
      description?: string | null;
      card?: LinkTwitterCard | null;
    } | null;
  }>;
};

export type BulkImportMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: BulkCreatePostsInput;
}>;

export type BulkImportMutation = { __typename?: 'Mutation'; startBulkCreatePosts: string };

export type GetPostsEditorQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;

export type GetPostsEditorQuery = {
  __typename?: 'Query';
  latestFamilyMembersOfPost: Array<{
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  }>;
};

export type CreatePostMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: PostGroupInput;
}>;

export type CreatePostMutation = {
  __typename?: 'Mutation';
  createPost: Array<{
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  }>;
};

export type GetCategoriesQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  statusFilter?: InputMaybe<CategoryArchiveFilter>;
}>;

export type GetCategoriesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    categories: Array<{
      __typename?: 'Category';
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
      archivedAttachedPostCount?: number | null;
      id: string;
      name: string;
      color: CategoryColor;
      onboardingContent: boolean;
      defaultSocialProfiles: Array<
        | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'FacebookSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'PinterestSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'InstagramSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      >;
    }>;
  };
};

export type InstagramGridPostsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
  futureCount?: InputMaybe<Scalars['Int']>;
}>;

export type InstagramGridPostsQuery = {
  __typename?: 'Query';
  instagramGridPosts: {
    __typename?: 'InstagramGridType';
    thirdPartyPostSearchError?: string | null;
    futurePosts: Array<{
      __typename?: 'Post';
      calculatedLocalDateTime?: any | null;
      calculatedUtcDatetime?: any | null;
      dateAdded?: any | null;
      dateFailed?: any | null;
      datePosted?: any | null;
      delayedUtcOriginalDatetime?: any | null;
      draftQueuePosition?: PostQueuePosition | null;
      expiryLocalDate?: any | null;
      failedMessage?: string | null;
      familyUuid?: string | null;
      feedType: PostFeedType;
      firstComment?: string | null;
      id: string;
      isEvergreen?: boolean | null;
      maxRepeats?: number | null;
      onboardingContent: boolean;
      order?: number | null;
      parentId?: string | null;
      pinterestBoardId?: string | null;
      prevPostedCount?: number | null;
      publishedUrl?: string | null;
      publishMethod: PostPublishMethod;
      actualPublishMethod?: PostPublishMethod | null;
      recurringInterval?: PostRecurringInterval | null;
      recurringValue?: number | null;
      futureScheduledLocalDateTimes: Array<any>;
      publishedUtcDateTimes: Array<any>;
      scheduledTimezone?: TimezoneSetting | null;
      siblingId: string;
      status: PostStatus;
      texts: Array<string>;
      timing: PostTiming;
      title?: string | null;
      category: {
        __typename?: 'Category';
        id: string;
        name: string;
        color: CategoryColor;
        seasonal: boolean;
        seasonalStartDate?: string | null;
        seasonalEndDate?: string | null;
        seasonallyPaused: boolean;
        archived: boolean;
        archivedDate?: any | null;
      };
      iterationAggregations?: {
        __typename?: 'PostIterationAggregations';
        id: string;
        sumClicks: number;
        sumLikes: number;
        sumShares: number;
        sumImpressions: number;
        sumComments: number;
        sumVideoViews: number;
        maxClicks: number;
        maxLikes: number;
        maxShares: number;
        maxImpressions: number;
        maxComments: number;
        maxVideoViews: number;
        boost: number;
        countTimesPosted: number;
        actualPublishMethods?: Array<PostPublishMethod> | null;
        oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
        newestPost?: { __typename?: 'Post'; id: string } | null;
      } | null;
      link?: {
        __typename?: 'Link';
        id: string;
        caption?: string | null;
        url: string;
        initialUrl: string;
        expandedUrl: string;
        bitlyDestinationUrl?: string | null;
        urlBitlink: boolean;
        initialUrlBitlink: boolean;
        destination: LinkDestination;
        clickTracking: LinkClickTracking;
        previewRemoved: boolean;
        googleCallToAction: LinkGoogleCallToAction;
        bitlyPreference: BitlyPreference;
        utm?: {
          __typename?: 'UTM';
          campaign: string;
          content: string;
          medium: string;
          source: string;
          term: string;
        } | null;
        openGraph?: {
          __typename?: 'OpenGraph';
          image?: string | null;
          title?: string | null;
          description?: string | null;
        } | null;
        twitterCard?: {
          __typename?: 'TwitterCard';
          image?: string | null;
          title?: string | null;
          description?: string | null;
          card?: LinkTwitterCard | null;
        } | null;
      } | null;
      mentions: Array<{
        __typename?: 'ThirdPartyProfile';
        photoUrl?: string | null;
        displayName: string;
        username: string;
        externalId?: string | null;
        platform?: string | null;
        profileUrl?: string | null;
      }>;
      photos: Array<{
        __typename?: 'Photo';
        id: string;
        width: number;
        height: number;
        url: string;
        proportions: MediaProportions;
        filesize?: number | null;
        filename?: string | null;
        type: MediaType;
        thumbnailUrl: string;
        gif: boolean;
      }>;
      publishedStats?: {
        __typename?: 'PostPublishedStats';
        clicks?: number | null;
        likes?: number | null;
        shares?: number | null;
        comments?: number | null;
        impressions?: number | null;
        videoViews?: number | null;
        saves?: number | null;
        boost?: number | null;
      } | null;
      socialProfile:
        | {
            __typename?: 'SocialProfile';
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'TikTokSocialProfile';
            tikTokId: string;
            privacy: TikTokPrivacy;
            commentDisabled: boolean;
            duetDisabled: boolean;
            stitchDisabled: boolean;
            maxVideoDuration: number;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'TwitterSocialProfile';
            twitterId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'FacebookSocialProfile';
            type: string;
            facebookId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
            postAs?: {
              __typename?: 'SocialProfileTokenOwner';
              displayName: string;
              id: string;
              externalId: string;
            } | null;
          }
        | {
            __typename?: 'GoogleSocialProfile';
            googleId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'PinterestSocialProfile';
            pinterestId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
            boards: Array<{
              __typename?: 'PinterestBoard';
              externalId: string;
              name: string;
              photoUrl?: string | null;
            }>;
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            type: string;
            linkedInId: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'InstagramSocialProfile';
            directPublishEnabled: boolean;
            type: string;
            apiType: InstagramApiType;
            instagramId?: string | null;
            username: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched?: boolean | null;
          }
        | {
            __typename?: 'GenericSocialProfile';
            network: Network;
            username: string;
            colour: string;
            platformName: string;
            id: string;
            connected: boolean;
            displayName: string;
            photoUrl: string;
            onboardingContent: boolean;
            photoUrlFetched: boolean;
            genericProfile: GenericProfileType;
          };
      tikTok?: {
        __typename?: 'PostTikTok';
        privacy?: PostTikTokPrivacy | null;
        disableComment?: boolean | null;
        disableDuet?: boolean | null;
        disableStitch?: boolean | null;
        brandSelf?: boolean | null;
        brandOther?: boolean | null;
        autoAddMusic?: boolean | null;
      } | null;
      variationMeta?: {
        __typename?: 'PostVariationMeta';
        total: number;
        currentIndex: number;
        hasMultiple: boolean;
        multiMediaAttachMode: PostMultiMediaAttachMode;
        currentVariation: {
          __typename?: 'PostCurrentVariation';
          text?: string | null;
          media: Array<
            | {
                __typename?: 'Photo';
                id: string;
                dateUploaded?: any | null;
                type: MediaType;
                archived: boolean;
                origin: MediaOrigin;
                proportions: MediaProportions;
                width: number;
                height: number;
                url: string;
                thumbnailUrl: string;
                source?: string | null;
                filesize?: number | null;
              }
            | {
                __typename?: 'Video';
                id: string;
                dateUploaded?: any | null;
                type: MediaType;
                archived: boolean;
                origin: MediaOrigin;
                proportions: MediaProportions;
                width: number;
                height: number;
                url: string;
                thumbnailUrl: string;
                source?: string | null;
                filesize?: number | null;
              }
            | {
                __typename?: 'Media';
                id: string;
                dateUploaded?: any | null;
                type: MediaType;
                archived: boolean;
                origin: MediaOrigin;
                proportions: MediaProportions;
                width: number;
                height: number;
                url: string;
                thumbnailUrl: string;
                source?: string | null;
                filesize?: number | null;
              }
          >;
        };
      } | null;
      videos: Array<{
        __typename?: 'Video';
        id: string;
        width: number;
        height: number;
        proportions: MediaProportions;
        url: string;
        source?: string | null;
        transcoded: boolean;
        length?: number | null;
        thumbnailUrl: string;
        type: MediaType;
        filesize?: number | null;
      }>;
    }>;
    pastPosts?: Array<{
      __typename?: 'ThirdPartyPost';
      attachmentTypes: Array<ThirdPartyPostAttachmentType>;
      comments?: number | null;
      createdAt: any;
      externalId: string;
      impressions?: number | null;
      likes?: number | null;
      platform: string;
      postUrl: string;
      saves?: number | null;
      shares?: number | null;
      source?: string | null;
      text: string;
      title?: string | null;
      tweetType?: ThirdPartyPostTweetType | null;
      linkDescription?: string | null;
      linkImageUrl?: string | null;
      linkName?: string | null;
      linkUrl?: string | null;
      externalProfile: {
        __typename?: 'ThirdPartyProfile';
        displayName: string;
        username: string;
        externalId?: string | null;
        platform?: string | null;
        profileUrl?: string | null;
      };
      media: Array<{
        __typename?: 'ThirdPartyPostMedia';
        type: ThirdPartyPostMediaType;
        url?: string | null;
        thumbnailUrl?: string | null;
      }>;
      textMentions: Array<{
        __typename?: 'ThirdPartyPostMention';
        externalId?: string | null;
        start?: number | null;
        length?: number | null;
      }>;
    }> | null;
  };
};

export type GetMediaLibraryQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  input?: InputMaybe<MediaLibraryInput>;
}>;

export type GetMediaLibraryQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    name: string;
    mediaLibrary: {
      __typename?: 'MediaItemsPagination';
      cursor?: number | null;
      count: number;
      items: Array<
        | {
            __typename?: 'Photo';
            filename?: string | null;
            gif: boolean;
            filesize?: number | null;
            id: string;
            dateUploaded?: any | null;
            type: MediaType;
            archived: boolean;
            origin: MediaOrigin;
            proportions: MediaProportions;
            width: number;
            height: number;
            url: string;
            thumbnailUrl: string;
            source?: string | null;
          }
        | {
            __typename?: 'Video';
            dateUploaded?: any | null;
            transcoded: boolean;
            length?: number | null;
            filesize?: number | null;
            id: string;
            type: MediaType;
            archived: boolean;
            origin: MediaOrigin;
            proportions: MediaProportions;
            width: number;
            height: number;
            url: string;
            thumbnailUrl: string;
            source?: string | null;
          }
        | {
            __typename?: 'Media';
            id: string;
            dateUploaded?: any | null;
            type: MediaType;
            archived: boolean;
            origin: MediaOrigin;
            proportions: MediaProportions;
            width: number;
            height: number;
            url: string;
            thumbnailUrl: string;
            source?: string | null;
            filesize?: number | null;
          }
      >;
    };
  };
};

export type BulkArchiveMediaMutationVariables = Exact<{
  media: Array<MediaSelectionInput> | MediaSelectionInput;
}>;

export type BulkArchiveMediaMutation = { __typename?: 'Mutation'; bulkArchiveMedia: boolean };

export type GetCategoryProfilesQueueMetaQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  statusFilter?: InputMaybe<CategoryArchiveFilter>;
}>;

export type GetCategoryProfilesQueueMetaQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    categories: Array<{
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    }>;
    socialProfiles: Array<
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
    >;
    queueMeta: Array<{
      __typename?: 'QueueMetadata';
      paused: boolean;
      socialProfile:
        | { __typename?: 'SocialProfile'; id: string }
        | { __typename?: 'TikTokSocialProfile'; id: string }
        | { __typename?: 'TwitterSocialProfile'; id: string }
        | { __typename?: 'FacebookSocialProfile'; id: string }
        | { __typename?: 'GoogleSocialProfile'; id: string }
        | { __typename?: 'PinterestSocialProfile'; id: string }
        | { __typename?: 'LinkedInSocialProfile'; id: string }
        | { __typename?: 'InstagramSocialProfile'; id: string }
        | { __typename?: 'GenericSocialProfile'; id: string };
      category: { __typename?: 'Category'; id: string };
    }>;
  };
};

export type GetPostQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;

export type GetPostQuery = {
  __typename?: 'Query';
  post: {
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  };
};

export type GetPostScheduleWeekQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: QueueInput;
}>;

export type GetPostScheduleWeekQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    queue: {
      __typename: 'QueueItemsPagination';
      dateRangePagination?: {
        __typename?: 'QueueItemsDateRangePagination';
        count: number;
        startDate?: any | null;
        endDate?: any | null;
        items: Array<{
          __typename?: 'Post';
          calculatedLocalDateTime?: any | null;
          calculatedUtcDatetime?: any | null;
          dateAdded?: any | null;
          dateFailed?: any | null;
          datePosted?: any | null;
          delayedUtcOriginalDatetime?: any | null;
          draftQueuePosition?: PostQueuePosition | null;
          expiryLocalDate?: any | null;
          failedMessage?: string | null;
          familyUuid?: string | null;
          feedType: PostFeedType;
          firstComment?: string | null;
          id: string;
          isEvergreen?: boolean | null;
          maxRepeats?: number | null;
          onboardingContent: boolean;
          order?: number | null;
          parentId?: string | null;
          pinterestBoardId?: string | null;
          prevPostedCount?: number | null;
          publishedUrl?: string | null;
          publishMethod: PostPublishMethod;
          actualPublishMethod?: PostPublishMethod | null;
          recurringInterval?: PostRecurringInterval | null;
          recurringValue?: number | null;
          futureScheduledLocalDateTimes: Array<any>;
          publishedUtcDateTimes: Array<any>;
          scheduledTimezone?: TimezoneSetting | null;
          siblingId: string;
          status: PostStatus;
          texts: Array<string>;
          timing: PostTiming;
          title?: string | null;
          category: {
            __typename?: 'Category';
            id: string;
            name: string;
            color: CategoryColor;
            seasonal: boolean;
            seasonalStartDate?: string | null;
            seasonalEndDate?: string | null;
            seasonallyPaused: boolean;
            archived: boolean;
            archivedDate?: any | null;
          };
          iterationAggregations?: {
            __typename?: 'PostIterationAggregations';
            id: string;
            sumClicks: number;
            sumLikes: number;
            sumShares: number;
            sumImpressions: number;
            sumComments: number;
            sumVideoViews: number;
            maxClicks: number;
            maxLikes: number;
            maxShares: number;
            maxImpressions: number;
            maxComments: number;
            maxVideoViews: number;
            boost: number;
            countTimesPosted: number;
            actualPublishMethods?: Array<PostPublishMethod> | null;
            oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
            newestPost?: { __typename?: 'Post'; id: string } | null;
          } | null;
          link?: {
            __typename?: 'Link';
            id: string;
            caption?: string | null;
            url: string;
            initialUrl: string;
            expandedUrl: string;
            bitlyDestinationUrl?: string | null;
            urlBitlink: boolean;
            initialUrlBitlink: boolean;
            destination: LinkDestination;
            clickTracking: LinkClickTracking;
            previewRemoved: boolean;
            googleCallToAction: LinkGoogleCallToAction;
            bitlyPreference: BitlyPreference;
            utm?: {
              __typename?: 'UTM';
              campaign: string;
              content: string;
              medium: string;
              source: string;
              term: string;
            } | null;
            openGraph?: {
              __typename?: 'OpenGraph';
              image?: string | null;
              title?: string | null;
              description?: string | null;
            } | null;
            twitterCard?: {
              __typename?: 'TwitterCard';
              image?: string | null;
              title?: string | null;
              description?: string | null;
              card?: LinkTwitterCard | null;
            } | null;
          } | null;
          mentions: Array<{
            __typename?: 'ThirdPartyProfile';
            photoUrl?: string | null;
            displayName: string;
            username: string;
            externalId?: string | null;
            platform?: string | null;
            profileUrl?: string | null;
          }>;
          photos: Array<{
            __typename?: 'Photo';
            id: string;
            width: number;
            height: number;
            url: string;
            proportions: MediaProportions;
            filesize?: number | null;
            filename?: string | null;
            type: MediaType;
            thumbnailUrl: string;
            gif: boolean;
          }>;
          publishedStats?: {
            __typename?: 'PostPublishedStats';
            clicks?: number | null;
            likes?: number | null;
            shares?: number | null;
            comments?: number | null;
            impressions?: number | null;
            videoViews?: number | null;
            saves?: number | null;
            boost?: number | null;
          } | null;
          socialProfile:
            | {
                __typename?: 'SocialProfile';
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'TikTokSocialProfile';
                tikTokId: string;
                privacy: TikTokPrivacy;
                commentDisabled: boolean;
                duetDisabled: boolean;
                stitchDisabled: boolean;
                maxVideoDuration: number;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'TwitterSocialProfile';
                twitterId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'FacebookSocialProfile';
                type: string;
                facebookId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
                postAs?: {
                  __typename?: 'SocialProfileTokenOwner';
                  displayName: string;
                  id: string;
                  externalId: string;
                } | null;
              }
            | {
                __typename?: 'GoogleSocialProfile';
                googleId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'PinterestSocialProfile';
                pinterestId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
                boards: Array<{
                  __typename?: 'PinterestBoard';
                  externalId: string;
                  name: string;
                  photoUrl?: string | null;
                }>;
              }
            | {
                __typename?: 'LinkedInSocialProfile';
                type: string;
                linkedInId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'InstagramSocialProfile';
                directPublishEnabled: boolean;
                type: string;
                apiType: InstagramApiType;
                instagramId?: string | null;
                username: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'GenericSocialProfile';
                network: Network;
                username: string;
                colour: string;
                platformName: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched: boolean;
                genericProfile: GenericProfileType;
              };
          tikTok?: {
            __typename?: 'PostTikTok';
            privacy?: PostTikTokPrivacy | null;
            disableComment?: boolean | null;
            disableDuet?: boolean | null;
            disableStitch?: boolean | null;
            brandSelf?: boolean | null;
            brandOther?: boolean | null;
            autoAddMusic?: boolean | null;
          } | null;
          variationMeta?: {
            __typename?: 'PostVariationMeta';
            total: number;
            currentIndex: number;
            hasMultiple: boolean;
            multiMediaAttachMode: PostMultiMediaAttachMode;
            currentVariation: {
              __typename?: 'PostCurrentVariation';
              text?: string | null;
              media: Array<
                | {
                    __typename?: 'Photo';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
                | {
                    __typename?: 'Video';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
                | {
                    __typename?: 'Media';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
              >;
            };
          } | null;
          videos: Array<{
            __typename?: 'Video';
            id: string;
            width: number;
            height: number;
            proportions: MediaProportions;
            url: string;
            source?: string | null;
            transcoded: boolean;
            length?: number | null;
            thumbnailUrl: string;
            type: MediaType;
            filesize?: number | null;
          }>;
        }>;
      } | null;
    };
  };
};

export type GetPostScheduleListQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: QueueInput;
}>;

export type GetPostScheduleListQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    queue: {
      __typename: 'QueueItemsPagination';
      cursorPagination?: {
        __typename?: 'QueueItemsCursorPagination';
        cursor?: string | null;
        count: number;
        items: Array<{
          __typename?: 'Post';
          calculatedLocalDateTime?: any | null;
          calculatedUtcDatetime?: any | null;
          dateAdded?: any | null;
          dateFailed?: any | null;
          datePosted?: any | null;
          delayedUtcOriginalDatetime?: any | null;
          draftQueuePosition?: PostQueuePosition | null;
          expiryLocalDate?: any | null;
          failedMessage?: string | null;
          familyUuid?: string | null;
          feedType: PostFeedType;
          firstComment?: string | null;
          id: string;
          isEvergreen?: boolean | null;
          maxRepeats?: number | null;
          onboardingContent: boolean;
          order?: number | null;
          parentId?: string | null;
          pinterestBoardId?: string | null;
          prevPostedCount?: number | null;
          publishedUrl?: string | null;
          publishMethod: PostPublishMethod;
          actualPublishMethod?: PostPublishMethod | null;
          recurringInterval?: PostRecurringInterval | null;
          recurringValue?: number | null;
          futureScheduledLocalDateTimes: Array<any>;
          publishedUtcDateTimes: Array<any>;
          scheduledTimezone?: TimezoneSetting | null;
          siblingId: string;
          status: PostStatus;
          texts: Array<string>;
          timing: PostTiming;
          title?: string | null;
          category: {
            __typename?: 'Category';
            id: string;
            name: string;
            color: CategoryColor;
            seasonal: boolean;
            seasonalStartDate?: string | null;
            seasonalEndDate?: string | null;
            seasonallyPaused: boolean;
            archived: boolean;
            archivedDate?: any | null;
          };
          iterationAggregations?: {
            __typename?: 'PostIterationAggregations';
            id: string;
            sumClicks: number;
            sumLikes: number;
            sumShares: number;
            sumImpressions: number;
            sumComments: number;
            sumVideoViews: number;
            maxClicks: number;
            maxLikes: number;
            maxShares: number;
            maxImpressions: number;
            maxComments: number;
            maxVideoViews: number;
            boost: number;
            countTimesPosted: number;
            actualPublishMethods?: Array<PostPublishMethod> | null;
            oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
            newestPost?: { __typename?: 'Post'; id: string } | null;
          } | null;
          link?: {
            __typename?: 'Link';
            id: string;
            caption?: string | null;
            url: string;
            initialUrl: string;
            expandedUrl: string;
            bitlyDestinationUrl?: string | null;
            urlBitlink: boolean;
            initialUrlBitlink: boolean;
            destination: LinkDestination;
            clickTracking: LinkClickTracking;
            previewRemoved: boolean;
            googleCallToAction: LinkGoogleCallToAction;
            bitlyPreference: BitlyPreference;
            utm?: {
              __typename?: 'UTM';
              campaign: string;
              content: string;
              medium: string;
              source: string;
              term: string;
            } | null;
            openGraph?: {
              __typename?: 'OpenGraph';
              image?: string | null;
              title?: string | null;
              description?: string | null;
            } | null;
            twitterCard?: {
              __typename?: 'TwitterCard';
              image?: string | null;
              title?: string | null;
              description?: string | null;
              card?: LinkTwitterCard | null;
            } | null;
          } | null;
          mentions: Array<{
            __typename?: 'ThirdPartyProfile';
            photoUrl?: string | null;
            displayName: string;
            username: string;
            externalId?: string | null;
            platform?: string | null;
            profileUrl?: string | null;
          }>;
          photos: Array<{
            __typename?: 'Photo';
            id: string;
            width: number;
            height: number;
            url: string;
            proportions: MediaProportions;
            filesize?: number | null;
            filename?: string | null;
            type: MediaType;
            thumbnailUrl: string;
            gif: boolean;
          }>;
          publishedStats?: {
            __typename?: 'PostPublishedStats';
            clicks?: number | null;
            likes?: number | null;
            shares?: number | null;
            comments?: number | null;
            impressions?: number | null;
            videoViews?: number | null;
            saves?: number | null;
            boost?: number | null;
          } | null;
          socialProfile:
            | {
                __typename?: 'SocialProfile';
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'TikTokSocialProfile';
                tikTokId: string;
                privacy: TikTokPrivacy;
                commentDisabled: boolean;
                duetDisabled: boolean;
                stitchDisabled: boolean;
                maxVideoDuration: number;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'TwitterSocialProfile';
                twitterId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'FacebookSocialProfile';
                type: string;
                facebookId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
                postAs?: {
                  __typename?: 'SocialProfileTokenOwner';
                  displayName: string;
                  id: string;
                  externalId: string;
                } | null;
              }
            | {
                __typename?: 'GoogleSocialProfile';
                googleId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'PinterestSocialProfile';
                pinterestId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
                boards: Array<{
                  __typename?: 'PinterestBoard';
                  externalId: string;
                  name: string;
                  photoUrl?: string | null;
                }>;
              }
            | {
                __typename?: 'LinkedInSocialProfile';
                type: string;
                linkedInId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'InstagramSocialProfile';
                directPublishEnabled: boolean;
                type: string;
                apiType: InstagramApiType;
                instagramId?: string | null;
                username: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'GenericSocialProfile';
                network: Network;
                username: string;
                colour: string;
                platformName: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched: boolean;
                genericProfile: GenericProfileType;
              };
          tikTok?: {
            __typename?: 'PostTikTok';
            privacy?: PostTikTokPrivacy | null;
            disableComment?: boolean | null;
            disableDuet?: boolean | null;
            disableStitch?: boolean | null;
            brandSelf?: boolean | null;
            brandOther?: boolean | null;
            autoAddMusic?: boolean | null;
          } | null;
          variationMeta?: {
            __typename?: 'PostVariationMeta';
            total: number;
            currentIndex: number;
            hasMultiple: boolean;
            multiMediaAttachMode: PostMultiMediaAttachMode;
            currentVariation: {
              __typename?: 'PostCurrentVariation';
              text?: string | null;
              media: Array<
                | {
                    __typename?: 'Photo';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
                | {
                    __typename?: 'Video';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
                | {
                    __typename?: 'Media';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
              >;
            };
          } | null;
          videos: Array<{
            __typename?: 'Video';
            id: string;
            width: number;
            height: number;
            proportions: MediaProportions;
            url: string;
            source?: string | null;
            transcoded: boolean;
            length?: number | null;
            thumbnailUrl: string;
            type: MediaType;
            filesize?: number | null;
          }>;
        }>;
      } | null;
    };
  };
};

export type GetPostListAscendingQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: QueueInput;
}>;

export type GetPostListAscendingQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    queue: {
      __typename: 'QueueItemsPagination';
      cursorPagination?: {
        __typename?: 'QueueItemsCursorPagination';
        cursor?: string | null;
        count: number;
        items: Array<{
          __typename?: 'Post';
          calculatedLocalDateTime?: any | null;
          calculatedUtcDatetime?: any | null;
          dateAdded?: any | null;
          dateFailed?: any | null;
          datePosted?: any | null;
          delayedUtcOriginalDatetime?: any | null;
          draftQueuePosition?: PostQueuePosition | null;
          expiryLocalDate?: any | null;
          failedMessage?: string | null;
          familyUuid?: string | null;
          feedType: PostFeedType;
          firstComment?: string | null;
          id: string;
          isEvergreen?: boolean | null;
          maxRepeats?: number | null;
          onboardingContent: boolean;
          order?: number | null;
          parentId?: string | null;
          pinterestBoardId?: string | null;
          prevPostedCount?: number | null;
          publishedUrl?: string | null;
          publishMethod: PostPublishMethod;
          actualPublishMethod?: PostPublishMethod | null;
          recurringInterval?: PostRecurringInterval | null;
          recurringValue?: number | null;
          futureScheduledLocalDateTimes: Array<any>;
          publishedUtcDateTimes: Array<any>;
          scheduledTimezone?: TimezoneSetting | null;
          siblingId: string;
          status: PostStatus;
          texts: Array<string>;
          timing: PostTiming;
          title?: string | null;
          category: {
            __typename?: 'Category';
            id: string;
            name: string;
            color: CategoryColor;
            seasonal: boolean;
            seasonalStartDate?: string | null;
            seasonalEndDate?: string | null;
            seasonallyPaused: boolean;
            archived: boolean;
            archivedDate?: any | null;
          };
          iterationAggregations?: {
            __typename?: 'PostIterationAggregations';
            id: string;
            sumClicks: number;
            sumLikes: number;
            sumShares: number;
            sumImpressions: number;
            sumComments: number;
            sumVideoViews: number;
            maxClicks: number;
            maxLikes: number;
            maxShares: number;
            maxImpressions: number;
            maxComments: number;
            maxVideoViews: number;
            boost: number;
            countTimesPosted: number;
            actualPublishMethods?: Array<PostPublishMethod> | null;
            oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
            newestPost?: { __typename?: 'Post'; id: string } | null;
          } | null;
          link?: {
            __typename?: 'Link';
            id: string;
            caption?: string | null;
            url: string;
            initialUrl: string;
            expandedUrl: string;
            bitlyDestinationUrl?: string | null;
            urlBitlink: boolean;
            initialUrlBitlink: boolean;
            destination: LinkDestination;
            clickTracking: LinkClickTracking;
            previewRemoved: boolean;
            googleCallToAction: LinkGoogleCallToAction;
            bitlyPreference: BitlyPreference;
            utm?: {
              __typename?: 'UTM';
              campaign: string;
              content: string;
              medium: string;
              source: string;
              term: string;
            } | null;
            openGraph?: {
              __typename?: 'OpenGraph';
              image?: string | null;
              title?: string | null;
              description?: string | null;
            } | null;
            twitterCard?: {
              __typename?: 'TwitterCard';
              image?: string | null;
              title?: string | null;
              description?: string | null;
              card?: LinkTwitterCard | null;
            } | null;
          } | null;
          mentions: Array<{
            __typename?: 'ThirdPartyProfile';
            photoUrl?: string | null;
            displayName: string;
            username: string;
            externalId?: string | null;
            platform?: string | null;
            profileUrl?: string | null;
          }>;
          photos: Array<{
            __typename?: 'Photo';
            id: string;
            width: number;
            height: number;
            url: string;
            proportions: MediaProportions;
            filesize?: number | null;
            filename?: string | null;
            type: MediaType;
            thumbnailUrl: string;
            gif: boolean;
          }>;
          publishedStats?: {
            __typename?: 'PostPublishedStats';
            clicks?: number | null;
            likes?: number | null;
            shares?: number | null;
            comments?: number | null;
            impressions?: number | null;
            videoViews?: number | null;
            saves?: number | null;
            boost?: number | null;
          } | null;
          socialProfile:
            | {
                __typename?: 'SocialProfile';
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'TikTokSocialProfile';
                tikTokId: string;
                privacy: TikTokPrivacy;
                commentDisabled: boolean;
                duetDisabled: boolean;
                stitchDisabled: boolean;
                maxVideoDuration: number;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'TwitterSocialProfile';
                twitterId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'FacebookSocialProfile';
                type: string;
                facebookId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
                postAs?: {
                  __typename?: 'SocialProfileTokenOwner';
                  displayName: string;
                  id: string;
                  externalId: string;
                } | null;
              }
            | {
                __typename?: 'GoogleSocialProfile';
                googleId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'PinterestSocialProfile';
                pinterestId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
                boards: Array<{
                  __typename?: 'PinterestBoard';
                  externalId: string;
                  name: string;
                  photoUrl?: string | null;
                }>;
              }
            | {
                __typename?: 'LinkedInSocialProfile';
                type: string;
                linkedInId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'InstagramSocialProfile';
                directPublishEnabled: boolean;
                type: string;
                apiType: InstagramApiType;
                instagramId?: string | null;
                username: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'GenericSocialProfile';
                network: Network;
                username: string;
                colour: string;
                platformName: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched: boolean;
                genericProfile: GenericProfileType;
              };
          tikTok?: {
            __typename?: 'PostTikTok';
            privacy?: PostTikTokPrivacy | null;
            disableComment?: boolean | null;
            disableDuet?: boolean | null;
            disableStitch?: boolean | null;
            brandSelf?: boolean | null;
            brandOther?: boolean | null;
            autoAddMusic?: boolean | null;
          } | null;
          variationMeta?: {
            __typename?: 'PostVariationMeta';
            total: number;
            currentIndex: number;
            hasMultiple: boolean;
            multiMediaAttachMode: PostMultiMediaAttachMode;
            currentVariation: {
              __typename?: 'PostCurrentVariation';
              text?: string | null;
              media: Array<
                | {
                    __typename?: 'Photo';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
                | {
                    __typename?: 'Video';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
                | {
                    __typename?: 'Media';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
              >;
            };
          } | null;
          videos: Array<{
            __typename?: 'Video';
            id: string;
            width: number;
            height: number;
            proportions: MediaProportions;
            url: string;
            source?: string | null;
            transcoded: boolean;
            length?: number | null;
            thumbnailUrl: string;
            type: MediaType;
            filesize?: number | null;
          }>;
        }>;
      } | null;
    };
  };
};

export type GetPostListDescendingQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: QueueInput;
}>;

export type GetPostListDescendingQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    queue: {
      __typename: 'QueueItemsPagination';
      cursorPagination?: {
        __typename?: 'QueueItemsCursorPagination';
        cursor?: string | null;
        count: number;
        items: Array<{
          __typename?: 'Post';
          calculatedLocalDateTime?: any | null;
          calculatedUtcDatetime?: any | null;
          dateAdded?: any | null;
          dateFailed?: any | null;
          datePosted?: any | null;
          delayedUtcOriginalDatetime?: any | null;
          draftQueuePosition?: PostQueuePosition | null;
          expiryLocalDate?: any | null;
          failedMessage?: string | null;
          familyUuid?: string | null;
          feedType: PostFeedType;
          firstComment?: string | null;
          id: string;
          isEvergreen?: boolean | null;
          maxRepeats?: number | null;
          onboardingContent: boolean;
          order?: number | null;
          parentId?: string | null;
          pinterestBoardId?: string | null;
          prevPostedCount?: number | null;
          publishedUrl?: string | null;
          publishMethod: PostPublishMethod;
          actualPublishMethod?: PostPublishMethod | null;
          recurringInterval?: PostRecurringInterval | null;
          recurringValue?: number | null;
          futureScheduledLocalDateTimes: Array<any>;
          publishedUtcDateTimes: Array<any>;
          scheduledTimezone?: TimezoneSetting | null;
          siblingId: string;
          status: PostStatus;
          texts: Array<string>;
          timing: PostTiming;
          title?: string | null;
          category: {
            __typename?: 'Category';
            id: string;
            name: string;
            color: CategoryColor;
            seasonal: boolean;
            seasonalStartDate?: string | null;
            seasonalEndDate?: string | null;
            seasonallyPaused: boolean;
            archived: boolean;
            archivedDate?: any | null;
          };
          iterationAggregations?: {
            __typename?: 'PostIterationAggregations';
            id: string;
            sumClicks: number;
            sumLikes: number;
            sumShares: number;
            sumImpressions: number;
            sumComments: number;
            sumVideoViews: number;
            maxClicks: number;
            maxLikes: number;
            maxShares: number;
            maxImpressions: number;
            maxComments: number;
            maxVideoViews: number;
            boost: number;
            countTimesPosted: number;
            actualPublishMethods?: Array<PostPublishMethod> | null;
            oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
            newestPost?: { __typename?: 'Post'; id: string } | null;
          } | null;
          link?: {
            __typename?: 'Link';
            id: string;
            caption?: string | null;
            url: string;
            initialUrl: string;
            expandedUrl: string;
            bitlyDestinationUrl?: string | null;
            urlBitlink: boolean;
            initialUrlBitlink: boolean;
            destination: LinkDestination;
            clickTracking: LinkClickTracking;
            previewRemoved: boolean;
            googleCallToAction: LinkGoogleCallToAction;
            bitlyPreference: BitlyPreference;
            utm?: {
              __typename?: 'UTM';
              campaign: string;
              content: string;
              medium: string;
              source: string;
              term: string;
            } | null;
            openGraph?: {
              __typename?: 'OpenGraph';
              image?: string | null;
              title?: string | null;
              description?: string | null;
            } | null;
            twitterCard?: {
              __typename?: 'TwitterCard';
              image?: string | null;
              title?: string | null;
              description?: string | null;
              card?: LinkTwitterCard | null;
            } | null;
          } | null;
          mentions: Array<{
            __typename?: 'ThirdPartyProfile';
            photoUrl?: string | null;
            displayName: string;
            username: string;
            externalId?: string | null;
            platform?: string | null;
            profileUrl?: string | null;
          }>;
          photos: Array<{
            __typename?: 'Photo';
            id: string;
            width: number;
            height: number;
            url: string;
            proportions: MediaProportions;
            filesize?: number | null;
            filename?: string | null;
            type: MediaType;
            thumbnailUrl: string;
            gif: boolean;
          }>;
          publishedStats?: {
            __typename?: 'PostPublishedStats';
            clicks?: number | null;
            likes?: number | null;
            shares?: number | null;
            comments?: number | null;
            impressions?: number | null;
            videoViews?: number | null;
            saves?: number | null;
            boost?: number | null;
          } | null;
          socialProfile:
            | {
                __typename?: 'SocialProfile';
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'TikTokSocialProfile';
                tikTokId: string;
                privacy: TikTokPrivacy;
                commentDisabled: boolean;
                duetDisabled: boolean;
                stitchDisabled: boolean;
                maxVideoDuration: number;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'TwitterSocialProfile';
                twitterId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'FacebookSocialProfile';
                type: string;
                facebookId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
                postAs?: {
                  __typename?: 'SocialProfileTokenOwner';
                  displayName: string;
                  id: string;
                  externalId: string;
                } | null;
              }
            | {
                __typename?: 'GoogleSocialProfile';
                googleId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'PinterestSocialProfile';
                pinterestId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
                boards: Array<{
                  __typename?: 'PinterestBoard';
                  externalId: string;
                  name: string;
                  photoUrl?: string | null;
                }>;
              }
            | {
                __typename?: 'LinkedInSocialProfile';
                type: string;
                linkedInId: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'InstagramSocialProfile';
                directPublishEnabled: boolean;
                type: string;
                apiType: InstagramApiType;
                instagramId?: string | null;
                username: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched?: boolean | null;
              }
            | {
                __typename?: 'GenericSocialProfile';
                network: Network;
                username: string;
                colour: string;
                platformName: string;
                id: string;
                connected: boolean;
                displayName: string;
                photoUrl: string;
                onboardingContent: boolean;
                photoUrlFetched: boolean;
                genericProfile: GenericProfileType;
              };
          tikTok?: {
            __typename?: 'PostTikTok';
            privacy?: PostTikTokPrivacy | null;
            disableComment?: boolean | null;
            disableDuet?: boolean | null;
            disableStitch?: boolean | null;
            brandSelf?: boolean | null;
            brandOther?: boolean | null;
            autoAddMusic?: boolean | null;
          } | null;
          variationMeta?: {
            __typename?: 'PostVariationMeta';
            total: number;
            currentIndex: number;
            hasMultiple: boolean;
            multiMediaAttachMode: PostMultiMediaAttachMode;
            currentVariation: {
              __typename?: 'PostCurrentVariation';
              text?: string | null;
              media: Array<
                | {
                    __typename?: 'Photo';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
                | {
                    __typename?: 'Video';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
                | {
                    __typename?: 'Media';
                    id: string;
                    dateUploaded?: any | null;
                    type: MediaType;
                    archived: boolean;
                    origin: MediaOrigin;
                    proportions: MediaProportions;
                    width: number;
                    height: number;
                    url: string;
                    thumbnailUrl: string;
                    source?: string | null;
                    filesize?: number | null;
                  }
              >;
            };
          } | null;
          videos: Array<{
            __typename?: 'Video';
            id: string;
            width: number;
            height: number;
            proportions: MediaProportions;
            url: string;
            source?: string | null;
            transcoded: boolean;
            length?: number | null;
            thumbnailUrl: string;
            type: MediaType;
            filesize?: number | null;
          }>;
        }>;
      } | null;
    };
  };
};

export type GetPostQueueCountQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  queueFilters: QueueFilterInput;
  queueContext: QueueContext;
}>;

export type GetPostQueueCountQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    queueCounts: {
      __typename?: 'PostQueueCountResult';
      categories: Array<{ __typename?: 'PostQueueCountCategory'; categoryId: number; count: number }>;
      socialProfiles: Array<{ __typename?: 'PostQueueCountSocialProfile'; socialProfileId: number; count: number }>;
      status: {
        __typename?: 'PostQueueCountStatus';
        scheduled: number;
        past: number;
        failed: number;
        paused: number;
        draft: number;
        unqueued: number;
        deleted: number;
      };
      content: {
        __typename?: 'PostQueueCountContent';
        image: number;
        imageLink: number;
        link: number;
        text: number;
        video: number;
        videoLink: number;
      };
      timing: { __typename?: 'PostQueueCountTiming'; setDates: number; recurring: number; queued: number };
      evergreen: { __typename?: 'PostQueueCountEvergreen'; evergreenOnly: number };
      source: {
        __typename?: 'PostQueueCountSource';
        autoRss: number;
        csvUpload: number;
        postEditor: number;
        socialImport: number;
      };
    };
  };
};

export type GetPostFamilyQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;

export type GetPostFamilyQuery = {
  __typename?: 'Query';
  latestFamilyMembersOfPost: Array<{
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  }>;
};

export type GetPostIterationsQueryVariables = Exact<{
  postId: Scalars['ID'];
}>;

export type GetPostIterationsQuery = {
  __typename?: 'Query';
  postIterations: Array<{
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  }>;
};

export type ShuffleQueueMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  filters: QueueFilterInput;
}>;

export type ShuffleQueueMutation = { __typename?: 'Mutation'; shuffleQueue: boolean };

export type UpdatePostOrderMutationVariables = Exact<{
  postId: Scalars['ID'];
  direction: PostOrderUpdateDirection;
  relativePostId: Scalars['ID'];
}>;

export type UpdatePostOrderMutation = {
  __typename?: 'Mutation';
  updatePostOrder: {
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  };
};

export type UpdatePostMutationVariables = Exact<{
  postId: Scalars['ID'];
  input: UpdatePostInput;
}>;

export type UpdatePostMutation = {
  __typename?: 'Mutation';
  updatePost: {
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  };
};

export type BulkUpdatePostsMutationVariables = Exact<{
  input: Array<BulkUpdatePostInput> | BulkUpdatePostInput;
}>;

export type BulkUpdatePostsMutation = {
  __typename?: 'Mutation';
  bulkUpdatePosts: Array<{
    __typename?: 'Post';
    calculatedLocalDateTime?: any | null;
    calculatedUtcDatetime?: any | null;
    dateAdded?: any | null;
    dateFailed?: any | null;
    datePosted?: any | null;
    delayedUtcOriginalDatetime?: any | null;
    draftQueuePosition?: PostQueuePosition | null;
    expiryLocalDate?: any | null;
    failedMessage?: string | null;
    familyUuid?: string | null;
    feedType: PostFeedType;
    firstComment?: string | null;
    id: string;
    isEvergreen?: boolean | null;
    maxRepeats?: number | null;
    onboardingContent: boolean;
    order?: number | null;
    parentId?: string | null;
    pinterestBoardId?: string | null;
    prevPostedCount?: number | null;
    publishedUrl?: string | null;
    publishMethod: PostPublishMethod;
    actualPublishMethod?: PostPublishMethod | null;
    recurringInterval?: PostRecurringInterval | null;
    recurringValue?: number | null;
    futureScheduledLocalDateTimes: Array<any>;
    publishedUtcDateTimes: Array<any>;
    scheduledTimezone?: TimezoneSetting | null;
    siblingId: string;
    status: PostStatus;
    texts: Array<string>;
    timing: PostTiming;
    title?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      seasonal: boolean;
      seasonalStartDate?: string | null;
      seasonalEndDate?: string | null;
      seasonallyPaused: boolean;
      archived: boolean;
      archivedDate?: any | null;
    };
    iterationAggregations?: {
      __typename?: 'PostIterationAggregations';
      id: string;
      sumClicks: number;
      sumLikes: number;
      sumShares: number;
      sumImpressions: number;
      sumComments: number;
      sumVideoViews: number;
      maxClicks: number;
      maxLikes: number;
      maxShares: number;
      maxImpressions: number;
      maxComments: number;
      maxVideoViews: number;
      boost: number;
      countTimesPosted: number;
      actualPublishMethods?: Array<PostPublishMethod> | null;
      oldestPost?: { __typename?: 'Post'; id: string; dateAdded?: any | null } | null;
      newestPost?: { __typename?: 'Post'; id: string } | null;
    } | null;
    link?: {
      __typename?: 'Link';
      id: string;
      caption?: string | null;
      url: string;
      initialUrl: string;
      expandedUrl: string;
      bitlyDestinationUrl?: string | null;
      urlBitlink: boolean;
      initialUrlBitlink: boolean;
      destination: LinkDestination;
      clickTracking: LinkClickTracking;
      previewRemoved: boolean;
      googleCallToAction: LinkGoogleCallToAction;
      bitlyPreference: BitlyPreference;
      utm?: {
        __typename?: 'UTM';
        campaign: string;
        content: string;
        medium: string;
        source: string;
        term: string;
      } | null;
      openGraph?: {
        __typename?: 'OpenGraph';
        image?: string | null;
        title?: string | null;
        description?: string | null;
      } | null;
      twitterCard?: {
        __typename?: 'TwitterCard';
        image?: string | null;
        title?: string | null;
        description?: string | null;
        card?: LinkTwitterCard | null;
      } | null;
    } | null;
    mentions: Array<{
      __typename?: 'ThirdPartyProfile';
      photoUrl?: string | null;
      displayName: string;
      username: string;
      externalId?: string | null;
      platform?: string | null;
      profileUrl?: string | null;
    }>;
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      width: number;
      height: number;
      url: string;
      proportions: MediaProportions;
      filesize?: number | null;
      filename?: string | null;
      type: MediaType;
      thumbnailUrl: string;
      gif: boolean;
    }>;
    publishedStats?: {
      __typename?: 'PostPublishedStats';
      clicks?: number | null;
      likes?: number | null;
      shares?: number | null;
      comments?: number | null;
      impressions?: number | null;
      videoViews?: number | null;
      saves?: number | null;
      boost?: number | null;
    } | null;
    socialProfile:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        };
    tikTok?: {
      __typename?: 'PostTikTok';
      privacy?: PostTikTokPrivacy | null;
      disableComment?: boolean | null;
      disableDuet?: boolean | null;
      disableStitch?: boolean | null;
      brandSelf?: boolean | null;
      brandOther?: boolean | null;
      autoAddMusic?: boolean | null;
    } | null;
    variationMeta?: {
      __typename?: 'PostVariationMeta';
      total: number;
      currentIndex: number;
      hasMultiple: boolean;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      currentVariation: {
        __typename?: 'PostCurrentVariation';
        text?: string | null;
        media: Array<
          | {
              __typename?: 'Photo';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Video';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
          | {
              __typename?: 'Media';
              id: string;
              dateUploaded?: any | null;
              type: MediaType;
              archived: boolean;
              origin: MediaOrigin;
              proportions: MediaProportions;
              width: number;
              height: number;
              url: string;
              thumbnailUrl: string;
              source?: string | null;
              filesize?: number | null;
            }
        >;
      };
    } | null;
    videos: Array<{
      __typename?: 'Video';
      id: string;
      width: number;
      height: number;
      proportions: MediaProportions;
      url: string;
      source?: string | null;
      transcoded: boolean;
      length?: number | null;
      thumbnailUrl: string;
      type: MediaType;
      filesize?: number | null;
    }>;
  }>;
};

export type BulkDeletePostsMutationVariables = Exact<{
  postIds: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type BulkDeletePostsMutation = { __typename?: 'Mutation'; bulkDeletePosts: boolean };

export type GetTimeslotsQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetTimeslotsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    timeslots: Array<{
      __typename?: 'Timeslot';
      id: string;
      day: TimeslotDay;
      time: string;
      onboardingContent: boolean;
      category: { __typename?: 'Category'; id: string; name: string; color: CategoryColor };
      socialProfiles: Array<
        | { __typename?: 'SocialProfile'; id: string }
        | { __typename?: 'TikTokSocialProfile'; id: string }
        | { __typename?: 'TwitterSocialProfile'; id: string }
        | { __typename?: 'FacebookSocialProfile'; id: string }
        | { __typename?: 'GoogleSocialProfile'; id: string }
        | { __typename?: 'PinterestSocialProfile'; id: string }
        | { __typename?: 'LinkedInSocialProfile'; id: string }
        | { __typename?: 'InstagramSocialProfile'; id: string }
        | { __typename?: 'GenericSocialProfile'; id: string }
      >;
    }>;
  };
};

export type DeleteTimeslotMutationVariables = Exact<{
  timeslotId: Scalars['ID'];
}>;

export type DeleteTimeslotMutation = { __typename?: 'Mutation'; deleteTimeslot: boolean };

export type GetSnippetsQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetSnippetsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    snippets: Array<{ __typename?: 'Snippet'; id: string; name?: string | null; content?: string | null }>;
  };
};

export type DeleteSnippetMutationVariables = Exact<{
  snippetId: Scalars['ID'];
}>;

export type DeleteSnippetMutation = { __typename?: 'Mutation'; deleteSnippet: boolean };

export type GetNotificationsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type GetNotificationsQuery = {
  __typename?: 'Query';
  notifications: {
    __typename?: 'PorpaginasResult_Notification';
    count?: number | null;
    items: Array<{
      __typename?: 'Notification';
      id: string;
      timestamp: number;
      message: string;
      isRead: boolean;
      name: NotificationName;
    }>;
  };
};

export type MarkAllNotificationsAsReadMutationVariables = Exact<{
  orgId: Scalars['ID'];
}>;

export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation'; markAllNotificationsAsRead: boolean };

export type BulkMarkNotificationsAsReadMutationVariables = Exact<{
  notificationIds: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type BulkMarkNotificationsAsReadMutation = {
  __typename?: 'Mutation';
  bulkMarkNotificationsAsRead: Array<{
    __typename?: 'Notification';
    id: string;
    timestamp: number;
    message: string;
    isRead: boolean;
    name: NotificationName;
  }>;
};

export type UpdateCombinedOrganizationSettingsMutationVariables = Exact<{
  input: CombinedOrganizationSettingsInput;
  organizationId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
}>;

export type UpdateCombinedOrganizationSettingsMutation = {
  __typename?: 'Mutation';
  updateOrganizationSettings: {
    __typename?: 'CombinedOrganizationSettings';
    userOrganizationSettings?: {
      __typename?: 'UserOrganizationSettings';
      id: string;
      timeFormat: TimeFormatSetting;
      dateFormat: DateFormatSetting;
      startOfWeekFormat: StartOfWeekFormatSetting;
    } | null;
    organizationSettings: { __typename?: 'OrganizationSettings'; id: string; productAnalyticsEnabled: boolean };
  };
};

export type UpdateUserOnlineMarketingMutationVariables = Exact<{
  onlineMarketing: Scalars['Boolean'];
  userId?: InputMaybe<Scalars['ID']>;
}>;

export type UpdateUserOnlineMarketingMutation = {
  __typename?: 'Mutation';
  updateUserSettings: {
    __typename?: 'UserSettings';
    id: string;
    onlineMarketing: boolean;
    notifyFeatureAddedEnabled: boolean;
    notifyMailingListEnabled: boolean;
    notifyProductUpdatesEnabled: boolean;
    notifyReferralCreditsEnabled: boolean;
  };
};

export type HelpscoutMetadataQueryVariables = Exact<{ [key: string]: never }>;

export type HelpscoutMetadataQuery = {
  __typename?: 'Query';
  helpscoutMetadata?: {
    __typename?: 'HelpscoutBeaconMetadata';
    beaconId: string;
    email: string;
    signature: string;
  } | null;
};

export type AdminUserFragment = {
  __typename?: 'User';
  id: string;
  email: string;
  firstName: string;
  appRole: UserAppRole;
  fromLegacy: boolean;
  migratedToOverhaul: boolean;
};

export type GetAdminUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type GetAdminUserQuery = {
  __typename?: 'Query';
  admin_user: {
    __typename?: 'User';
    id: string;
    email: string;
    firstName: string;
    appRole: UserAppRole;
    fromLegacy: boolean;
    migratedToOverhaul: boolean;
  };
};

export type GetInvoicesAndBillingQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;

export type GetInvoicesAndBillingQuery = {
  __typename?: 'Query';
  organization: {
    __typename?: 'Organization';
    id: string;
    invoices: Array<{
      __typename?: 'Invoice';
      id: string;
      status?: InvoiceStatus | null;
      failureMessage?: string | null;
      planAmount: string;
      planType: PlanType;
      accountNumber: string;
      invoiceNumber: string;
      date: any;
      billingPeriodStartDate: any;
      billingPeriodEndDate: any;
      amount: string;
      amountGbp: string;
      addonsAmount: string;
      discountAmount: string;
      discountPercentage?: string | null;
      discountType?: string | null;
      currencyCode: CurrencyCode;
      paypalEmail?: string | null;
      type: InvoiceTransactionType;
      paymentMethod: InvoicePaymentMethod;
      renewalType: InvoiceRenewalType;
      vatAmount?: string | null;
      preVatAmount: string;
      vatReverseCharge: boolean;
      billingAddressDetails: {
        __typename?: 'InvoiceBillingAddressDetailsType';
        firstName: string;
        lastName: string;
        email: string;
        countryCode: string;
      };
      businessAddressDetails: {
        __typename?: 'InvoiceBusinessAddressDetailsType';
        companyName: string;
        address1: string;
        address2?: string | null;
        city: string;
        region: string;
        postCode: string;
        countryCode: string;
      };
      vatBusinessDetails?: {
        __typename?: 'InvoiceVatBusinessDetailsType';
        numberCountryCode: string;
        number: string;
        rateCharged: string;
        countryChargedCode: string;
        countryChargedDisplayName: string;
      } | null;
      creditCard?: {
        __typename?: 'BraintreeCreditCardType';
        type: string;
        last4Digits: string;
        expiryMonth: number;
        expiryYear: number;
        countryCode: string;
      } | null;
    }>;
  };
};

export type DeleteWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type DeleteWorkspaceMutation = { __typename?: 'Mutation'; deleteWorkspace: boolean };

export type GetEmailNotificationSettingsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;

export type GetEmailNotificationSettingsQuery = {
  __typename?: 'Query';
  organization: {
    __typename?: 'Organization';
    id: string;
    name: string;
    settings: {
      __typename?: 'OrganizationSettings';
      id: string;
      productAnalyticsEnabled: boolean;
      notifySubscriptionEnabled: boolean;
    };
    myUserAssignment?: {
      __typename?: 'UserOrganizationAssignment';
      id: string;
      role: UserOrganizationRole;
      settings: {
        __typename?: 'UserOrganizationSettings';
        id: string;
        dateFormat: DateFormatSetting;
        timeFormat: TimeFormatSetting;
        notifyWeeklyStatsEnabled: boolean;
        notifyQueueEmptyEnabled: boolean;
        notifyPostProfileErrorEnabled: boolean;
        notifyInstagramPostEnabled: boolean;
        notifyAutoRssEnabled: boolean;
      };
      user: { __typename?: 'User'; id: string; firstName: string; email: string };
    } | null;
  };
};

export type UpdateEmailNotificationSettingsMutationVariables = Exact<{
  input: CombinedOrganizationSettingsInput;
  organizationId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
}>;

export type UpdateEmailNotificationSettingsMutation = {
  __typename?: 'Mutation';
  updateOrganizationSettings: {
    __typename?: 'CombinedOrganizationSettings';
    userOrganizationSettings?: {
      __typename?: 'UserOrganizationSettings';
      id: string;
      timeFormat: TimeFormatSetting;
      dateFormat: DateFormatSetting;
      notifyPostProfileErrorEnabled: boolean;
      notifyWeeklyStatsEnabled: boolean;
      notifyQueueEmptyEnabled: boolean;
      notifyInstagramPostEnabled: boolean;
      notifyAutoRssEnabled: boolean;
    } | null;
    organizationSettings: {
      __typename?: 'OrganizationSettings';
      id: string;
      productAnalyticsEnabled: boolean;
      notifySubscriptionEnabled: boolean;
    };
  };
};

export type UpdateUserSettingsMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  input: UserSettingsInput;
}>;

export type UpdateUserSettingsMutation = {
  __typename?: 'Mutation';
  updateUserSettings: {
    __typename?: 'UserSettings';
    id: string;
    onlineMarketing: boolean;
    notifyFeatureAddedEnabled: boolean;
    notifyMailingListEnabled: boolean;
    notifyProductUpdatesEnabled: boolean;
    notifyReferralCreditsEnabled: boolean;
  };
};

export type CreateInvitedMemberMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  input: UserInvitationInput;
}>;

export type CreateInvitedMemberMutation = {
  __typename?: 'Mutation';
  createUserInvitation: {
    __typename?: 'UserInvitation';
    id: string;
    email: string;
    role: UserOrganizationRole;
    workspaceIds: Array<string>;
    token: string;
  };
};

export type GetBitlyAccountsQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetBitlyAccountsQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    settings: {
      __typename?: 'WorkspaceSettings';
      id: string;
      campaignTracking: boolean;
      shouldRemoveUtm: boolean;
      utm?: {
        __typename?: 'UTM';
        source: string;
        medium: string;
        campaign: string;
        term: string;
        content: string;
      } | null;
      defaultBitly?: {
        __typename?: 'DefaultBitly';
        domain: string;
        bitly: { __typename?: 'Bitly'; id: string; displayName: string; connected: boolean; domains: Array<string> };
      } | null;
    };
    bitlyAccounts: Array<{
      __typename?: 'Bitly';
      id: string;
      displayName: string;
      connected: boolean;
      domains: Array<string>;
    }>;
    socialProfiles: Array<
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
          customBitly?: {
            __typename?: 'CustomBitly';
            id: string;
            domain?: string | null;
            bitly?: {
              __typename?: 'Bitly';
              id: string;
              displayName: string;
              connected: boolean;
              domains: Array<string>;
            } | null;
          } | null;
        }
    >;
  };
};

export type ConnectBitlyMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  socialAuthToken: Scalars['String'];
}>;

export type ConnectBitlyMutation = {
  __typename?: 'Mutation';
  connectBitly: { __typename?: 'Bitly'; id: string; displayName: string; connected: boolean; domains: Array<string> };
};

export type ReconnectBitlyMutationVariables = Exact<{
  bitlyId: Scalars['ID'];
  socialAuthToken: Scalars['String'];
}>;

export type ReconnectBitlyMutation = {
  __typename?: 'Mutation';
  reconnectBitly: { __typename?: 'Bitly'; id: string; displayName: string; connected: boolean; domains: Array<string> };
};

export type RemoveBitlyMutationVariables = Exact<{
  bitlyId: Scalars['ID'];
}>;

export type RemoveBitlyMutation = { __typename?: 'Mutation'; removeBitly: boolean };

export type UpdateCustomBitlySettingsMutationVariables = Exact<{
  input: Array<UpdateCustomBitlySettingsInput> | UpdateCustomBitlySettingsInput;
}>;

export type UpdateCustomBitlySettingsMutation = {
  __typename?: 'Mutation';
  bulkUpdateCustomBitlySettings: Array<
    | {
        __typename?: 'SocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
    | {
        __typename?: 'TikTokSocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
    | {
        __typename?: 'TwitterSocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
    | {
        __typename?: 'FacebookSocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
    | {
        __typename?: 'GoogleSocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
    | {
        __typename?: 'PinterestSocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
    | {
        __typename?: 'LinkedInSocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
    | {
        __typename?: 'InstagramSocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
    | {
        __typename?: 'GenericSocialProfile';
        id: string;
        customBitly?: {
          __typename?: 'CustomBitly';
          id: string;
          domain?: string | null;
          bitly?: {
            __typename?: 'Bitly';
            id: string;
            displayName: string;
            connected: boolean;
            domains: Array<string>;
          } | null;
        } | null;
      }
  >;
};

export type ChangeNameEmailMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
}>;

export type ChangeNameEmailMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    firstName: string;
    email: string;
    appRole: UserAppRole;
    timezone: TimezoneSetting;
    passwordSet: boolean;
  };
};

export type CreateWorkspaceMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  input: WorkspaceInput;
}>;

export type CreateWorkspaceMutation = {
  __typename?: 'Mutation';
  createWorkspace: {
    __typename?: 'Workspace';
    id: string;
    name: string;
    timezone: TimezoneSetting;
    users: Array<{ __typename?: 'User'; id: string; firstName: string; email: string; appRole: UserAppRole }>;
    organization: { __typename?: 'Organization'; id: string };
  };
};

export type UpdateWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: WorkspaceInput;
}>;

export type UpdateWorkspaceMutation = {
  __typename?: 'Mutation';
  updateWorkspace: {
    __typename?: 'Workspace';
    id: string;
    name: string;
    timezone: TimezoneSetting;
    users: Array<{ __typename?: 'User'; id: string; firstName: string; email: string; appRole: UserAppRole }>;
    organization: { __typename?: 'Organization'; id: string };
  };
};

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    firstName: string;
    email: string;
    appRole: UserAppRole;
    timezone: TimezoneSetting;
    passwordSet: boolean;
  };
};

export type SetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  userId?: InputMaybe<Scalars['ID']>;
}>;

export type SetPasswordMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'User';
    id: string;
    firstName: string;
    email: string;
    appRole: UserAppRole;
    timezone: TimezoneSetting;
    passwordSet: boolean;
  };
};

export type UpdatePauseSettingsMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: UpdateWorkspaceSettingsInput;
}>;

export type UpdatePauseSettingsMutation = {
  __typename?: 'Mutation';
  updateWorkspaceSettings: {
    __typename?: 'WorkspaceSettings';
    id: string;
    queuesPaused: boolean;
    autoImportsPaused: boolean;
  };
};

export type UpdatePauseSettingsPerProfileCategoryMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: Array<QueueMetaInput> | QueueMetaInput;
}>;

export type UpdatePauseSettingsPerProfileCategoryMutation = {
  __typename?: 'Mutation';
  bulkUpdateQueueMeta: Array<{
    __typename?: 'QueueMetadata';
    paused: boolean;
    socialProfile:
      | { __typename?: 'SocialProfile'; id: string }
      | { __typename?: 'TikTokSocialProfile'; id: string }
      | { __typename?: 'TwitterSocialProfile'; id: string }
      | { __typename?: 'FacebookSocialProfile'; id: string }
      | { __typename?: 'GoogleSocialProfile'; id: string }
      | { __typename?: 'PinterestSocialProfile'; id: string }
      | { __typename?: 'LinkedInSocialProfile'; id: string }
      | { __typename?: 'InstagramSocialProfile'; id: string }
      | { __typename?: 'GenericSocialProfile'; id: string };
    category: { __typename?: 'Category'; id: string };
  }>;
};

export type GetQueueMetadataQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetQueueMetadataQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    queueMeta: Array<{
      __typename?: 'QueueMetadata';
      paused: boolean;
      socialProfile:
        | { __typename?: 'SocialProfile'; id: string }
        | { __typename?: 'TikTokSocialProfile'; id: string }
        | { __typename?: 'TwitterSocialProfile'; id: string }
        | { __typename?: 'FacebookSocialProfile'; id: string }
        | { __typename?: 'GoogleSocialProfile'; id: string }
        | { __typename?: 'PinterestSocialProfile'; id: string }
        | { __typename?: 'LinkedInSocialProfile'; id: string }
        | { __typename?: 'InstagramSocialProfile'; id: string }
        | { __typename?: 'GenericSocialProfile'; id: string };
      category: { __typename?: 'Category'; id: string };
    }>;
  };
};

export type GetSocialProfilesQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetSocialProfilesQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    socialProfiles: Array<
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
    >;
  };
};

export type ConnectMainSocialProfileMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  socialAuthToken: Scalars['String'];
}>;

export type ConnectMainSocialProfileMutation = {
  __typename?: 'Mutation';
  connectMainSocialProfile: Array<{
    __typename: 'SocialProfileConnectionResult';
    connected: boolean;
    reconnected: boolean;
    additionalReconnection: boolean;
    error?: string | null;
    socialProfile?:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
      | null;
  }>;
};

export type ReconnectSocialProfileMutationVariables = Exact<{
  socialAuthToken: Scalars['String'];
  profileId: Scalars['ID'];
}>;

export type ReconnectSocialProfileMutation = {
  __typename?: 'Mutation';
  reconnectSocialProfile: Array<{
    __typename: 'SocialProfileConnectionResult';
    connected: boolean;
    reconnected: boolean;
    additionalReconnection: boolean;
    error?: string | null;
    socialProfile?:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          workspace: { __typename?: 'Workspace'; id: string };
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          workspace: { __typename?: 'Workspace'; id: string };
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          workspace: { __typename?: 'Workspace'; id: string };
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          workspace: { __typename?: 'Workspace'; id: string };
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          workspace: { __typename?: 'Workspace'; id: string };
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          workspace: { __typename?: 'Workspace'; id: string };
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          workspace: { __typename?: 'Workspace'; id: string };
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          workspace: { __typename?: 'Workspace'; id: string };
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
          workspace: { __typename?: 'Workspace'; id: string };
        }
      | null;
  }>;
};

export type AppInstalledQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type AppInstalledQuery = {
  __typename?: 'Query';
  socialProfile:
    | { __typename?: 'SocialProfile' }
    | { __typename?: 'TikTokSocialProfile' }
    | { __typename?: 'TwitterSocialProfile' }
    | { __typename?: 'FacebookSocialProfile'; id: string; groupAppInstalled?: boolean | null }
    | { __typename?: 'GoogleSocialProfile' }
    | { __typename?: 'PinterestSocialProfile' }
    | { __typename?: 'LinkedInSocialProfile' }
    | { __typename?: 'InstagramSocialProfile' }
    | { __typename?: 'GenericSocialProfile' };
};

export type ExternalSecondaryProfilesQueryVariables = Exact<{
  socialAuthToken: Scalars['String'];
  type: SecondaryProfileType;
  profileNetwork: Network;
  workspaceId: Scalars['ID'];
}>;

export type ExternalSecondaryProfilesQuery = {
  __typename?: 'Query';
  externalSecondaryProfiles: Array<{
    __typename?: 'ExternalSecondaryProfileData';
    externalId: string;
    displayName: string;
    organizationId?: string | null;
    workspaceId?: string | null;
    photoUrl?: string | null;
    availablePostAsProfiles?: Array<{ __typename?: 'PostAsProfile'; externalId: string; displayName: string }> | null;
  }>;
};

export type UpdateSocialProfileDirectPublishingMutationVariables = Exact<{
  socialProfileId: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;

export type UpdateSocialProfileDirectPublishingMutation = {
  __typename?: 'Mutation';
  updateSocialProfileDirectPublishing: {
    __typename?: 'InstagramSocialProfile';
    id: string;
    directPublishEnabled: boolean;
  };
};

export type GetWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type GetWorkspaceQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    id: string;
    name: string;
    settings: {
      __typename?: 'WorkspaceSettings';
      id: string;
      evergreenRecycling: boolean;
      attributionInstagram: boolean;
      minimumRecycleTime: MinimumRecycleTime;
      multiMediaAttachMode: PostMultiMediaAttachMode;
      defaultQueuePosition: PostQueuePosition;
      fbLinkPreview: FbLinkPreview;
      importMediaBehavior: ImportMediaBehavior;
    };
  };
};

export type UpdateWorkspaceSettingsMutationVariables = Exact<{
  input: UpdateWorkspaceSettingsInput;
  workspaceId: Scalars['ID'];
}>;

export type UpdateWorkspaceSettingsMutation = {
  __typename?: 'Mutation';
  updateWorkspaceSettings: {
    __typename?: 'WorkspaceSettings';
    workspace: {
      __typename?: 'Workspace';
      id: string;
      settings: {
        __typename?: 'WorkspaceSettings';
        id: string;
        campaignTracking: boolean;
        shouldRemoveUtm: boolean;
        evergreenRecycling: boolean;
        attributionInstagram: boolean;
        minimumRecycleTime: MinimumRecycleTime;
        multiMediaAttachMode: PostMultiMediaAttachMode;
        defaultQueuePosition: PostQueuePosition;
        fbLinkPreview: FbLinkPreview;
        importMediaBehavior: ImportMediaBehavior;
        defaultBitly?: {
          __typename?: 'DefaultBitly';
          domain: string;
          bitly: { __typename?: 'Bitly'; id: string; displayName: string; connected: boolean; domains: Array<string> };
        } | null;
      };
    };
  };
};

export type DeleteInvitedMemberMutationVariables = Exact<{
  userInvitationId: Scalars['ID'];
}>;

export type DeleteInvitedMemberMutation = { __typename?: 'Mutation'; deleteUserInvitation: boolean };

export type RemoveUserOrganizationAssignmentMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
}>;

export type RemoveUserOrganizationAssignmentMutation = {
  __typename?: 'Mutation';
  removeUserOrganizationAssignment: boolean;
};

export type GetOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;

export type GetOrganizationQuery = {
  __typename?: 'Query';
  organization: {
    __typename?: 'Organization';
    id: string;
    userAssignments: Array<{
      __typename?: 'UserOrganizationAssignment';
      id: string;
      role: UserOrganizationRole;
      user: { __typename?: 'User'; id: string; firstName: string; email: string };
    }>;
    userInvitations: Array<{
      __typename?: 'UserInvitation';
      id: string;
      email: string;
      role: UserOrganizationRole;
      workspaceIds: Array<string>;
      token: string;
    }>;
    workspaces: Array<{
      __typename?: 'Workspace';
      id: string;
      name: string;
      timezone: TimezoneSetting;
      users: Array<{ __typename?: 'User'; id: string; firstName: string }>;
      socialProfiles: Array<
        | {
            __typename?: 'SocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
        | {
            __typename?: 'TikTokSocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
        | {
            __typename?: 'TwitterSocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
        | {
            __typename?: 'FacebookSocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
        | {
            __typename?: 'GoogleSocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
        | {
            __typename?: 'PinterestSocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
        | {
            __typename?: 'InstagramSocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
        | {
            __typename?: 'GenericSocialProfile';
            id: string;
            connected: boolean;
            photoUrl: string;
            displayName: string;
            onboardingContent: boolean;
            workspace: { __typename?: 'Workspace'; id: string };
          }
      >;
    }>;
  };
};

export type UpdateUserInvitationMutationVariables = Exact<{
  userInvitationId: Scalars['ID'];
  input: UserInvitationInput;
}>;

export type UpdateUserInvitationMutation = {
  __typename?: 'Mutation';
  updateUserInvitation: {
    __typename?: 'UserInvitation';
    id: string;
    email: string;
    role: UserOrganizationRole;
    workspaceIds: Array<string>;
  };
};

export type UpdateUserOrganizationAssignmentMutationVariables = Exact<{
  userId: Scalars['ID'];
  organizationId: Scalars['ID'];
  input: UserOrganizationAssignmentInput;
}>;

export type UpdateUserOrganizationAssignmentMutation = {
  __typename?: 'Mutation';
  updateUserOrganizationAssignment: {
    __typename?: 'UserOrganizationAssignment';
    id: string;
    role: UserOrganizationRole;
  };
};

export type CreateUserWorkspaceAssignmentMutationVariables = Exact<{
  userId: Scalars['ID'];
  workspaceId: Scalars['ID'];
}>;

export type CreateUserWorkspaceAssignmentMutation = {
  __typename?: 'Mutation';
  createUserWorkspaceAssignment: {
    __typename?: 'Workspace';
    id: string;
    name: string;
    users: Array<{ __typename?: 'User'; id: string; firstName: string; email: string }>;
    organization: { __typename?: 'Organization'; id: string };
  };
};

export type RemoveUserWorkspaceAssignmentMutationVariables = Exact<{
  userId: Scalars['ID'];
  workspaceId: Scalars['ID'];
}>;

export type RemoveUserWorkspaceAssignmentMutation = { __typename?: 'Mutation'; removeUserWorkspaceAssignment: boolean };

export type ResendUserInvitationMutationVariables = Exact<{
  userInvitationId: Scalars['ID'];
}>;

export type ResendUserInvitationMutation = { __typename?: 'Mutation'; resendUserInvitation: boolean };

export type GetUnreadNotificationsQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;

export type GetUnreadNotificationsQuery = { __typename?: 'Query'; unreadNotificationCount: number };

export type GetUnreadSiteNewsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUnreadSiteNewsQuery = {
  __typename?: 'Query';
  unreadSiteNews: Array<{ __typename?: 'SiteNews'; text: string; title: string; id: string; date: any }>;
};

export type UpdateLastReadSiteNewsMutationVariables = Exact<{
  siteNewsId: Scalars['ID'];
}>;

export type UpdateLastReadSiteNewsMutation = { __typename?: 'Mutation'; updateLastReadSiteNews: boolean };

export type GetAllSiteNewsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllSiteNewsQuery = {
  __typename?: 'Query';
  allSiteNews: Array<{ __typename?: 'SiteNews'; text: string; title: string; id: string; date: any }>;
};

export type GetCategoriesUsageQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  selectedProfilesIds: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type GetCategoriesUsageQuery = {
  __typename?: 'Query';
  workspace: {
    __typename?: 'Workspace';
    categories: Array<{
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      onboardingContent: boolean;
      defaultSocialProfiles: Array<
        | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'FacebookSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'PinterestSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'InstagramSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      >;
    }>;
  };
  analyticsPostStats: {
    __typename?: 'PostStatsResult';
    postStatsByCategory?: Array<{
      __typename?: 'PostStatsByCategory';
      categoryId: string;
      postStats: Array<{
        __typename?: 'PostStats';
        postCount: number;
        rangeStartDate: string;
        rangeEndDate: string;
        likes?: number | null;
        comments?: number | null;
        shares?: number | null;
      }>;
    }> | null;
  };
};

export type GetPostStatsQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  selectedProfilesIds: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type GetPostStatsQuery = {
  __typename?: 'Query';
  analyticsPostStats: {
    __typename?: 'PostStatsResult';
    postStatsByProfile?: Array<{
      __typename?: 'PostStatsByProfile';
      socialProfileId: string;
      postStats: Array<{
        __typename?: 'PostStats';
        postCount: number;
        rangeStartDate: string;
        rangeEndDate: string;
        likes?: number | null;
        comments?: number | null;
        shares?: number | null;
      }>;
    }> | null;
  };
};

export type GetAnalyticsOverviewDataQueryVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  selectedProfilesIds: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type GetAnalyticsOverviewDataQuery = {
  __typename?: 'Query';
  analyticsFollowers: Array<{
    __typename?: 'ProfileFollowersStats';
    socialProfileId: string;
    previousPeriodStats?: {
      __typename?: 'FollowersStats';
      rangeStartDate: string;
      rangeEndDate: string;
      followers?: number | null;
    } | null;
    followersStats: Array<{
      __typename?: 'FollowersStats';
      rangeStartDate: string;
      rangeEndDate: string;
      followers?: number | null;
    }>;
  }>;
  analyticsPostStats: {
    __typename?: 'PostStatsResult';
    postStatsByProfile?: Array<{
      __typename?: 'PostStatsByProfile';
      socialProfileId: string;
      postStats: Array<{
        __typename?: 'PostStats';
        postCount: number;
        rangeStartDate: string;
        rangeEndDate: string;
        likes?: number | null;
        comments?: number | null;
        shares?: number | null;
        impressions?: number | null;
      }>;
    }> | null;
  };
};

export type CreateAutoImportMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: CreateAutoImportInput;
}>;

export type CreateAutoImportMutation = {
  __typename?: 'Mutation';
  createAutoImport: {
    __typename?: 'AutoImport';
    id: string;
    name: string;
    url: string;
    refineByTerm: string;
    postTiming: AutoImportPostTiming;
    status: AutoImportStatus;
    prefixText?: string | null;
    suffixText?: string | null;
    recycle: boolean;
    recycleMaxRepeats: number;
    bitlyTracking: boolean;
    removeLinks: boolean;
    firstImportedPost: any;
    lastImportedPost: any;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      onboardingContent: boolean;
      defaultSocialProfiles: Array<
        | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'FacebookSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'PinterestSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'InstagramSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      >;
    };
    socialProfiles: Array<
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
    >;
    pinterestBoards: Array<{
      __typename?: 'AutoImportPinterestBoard';
      pinterestBoardId: string;
      socialProfileId: string;
    }>;
  };
};

export type EditAutoImportMutationVariables = Exact<{
  autoImportId: Scalars['ID'];
  input: UpdateAutoImportInput;
}>;

export type EditAutoImportMutation = {
  __typename?: 'Mutation';
  updateAutoImport: {
    __typename?: 'AutoImport';
    id: string;
    name: string;
    url: string;
    refineByTerm: string;
    postTiming: AutoImportPostTiming;
    status: AutoImportStatus;
    prefixText?: string | null;
    suffixText?: string | null;
    recycle: boolean;
    recycleMaxRepeats: number;
    bitlyTracking: boolean;
    removeLinks: boolean;
    firstImportedPost: any;
    lastImportedPost: any;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      color: CategoryColor;
      onboardingContent: boolean;
      defaultSocialProfiles: Array<
        | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'FacebookSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
        | {
            __typename?: 'PinterestSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'LinkedInSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | {
            __typename?: 'InstagramSocialProfile';
            id: string;
            displayName: string;
            photoUrl: string;
            connected: boolean;
          }
        | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      >;
    };
    socialProfiles: Array<
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
    >;
    pinterestBoards: Array<{
      __typename?: 'AutoImportPinterestBoard';
      pinterestBoardId: string;
      socialProfileId: string;
    }>;
  };
};

export type DeleteAutoImportMutationVariables = Exact<{
  importId: Scalars['ID'];
}>;

export type DeleteAutoImportMutation = { __typename?: 'Mutation'; deleteAutoImport: boolean };

export type DeleteAllAutoImportsMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;

export type DeleteAllAutoImportsMutation = { __typename?: 'Mutation'; deleteAllAutoImports: boolean };

export type CreateImportFolderMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: CreateImportFolderInput;
}>;

export type CreateImportFolderMutation = {
  __typename?: 'Mutation';
  createImportFolder: {
    __typename?: 'ImportFolder';
    id: string;
    name?: string | null;
    order: number;
    importSources: Array<{
      __typename?: 'ImportSource';
      id: string;
      type: ImportSourceType;
      name?: string | null;
      order: number;
      args:
        | { __typename?: 'ImportSourceArgsRss'; url?: string | null; term?: string | null }
        | {
            __typename: 'ImportSourceArgsTwitter';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            includeReplies: boolean;
            includeRetweets: boolean;
            thirdPartyProfileDisplayName?: string | null;
            twitterSearchType: TwitterSearchType;
            twitterContentType: TwitterSearchContentType;
            twitterSortType: TwitterSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsLinkedIn';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            linkedInSearchType: LinkedInSearchType;
            linkedInContentType: LinkedInSearchContentType;
            linkedInSortType: LinkedInSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsPinterest';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            boardId?: string | null;
            pinterestSearchType: PinterestSearchType;
            pinterestContentType: PinterestSearchContentType;
            pinterestSortType: PinterestSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsInstagram';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            instagramSearchType: InstagramSearchType;
            instagramSortType: InstagramSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsFacebook';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            facebookSearchType: FacebookSearchType;
            facebookContentType: FacebookSearchContentType;
            facebookSortType: FacebookSearchSortType;
          }
        | { __typename?: 'ImportSourceArgsSocialNetwork'; term?: string | null }
        | { __typename?: 'ImportSourceArgs'; term?: string | null };
      folder?: { __typename?: 'ImportFolder'; id: string } | null;
    }>;
  };
};

export type SearchFacebookPostsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
  searchType: FacebookSearchType;
  sortType: FacebookSearchSortType;
  contentType: FacebookSearchContentType;
  externalId: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type SearchFacebookPostsQuery = {
  __typename?: 'Query';
  searchFacebookPosts: {
    __typename?: 'ThirdPartyPostSearchResult';
    cursor?: string | null;
    items: Array<{
      __typename?: 'ThirdPartyPost';
      attachmentTypes: Array<ThirdPartyPostAttachmentType>;
      comments?: number | null;
      createdAt: any;
      externalId: string;
      impressions?: number | null;
      likes?: number | null;
      platform: string;
      postUrl: string;
      saves?: number | null;
      shares?: number | null;
      source?: string | null;
      text: string;
      title?: string | null;
      tweetType?: ThirdPartyPostTweetType | null;
      linkDescription?: string | null;
      linkImageUrl?: string | null;
      linkName?: string | null;
      linkUrl?: string | null;
      externalProfile: {
        __typename?: 'ThirdPartyProfile';
        displayName: string;
        username: string;
        externalId?: string | null;
        platform?: string | null;
        profileUrl?: string | null;
      };
      media: Array<{
        __typename?: 'ThirdPartyPostMedia';
        type: ThirdPartyPostMediaType;
        url?: string | null;
        thumbnailUrl?: string | null;
      }>;
      textMentions: Array<{
        __typename?: 'ThirdPartyPostMention';
        externalId?: string | null;
        start?: number | null;
        length?: number | null;
      }>;
    }>;
  };
};

export type SearchFacebookLikedPagesQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
}>;

export type SearchFacebookLikedPagesQuery = {
  __typename?: 'Query';
  searchFacebookLikedPages: Array<{
    __typename?: 'ThirdPartyProfile';
    photoUrl?: string | null;
    displayName: string;
    username: string;
    externalId?: string | null;
    platform?: string | null;
    profileUrl?: string | null;
  }>;
};

export type SearchInstagramPostsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
  externalId: Scalars['String'];
  searchType: InstagramSearchType;
  sortType: InstagramSearchSortType;
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type SearchInstagramPostsQuery = {
  __typename?: 'Query';
  searchInstagramPosts: {
    __typename?: 'ThirdPartyPostSearchResult';
    cursor?: string | null;
    items: Array<{
      __typename?: 'ThirdPartyPost';
      attachmentTypes: Array<ThirdPartyPostAttachmentType>;
      comments?: number | null;
      createdAt: any;
      externalId: string;
      impressions?: number | null;
      likes?: number | null;
      platform: string;
      postUrl: string;
      saves?: number | null;
      shares?: number | null;
      source?: string | null;
      text: string;
      title?: string | null;
      tweetType?: ThirdPartyPostTweetType | null;
      linkDescription?: string | null;
      linkImageUrl?: string | null;
      linkName?: string | null;
      linkUrl?: string | null;
      externalProfile: {
        __typename?: 'ThirdPartyProfile';
        displayName: string;
        username: string;
        externalId?: string | null;
        platform?: string | null;
        profileUrl?: string | null;
      };
      media: Array<{
        __typename?: 'ThirdPartyPostMedia';
        type: ThirdPartyPostMediaType;
        url?: string | null;
        thumbnailUrl?: string | null;
      }>;
      textMentions: Array<{
        __typename?: 'ThirdPartyPostMention';
        externalId?: string | null;
        start?: number | null;
        length?: number | null;
      }>;
    }>;
  };
};

export type SearchLinkedInPostsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
  searchType: LinkedInSearchType;
  contentType: LinkedInSearchContentType;
  sortType: LinkedInSearchSortType;
  externalId: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type SearchLinkedInPostsQuery = {
  __typename?: 'Query';
  searchLinkedInPosts: {
    __typename?: 'ThirdPartyPostSearchResult';
    cursor?: string | null;
    items: Array<{
      __typename?: 'ThirdPartyPost';
      attachmentTypes: Array<ThirdPartyPostAttachmentType>;
      comments?: number | null;
      createdAt: any;
      externalId: string;
      impressions?: number | null;
      likes?: number | null;
      platform: string;
      postUrl: string;
      saves?: number | null;
      shares?: number | null;
      source?: string | null;
      text: string;
      title?: string | null;
      tweetType?: ThirdPartyPostTweetType | null;
      linkDescription?: string | null;
      linkImageUrl?: string | null;
      linkName?: string | null;
      linkUrl?: string | null;
      externalProfile: {
        __typename?: 'ThirdPartyProfile';
        displayName: string;
        username: string;
        externalId?: string | null;
        platform?: string | null;
        profileUrl?: string | null;
      };
      media: Array<{
        __typename?: 'ThirdPartyPostMedia';
        type: ThirdPartyPostMediaType;
        url?: string | null;
        thumbnailUrl?: string | null;
      }>;
      textMentions: Array<{
        __typename?: 'ThirdPartyPostMention';
        externalId?: string | null;
        start?: number | null;
        length?: number | null;
      }>;
    }>;
  };
};

export type SearchPinterestFollowedBoardsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
}>;

export type SearchPinterestFollowedBoardsQuery = {
  __typename?: 'Query';
  searchPinterestFollowedBoards: Array<{
    __typename?: 'PinterestBoard';
    externalId: string;
    name: string;
    photoUrl?: string | null;
  }>;
};

export type SearchPinterestPostsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
  searchType: PinterestSearchType;
  contentType: PinterestSearchContentType;
  sortType: PinterestSearchSortType;
  externalId: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type SearchPinterestPostsQuery = {
  __typename?: 'Query';
  searchPinterestPosts: {
    __typename?: 'ThirdPartyPostSearchResult';
    cursor?: string | null;
    items: Array<{
      __typename?: 'ThirdPartyPost';
      attachmentTypes: Array<ThirdPartyPostAttachmentType>;
      comments?: number | null;
      createdAt: any;
      externalId: string;
      impressions?: number | null;
      likes?: number | null;
      platform: string;
      postUrl: string;
      saves?: number | null;
      shares?: number | null;
      source?: string | null;
      text: string;
      title?: string | null;
      tweetType?: ThirdPartyPostTweetType | null;
      linkDescription?: string | null;
      linkImageUrl?: string | null;
      linkName?: string | null;
      linkUrl?: string | null;
      externalProfile: {
        __typename?: 'ThirdPartyProfile';
        displayName: string;
        username: string;
        externalId?: string | null;
        platform?: string | null;
        profileUrl?: string | null;
      };
      media: Array<{
        __typename?: 'ThirdPartyPostMedia';
        type: ThirdPartyPostMediaType;
        url?: string | null;
        thumbnailUrl?: string | null;
      }>;
      textMentions: Array<{
        __typename?: 'ThirdPartyPostMention';
        externalId?: string | null;
        start?: number | null;
        length?: number | null;
      }>;
    }>;
  };
};

export type SearchRssPostsQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
  url: Scalars['String'];
  term?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type SearchRssPostsQuery = {
  __typename?: 'Query';
  searchRssPosts: {
    __typename?: 'RssPostSearchResultType';
    cursor?: string | null;
    items: Array<{
      __typename?: 'ExternalRssPost';
      createdAt?: any | null;
      content: string;
      postUrl?: string | null;
      imageUrl?: string | null;
    }>;
  };
};

export type SearchTwitterListsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
}>;

export type SearchTwitterListsQuery = {
  __typename?: 'Query';
  searchTwitterLists: Array<{ __typename?: 'TwitterList'; externalId: string; name: string; memberCount: number }>;
};

export type SearchTwitterPostsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
  searchType: TwitterSearchType;
  contentType: TwitterSearchContentType;
  sortType: TwitterSearchSortType;
  includeRetweets?: InputMaybe<Scalars['Boolean']>;
  includeReplies?: InputMaybe<Scalars['Boolean']>;
  term?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;

export type SearchTwitterPostsQuery = {
  __typename?: 'Query';
  searchTwitterPosts: {
    __typename?: 'ThirdPartyPostSearchResult';
    cursor?: string | null;
    items: Array<{
      __typename?: 'ThirdPartyPost';
      attachmentTypes: Array<ThirdPartyPostAttachmentType>;
      comments?: number | null;
      createdAt: any;
      externalId: string;
      impressions?: number | null;
      likes?: number | null;
      platform: string;
      postUrl: string;
      saves?: number | null;
      shares?: number | null;
      source?: string | null;
      text: string;
      title?: string | null;
      tweetType?: ThirdPartyPostTweetType | null;
      linkDescription?: string | null;
      linkImageUrl?: string | null;
      linkName?: string | null;
      linkUrl?: string | null;
      externalProfile: {
        __typename?: 'ThirdPartyProfile';
        displayName: string;
        username: string;
        externalId?: string | null;
        platform?: string | null;
        profileUrl?: string | null;
      };
      media: Array<{
        __typename?: 'ThirdPartyPostMedia';
        type: ThirdPartyPostMediaType;
        url?: string | null;
        thumbnailUrl?: string | null;
      }>;
      textMentions: Array<{
        __typename?: 'ThirdPartyPostMention';
        externalId?: string | null;
        start?: number | null;
        length?: number | null;
      }>;
    }>;
  };
};

export type DeleteImportFolderMutationVariables = Exact<{
  importFolderId: Scalars['ID'];
}>;

export type DeleteImportFolderMutation = { __typename?: 'Mutation'; deleteImportFolder: boolean };

export type DeleteImportSourceMutationVariables = Exact<{
  importSourceId: Scalars['ID'];
}>;

export type DeleteImportSourceMutation = { __typename?: 'Mutation'; deleteImportSource: boolean };

export type RssOpmlUploadMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  file: Scalars['Upload'];
}>;

export type RssOpmlUploadMutation = {
  __typename?: 'Mutation';
  rssOpmlUpload: {
    __typename?: 'RssOpmlUploadResult';
    importFolders: Array<{ __typename?: 'ImportFolder'; id: string; name?: string | null; order: number }>;
    importSources: Array<{
      __typename?: 'ImportSource';
      id: string;
      type: ImportSourceType;
      name?: string | null;
      order: number;
      args:
        | { __typename?: 'ImportSourceArgsRss'; url?: string | null; term?: string | null }
        | {
            __typename: 'ImportSourceArgsTwitter';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            includeReplies: boolean;
            includeRetweets: boolean;
            thirdPartyProfileDisplayName?: string | null;
            twitterSearchType: TwitterSearchType;
            twitterContentType: TwitterSearchContentType;
            twitterSortType: TwitterSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsLinkedIn';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            linkedInSearchType: LinkedInSearchType;
            linkedInContentType: LinkedInSearchContentType;
            linkedInSortType: LinkedInSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsPinterest';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            boardId?: string | null;
            pinterestSearchType: PinterestSearchType;
            pinterestContentType: PinterestSearchContentType;
            pinterestSortType: PinterestSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsInstagram';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            instagramSearchType: InstagramSearchType;
            instagramSortType: InstagramSearchSortType;
          }
        | {
            __typename?: 'ImportSourceArgsFacebook';
            term?: string | null;
            socialProfileId?: number | null;
            externalId?: string | null;
            facebookSearchType: FacebookSearchType;
            facebookContentType: FacebookSearchContentType;
            facebookSortType: FacebookSearchSortType;
          }
        | { __typename?: 'ImportSourceArgsSocialNetwork'; term?: string | null }
        | { __typename?: 'ImportSourceArgs'; term?: string | null };
      folder?: { __typename?: 'ImportFolder'; id: string } | null;
    }>;
  };
};

export type UpdateImportFolderMutationVariables = Exact<{
  importFolderId: Scalars['ID'];
  input: UpdateImportFolderInput;
}>;

export type UpdateImportFolderMutation = {
  __typename?: 'Mutation';
  updateImportFolder: { __typename?: 'ImportFolder'; id: string; name?: string | null; order: number };
};

export type UpdateImportSourceMutationVariables = Exact<{
  importSourceId: Scalars['ID'];
  input: UpdateImportSourceInput;
}>;

export type UpdateImportSourceMutation = {
  __typename?: 'Mutation';
  updateImportSource: {
    __typename?: 'ImportSource';
    id: string;
    type: ImportSourceType;
    name?: string | null;
    order: number;
    args:
      | { __typename?: 'ImportSourceArgsRss'; url?: string | null; term?: string | null }
      | {
          __typename: 'ImportSourceArgsTwitter';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          includeReplies: boolean;
          includeRetweets: boolean;
          thirdPartyProfileDisplayName?: string | null;
          twitterSearchType: TwitterSearchType;
          twitterContentType: TwitterSearchContentType;
          twitterSortType: TwitterSearchSortType;
        }
      | {
          __typename?: 'ImportSourceArgsLinkedIn';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          linkedInSearchType: LinkedInSearchType;
          linkedInContentType: LinkedInSearchContentType;
          linkedInSortType: LinkedInSearchSortType;
        }
      | {
          __typename?: 'ImportSourceArgsPinterest';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          boardId?: string | null;
          pinterestSearchType: PinterestSearchType;
          pinterestContentType: PinterestSearchContentType;
          pinterestSortType: PinterestSearchSortType;
        }
      | {
          __typename?: 'ImportSourceArgsInstagram';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          instagramSearchType: InstagramSearchType;
          instagramSortType: InstagramSearchSortType;
        }
      | {
          __typename?: 'ImportSourceArgsFacebook';
          term?: string | null;
          socialProfileId?: number | null;
          externalId?: string | null;
          facebookSearchType: FacebookSearchType;
          facebookContentType: FacebookSearchContentType;
          facebookSortType: FacebookSearchSortType;
        }
      | { __typename?: 'ImportSourceArgsSocialNetwork'; term?: string | null }
      | { __typename?: 'ImportSourceArgs'; term?: string | null };
    folder?: { __typename?: 'ImportFolder'; id: string } | null;
  };
};

export type GetThirdPartyProfilesQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
  method: ThirdPartyProfileSearchType;
  term: Scalars['String'];
}>;

export type GetThirdPartyProfilesQuery = {
  __typename?: 'Query';
  searchThirdPartyProfiles: Array<{
    __typename?: 'ThirdPartyProfile';
    photoUrl?: string | null;
    displayName: string;
    username: string;
    externalId?: string | null;
    platform?: string | null;
    profileUrl?: string | null;
  }>;
};

export type GetCategoryQueryVariables = Exact<{
  categoryId: Scalars['ID'];
}>;

export type GetCategoryQuery = {
  __typename?: 'Query';
  category: {
    __typename?: 'Category';
    id: string;
    name: string;
    seasonal: boolean;
    seasonalStartDate?: string | null;
    seasonalEndDate?: string | null;
    seasonallyPaused: boolean;
    archived: boolean;
    archivedDate?: any | null;
    archivedAttachedPostCount?: number | null;
    defaultSocialProfiles: Array<
      | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'FacebookSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'PinterestSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'LinkedInSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'InstagramSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    >;
  };
};

export type CreateCategoryMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: CreateCategoryInput;
}>;

export type CreateCategoryMutation = {
  __typename?: 'Mutation';
  createCategory: {
    __typename?: 'Category';
    id: string;
    name: string;
    seasonal: boolean;
    seasonalStartDate?: string | null;
    seasonalEndDate?: string | null;
    seasonallyPaused: boolean;
    archived: boolean;
    archivedDate?: any | null;
    archivedAttachedPostCount?: number | null;
    color: CategoryColor;
    onboardingContent: boolean;
    defaultSocialProfiles: Array<
      | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'FacebookSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'PinterestSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'LinkedInSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'InstagramSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    >;
  };
};

export type UpdateCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID'];
  input: UpdateCategoryInput;
}>;

export type UpdateCategoryMutation = {
  __typename?: 'Mutation';
  updateCategory: {
    __typename?: 'Category';
    id: string;
    name: string;
    seasonal: boolean;
    seasonalStartDate?: string | null;
    seasonalEndDate?: string | null;
    seasonallyPaused: boolean;
    archived: boolean;
    archivedDate?: any | null;
    archivedAttachedPostCount?: number | null;
    color: CategoryColor;
    defaultSocialProfiles: Array<
      | { __typename?: 'SocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'TikTokSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'TwitterSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'FacebookSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'GoogleSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'PinterestSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'LinkedInSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'InstagramSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
      | { __typename?: 'GenericSocialProfile'; id: string; displayName: string; photoUrl: string; connected: boolean }
    >;
  };
};

export type DeleteCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID'];
}>;

export type DeleteCategoryMutation = { __typename?: 'Mutation'; deleteCategory: boolean };

export type SearchPixabayQueryVariables = Exact<{
  input: PixabaySearchInput;
}>;

export type SearchPixabayQuery = {
  __typename?: 'Query';
  searchPixabay: Array<{
    __typename?: 'ThirdPartyMediaItem';
    mediaType: MediaType;
    url: string;
    previewUrl: string;
    proportions: MediaProportions;
    gif: boolean;
    createdBy?: string | null;
    createdByUsername?: string | null;
  }>;
};

export type SearchGiphyQueryVariables = Exact<{
  input: GiphySearchInput;
}>;

export type SearchGiphyQuery = {
  __typename?: 'Query';
  searchGiphy: Array<{
    __typename?: 'ThirdPartyMediaItem';
    mediaType: MediaType;
    url: string;
    previewUrl: string;
    proportions: MediaProportions;
    gif: boolean;
    createdBy?: string | null;
    createdByUsername?: string | null;
  }>;
};

export type SearchUnsplashQueryVariables = Exact<{
  input: UnsplashSearchInput;
}>;

export type SearchUnsplashQuery = {
  __typename?: 'Query';
  searchUnsplash: Array<{
    __typename?: 'ThirdPartyMediaItem';
    mediaType: MediaType;
    url: string;
    previewUrl: string;
    proportions: MediaProportions;
    gif: boolean;
    createdBy?: string | null;
    createdByUsername?: string | null;
  }>;
};

export type CreateTimeslotMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: TimeslotInput;
}>;

export type CreateTimeslotMutation = {
  __typename?: 'Mutation';
  createTimeslot: {
    __typename?: 'Timeslot';
    id: string;
    day: TimeslotDay;
    time: string;
    onboardingContent: boolean;
    category: { __typename?: 'Category'; id: string; name: string; color: CategoryColor };
    socialProfiles: Array<
      | { __typename?: 'SocialProfile'; id: string }
      | { __typename?: 'TikTokSocialProfile'; id: string }
      | { __typename?: 'TwitterSocialProfile'; id: string }
      | { __typename?: 'FacebookSocialProfile'; id: string }
      | { __typename?: 'GoogleSocialProfile'; id: string }
      | { __typename?: 'PinterestSocialProfile'; id: string }
      | { __typename?: 'LinkedInSocialProfile'; id: string }
      | { __typename?: 'InstagramSocialProfile'; id: string }
      | { __typename?: 'GenericSocialProfile'; id: string }
    >;
  };
};

export type UpdateTimeslotMutationVariables = Exact<{
  timeslotId: Scalars['ID'];
  input: TimeslotInput;
}>;

export type UpdateTimeslotMutation = {
  __typename?: 'Mutation';
  updateTimeslot: {
    __typename?: 'Timeslot';
    id: string;
    day: TimeslotDay;
    time: string;
    onboardingContent: boolean;
    category: { __typename?: 'Category'; id: string };
    socialProfiles: Array<
      | { __typename?: 'SocialProfile'; id: string }
      | { __typename?: 'TikTokSocialProfile'; id: string }
      | { __typename?: 'TwitterSocialProfile'; id: string }
      | { __typename?: 'FacebookSocialProfile'; id: string }
      | { __typename?: 'GoogleSocialProfile'; id: string }
      | { __typename?: 'PinterestSocialProfile'; id: string }
      | { __typename?: 'LinkedInSocialProfile'; id: string }
      | { __typename?: 'InstagramSocialProfile'; id: string }
      | { __typename?: 'GenericSocialProfile'; id: string }
    >;
  };
};

export type BulkDeleteTimeslotsMutationVariables = Exact<{
  timeslotIds: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type BulkDeleteTimeslotsMutation = { __typename?: 'Mutation'; bulkDeleteTimeslots: boolean };

export type CreateSnippetMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: CreateSnippetInput;
}>;

export type CreateSnippetMutation = {
  __typename?: 'Mutation';
  createSnippet: { __typename?: 'Snippet'; id: string; name?: string | null; content?: string | null };
};

export type UpdateSnippetMutationVariables = Exact<{
  snippetId: Scalars['ID'];
  input: UpdateSnippetInput;
}>;

export type UpdateSnippetMutation = {
  __typename?: 'Mutation';
  updateSnippet: { __typename?: 'Snippet'; id: string; name?: string | null; content?: string | null };
};

export type GetAdminUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminUsersQuery = {
  __typename?: 'Query';
  admin_users: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    firstName: string;
    appRole: UserAppRole;
    fromLegacy: boolean;
    migratedToOverhaul: boolean;
  }>;
};

export type UpdateUtmSettingsMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  input: UpdateWorkspaceSettingsInput;
}>;

export type UpdateUtmSettingsMutation = {
  __typename?: 'Mutation';
  updateWorkspaceSettings: {
    __typename?: 'WorkspaceSettings';
    id: string;
    campaignTracking: boolean;
    utm?: {
      __typename?: 'UTM';
      source: string;
      medium: string;
      campaign: string;
      term: string;
      content: string;
    } | null;
  };
};

export type ConnectSecondarySocialProfilesMutationVariables = Exact<{
  workspaceId: Scalars['ID'];
  socialAuthToken: Scalars['String'];
  profilesNetwork: Network;
  profiles: Array<SecondaryProfileConnectionInput> | SecondaryProfileConnectionInput;
}>;

export type ConnectSecondarySocialProfilesMutation = {
  __typename?: 'Mutation';
  connectSecondarySocialProfiles: Array<{
    __typename?: 'SocialProfileConnectionResult';
    connected: boolean;
    reconnected: boolean;
    additionalReconnection: boolean;
    error?: string | null;
    socialProfile?:
      | {
          __typename?: 'SocialProfile';
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TikTokSocialProfile';
          tikTokId: string;
          privacy: TikTokPrivacy;
          commentDisabled: boolean;
          duetDisabled: boolean;
          stitchDisabled: boolean;
          maxVideoDuration: number;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'TwitterSocialProfile';
          twitterId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'FacebookSocialProfile';
          type: string;
          facebookId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          postAs?: {
            __typename?: 'SocialProfileTokenOwner';
            displayName: string;
            id: string;
            externalId: string;
          } | null;
        }
      | {
          __typename?: 'GoogleSocialProfile';
          googleId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'PinterestSocialProfile';
          pinterestId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
          boards: Array<{ __typename?: 'PinterestBoard'; externalId: string; name: string; photoUrl?: string | null }>;
        }
      | {
          __typename?: 'LinkedInSocialProfile';
          type: string;
          linkedInId: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'InstagramSocialProfile';
          directPublishEnabled: boolean;
          type: string;
          apiType: InstagramApiType;
          instagramId?: string | null;
          username: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched?: boolean | null;
        }
      | {
          __typename?: 'GenericSocialProfile';
          network: Network;
          username: string;
          colour: string;
          platformName: string;
          id: string;
          connected: boolean;
          displayName: string;
          photoUrl: string;
          onboardingContent: boolean;
          photoUrlFetched: boolean;
          genericProfile: GenericProfileType;
        }
      | null;
  }>;
};

export type RemoveSocialProfileMutationVariables = Exact<{
  socialProfileId: Scalars['ID'];
}>;

export type RemoveSocialProfileMutation = { __typename?: 'Mutation'; removeSocialProfile: boolean };

export type GetBestTimePostStatsQueryVariables = Exact<{
  socialProfileId: Scalars['ID'];
}>;

export type GetBestTimePostStatsQuery = {
  __typename?: 'Query';
  analyticsBestTimeToPostStats: {
    __typename?: 'BestTimeToPostStatsResult';
    postEngagementByDayOfWeek: {
      __typename?: 'PostEngagementByDayOfWeek';
      monday?: number | null;
      tuesday?: number | null;
      wednesday?: number | null;
      thursday?: number | null;
      friday?: number | null;
      saturday?: number | null;
      sunday?: number | null;
    };
    postEngagementByHourOfDay: {
      __typename?: 'PostEngagementByHourOfDay';
      hour0?: number | null;
      hour1?: number | null;
      hour2?: number | null;
      hour3?: number | null;
      hour4?: number | null;
      hour5?: number | null;
      hour6?: number | null;
      hour7?: number | null;
      hour8?: number | null;
      hour9?: number | null;
      hour10?: number | null;
      hour11?: number | null;
      hour12?: number | null;
      hour13?: number | null;
      hour14?: number | null;
      hour15?: number | null;
      hour16?: number | null;
      hour17?: number | null;
      hour18?: number | null;
      hour19?: number | null;
      hour20?: number | null;
      hour21?: number | null;
      hour22?: number | null;
      hour23?: number | null;
    };
  };
};

export const CoreAutoImportFieldsFragmentDoc = gql`
  fragment CoreAutoImportFields on AutoImport {
    id
    name
    url
    refineByTerm
    postTiming
    status
    prefixText
    suffixText
    recycle
    recycleMaxRepeats
    bitlyTracking
    removeLinks
    firstImportedPost
    lastImportedPost
  }
`;
export const AutoImportFieldsFragmentDoc = gql`
  fragment AutoImportFields on AutoImport {
    ...CoreAutoImportFields
    pinterestBoards {
      pinterestBoardId
      socialProfileId
    }
  }
  ${CoreAutoImportFieldsFragmentDoc}
`;
export const CoreDefaultProfilesFieldsFragmentDoc = gql`
  fragment CoreDefaultProfilesFields on SocialProfileInterface {
    id
    displayName
    photoUrl
    connected
  }
`;
export const CategoryFieldsFragmentDoc = gql`
  fragment CategoryFields on Category {
    id
    name
    color
    onboardingContent
    defaultSocialProfiles {
      ...CoreDefaultProfilesFields
    }
  }
  ${CoreDefaultProfilesFieldsFragmentDoc}
`;
export const CoreAiCaptionGenerationFieldsFragmentDoc = gql`
  fragment CoreAiCaptionGenerationFields on AiCaptionGenerationType {
    captions
    createdAt
    lastUpdated
    status
  }
`;
export const CoreAiCaptionInitiateTypeFragmentDoc = gql`
  fragment CoreAiCaptionInitiateType on AiCaptionInitiateType {
    cacheKey
  }
`;
export const CoreBillingAddressDetailsFieldsFragmentDoc = gql`
  fragment CoreBillingAddressDetailsFields on InvoiceBillingAddressDetailsType {
    firstName
    lastName
    email
    countryCode
  }
`;
export const CoreBitlyFieldsFragmentDoc = gql`
  fragment CoreBitlyFields on Bitly {
    id
    displayName
    connected
    domains
  }
`;
export const CoreBusinessAddressDetailsFieldsFragmentDoc = gql`
  fragment CoreBusinessAddressDetailsFields on InvoiceBusinessAddressDetailsType {
    companyName
    address1
    address2
    city
    region
    postCode
    countryCode
  }
`;
export const CoreCreditCardFieldsFragmentDoc = gql`
  fragment CoreCreditCardFields on BraintreeCreditCardType {
    type
    last4Digits
    expiryMonth
    expiryYear
    countryCode
  }
`;
export const CorePostFieldsFragmentDoc = gql`
  fragment CorePostFields on Post {
    calculatedLocalDateTime
    calculatedUtcDatetime
    dateAdded
    dateFailed
    datePosted
    delayedUtcOriginalDatetime
    draftQueuePosition
    expiryLocalDate
    failedMessage
    familyUuid
    feedType
    firstComment
    id
    isEvergreen
    maxRepeats
    onboardingContent
    order
    parentId
    pinterestBoardId
    prevPostedCount
    publishedUrl
    publishMethod
    actualPublishMethod
    recurringInterval
    recurringValue
    futureScheduledLocalDateTimes
    publishedUtcDateTimes
    scheduledTimezone
    siblingId
    status
    texts
    timing
    title
  }
`;
export const CoreCategoryFieldsFragmentDoc = gql`
  fragment CoreCategoryFields on Category {
    id
    name
    color
    seasonal
    seasonalStartDate
    seasonalEndDate
    seasonallyPaused
    archived
    archivedDate
  }
`;
export const IterationsAggregationFieldsFragmentDoc = gql`
  fragment IterationsAggregationFields on PostIterationAggregations {
    id
    sumClicks
    sumLikes
    sumShares
    sumImpressions
    sumComments
    sumVideoViews
    maxClicks
    maxLikes
    maxShares
    maxImpressions
    maxComments
    maxVideoViews
    boost
    countTimesPosted
    oldestPost {
      id
      dateAdded
    }
    newestPost {
      id
    }
    actualPublishMethods
  }
`;
export const CoreLinkFieldsFragmentDoc = gql`
  fragment CoreLinkFields on Link {
    id
    caption
    url
    initialUrl
    expandedUrl
    bitlyDestinationUrl
    urlBitlink
    initialUrlBitlink
    destination
    clickTracking
    previewRemoved
    googleCallToAction
    bitlyPreference
  }
`;
export const CoreUtmFieldsFragmentDoc = gql`
  fragment CoreUtmFields on UTM {
    campaign
    content
    medium
    source
    term
  }
`;
export const CoreOpenGraphFieldsFragmentDoc = gql`
  fragment CoreOpenGraphFields on OpenGraph {
    image
    title
    description
  }
`;
export const CoreTwitterCardFieldsFragmentDoc = gql`
  fragment CoreTwitterCardFields on TwitterCard {
    image
    title
    description
    card
  }
`;
export const LinkFieldsFragmentDoc = gql`
  fragment LinkFields on Link {
    ...CoreLinkFields
    utm {
      ...CoreUtmFields
    }
    openGraph {
      ...CoreOpenGraphFields
    }
    twitterCard {
      ...CoreTwitterCardFields
    }
  }
  ${CoreLinkFieldsFragmentDoc}
  ${CoreUtmFieldsFragmentDoc}
  ${CoreOpenGraphFieldsFragmentDoc}
  ${CoreTwitterCardFieldsFragmentDoc}
`;
export const ThirdPartyProfileFieldsWithoutPhotoUrlFragmentDoc = gql`
  fragment ThirdPartyProfileFieldsWithoutPhotoUrl on ThirdPartyProfile {
    displayName
    username
    externalId
    platform
    profileUrl
  }
`;
export const ThirdPartyProfileFieldsFragmentDoc = gql`
  fragment ThirdPartyProfileFields on ThirdPartyProfile {
    ...ThirdPartyProfileFieldsWithoutPhotoUrl
    photoUrl
  }
  ${ThirdPartyProfileFieldsWithoutPhotoUrlFragmentDoc}
`;
export const CorePhotoFieldsFragmentDoc = gql`
  fragment CorePhotoFields on Photo {
    id
    width
    height
    url
    proportions
    filesize
    filename
    type
    thumbnailUrl
    gif
  }
`;
export const CorePostPublishedStatFieldsFragmentDoc = gql`
  fragment CorePostPublishedStatFields on PostPublishedStats {
    clicks
    likes
    shares
    comments
    impressions
    videoViews
    saves
    boost
  }
`;
export const CoreSocialProfileFieldsFragmentDoc = gql`
  fragment CoreSocialProfileFields on SocialProfileInterface {
    id
    connected
    displayName
    photoUrl
    onboardingContent
    photoUrlFetched @client
  }
`;
export const CoreTikTokProfileFieldsFragmentDoc = gql`
  fragment CoreTikTokProfileFields on TikTokSocialProfile {
    tikTokId
    privacy
    commentDisabled
    duetDisabled
    stitchDisabled
    maxVideoDuration
  }
`;
export const CorePinterestBoardFieldsFragmentDoc = gql`
  fragment CorePinterestBoardFields on PinterestBoard {
    externalId
    name
    photoUrl
  }
`;
export const SocialProfileFieldsFragmentDoc = gql`
  fragment SocialProfileFields on SocialProfileInterface {
    ...CoreSocialProfileFields
    ... on FacebookSocialProfile {
      type
      facebookId
      postAs: tokenOwner {
        displayName
        id
        externalId
      }
    }
    ... on LinkedInSocialProfile {
      type
      linkedInId
    }
    ... on InstagramSocialProfile {
      directPublishEnabled
      type
      apiType
      instagramId
      username
    }
    ... on TikTokSocialProfile {
      ...CoreTikTokProfileFields
    }
    ... on TwitterSocialProfile {
      twitterId
    }
    ... on GoogleSocialProfile {
      googleId
    }
    ... on PinterestSocialProfile {
      pinterestId
      boards {
        ...CorePinterestBoardFields
      }
    }
    ... on GenericSocialProfile {
      network
      username
      colour
      platformName
      genericProfile: type
    }
  }
  ${CoreSocialProfileFieldsFragmentDoc}
  ${CoreTikTokProfileFieldsFragmentDoc}
  ${CorePinterestBoardFieldsFragmentDoc}
`;
export const PostTikTokFieldsFragmentDoc = gql`
  fragment PostTikTokFields on PostTikTok {
    privacy
    disableComment
    disableDuet
    disableStitch
    brandSelf
    brandOther
    autoAddMusic
  }
`;
export const CoreMediaLibraryItemFieldsFragmentDoc = gql`
  fragment CoreMediaLibraryItemFields on MediaInterface {
    id
    dateUploaded
    type
    archived
    origin
    proportions
    width
    height
    url
    thumbnailUrl
    source
    filesize
  }
`;
export const CurrentVariationFieldsFragmentDoc = gql`
  fragment CurrentVariationFields on PostCurrentVariation {
    text
    media {
      ...CoreMediaLibraryItemFields
    }
  }
  ${CoreMediaLibraryItemFieldsFragmentDoc}
`;
export const VariationsMetaFieldsFragmentDoc = gql`
  fragment VariationsMetaFields on PostVariationMeta {
    total
    currentIndex
    hasMultiple
    multiMediaAttachMode
    currentIndex
    currentVariation {
      ...CurrentVariationFields
    }
  }
  ${CurrentVariationFieldsFragmentDoc}
`;
export const CoreVideoFieldsFragmentDoc = gql`
  fragment CoreVideoFields on Video {
    id
    width
    height
    proportions
    url
    source
    transcoded
    length
    thumbnailUrl
    type
    filesize
  }
`;
export const PostItemFragmentDoc = gql`
  fragment PostItem on Post {
    ...CorePostFields
    category {
      ...CoreCategoryFields
    }
    iterationAggregations {
      ...IterationsAggregationFields
    }
    link {
      ...LinkFields
    }
    mentions {
      ...ThirdPartyProfileFields
    }
    photos {
      ...CorePhotoFields
    }
    publishedStats {
      ...CorePostPublishedStatFields
    }
    socialProfile {
      ...SocialProfileFields
    }
    tikTok {
      ...PostTikTokFields
    }
    variationMeta {
      ...VariationsMetaFields
    }
    videos {
      ...CoreVideoFields
    }
  }
  ${CorePostFieldsFragmentDoc}
  ${CoreCategoryFieldsFragmentDoc}
  ${IterationsAggregationFieldsFragmentDoc}
  ${LinkFieldsFragmentDoc}
  ${ThirdPartyProfileFieldsFragmentDoc}
  ${CorePhotoFieldsFragmentDoc}
  ${CorePostPublishedStatFieldsFragmentDoc}
  ${SocialProfileFieldsFragmentDoc}
  ${PostTikTokFieldsFragmentDoc}
  ${VariationsMetaFieldsFragmentDoc}
  ${CoreVideoFieldsFragmentDoc}
`;
export const CoreCursorPaginationFragmentDoc = gql`
  fragment CoreCursorPagination on QueueItemsCursorPagination {
    cursor
    count
    items {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;
export const CoreCustomBitlyFieldsFragmentDoc = gql`
  fragment CoreCustomBitlyFields on CustomBitly {
    id
    domain
  }
`;
export const CoreDateRangePaginationFragmentDoc = gql`
  fragment CoreDateRangePagination on QueueItemsDateRangePagination {
    count
    startDate
    endDate
    items {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;
export const CoreImportFolderFieldsFragmentDoc = gql`
  fragment CoreImportFolderFields on ImportFolder {
    id
    name
    order
  }
`;
export const CoreInvoiceFieldsFragmentDoc = gql`
  fragment CoreInvoiceFields on Invoice {
    id
    status
    failureMessage
    planAmount
    planType
    accountNumber
    invoiceNumber
    date
    billingPeriodStartDate
    billingPeriodEndDate
    amount
    amountGbp
    addonsAmount
    discountAmount
    discountPercentage
    discountType
    currencyCode
    paypalEmail
    type
    paymentMethod
    renewalType
    vatAmount
    preVatAmount
    vatReverseCharge
  }
`;
export const CoreMediaLibraryPhotoFieldsFragmentDoc = gql`
  fragment CoreMediaLibraryPhotoFields on Photo {
    filename
    gif
    filesize
  }
`;
export const CoreMediaLibraryVideoFieldsFragmentDoc = gql`
  fragment CoreMediaLibraryVideoFields on Video {
    dateUploaded
    transcoded
    length
    filesize
  }
`;
export const CoreStepsSeenFieldsFragmentDoc = gql`
  fragment CoreStepsSeenFields on UserOnboardingStep {
    name
  }
`;
export const CoreOnboardingFieldsFragmentDoc = gql`
  fragment CoreOnboardingFields on UserOnboardingType {
    version
    completed
    stepsSeen {
      ...CoreStepsSeenFields
    }
  }
  ${CoreStepsSeenFieldsFragmentDoc}
`;
export const CoreSnippetFieldsFragmentDoc = gql`
  fragment CoreSnippetFields on Snippet {
    id
    name
    content
  }
`;
export const CoreThirdPartySearchFieldsFragmentDoc = gql`
  fragment CoreThirdPartySearchFields on ThirdPartyMediaItem {
    mediaType
    url
    previewUrl
    proportions
    gif
    createdBy
    createdByUsername
  }
`;
export const CoreTimeslotFieldsFragmentDoc = gql`
  fragment CoreTimeslotFields on Timeslot {
    id
    day
    time
    onboardingContent
  }
`;
export const CoreTokenFieldsFragmentDoc = gql`
  fragment CoreTokenFields on Token {
    token
    expiresIn
  }
`;
export const CoreVatBusinessDetailFieldsFragmentDoc = gql`
  fragment CoreVatBusinessDetailFields on InvoiceVatBusinessDetailsType {
    numberCountryCode
    number
    rateCharged
    countryChargedCode
    countryChargedDisplayName
  }
`;
export const ExternalRssPostFieldsFragmentDoc = gql`
  fragment ExternalRssPostFields on ExternalRssPost {
    createdAt
    content
    postUrl
    imageUrl
  }
`;
export const CoreImportSourceFieldsFragmentDoc = gql`
  fragment CoreImportSourceFields on ImportSource {
    id
    type
    name
    order
  }
`;
export const CoreImportSourceFacebookArgFieldsFragmentDoc = gql`
  fragment CoreImportSourceFacebookArgFields on ImportSourceArgsFacebook {
    socialProfileId
    externalId
    facebookSearchType: searchType
    facebookContentType: contentType
    facebookSortType: sortType
  }
`;
export const CoreImportSourceInstagramArgFieldsFragmentDoc = gql`
  fragment CoreImportSourceInstagramArgFields on ImportSourceArgsInstagram {
    socialProfileId
    externalId
    instagramSearchType: searchType
    instagramSortType: sortType
  }
`;
export const CoreImportSourceTwitterArgFieldsFragmentDoc = gql`
  fragment CoreImportSourceTwitterArgFields on ImportSourceArgsTwitter {
    socialProfileId
    externalId
    twitterSearchType: searchType
    twitterContentType: contentType
    twitterSortType: sortType
    includeReplies
    includeRetweets
    thirdPartyProfileDisplayName
  }
`;
export const CoreImportSourceLinkedInArgFieldsFragmentDoc = gql`
  fragment CoreImportSourceLinkedInArgFields on ImportSourceArgsLinkedIn {
    socialProfileId
    externalId
    linkedInSearchType: searchType
    linkedInContentType: contentType
    linkedInSortType: sortType
  }
`;
export const CoreImportSourcePinterestArgFieldsFragmentDoc = gql`
  fragment CoreImportSourcePinterestArgFields on ImportSourceArgsPinterest {
    socialProfileId
    externalId
    boardId
    pinterestSearchType: searchType
    pinterestContentType: contentType
    pinterestSortType: sortType
  }
`;
export const ImportSourceFieldsFragmentDoc = gql`
  fragment ImportSourceFields on ImportSource {
    ...CoreImportSourceFields
    args {
      term
      ... on ImportSourceArgsFacebook {
        ...CoreImportSourceFacebookArgFields
      }
      ... on ImportSourceArgsInstagram {
        ...CoreImportSourceInstagramArgFields
      }
      ... on ImportSourceArgsTwitter {
        __typename
        ...CoreImportSourceTwitterArgFields
      }
      ... on ImportSourceArgsLinkedIn {
        ...CoreImportSourceLinkedInArgFields
      }
      ... on ImportSourceArgsPinterest {
        ...CoreImportSourcePinterestArgFields
      }
      ... on ImportSourceArgsRss {
        url
      }
    }
    folder {
      id
    }
  }
  ${CoreImportSourceFieldsFragmentDoc}
  ${CoreImportSourceFacebookArgFieldsFragmentDoc}
  ${CoreImportSourceInstagramArgFieldsFragmentDoc}
  ${CoreImportSourceTwitterArgFieldsFragmentDoc}
  ${CoreImportSourceLinkedInArgFieldsFragmentDoc}
  ${CoreImportSourcePinterestArgFieldsFragmentDoc}
`;
export const CoreLinkMetadataFieldsFragmentDoc = gql`
  fragment CoreLinkMetadataFields on LinkMetadata {
    error
    initialUrl
    expandedUrl
    domain
    images
    isBitlink
  }
`;
export const LinkMetadataFieldsFragmentDoc = gql`
  fragment LinkMetadataFields on LinkMetadata {
    ...CoreLinkMetadataFields
    openGraph {
      ...CoreOpenGraphFields
    }
    twitterCard {
      ...CoreTwitterCardFields
    }
  }
  ${CoreLinkMetadataFieldsFragmentDoc}
  ${CoreOpenGraphFieldsFragmentDoc}
  ${CoreTwitterCardFieldsFragmentDoc}
`;
export const MobileAppFieldsFragmentDoc = gql`
  fragment MobileAppFields on MobileApp {
    id
    connected
    deviceName
    deviceType
    firstConnectedTime
    lastConnectedTime
    owner {
      id
      firstName
    }
  }
`;
export const QueueCountsFieldsFragmentDoc = gql`
  fragment QueueCountsFields on PostQueueCountResult {
    categories {
      categoryId
      count
    }
    socialProfiles {
      socialProfileId
      count
    }
    status {
      scheduled
      past
      failed
      paused
      draft
      unqueued
      deleted
    }
    content {
      image
      imageLink
      link
      text
      video
      videoLink
    }
    timing {
      setDates
      recurring
      queued
    }
    evergreen {
      evergreenOnly
    }
    source {
      autoRss
      csvUpload
      postEditor
      socialImport
    }
  }
`;
export const QueueMetaFieldsFragmentDoc = gql`
  fragment QueueMetaFields on QueueMetadata {
    socialProfile {
      id
    }
    category {
      id
    }
    paused
  }
`;
export const SocialAuthTokenFieldsFragmentDoc = gql`
  fragment SocialAuthTokenFields on SocialAuthToken {
    network
    externalId
    email
    firstName
    displayName
    photoUrl
  }
`;
export const ThirdPartyPostLinkFieldsFragmentDoc = gql`
  fragment ThirdPartyPostLinkFields on ThirdPartyPost {
    linkDescription
    linkImageUrl
    linkName
    linkUrl
  }
`;
export const ThirdPartyPostMentionFieldsFragmentDoc = gql`
  fragment ThirdPartyPostMentionFields on ThirdPartyPostMention {
    externalId
    start
    length
  }
`;
export const ThirdPartyPostFieldsFragmentDoc = gql`
  fragment ThirdPartyPostFields on ThirdPartyPost {
    ...ThirdPartyPostLinkFields
    attachmentTypes
    comments
    createdAt
    externalId
    externalProfile {
      ...ThirdPartyProfileFieldsWithoutPhotoUrl
    }
    impressions
    likes
    media {
      type
      url
      thumbnailUrl
    }
    platform
    postUrl
    saves
    shares
    source
    text
    textMentions {
      ...ThirdPartyPostMentionFields
    }
    title
    tweetType
  }
  ${ThirdPartyPostLinkFieldsFragmentDoc}
  ${ThirdPartyProfileFieldsWithoutPhotoUrlFragmentDoc}
  ${ThirdPartyPostMentionFieldsFragmentDoc}
`;
export const UserFieldsFragmentDoc = gql`
  fragment UserFields on User {
    id
    firstName
    email
    appRole
    timezone
    passwordSet
  }
`;
export const UsageFieldsFragmentDoc = gql`
  fragment UsageFields on PlanUsageType {
    __typename
    posts
    socialProfiles
    activeCategories
    autoImports
    importSources
    aiCredits
    users
  }
`;
export const AdminUserFragmentDoc = gql`
  fragment AdminUser on User {
    id
    email
    firstName
    appRole
    fromLegacy
    migratedToOverhaul
  }
`;
export const LogoutDocument = gql`
  mutation Logout {
    logout
  }
`;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RefreshAccessTokenDocument = gql`
  mutation RefreshAccessToken {
    refreshAccessToken {
      ...CoreTokenFields
    }
  }
  ${CoreTokenFieldsFragmentDoc}
`;
export type RefreshAccessTokenMutationFn = Apollo.MutationFunction<
  RefreshAccessTokenMutation,
  RefreshAccessTokenMutationVariables
>;

/**
 * __useRefreshAccessTokenMutation__
 *
 * To run a mutation, you first call `useRefreshAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAccessTokenMutation, { data, loading, error }] = useRefreshAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>(
    RefreshAccessTokenDocument,
    options
  );
}
export type RefreshAccessTokenMutationHookResult = ReturnType<typeof useRefreshAccessTokenMutation>;
export type RefreshAccessTokenMutationResult = Apollo.MutationResult<RefreshAccessTokenMutation>;
export type RefreshAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshAccessTokenMutation,
  RefreshAccessTokenMutationVariables
>;
export const GetCategoriesProfilesWithBoardsDocument = gql`
  query GetCategoriesProfilesWithBoards($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      categories(statusFilter: ACTIVE) {
        ...CategoryFields
      }
      socialProfiles {
        ...SocialProfileFields
      }
    }
  }
  ${CategoryFieldsFragmentDoc}
  ${SocialProfileFieldsFragmentDoc}
`;

/**
 * __useGetCategoriesProfilesWithBoardsQuery__
 *
 * To run a query within a React component, call `useGetCategoriesProfilesWithBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesProfilesWithBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesProfilesWithBoardsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetCategoriesProfilesWithBoardsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCategoriesProfilesWithBoardsQuery,
    GetCategoriesProfilesWithBoardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCategoriesProfilesWithBoardsQuery, GetCategoriesProfilesWithBoardsQueryVariables>(
    GetCategoriesProfilesWithBoardsDocument,
    options
  );
}
export function useGetCategoriesProfilesWithBoardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCategoriesProfilesWithBoardsQuery,
    GetCategoriesProfilesWithBoardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCategoriesProfilesWithBoardsQuery, GetCategoriesProfilesWithBoardsQueryVariables>(
    GetCategoriesProfilesWithBoardsDocument,
    options
  );
}
export type GetCategoriesProfilesWithBoardsQueryHookResult = ReturnType<typeof useGetCategoriesProfilesWithBoardsQuery>;
export type GetCategoriesProfilesWithBoardsLazyQueryHookResult = ReturnType<
  typeof useGetCategoriesProfilesWithBoardsLazyQuery
>;
export type GetCategoriesProfilesWithBoardsQueryResult = Apollo.QueryResult<
  GetCategoriesProfilesWithBoardsQuery,
  GetCategoriesProfilesWithBoardsQueryVariables
>;
export const LogErrorDocument = gql`
  mutation LogError(
    $workspaceId: ID!
    $message: String!
    $url: String!
    $stackTrace: String!
    $severity: ClientErrorLogSeverity!
  ) {
    logError(workspaceId: $workspaceId, message: $message, url: $url, stackTrace: $stackTrace, severity: $severity)
  }
`;
export type LogErrorMutationFn = Apollo.MutationFunction<LogErrorMutation, LogErrorMutationVariables>;

/**
 * __useLogErrorMutation__
 *
 * To run a mutation, you first call `useLogErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logErrorMutation, { data, loading, error }] = useLogErrorMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      message: // value for 'message'
 *      url: // value for 'url'
 *      stackTrace: // value for 'stackTrace'
 *      severity: // value for 'severity'
 *   },
 * });
 */
export function useLogErrorMutation(
  baseOptions?: Apollo.MutationHookOptions<LogErrorMutation, LogErrorMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogErrorMutation, LogErrorMutationVariables>(LogErrorDocument, options);
}
export type LogErrorMutationHookResult = ReturnType<typeof useLogErrorMutation>;
export type LogErrorMutationResult = Apollo.MutationResult<LogErrorMutation>;
export type LogErrorMutationOptions = Apollo.BaseMutationOptions<LogErrorMutation, LogErrorMutationVariables>;
export const BulkRegisterMediaUploadsDocument = gql`
  mutation BulkRegisterMediaUploads($workspaceId: ID!, $input: [RegisterMediaInput!]!) {
    bulkRegisterMediaItemUploads(workspaceId: $workspaceId, input: $input) {
      suppliedUploadId
      registrationKey
      uploadUrl
    }
  }
`;
export type BulkRegisterMediaUploadsMutationFn = Apollo.MutationFunction<
  BulkRegisterMediaUploadsMutation,
  BulkRegisterMediaUploadsMutationVariables
>;

/**
 * __useBulkRegisterMediaUploadsMutation__
 *
 * To run a mutation, you first call `useBulkRegisterMediaUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRegisterMediaUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRegisterMediaUploadsMutation, { data, loading, error }] = useBulkRegisterMediaUploadsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkRegisterMediaUploadsMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkRegisterMediaUploadsMutation, BulkRegisterMediaUploadsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkRegisterMediaUploadsMutation, BulkRegisterMediaUploadsMutationVariables>(
    BulkRegisterMediaUploadsDocument,
    options
  );
}
export type BulkRegisterMediaUploadsMutationHookResult = ReturnType<typeof useBulkRegisterMediaUploadsMutation>;
export type BulkRegisterMediaUploadsMutationResult = Apollo.MutationResult<BulkRegisterMediaUploadsMutation>;
export type BulkRegisterMediaUploadsMutationOptions = Apollo.BaseMutationOptions<
  BulkRegisterMediaUploadsMutation,
  BulkRegisterMediaUploadsMutationVariables
>;
export const BulkCompleteMediaUploadsDocument = gql`
  mutation BulkCompleteMediaUploads($workspaceId: ID!, $input: [UploadMediaInput!]!) {
    bulkCompleteMediaUploads(workspaceId: $workspaceId, input: $input) {
      suppliedRegistrationKey
      error
      media {
        ...CoreMediaLibraryItemFields
        ... on Photo {
          ...CoreMediaLibraryPhotoFields
        }
        ... on Video {
          ...CoreMediaLibraryVideoFields
        }
      }
    }
  }
  ${CoreMediaLibraryItemFieldsFragmentDoc}
  ${CoreMediaLibraryPhotoFieldsFragmentDoc}
  ${CoreMediaLibraryVideoFieldsFragmentDoc}
`;
export type BulkCompleteMediaUploadsMutationFn = Apollo.MutationFunction<
  BulkCompleteMediaUploadsMutation,
  BulkCompleteMediaUploadsMutationVariables
>;

/**
 * __useBulkCompleteMediaUploadsMutation__
 *
 * To run a mutation, you first call `useBulkCompleteMediaUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCompleteMediaUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCompleteMediaUploadsMutation, { data, loading, error }] = useBulkCompleteMediaUploadsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCompleteMediaUploadsMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkCompleteMediaUploadsMutation, BulkCompleteMediaUploadsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkCompleteMediaUploadsMutation, BulkCompleteMediaUploadsMutationVariables>(
    BulkCompleteMediaUploadsDocument,
    options
  );
}
export type BulkCompleteMediaUploadsMutationHookResult = ReturnType<typeof useBulkCompleteMediaUploadsMutation>;
export type BulkCompleteMediaUploadsMutationResult = Apollo.MutationResult<BulkCompleteMediaUploadsMutation>;
export type BulkCompleteMediaUploadsMutationOptions = Apollo.BaseMutationOptions<
  BulkCompleteMediaUploadsMutation,
  BulkCompleteMediaUploadsMutationVariables
>;
export const BulkAddExternalPhotosDocument = gql`
  mutation BulkAddExternalPhotos($workspaceId: ID!, $input: [ExternalMediaInput!]!) {
    bulkAddExternalPhotos(workspaceId: $workspaceId, input: $input) {
      suppliedRegistrationKey
      error
      media {
        ...CoreMediaLibraryItemFields
        ... on Photo {
          ...CoreMediaLibraryPhotoFields
        }
        ... on Video {
          ...CoreMediaLibraryVideoFields
        }
      }
    }
  }
  ${CoreMediaLibraryItemFieldsFragmentDoc}
  ${CoreMediaLibraryPhotoFieldsFragmentDoc}
  ${CoreMediaLibraryVideoFieldsFragmentDoc}
`;
export type BulkAddExternalPhotosMutationFn = Apollo.MutationFunction<
  BulkAddExternalPhotosMutation,
  BulkAddExternalPhotosMutationVariables
>;

/**
 * __useBulkAddExternalPhotosMutation__
 *
 * To run a mutation, you first call `useBulkAddExternalPhotosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddExternalPhotosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddExternalPhotosMutation, { data, loading, error }] = useBulkAddExternalPhotosMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAddExternalPhotosMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkAddExternalPhotosMutation, BulkAddExternalPhotosMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkAddExternalPhotosMutation, BulkAddExternalPhotosMutationVariables>(
    BulkAddExternalPhotosDocument,
    options
  );
}
export type BulkAddExternalPhotosMutationHookResult = ReturnType<typeof useBulkAddExternalPhotosMutation>;
export type BulkAddExternalPhotosMutationResult = Apollo.MutationResult<BulkAddExternalPhotosMutation>;
export type BulkAddExternalPhotosMutationOptions = Apollo.BaseMutationOptions<
  BulkAddExternalPhotosMutation,
  BulkAddExternalPhotosMutationVariables
>;
export const GetUsageFieldsDocument = gql`
  query GetUsageFields {
    me {
      organizations {
        plan {
          usage {
            ...UsageFields
            __typename
          }
        }
      }
    }
  }
  ${UsageFieldsFragmentDoc}
`;

/**
 * __useGetUsageFieldsQuery__
 *
 * To run a query within a React component, call `useGetUsageFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsageFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsageFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsageFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsageFieldsQuery, GetUsageFieldsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsageFieldsQuery, GetUsageFieldsQueryVariables>(GetUsageFieldsDocument, options);
}
export function useGetUsageFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsageFieldsQuery, GetUsageFieldsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsageFieldsQuery, GetUsageFieldsQueryVariables>(GetUsageFieldsDocument, options);
}
export type GetUsageFieldsQueryHookResult = ReturnType<typeof useGetUsageFieldsQuery>;
export type GetUsageFieldsLazyQueryHookResult = ReturnType<typeof useGetUsageFieldsLazyQuery>;
export type GetUsageFieldsQueryResult = Apollo.QueryResult<GetUsageFieldsQuery, GetUsageFieldsQueryVariables>;
export const GetMeDocument = gql`
  query GetMe {
    me {
      ...UserFields
      settings {
        id
        onlineMarketing
        notifyFeatureAddedEnabled
        notifyMailingListEnabled
        notifyProductUpdatesEnabled
        notifyReferralCreditsEnabled
      }
      organizations {
        id
        name
        legacyMemberId
        fromLegacy
        myUserAssignment {
          role
          settings {
            id
            dateFormat
            timeFormat
            startOfWeekFormat
          }
        }
        suspended
        spamLocked
        subscription {
          status
          billingCycle
          nextBillingDateUtc
          trialExpiryDateUtc
          upgradedDateUtc
        }
        plan {
          name
          importerType
          analyticsType
          featureFlags
          limits {
            activeCategories
            posts
            socialProfiles
            timeslotsPerWeekdayPerProfile
            autoImports
            importSources
            aiCredits
            users
          }
          usage {
            ...UsageFields
          }
        }
        workspaces {
          id
          name
          timezone
          settings {
            id
            defaultBitly {
              domain
              bitly {
                ...CoreBitlyFields
              }
            }
            evergreenRecycling
            multiMediaAttachMode
            defaultQueuePosition
            queuesPaused
            autoImportsPaused
            shouldRemoveUtm
            campaignTracking
            utm {
              campaign
              content
              medium
              source
              term
            }
          }
        }
        settings {
          id
          productAnalyticsEnabled
        }
        mobileApps {
          ...MobileAppFields
        }
      }
      onboarding {
        ...CoreOnboardingFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
  ${UsageFieldsFragmentDoc}
  ${CoreBitlyFieldsFragmentDoc}
  ${MobileAppFieldsFragmentDoc}
  ${CoreOnboardingFieldsFragmentDoc}
`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
}
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
}
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const ChangeTimezoneDocument = gql`
  mutation ChangeTimezone($newTimezone: TimezoneSetting!, $userId: ID) {
    updateUser(input: { timezone: $newTimezone }, userId: $userId) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type ChangeTimezoneMutationFn = Apollo.MutationFunction<ChangeTimezoneMutation, ChangeTimezoneMutationVariables>;

/**
 * __useChangeTimezoneMutation__
 *
 * To run a mutation, you first call `useChangeTimezoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTimezoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTimezoneMutation, { data, loading, error }] = useChangeTimezoneMutation({
 *   variables: {
 *      newTimezone: // value for 'newTimezone'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChangeTimezoneMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeTimezoneMutation, ChangeTimezoneMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangeTimezoneMutation, ChangeTimezoneMutationVariables>(ChangeTimezoneDocument, options);
}
export type ChangeTimezoneMutationHookResult = ReturnType<typeof useChangeTimezoneMutation>;
export type ChangeTimezoneMutationResult = Apollo.MutationResult<ChangeTimezoneMutation>;
export type ChangeTimezoneMutationOptions = Apollo.BaseMutationOptions<
  ChangeTimezoneMutation,
  ChangeTimezoneMutationVariables
>;
export const CreateFollowersDocument = gql`
  mutation CreateFollowers($workspaceId: ID!) {
    devAnalyticsCreateFollowers(workspaceId: $workspaceId)
  }
`;
export type CreateFollowersMutationFn = Apollo.MutationFunction<
  CreateFollowersMutation,
  CreateFollowersMutationVariables
>;

/**
 * __useCreateFollowersMutation__
 *
 * To run a mutation, you first call `useCreateFollowersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFollowersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFollowersMutation, { data, loading, error }] = useCreateFollowersMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateFollowersMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFollowersMutation, CreateFollowersMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFollowersMutation, CreateFollowersMutationVariables>(
    CreateFollowersDocument,
    options
  );
}
export type CreateFollowersMutationHookResult = ReturnType<typeof useCreateFollowersMutation>;
export type CreateFollowersMutationResult = Apollo.MutationResult<CreateFollowersMutation>;
export type CreateFollowersMutationOptions = Apollo.BaseMutationOptions<
  CreateFollowersMutation,
  CreateFollowersMutationVariables
>;
export const GenerateQueueContentDocument = gql`
  mutation GenerateQueueContent($workspaceId: ID!) {
    devGenerateQueueContent(workspaceId: $workspaceId)
  }
`;
export type GenerateQueueContentMutationFn = Apollo.MutationFunction<
  GenerateQueueContentMutation,
  GenerateQueueContentMutationVariables
>;

/**
 * __useGenerateQueueContentMutation__
 *
 * To run a mutation, you first call `useGenerateQueueContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQueueContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQueueContentMutation, { data, loading, error }] = useGenerateQueueContentMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGenerateQueueContentMutation(
  baseOptions?: Apollo.MutationHookOptions<GenerateQueueContentMutation, GenerateQueueContentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateQueueContentMutation, GenerateQueueContentMutationVariables>(
    GenerateQueueContentDocument,
    options
  );
}
export type GenerateQueueContentMutationHookResult = ReturnType<typeof useGenerateQueueContentMutation>;
export type GenerateQueueContentMutationResult = Apollo.MutationResult<GenerateQueueContentMutation>;
export type GenerateQueueContentMutationOptions = Apollo.BaseMutationOptions<
  GenerateQueueContentMutation,
  GenerateQueueContentMutationVariables
>;
export const CreatePostStatsDocument = gql`
  mutation CreatePostStats(
    $workspaceId: ID!
    $startDate: String
    $endDate: String
    $minPostsPerDay: Int
    $maxPostsPerDay: Int
    $socialProfileIds: [ID!]
  ) {
    devAnalyticsCreatePostStats(
      workspaceId: $workspaceId
      startDate: $startDate
      endDate: $endDate
      minPostsPerDay: $minPostsPerDay
      maxPostsPerDay: $maxPostsPerDay
      socialProfileIds: $socialProfileIds
    )
  }
`;
export type CreatePostStatsMutationFn = Apollo.MutationFunction<
  CreatePostStatsMutation,
  CreatePostStatsMutationVariables
>;

/**
 * __useCreatePostStatsMutation__
 *
 * To run a mutation, you first call `useCreatePostStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostStatsMutation, { data, loading, error }] = useCreatePostStatsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      minPostsPerDay: // value for 'minPostsPerDay'
 *      maxPostsPerDay: // value for 'maxPostsPerDay'
 *      socialProfileIds: // value for 'socialProfileIds'
 *   },
 * });
 */
export function useCreatePostStatsMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePostStatsMutation, CreatePostStatsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePostStatsMutation, CreatePostStatsMutationVariables>(
    CreatePostStatsDocument,
    options
  );
}
export type CreatePostStatsMutationHookResult = ReturnType<typeof useCreatePostStatsMutation>;
export type CreatePostStatsMutationResult = Apollo.MutationResult<CreatePostStatsMutation>;
export type CreatePostStatsMutationOptions = Apollo.BaseMutationOptions<
  CreatePostStatsMutation,
  CreatePostStatsMutationVariables
>;
export const SetSocialProfileToDisconnectedDocument = gql`
  mutation SetSocialProfileToDisconnected($socialProfileId: ID!) {
    devSocialProfileSetDisconnected(socialProfileId: $socialProfileId)
  }
`;
export type SetSocialProfileToDisconnectedMutationFn = Apollo.MutationFunction<
  SetSocialProfileToDisconnectedMutation,
  SetSocialProfileToDisconnectedMutationVariables
>;

/**
 * __useSetSocialProfileToDisconnectedMutation__
 *
 * To run a mutation, you first call `useSetSocialProfileToDisconnectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSocialProfileToDisconnectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSocialProfileToDisconnectedMutation, { data, loading, error }] = useSetSocialProfileToDisconnectedMutation({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *   },
 * });
 */
export function useSetSocialProfileToDisconnectedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSocialProfileToDisconnectedMutation,
    SetSocialProfileToDisconnectedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetSocialProfileToDisconnectedMutation, SetSocialProfileToDisconnectedMutationVariables>(
    SetSocialProfileToDisconnectedDocument,
    options
  );
}
export type SetSocialProfileToDisconnectedMutationHookResult = ReturnType<
  typeof useSetSocialProfileToDisconnectedMutation
>;
export type SetSocialProfileToDisconnectedMutationResult =
  Apollo.MutationResult<SetSocialProfileToDisconnectedMutation>;
export type SetSocialProfileToDisconnectedMutationOptions = Apollo.BaseMutationOptions<
  SetSocialProfileToDisconnectedMutation,
  SetSocialProfileToDisconnectedMutationVariables
>;
export const SetSocialProfileToConnectedDocument = gql`
  mutation SetSocialProfileToConnected($socialProfileId: ID!) {
    devSocialProfileSetConnected(socialProfileId: $socialProfileId)
  }
`;
export type SetSocialProfileToConnectedMutationFn = Apollo.MutationFunction<
  SetSocialProfileToConnectedMutation,
  SetSocialProfileToConnectedMutationVariables
>;

/**
 * __useSetSocialProfileToConnectedMutation__
 *
 * To run a mutation, you first call `useSetSocialProfileToConnectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSocialProfileToConnectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSocialProfileToConnectedMutation, { data, loading, error }] = useSetSocialProfileToConnectedMutation({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *   },
 * });
 */
export function useSetSocialProfileToConnectedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSocialProfileToConnectedMutation,
    SetSocialProfileToConnectedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetSocialProfileToConnectedMutation, SetSocialProfileToConnectedMutationVariables>(
    SetSocialProfileToConnectedDocument,
    options
  );
}
export type SetSocialProfileToConnectedMutationHookResult = ReturnType<typeof useSetSocialProfileToConnectedMutation>;
export type SetSocialProfileToConnectedMutationResult = Apollo.MutationResult<SetSocialProfileToConnectedMutation>;
export type SetSocialProfileToConnectedMutationOptions = Apollo.BaseMutationOptions<
  SetSocialProfileToConnectedMutation,
  SetSocialProfileToConnectedMutationVariables
>;
export const ClearThirdPartyPostCacheDocument = gql`
  mutation ClearThirdPartyPostCache {
    devClearThirdPartyPostCache
  }
`;
export type ClearThirdPartyPostCacheMutationFn = Apollo.MutationFunction<
  ClearThirdPartyPostCacheMutation,
  ClearThirdPartyPostCacheMutationVariables
>;

/**
 * __useClearThirdPartyPostCacheMutation__
 *
 * To run a mutation, you first call `useClearThirdPartyPostCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearThirdPartyPostCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearThirdPartyPostCacheMutation, { data, loading, error }] = useClearThirdPartyPostCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearThirdPartyPostCacheMutation(
  baseOptions?: Apollo.MutationHookOptions<ClearThirdPartyPostCacheMutation, ClearThirdPartyPostCacheMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ClearThirdPartyPostCacheMutation, ClearThirdPartyPostCacheMutationVariables>(
    ClearThirdPartyPostCacheDocument,
    options
  );
}
export type ClearThirdPartyPostCacheMutationHookResult = ReturnType<typeof useClearThirdPartyPostCacheMutation>;
export type ClearThirdPartyPostCacheMutationResult = Apollo.MutationResult<ClearThirdPartyPostCacheMutation>;
export type ClearThirdPartyPostCacheMutationOptions = Apollo.BaseMutationOptions<
  ClearThirdPartyPostCacheMutation,
  ClearThirdPartyPostCacheMutationVariables
>;
export const ChangeOrganizationPlanDocument = gql`
  mutation ChangeOrganizationPlan($organizationId: ID!, $planName: String!) {
    devChangeOrganizationPlan(organizationId: $organizationId, planName: $planName)
  }
`;
export type ChangeOrganizationPlanMutationFn = Apollo.MutationFunction<
  ChangeOrganizationPlanMutation,
  ChangeOrganizationPlanMutationVariables
>;

/**
 * __useChangeOrganizationPlanMutation__
 *
 * To run a mutation, you first call `useChangeOrganizationPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrganizationPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrganizationPlanMutation, { data, loading, error }] = useChangeOrganizationPlanMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useChangeOrganizationPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeOrganizationPlanMutation, ChangeOrganizationPlanMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangeOrganizationPlanMutation, ChangeOrganizationPlanMutationVariables>(
    ChangeOrganizationPlanDocument,
    options
  );
}
export type ChangeOrganizationPlanMutationHookResult = ReturnType<typeof useChangeOrganizationPlanMutation>;
export type ChangeOrganizationPlanMutationResult = Apollo.MutationResult<ChangeOrganizationPlanMutation>;
export type ChangeOrganizationPlanMutationOptions = Apollo.BaseMutationOptions<
  ChangeOrganizationPlanMutation,
  ChangeOrganizationPlanMutationVariables
>;
export const RefreshPinterestBoardsDocument = gql`
  mutation RefreshPinterestBoards($id: ID!) {
    refreshPinterestBoards(socialProfileId: $id) {
      id
      boards {
        ...CorePinterestBoardFields
      }
    }
  }
  ${CorePinterestBoardFieldsFragmentDoc}
`;
export type RefreshPinterestBoardsMutationFn = Apollo.MutationFunction<
  RefreshPinterestBoardsMutation,
  RefreshPinterestBoardsMutationVariables
>;

/**
 * __useRefreshPinterestBoardsMutation__
 *
 * To run a mutation, you first call `useRefreshPinterestBoardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPinterestBoardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPinterestBoardsMutation, { data, loading, error }] = useRefreshPinterestBoardsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshPinterestBoardsMutation(
  baseOptions?: Apollo.MutationHookOptions<RefreshPinterestBoardsMutation, RefreshPinterestBoardsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RefreshPinterestBoardsMutation, RefreshPinterestBoardsMutationVariables>(
    RefreshPinterestBoardsDocument,
    options
  );
}
export type RefreshPinterestBoardsMutationHookResult = ReturnType<typeof useRefreshPinterestBoardsMutation>;
export type RefreshPinterestBoardsMutationResult = Apollo.MutationResult<RefreshPinterestBoardsMutation>;
export type RefreshPinterestBoardsMutationOptions = Apollo.BaseMutationOptions<
  RefreshPinterestBoardsMutation,
  RefreshPinterestBoardsMutationVariables
>;
export const RefreshSocialProfilePhotoUrlDocument = gql`
  mutation RefreshSocialProfilePhotoUrl($socialProfileId: ID!) {
    refreshSocialProfilePhotoUrl(socialProfileId: $socialProfileId) {
      photoUrl
    }
  }
`;
export type RefreshSocialProfilePhotoUrlMutationFn = Apollo.MutationFunction<
  RefreshSocialProfilePhotoUrlMutation,
  RefreshSocialProfilePhotoUrlMutationVariables
>;

/**
 * __useRefreshSocialProfilePhotoUrlMutation__
 *
 * To run a mutation, you first call `useRefreshSocialProfilePhotoUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSocialProfilePhotoUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSocialProfilePhotoUrlMutation, { data, loading, error }] = useRefreshSocialProfilePhotoUrlMutation({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *   },
 * });
 */
export function useRefreshSocialProfilePhotoUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshSocialProfilePhotoUrlMutation,
    RefreshSocialProfilePhotoUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RefreshSocialProfilePhotoUrlMutation, RefreshSocialProfilePhotoUrlMutationVariables>(
    RefreshSocialProfilePhotoUrlDocument,
    options
  );
}
export type RefreshSocialProfilePhotoUrlMutationHookResult = ReturnType<typeof useRefreshSocialProfilePhotoUrlMutation>;
export type RefreshSocialProfilePhotoUrlMutationResult = Apollo.MutationResult<RefreshSocialProfilePhotoUrlMutation>;
export type RefreshSocialProfilePhotoUrlMutationOptions = Apollo.BaseMutationOptions<
  RefreshSocialProfilePhotoUrlMutation,
  RefreshSocialProfilePhotoUrlMutationVariables
>;
export const RefreshTikTokSocialProfileSettingsDocument = gql`
  mutation RefreshTikTokSocialProfileSettings($id: ID!) {
    refreshTikTokSocialProfileSettings(socialProfileId: $id) {
      ...CoreSocialProfileFields
      ...CoreTikTokProfileFields
    }
  }
  ${CoreSocialProfileFieldsFragmentDoc}
  ${CoreTikTokProfileFieldsFragmentDoc}
`;
export type RefreshTikTokSocialProfileSettingsMutationFn = Apollo.MutationFunction<
  RefreshTikTokSocialProfileSettingsMutation,
  RefreshTikTokSocialProfileSettingsMutationVariables
>;

/**
 * __useRefreshTikTokSocialProfileSettingsMutation__
 *
 * To run a mutation, you first call `useRefreshTikTokSocialProfileSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTikTokSocialProfileSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTikTokSocialProfileSettingsMutation, { data, loading, error }] = useRefreshTikTokSocialProfileSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshTikTokSocialProfileSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshTikTokSocialProfileSettingsMutation,
    RefreshTikTokSocialProfileSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshTikTokSocialProfileSettingsMutation,
    RefreshTikTokSocialProfileSettingsMutationVariables
  >(RefreshTikTokSocialProfileSettingsDocument, options);
}
export type RefreshTikTokSocialProfileSettingsMutationHookResult = ReturnType<
  typeof useRefreshTikTokSocialProfileSettingsMutation
>;
export type RefreshTikTokSocialProfileSettingsMutationResult =
  Apollo.MutationResult<RefreshTikTokSocialProfileSettingsMutation>;
export type RefreshTikTokSocialProfileSettingsMutationOptions = Apollo.BaseMutationOptions<
  RefreshTikTokSocialProfileSettingsMutation,
  RefreshTikTokSocialProfileSettingsMutationVariables
>;
export const SendPasswordResetEmailDocument = gql`
  mutation SendPasswordResetEmail($email: String!) {
    sendPasswordResetEmail(email: $email)
  }
`;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<
  SendPasswordResetEmailMutation,
  SendPasswordResetEmailMutationVariables
>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(
    SendPasswordResetEmailDocument,
    options
  );
}
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<
  SendPasswordResetEmailMutation,
  SendPasswordResetEmailMutationVariables
>;
export const GetInvitationDetailsDocument = gql`
  query GetInvitationDetails($invitationToken: String!) {
    getInvitationDetails(invitationToken: $invitationToken) {
      email
      organizationName
      organizationID
    }
  }
`;

/**
 * __useGetInvitationDetailsQuery__
 *
 * To run a query within a React component, call `useGetInvitationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationDetailsQuery({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *   },
 * });
 */
export function useGetInvitationDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>(
    GetInvitationDetailsDocument,
    options
  );
}
export function useGetInvitationDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvitationDetailsQuery, GetInvitationDetailsQueryVariables>(
    GetInvitationDetailsDocument,
    options
  );
}
export type GetInvitationDetailsQueryHookResult = ReturnType<typeof useGetInvitationDetailsQuery>;
export type GetInvitationDetailsLazyQueryHookResult = ReturnType<typeof useGetInvitationDetailsLazyQuery>;
export type GetInvitationDetailsQueryResult = Apollo.QueryResult<
  GetInvitationDetailsQuery,
  GetInvitationDetailsQueryVariables
>;
export const JoinOrganizationFromInvitationDocument = gql`
  mutation JoinOrganizationFromInvitation($invitationToken: String!) {
    joinOrganizationFromInvitation(invitationToken: $invitationToken) {
      workspaces {
        id
      }
    }
  }
`;
export type JoinOrganizationFromInvitationMutationFn = Apollo.MutationFunction<
  JoinOrganizationFromInvitationMutation,
  JoinOrganizationFromInvitationMutationVariables
>;

/**
 * __useJoinOrganizationFromInvitationMutation__
 *
 * To run a mutation, you first call `useJoinOrganizationFromInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinOrganizationFromInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinOrganizationFromInvitationMutation, { data, loading, error }] = useJoinOrganizationFromInvitationMutation({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *   },
 * });
 */
export function useJoinOrganizationFromInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinOrganizationFromInvitationMutation,
    JoinOrganizationFromInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<JoinOrganizationFromInvitationMutation, JoinOrganizationFromInvitationMutationVariables>(
    JoinOrganizationFromInvitationDocument,
    options
  );
}
export type JoinOrganizationFromInvitationMutationHookResult = ReturnType<
  typeof useJoinOrganizationFromInvitationMutation
>;
export type JoinOrganizationFromInvitationMutationResult =
  Apollo.MutationResult<JoinOrganizationFromInvitationMutation>;
export type JoinOrganizationFromInvitationMutationOptions = Apollo.BaseMutationOptions<
  JoinOrganizationFromInvitationMutation,
  JoinOrganizationFromInvitationMutationVariables
>;
export const LoginDocument = gql`
  mutation Login($input: LoginWithEmailInput!) {
    loginWithEmail(input: $input) {
      user {
        id
        organizations {
          id
          workspaces {
            id
          }
        }
      }
      token {
        ...CoreTokenFields
      }
    }
  }
  ${CoreTokenFieldsFragmentDoc}
`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginWithSocialDocument = gql`
  mutation LoginWithSocial($socialAuthToken: String!) {
    loginWithSocial(socialAuthToken: $socialAuthToken) {
      user {
        id
        organizations {
          id
          workspaces {
            id
          }
        }
      }
      token {
        ...CoreTokenFields
      }
    }
  }
  ${CoreTokenFieldsFragmentDoc}
`;
export type LoginWithSocialMutationFn = Apollo.MutationFunction<
  LoginWithSocialMutation,
  LoginWithSocialMutationVariables
>;

/**
 * __useLoginWithSocialMutation__
 *
 * To run a mutation, you first call `useLoginWithSocialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithSocialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithSocialMutation, { data, loading, error }] = useLoginWithSocialMutation({
 *   variables: {
 *      socialAuthToken: // value for 'socialAuthToken'
 *   },
 * });
 */
export function useLoginWithSocialMutation(
  baseOptions?: Apollo.MutationHookOptions<LoginWithSocialMutation, LoginWithSocialMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginWithSocialMutation, LoginWithSocialMutationVariables>(
    LoginWithSocialDocument,
    options
  );
}
export type LoginWithSocialMutationHookResult = ReturnType<typeof useLoginWithSocialMutation>;
export type LoginWithSocialMutationResult = Apollo.MutationResult<LoginWithSocialMutation>;
export type LoginWithSocialMutationOptions = Apollo.BaseMutationOptions<
  LoginWithSocialMutation,
  LoginWithSocialMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(resetToken: $token, newPassword: $password)
  }
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const SocialAuthTokenDocument = gql`
  query SocialAuthToken($clientToken: String!) {
    socialAuthToken(socialAuthToken: $clientToken) {
      ...SocialAuthTokenFields
    }
  }
  ${SocialAuthTokenFieldsFragmentDoc}
`;

/**
 * __useSocialAuthTokenQuery__
 *
 * To run a query within a React component, call `useSocialAuthTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialAuthTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialAuthTokenQuery({
 *   variables: {
 *      clientToken: // value for 'clientToken'
 *   },
 * });
 */
export function useSocialAuthTokenQuery(
  baseOptions: Apollo.QueryHookOptions<SocialAuthTokenQuery, SocialAuthTokenQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SocialAuthTokenQuery, SocialAuthTokenQueryVariables>(SocialAuthTokenDocument, options);
}
export function useSocialAuthTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SocialAuthTokenQuery, SocialAuthTokenQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SocialAuthTokenQuery, SocialAuthTokenQueryVariables>(SocialAuthTokenDocument, options);
}
export type SocialAuthTokenQueryHookResult = ReturnType<typeof useSocialAuthTokenQuery>;
export type SocialAuthTokenLazyQueryHookResult = ReturnType<typeof useSocialAuthTokenLazyQuery>;
export type SocialAuthTokenQueryResult = Apollo.QueryResult<SocialAuthTokenQuery, SocialAuthTokenQueryVariables>;
export const RegisterEmailAvailableDocument = gql`
  query RegisterEmailAvailable($email: String!) {
    registerEmailAvailable(email: $email)
  }
`;

/**
 * __useRegisterEmailAvailableQuery__
 *
 * To run a query within a React component, call `useRegisterEmailAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterEmailAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterEmailAvailableQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRegisterEmailAvailableQuery(
  baseOptions: Apollo.QueryHookOptions<RegisterEmailAvailableQuery, RegisterEmailAvailableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegisterEmailAvailableQuery, RegisterEmailAvailableQueryVariables>(
    RegisterEmailAvailableDocument,
    options
  );
}
export function useRegisterEmailAvailableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RegisterEmailAvailableQuery, RegisterEmailAvailableQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RegisterEmailAvailableQuery, RegisterEmailAvailableQueryVariables>(
    RegisterEmailAvailableDocument,
    options
  );
}
export type RegisterEmailAvailableQueryHookResult = ReturnType<typeof useRegisterEmailAvailableQuery>;
export type RegisterEmailAvailableLazyQueryHookResult = ReturnType<typeof useRegisterEmailAvailableLazyQuery>;
export type RegisterEmailAvailableQueryResult = Apollo.QueryResult<
  RegisterEmailAvailableQuery,
  RegisterEmailAvailableQueryVariables
>;
export const StartSocialOAuthDocument = gql`
  mutation StartSocialOAuth(
    $oAuthProvider: SocialOAuthProvider!
    $profileNetwork: Network
    $context: SocialOAuthContext!
  ) {
    startSocialOAuth(oAuthProvider: $oAuthProvider, profileNetwork: $profileNetwork, context: $context) {
      socialAuthToken
      redirectUrl
    }
  }
`;
export type StartSocialOAuthMutationFn = Apollo.MutationFunction<
  StartSocialOAuthMutation,
  StartSocialOAuthMutationVariables
>;

/**
 * __useStartSocialOAuthMutation__
 *
 * To run a mutation, you first call `useStartSocialOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSocialOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSocialOAuthMutation, { data, loading, error }] = useStartSocialOAuthMutation({
 *   variables: {
 *      oAuthProvider: // value for 'oAuthProvider'
 *      profileNetwork: // value for 'profileNetwork'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useStartSocialOAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<StartSocialOAuthMutation, StartSocialOAuthMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartSocialOAuthMutation, StartSocialOAuthMutationVariables>(
    StartSocialOAuthDocument,
    options
  );
}
export type StartSocialOAuthMutationHookResult = ReturnType<typeof useStartSocialOAuthMutation>;
export type StartSocialOAuthMutationResult = Apollo.MutationResult<StartSocialOAuthMutation>;
export type StartSocialOAuthMutationOptions = Apollo.BaseMutationOptions<
  StartSocialOAuthMutation,
  StartSocialOAuthMutationVariables
>;
export const RegisterDocument = gql`
  mutation Register($input: RegistrationInput!) {
    register(input: $input) {
      user {
        id
        organizations {
          id
          workspaces {
            id
          }
        }
      }
      token {
        ...CoreTokenFields
      }
    }
  }
  ${CoreTokenFieldsFragmentDoc}
`;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const GetAutoImportsDocument = gql`
  query GetAutoImports($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      socialProfiles {
        ...SocialProfileFields
        ... on PinterestSocialProfile {
          boards {
            ...CorePinterestBoardFields
          }
        }
      }
      categories {
        ...CategoryFields
      }
      autoImports {
        ...AutoImportFields
        category {
          ...CategoryFields
        }
        socialProfiles {
          ...SocialProfileFields
          ... on PinterestSocialProfile {
            boards {
              ...CorePinterestBoardFields
            }
          }
        }
      }
    }
  }
  ${SocialProfileFieldsFragmentDoc}
  ${CorePinterestBoardFieldsFragmentDoc}
  ${CategoryFieldsFragmentDoc}
  ${AutoImportFieldsFragmentDoc}
`;

/**
 * __useGetAutoImportsQuery__
 *
 * To run a query within a React component, call `useGetAutoImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoImportsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAutoImportsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAutoImportsQuery, GetAutoImportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAutoImportsQuery, GetAutoImportsQueryVariables>(GetAutoImportsDocument, options);
}
export function useGetAutoImportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAutoImportsQuery, GetAutoImportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAutoImportsQuery, GetAutoImportsQueryVariables>(GetAutoImportsDocument, options);
}
export type GetAutoImportsQueryHookResult = ReturnType<typeof useGetAutoImportsQuery>;
export type GetAutoImportsLazyQueryHookResult = ReturnType<typeof useGetAutoImportsLazyQuery>;
export type GetAutoImportsQueryResult = Apollo.QueryResult<GetAutoImportsQuery, GetAutoImportsQueryVariables>;
export const GetWorkspaceSourcesDocument = gql`
  query GetWorkspaceSources($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      importFolders {
        ...CoreImportFolderFields
      }
      importSources {
        ...ImportSourceFields
      }
      socialProfiles {
        ...SocialProfileFields
      }
    }
  }
  ${CoreImportFolderFieldsFragmentDoc}
  ${ImportSourceFieldsFragmentDoc}
  ${SocialProfileFieldsFragmentDoc}
`;

/**
 * __useGetWorkspaceSourcesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSourcesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceSourcesQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkspaceSourcesQuery, GetWorkspaceSourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkspaceSourcesQuery, GetWorkspaceSourcesQueryVariables>(
    GetWorkspaceSourcesDocument,
    options
  );
}
export function useGetWorkspaceSourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSourcesQuery, GetWorkspaceSourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkspaceSourcesQuery, GetWorkspaceSourcesQueryVariables>(
    GetWorkspaceSourcesDocument,
    options
  );
}
export type GetWorkspaceSourcesQueryHookResult = ReturnType<typeof useGetWorkspaceSourcesQuery>;
export type GetWorkspaceSourcesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSourcesLazyQuery>;
export type GetWorkspaceSourcesQueryResult = Apollo.QueryResult<
  GetWorkspaceSourcesQuery,
  GetWorkspaceSourcesQueryVariables
>;
export const SearchThirdPartyProfilesDocument = gql`
  query SearchThirdPartyProfiles($socialProfileId: ID!, $method: ThirdPartyProfileSearchType!, $term: String!) {
    searchThirdPartyProfiles(socialProfileId: $socialProfileId, method: $method, term: $term) {
      displayName
      username
      photoUrl
      externalId
      platform
      profileUrl
    }
  }
`;

/**
 * __useSearchThirdPartyProfilesQuery__
 *
 * To run a query within a React component, call `useSearchThirdPartyProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchThirdPartyProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchThirdPartyProfilesQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      method: // value for 'method'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useSearchThirdPartyProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<SearchThirdPartyProfilesQuery, SearchThirdPartyProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchThirdPartyProfilesQuery, SearchThirdPartyProfilesQueryVariables>(
    SearchThirdPartyProfilesDocument,
    options
  );
}
export function useSearchThirdPartyProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchThirdPartyProfilesQuery, SearchThirdPartyProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchThirdPartyProfilesQuery, SearchThirdPartyProfilesQueryVariables>(
    SearchThirdPartyProfilesDocument,
    options
  );
}
export type SearchThirdPartyProfilesQueryHookResult = ReturnType<typeof useSearchThirdPartyProfilesQuery>;
export type SearchThirdPartyProfilesLazyQueryHookResult = ReturnType<typeof useSearchThirdPartyProfilesLazyQuery>;
export type SearchThirdPartyProfilesQueryResult = Apollo.QueryResult<
  SearchThirdPartyProfilesQuery,
  SearchThirdPartyProfilesQueryVariables
>;
export const CreateImportSourceDocument = gql`
  mutation CreateImportSource($workspaceId: ID!, $input: CreateImportSourceInput!) {
    createImportSource(workspaceId: $workspaceId, input: $input) {
      ...ImportSourceFields
    }
  }
  ${ImportSourceFieldsFragmentDoc}
`;
export type CreateImportSourceMutationFn = Apollo.MutationFunction<
  CreateImportSourceMutation,
  CreateImportSourceMutationVariables
>;

/**
 * __useCreateImportSourceMutation__
 *
 * To run a mutation, you first call `useCreateImportSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportSourceMutation, { data, loading, error }] = useCreateImportSourceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImportSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateImportSourceMutation, CreateImportSourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateImportSourceMutation, CreateImportSourceMutationVariables>(
    CreateImportSourceDocument,
    options
  );
}
export type CreateImportSourceMutationHookResult = ReturnType<typeof useCreateImportSourceMutation>;
export type CreateImportSourceMutationResult = Apollo.MutationResult<CreateImportSourceMutation>;
export type CreateImportSourceMutationOptions = Apollo.BaseMutationOptions<
  CreateImportSourceMutation,
  CreateImportSourceMutationVariables
>;
export const CompleteOnboardingDocument = gql`
  mutation CompleteOnboarding {
    completeOnboarding {
      ...UserFields
      onboarding {
        ...CoreOnboardingFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
  ${CoreOnboardingFieldsFragmentDoc}
`;
export type CompleteOnboardingMutationFn = Apollo.MutationFunction<
  CompleteOnboardingMutation,
  CompleteOnboardingMutationVariables
>;

/**
 * __useCompleteOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOnboardingMutation, { data, loading, error }] = useCompleteOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useCompleteOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>(
    CompleteOnboardingDocument,
    options
  );
}
export type CompleteOnboardingMutationHookResult = ReturnType<typeof useCompleteOnboardingMutation>;
export type CompleteOnboardingMutationResult = Apollo.MutationResult<CompleteOnboardingMutation>;
export type CompleteOnboardingMutationOptions = Apollo.BaseMutationOptions<
  CompleteOnboardingMutation,
  CompleteOnboardingMutationVariables
>;
export const SeeOnboardingStepDocument = gql`
  mutation SeeOnboardingStep($name: String!) {
    markOnboardingStepSeen(input: { name: $name }) {
      name
    }
  }
`;
export type SeeOnboardingStepMutationFn = Apollo.MutationFunction<
  SeeOnboardingStepMutation,
  SeeOnboardingStepMutationVariables
>;

/**
 * __useSeeOnboardingStepMutation__
 *
 * To run a mutation, you first call `useSeeOnboardingStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeeOnboardingStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seeOnboardingStepMutation, { data, loading, error }] = useSeeOnboardingStepMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSeeOnboardingStepMutation(
  baseOptions?: Apollo.MutationHookOptions<SeeOnboardingStepMutation, SeeOnboardingStepMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SeeOnboardingStepMutation, SeeOnboardingStepMutationVariables>(
    SeeOnboardingStepDocument,
    options
  );
}
export type SeeOnboardingStepMutationHookResult = ReturnType<typeof useSeeOnboardingStepMutation>;
export type SeeOnboardingStepMutationResult = Apollo.MutationResult<SeeOnboardingStepMutation>;
export type SeeOnboardingStepMutationOptions = Apollo.BaseMutationOptions<
  SeeOnboardingStepMutation,
  SeeOnboardingStepMutationVariables
>;
export const GetCaptionsDocument = gql`
  query GetCaptions($cacheKey: String!) {
    captions(cacheKey: $cacheKey) {
      ...CoreAiCaptionGenerationFields
    }
  }
  ${CoreAiCaptionGenerationFieldsFragmentDoc}
`;

/**
 * __useGetCaptionsQuery__
 *
 * To run a query within a React component, call `useGetCaptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaptionsQuery({
 *   variables: {
 *      cacheKey: // value for 'cacheKey'
 *   },
 * });
 */
export function useGetCaptionsQuery(baseOptions: Apollo.QueryHookOptions<GetCaptionsQuery, GetCaptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCaptionsQuery, GetCaptionsQueryVariables>(GetCaptionsDocument, options);
}
export function useGetCaptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCaptionsQuery, GetCaptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCaptionsQuery, GetCaptionsQueryVariables>(GetCaptionsDocument, options);
}
export type GetCaptionsQueryHookResult = ReturnType<typeof useGetCaptionsQuery>;
export type GetCaptionsLazyQueryHookResult = ReturnType<typeof useGetCaptionsLazyQuery>;
export type GetCaptionsQueryResult = Apollo.QueryResult<GetCaptionsQuery, GetCaptionsQueryVariables>;
export const InitiateCaptionsDocument = gql`
  mutation InitiateCaptions($input: AiCaptionInitiateInput!, $organizationId: ID!) {
    initiateCaptions(input: $input, organizationId: $organizationId) {
      ...CoreAiCaptionInitiateType
    }
  }
  ${CoreAiCaptionInitiateTypeFragmentDoc}
`;
export type InitiateCaptionsMutationFn = Apollo.MutationFunction<
  InitiateCaptionsMutation,
  InitiateCaptionsMutationVariables
>;

/**
 * __useInitiateCaptionsMutation__
 *
 * To run a mutation, you first call `useInitiateCaptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateCaptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateCaptionsMutation, { data, loading, error }] = useInitiateCaptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInitiateCaptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<InitiateCaptionsMutation, InitiateCaptionsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InitiateCaptionsMutation, InitiateCaptionsMutationVariables>(
    InitiateCaptionsDocument,
    options
  );
}
export type InitiateCaptionsMutationHookResult = ReturnType<typeof useInitiateCaptionsMutation>;
export type InitiateCaptionsMutationResult = Apollo.MutationResult<InitiateCaptionsMutation>;
export type InitiateCaptionsMutationOptions = Apollo.BaseMutationOptions<
  InitiateCaptionsMutation,
  InitiateCaptionsMutationVariables
>;
export const StopCaptionsDocument = gql`
  mutation StopCaptions($cacheKey: String!) {
    stopCaptions(cacheKey: $cacheKey) {
      ...CoreAiCaptionGenerationFields
    }
  }
  ${CoreAiCaptionGenerationFieldsFragmentDoc}
`;
export type StopCaptionsMutationFn = Apollo.MutationFunction<StopCaptionsMutation, StopCaptionsMutationVariables>;

/**
 * __useStopCaptionsMutation__
 *
 * To run a mutation, you first call `useStopCaptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopCaptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopCaptionsMutation, { data, loading, error }] = useStopCaptionsMutation({
 *   variables: {
 *      cacheKey: // value for 'cacheKey'
 *   },
 * });
 */
export function useStopCaptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<StopCaptionsMutation, StopCaptionsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StopCaptionsMutation, StopCaptionsMutationVariables>(StopCaptionsDocument, options);
}
export type StopCaptionsMutationHookResult = ReturnType<typeof useStopCaptionsMutation>;
export type StopCaptionsMutationResult = Apollo.MutationResult<StopCaptionsMutation>;
export type StopCaptionsMutationOptions = Apollo.BaseMutationOptions<
  StopCaptionsMutation,
  StopCaptionsMutationVariables
>;
export const GetLinkMetadataDocument = gql`
  query GetLinkMetadata($urls: [String!]!) {
    linkMetadata(urls: $urls) {
      ...LinkMetadataFields
    }
  }
  ${LinkMetadataFieldsFragmentDoc}
`;

/**
 * __useGetLinkMetadataQuery__
 *
 * To run a query within a React component, call `useGetLinkMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkMetadataQuery({
 *   variables: {
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useGetLinkMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>(GetLinkMetadataDocument, options);
}
export function useGetLinkMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>(GetLinkMetadataDocument, options);
}
export type GetLinkMetadataQueryHookResult = ReturnType<typeof useGetLinkMetadataQuery>;
export type GetLinkMetadataLazyQueryHookResult = ReturnType<typeof useGetLinkMetadataLazyQuery>;
export type GetLinkMetadataQueryResult = Apollo.QueryResult<GetLinkMetadataQuery, GetLinkMetadataQueryVariables>;
export const BulkImportDocument = gql`
  mutation BulkImport($workspaceId: ID!, $input: BulkCreatePostsInput!) {
    startBulkCreatePosts(workspaceId: $workspaceId, input: $input)
  }
`;
export type BulkImportMutationFn = Apollo.MutationFunction<BulkImportMutation, BulkImportMutationVariables>;

/**
 * __useBulkImportMutation__
 *
 * To run a mutation, you first call `useBulkImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkImportMutation, { data, loading, error }] = useBulkImportMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkImportMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkImportMutation, BulkImportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkImportMutation, BulkImportMutationVariables>(BulkImportDocument, options);
}
export type BulkImportMutationHookResult = ReturnType<typeof useBulkImportMutation>;
export type BulkImportMutationResult = Apollo.MutationResult<BulkImportMutation>;
export type BulkImportMutationOptions = Apollo.BaseMutationOptions<BulkImportMutation, BulkImportMutationVariables>;
export const GetPostsEditorDocument = gql`
  query GetPostsEditor($postId: ID!) {
    latestFamilyMembersOfPost(postId: $postId) {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;

/**
 * __useGetPostsEditorQuery__
 *
 * To run a query within a React component, call `useGetPostsEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsEditorQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostsEditorQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostsEditorQuery, GetPostsEditorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostsEditorQuery, GetPostsEditorQueryVariables>(GetPostsEditorDocument, options);
}
export function useGetPostsEditorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostsEditorQuery, GetPostsEditorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostsEditorQuery, GetPostsEditorQueryVariables>(GetPostsEditorDocument, options);
}
export type GetPostsEditorQueryHookResult = ReturnType<typeof useGetPostsEditorQuery>;
export type GetPostsEditorLazyQueryHookResult = ReturnType<typeof useGetPostsEditorLazyQuery>;
export type GetPostsEditorQueryResult = Apollo.QueryResult<GetPostsEditorQuery, GetPostsEditorQueryVariables>;
export const CreatePostDocument = gql`
  mutation CreatePost($workspaceId: ID!, $input: PostGroupInput!) {
    createPost(workspaceId: $workspaceId, input: $input) {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePostMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
}
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const GetCategoriesDocument = gql`
  query GetCategories($workspaceId: ID!, $statusFilter: CategoryArchiveFilter = ACTIVE) {
    workspace(workspaceId: $workspaceId) {
      id
      categories(statusFilter: $statusFilter) {
        ...CategoryFields
        seasonal
        seasonalStartDate
        seasonalEndDate
        seasonallyPaused
        archived
        archivedDate
        archivedAttachedPostCount
      }
    }
  }
  ${CategoryFieldsFragmentDoc}
`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
}
export function useGetCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
}
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const InstagramGridPostsDocument = gql`
  query InstagramGridPosts($socialProfileId: ID!, $futureCount: Int) {
    instagramGridPosts(socialProfileId: $socialProfileId, futureCount: $futureCount) {
      futurePosts {
        ...PostItem
      }
      pastPosts {
        ...ThirdPartyPostFields
      }
      thirdPartyPostSearchError
    }
  }
  ${PostItemFragmentDoc}
  ${ThirdPartyPostFieldsFragmentDoc}
`;

/**
 * __useInstagramGridPostsQuery__
 *
 * To run a query within a React component, call `useInstagramGridPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstagramGridPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstagramGridPostsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      futureCount: // value for 'futureCount'
 *   },
 * });
 */
export function useInstagramGridPostsQuery(
  baseOptions: Apollo.QueryHookOptions<InstagramGridPostsQuery, InstagramGridPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InstagramGridPostsQuery, InstagramGridPostsQueryVariables>(
    InstagramGridPostsDocument,
    options
  );
}
export function useInstagramGridPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InstagramGridPostsQuery, InstagramGridPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InstagramGridPostsQuery, InstagramGridPostsQueryVariables>(
    InstagramGridPostsDocument,
    options
  );
}
export type InstagramGridPostsQueryHookResult = ReturnType<typeof useInstagramGridPostsQuery>;
export type InstagramGridPostsLazyQueryHookResult = ReturnType<typeof useInstagramGridPostsLazyQuery>;
export type InstagramGridPostsQueryResult = Apollo.QueryResult<
  InstagramGridPostsQuery,
  InstagramGridPostsQueryVariables
>;
export const GetMediaLibraryDocument = gql`
  query GetMediaLibrary($workspaceId: ID!, $input: MediaLibraryInput) {
    workspace(workspaceId: $workspaceId) {
      id
      name
      mediaLibrary(input: $input) {
        items {
          ...CoreMediaLibraryItemFields
          ... on Photo {
            ...CoreMediaLibraryPhotoFields
          }
          ... on Video {
            ...CoreMediaLibraryVideoFields
          }
        }
        cursor
        count
      }
    }
  }
  ${CoreMediaLibraryItemFieldsFragmentDoc}
  ${CoreMediaLibraryPhotoFieldsFragmentDoc}
  ${CoreMediaLibraryVideoFieldsFragmentDoc}
`;

/**
 * __useGetMediaLibraryQuery__
 *
 * To run a query within a React component, call `useGetMediaLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaLibraryQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMediaLibraryQuery(
  baseOptions: Apollo.QueryHookOptions<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>(GetMediaLibraryDocument, options);
}
export function useGetMediaLibraryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>(GetMediaLibraryDocument, options);
}
export type GetMediaLibraryQueryHookResult = ReturnType<typeof useGetMediaLibraryQuery>;
export type GetMediaLibraryLazyQueryHookResult = ReturnType<typeof useGetMediaLibraryLazyQuery>;
export type GetMediaLibraryQueryResult = Apollo.QueryResult<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>;
export const BulkArchiveMediaDocument = gql`
  mutation BulkArchiveMedia($media: [MediaSelectionInput!]!) {
    bulkArchiveMedia(media: $media)
  }
`;
export type BulkArchiveMediaMutationFn = Apollo.MutationFunction<
  BulkArchiveMediaMutation,
  BulkArchiveMediaMutationVariables
>;

/**
 * __useBulkArchiveMediaMutation__
 *
 * To run a mutation, you first call `useBulkArchiveMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkArchiveMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkArchiveMediaMutation, { data, loading, error }] = useBulkArchiveMediaMutation({
 *   variables: {
 *      media: // value for 'media'
 *   },
 * });
 */
export function useBulkArchiveMediaMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkArchiveMediaMutation, BulkArchiveMediaMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkArchiveMediaMutation, BulkArchiveMediaMutationVariables>(
    BulkArchiveMediaDocument,
    options
  );
}
export type BulkArchiveMediaMutationHookResult = ReturnType<typeof useBulkArchiveMediaMutation>;
export type BulkArchiveMediaMutationResult = Apollo.MutationResult<BulkArchiveMediaMutation>;
export type BulkArchiveMediaMutationOptions = Apollo.BaseMutationOptions<
  BulkArchiveMediaMutation,
  BulkArchiveMediaMutationVariables
>;
export const GetCategoryProfilesQueueMetaDocument = gql`
  query GetCategoryProfilesQueueMeta($workspaceId: ID!, $statusFilter: CategoryArchiveFilter = ACTIVE) {
    workspace(workspaceId: $workspaceId) {
      id
      categories(statusFilter: $statusFilter) {
        ...CoreCategoryFields
      }
      socialProfiles {
        ...SocialProfileFields
      }
      queueMeta {
        ...QueueMetaFields
      }
    }
  }
  ${CoreCategoryFieldsFragmentDoc}
  ${SocialProfileFieldsFragmentDoc}
  ${QueueMetaFieldsFragmentDoc}
`;

/**
 * __useGetCategoryProfilesQueueMetaQuery__
 *
 * To run a query within a React component, call `useGetCategoryProfilesQueueMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryProfilesQueueMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryProfilesQueueMetaQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetCategoryProfilesQueueMetaQuery(
  baseOptions: Apollo.QueryHookOptions<GetCategoryProfilesQueueMetaQuery, GetCategoryProfilesQueueMetaQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCategoryProfilesQueueMetaQuery, GetCategoryProfilesQueueMetaQueryVariables>(
    GetCategoryProfilesQueueMetaDocument,
    options
  );
}
export function useGetCategoryProfilesQueueMetaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCategoryProfilesQueueMetaQuery,
    GetCategoryProfilesQueueMetaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCategoryProfilesQueueMetaQuery, GetCategoryProfilesQueueMetaQueryVariables>(
    GetCategoryProfilesQueueMetaDocument,
    options
  );
}
export type GetCategoryProfilesQueueMetaQueryHookResult = ReturnType<typeof useGetCategoryProfilesQueueMetaQuery>;
export type GetCategoryProfilesQueueMetaLazyQueryHookResult = ReturnType<
  typeof useGetCategoryProfilesQueueMetaLazyQuery
>;
export type GetCategoryProfilesQueueMetaQueryResult = Apollo.QueryResult<
  GetCategoryProfilesQueueMetaQuery,
  GetCategoryProfilesQueueMetaQueryVariables
>;
export const GetPostDocument = gql`
  query GetPost($postId: ID!) {
    post(postId: $postId) {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;

/**
 * __useGetPostQuery__
 *
 * To run a query within a React component, call `useGetPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostQuery(baseOptions: Apollo.QueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
}
export function useGetPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
}
export type GetPostQueryHookResult = ReturnType<typeof useGetPostQuery>;
export type GetPostLazyQueryHookResult = ReturnType<typeof useGetPostLazyQuery>;
export type GetPostQueryResult = Apollo.QueryResult<GetPostQuery, GetPostQueryVariables>;
export const GetPostScheduleWeekDocument = gql`
  query GetPostScheduleWeek($workspaceId: ID!, $input: QueueInput!) {
    workspace(workspaceId: $workspaceId) {
      id
      queue(input: $input) {
        __typename
        dateRangePagination {
          ...CoreDateRangePagination
        }
      }
    }
  }
  ${CoreDateRangePaginationFragmentDoc}
`;

/**
 * __useGetPostScheduleWeekQuery__
 *
 * To run a query within a React component, call `useGetPostScheduleWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostScheduleWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostScheduleWeekQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostScheduleWeekQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostScheduleWeekQuery, GetPostScheduleWeekQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostScheduleWeekQuery, GetPostScheduleWeekQueryVariables>(
    GetPostScheduleWeekDocument,
    options
  );
}
export function useGetPostScheduleWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostScheduleWeekQuery, GetPostScheduleWeekQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostScheduleWeekQuery, GetPostScheduleWeekQueryVariables>(
    GetPostScheduleWeekDocument,
    options
  );
}
export type GetPostScheduleWeekQueryHookResult = ReturnType<typeof useGetPostScheduleWeekQuery>;
export type GetPostScheduleWeekLazyQueryHookResult = ReturnType<typeof useGetPostScheduleWeekLazyQuery>;
export type GetPostScheduleWeekQueryResult = Apollo.QueryResult<
  GetPostScheduleWeekQuery,
  GetPostScheduleWeekQueryVariables
>;
export const GetPostScheduleListDocument = gql`
  query GetPostScheduleList($workspaceId: ID!, $input: QueueInput!) {
    workspace(workspaceId: $workspaceId) {
      id
      queue(input: $input) {
        __typename
        cursorPagination {
          ...CoreCursorPagination
        }
      }
    }
  }
  ${CoreCursorPaginationFragmentDoc}
`;

/**
 * __useGetPostScheduleListQuery__
 *
 * To run a query within a React component, call `useGetPostScheduleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostScheduleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostScheduleListQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostScheduleListQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostScheduleListQuery, GetPostScheduleListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostScheduleListQuery, GetPostScheduleListQueryVariables>(
    GetPostScheduleListDocument,
    options
  );
}
export function useGetPostScheduleListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostScheduleListQuery, GetPostScheduleListQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostScheduleListQuery, GetPostScheduleListQueryVariables>(
    GetPostScheduleListDocument,
    options
  );
}
export type GetPostScheduleListQueryHookResult = ReturnType<typeof useGetPostScheduleListQuery>;
export type GetPostScheduleListLazyQueryHookResult = ReturnType<typeof useGetPostScheduleListLazyQuery>;
export type GetPostScheduleListQueryResult = Apollo.QueryResult<
  GetPostScheduleListQuery,
  GetPostScheduleListQueryVariables
>;
export const GetPostListAscendingDocument = gql`
  query GetPostListAscending($workspaceId: ID!, $input: QueueInput!) {
    workspace(workspaceId: $workspaceId) {
      id
      queue(input: $input) {
        __typename
        cursorPagination {
          ...CoreCursorPagination
        }
      }
    }
  }
  ${CoreCursorPaginationFragmentDoc}
`;

/**
 * __useGetPostListAscendingQuery__
 *
 * To run a query within a React component, call `useGetPostListAscendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostListAscendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostListAscendingQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostListAscendingQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostListAscendingQuery, GetPostListAscendingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostListAscendingQuery, GetPostListAscendingQueryVariables>(
    GetPostListAscendingDocument,
    options
  );
}
export function useGetPostListAscendingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostListAscendingQuery, GetPostListAscendingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostListAscendingQuery, GetPostListAscendingQueryVariables>(
    GetPostListAscendingDocument,
    options
  );
}
export type GetPostListAscendingQueryHookResult = ReturnType<typeof useGetPostListAscendingQuery>;
export type GetPostListAscendingLazyQueryHookResult = ReturnType<typeof useGetPostListAscendingLazyQuery>;
export type GetPostListAscendingQueryResult = Apollo.QueryResult<
  GetPostListAscendingQuery,
  GetPostListAscendingQueryVariables
>;
export const GetPostListDescendingDocument = gql`
  query GetPostListDescending($workspaceId: ID!, $input: QueueInput!) {
    workspace(workspaceId: $workspaceId) {
      id
      queue(input: $input) {
        __typename
        cursorPagination {
          ...CoreCursorPagination
        }
      }
    }
  }
  ${CoreCursorPaginationFragmentDoc}
`;

/**
 * __useGetPostListDescendingQuery__
 *
 * To run a query within a React component, call `useGetPostListDescendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostListDescendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostListDescendingQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPostListDescendingQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostListDescendingQuery, GetPostListDescendingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostListDescendingQuery, GetPostListDescendingQueryVariables>(
    GetPostListDescendingDocument,
    options
  );
}
export function useGetPostListDescendingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostListDescendingQuery, GetPostListDescendingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostListDescendingQuery, GetPostListDescendingQueryVariables>(
    GetPostListDescendingDocument,
    options
  );
}
export type GetPostListDescendingQueryHookResult = ReturnType<typeof useGetPostListDescendingQuery>;
export type GetPostListDescendingLazyQueryHookResult = ReturnType<typeof useGetPostListDescendingLazyQuery>;
export type GetPostListDescendingQueryResult = Apollo.QueryResult<
  GetPostListDescendingQuery,
  GetPostListDescendingQueryVariables
>;
export const GetPostQueueCountDocument = gql`
  query GetPostQueueCount($workspaceId: ID!, $queueFilters: QueueFilterInput!, $queueContext: QueueContext!) {
    workspace(workspaceId: $workspaceId) {
      id
      queueCounts(filterInput: $queueFilters, queueContext: $queueContext) {
        ...QueueCountsFields
      }
    }
  }
  ${QueueCountsFieldsFragmentDoc}
`;

/**
 * __useGetPostQueueCountQuery__
 *
 * To run a query within a React component, call `useGetPostQueueCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQueueCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQueueCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      queueFilters: // value for 'queueFilters'
 *      queueContext: // value for 'queueContext'
 *   },
 * });
 */
export function useGetPostQueueCountQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostQueueCountQuery, GetPostQueueCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostQueueCountQuery, GetPostQueueCountQueryVariables>(GetPostQueueCountDocument, options);
}
export function useGetPostQueueCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostQueueCountQuery, GetPostQueueCountQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostQueueCountQuery, GetPostQueueCountQueryVariables>(
    GetPostQueueCountDocument,
    options
  );
}
export type GetPostQueueCountQueryHookResult = ReturnType<typeof useGetPostQueueCountQuery>;
export type GetPostQueueCountLazyQueryHookResult = ReturnType<typeof useGetPostQueueCountLazyQuery>;
export type GetPostQueueCountQueryResult = Apollo.QueryResult<GetPostQueueCountQuery, GetPostQueueCountQueryVariables>;
export const GetPostFamilyDocument = gql`
  query GetPostFamily($postId: ID!) {
    latestFamilyMembersOfPost(postId: $postId) {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;

/**
 * __useGetPostFamilyQuery__
 *
 * To run a query within a React component, call `useGetPostFamilyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostFamilyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostFamilyQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostFamilyQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostFamilyQuery, GetPostFamilyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostFamilyQuery, GetPostFamilyQueryVariables>(GetPostFamilyDocument, options);
}
export function useGetPostFamilyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostFamilyQuery, GetPostFamilyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostFamilyQuery, GetPostFamilyQueryVariables>(GetPostFamilyDocument, options);
}
export type GetPostFamilyQueryHookResult = ReturnType<typeof useGetPostFamilyQuery>;
export type GetPostFamilyLazyQueryHookResult = ReturnType<typeof useGetPostFamilyLazyQuery>;
export type GetPostFamilyQueryResult = Apollo.QueryResult<GetPostFamilyQuery, GetPostFamilyQueryVariables>;
export const GetPostIterationsDocument = gql`
  query GetPostIterations($postId: ID!) {
    postIterations(postId: $postId) {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;

/**
 * __useGetPostIterationsQuery__
 *
 * To run a query within a React component, call `useGetPostIterationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostIterationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostIterationsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostIterationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostIterationsQuery, GetPostIterationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostIterationsQuery, GetPostIterationsQueryVariables>(GetPostIterationsDocument, options);
}
export function useGetPostIterationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostIterationsQuery, GetPostIterationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostIterationsQuery, GetPostIterationsQueryVariables>(
    GetPostIterationsDocument,
    options
  );
}
export type GetPostIterationsQueryHookResult = ReturnType<typeof useGetPostIterationsQuery>;
export type GetPostIterationsLazyQueryHookResult = ReturnType<typeof useGetPostIterationsLazyQuery>;
export type GetPostIterationsQueryResult = Apollo.QueryResult<GetPostIterationsQuery, GetPostIterationsQueryVariables>;
export const ShuffleQueueDocument = gql`
  mutation ShuffleQueue($workspaceId: ID!, $filters: QueueFilterInput!) {
    shuffleQueue(workspaceId: $workspaceId, filters: $filters)
  }
`;
export type ShuffleQueueMutationFn = Apollo.MutationFunction<ShuffleQueueMutation, ShuffleQueueMutationVariables>;

/**
 * __useShuffleQueueMutation__
 *
 * To run a mutation, you first call `useShuffleQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShuffleQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shuffleQueueMutation, { data, loading, error }] = useShuffleQueueMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useShuffleQueueMutation(
  baseOptions?: Apollo.MutationHookOptions<ShuffleQueueMutation, ShuffleQueueMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ShuffleQueueMutation, ShuffleQueueMutationVariables>(ShuffleQueueDocument, options);
}
export type ShuffleQueueMutationHookResult = ReturnType<typeof useShuffleQueueMutation>;
export type ShuffleQueueMutationResult = Apollo.MutationResult<ShuffleQueueMutation>;
export type ShuffleQueueMutationOptions = Apollo.BaseMutationOptions<
  ShuffleQueueMutation,
  ShuffleQueueMutationVariables
>;
export const UpdatePostOrderDocument = gql`
  mutation UpdatePostOrder($postId: ID!, $direction: PostOrderUpdateDirection!, $relativePostId: ID!) {
    updatePostOrder(postId: $postId, direction: $direction, relativePostId: $relativePostId) {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;
export type UpdatePostOrderMutationFn = Apollo.MutationFunction<
  UpdatePostOrderMutation,
  UpdatePostOrderMutationVariables
>;

/**
 * __useUpdatePostOrderMutation__
 *
 * To run a mutation, you first call `useUpdatePostOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostOrderMutation, { data, loading, error }] = useUpdatePostOrderMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      direction: // value for 'direction'
 *      relativePostId: // value for 'relativePostId'
 *   },
 * });
 */
export function useUpdatePostOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePostOrderMutation, UpdatePostOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePostOrderMutation, UpdatePostOrderMutationVariables>(
    UpdatePostOrderDocument,
    options
  );
}
export type UpdatePostOrderMutationHookResult = ReturnType<typeof useUpdatePostOrderMutation>;
export type UpdatePostOrderMutationResult = Apollo.MutationResult<UpdatePostOrderMutation>;
export type UpdatePostOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdatePostOrderMutation,
  UpdatePostOrderMutationVariables
>;
export const UpdatePostDocument = gql`
  mutation UpdatePost($postId: ID!, $input: UpdatePostInput!) {
    updatePost(postId: $postId, input: $input) {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
}
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const BulkUpdatePostsDocument = gql`
  mutation BulkUpdatePosts($input: [BulkUpdatePostInput!]!) {
    bulkUpdatePosts(input: $input) {
      ...PostItem
    }
  }
  ${PostItemFragmentDoc}
`;
export type BulkUpdatePostsMutationFn = Apollo.MutationFunction<
  BulkUpdatePostsMutation,
  BulkUpdatePostsMutationVariables
>;

/**
 * __useBulkUpdatePostsMutation__
 *
 * To run a mutation, you first call `useBulkUpdatePostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdatePostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdatePostsMutation, { data, loading, error }] = useBulkUpdatePostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdatePostsMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkUpdatePostsMutation, BulkUpdatePostsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkUpdatePostsMutation, BulkUpdatePostsMutationVariables>(
    BulkUpdatePostsDocument,
    options
  );
}
export type BulkUpdatePostsMutationHookResult = ReturnType<typeof useBulkUpdatePostsMutation>;
export type BulkUpdatePostsMutationResult = Apollo.MutationResult<BulkUpdatePostsMutation>;
export type BulkUpdatePostsMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdatePostsMutation,
  BulkUpdatePostsMutationVariables
>;
export const BulkDeletePostsDocument = gql`
  mutation BulkDeletePosts($postIds: [ID!]!) {
    bulkDeletePosts(postIds: $postIds)
  }
`;
export type BulkDeletePostsMutationFn = Apollo.MutationFunction<
  BulkDeletePostsMutation,
  BulkDeletePostsMutationVariables
>;

/**
 * __useBulkDeletePostsMutation__
 *
 * To run a mutation, you first call `useBulkDeletePostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeletePostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeletePostsMutation, { data, loading, error }] = useBulkDeletePostsMutation({
 *   variables: {
 *      postIds: // value for 'postIds'
 *   },
 * });
 */
export function useBulkDeletePostsMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkDeletePostsMutation, BulkDeletePostsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkDeletePostsMutation, BulkDeletePostsMutationVariables>(
    BulkDeletePostsDocument,
    options
  );
}
export type BulkDeletePostsMutationHookResult = ReturnType<typeof useBulkDeletePostsMutation>;
export type BulkDeletePostsMutationResult = Apollo.MutationResult<BulkDeletePostsMutation>;
export type BulkDeletePostsMutationOptions = Apollo.BaseMutationOptions<
  BulkDeletePostsMutation,
  BulkDeletePostsMutationVariables
>;
export const GetTimeslotsDocument = gql`
  query GetTimeslots($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      timeslots {
        ...CoreTimeslotFields
        category {
          id
          name
          color
        }
        socialProfiles {
          id
        }
      }
    }
  }
  ${CoreTimeslotFieldsFragmentDoc}
`;

/**
 * __useGetTimeslotsQuery__
 *
 * To run a query within a React component, call `useGetTimeslotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeslotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeslotsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetTimeslotsQuery(
  baseOptions: Apollo.QueryHookOptions<GetTimeslotsQuery, GetTimeslotsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTimeslotsQuery, GetTimeslotsQueryVariables>(GetTimeslotsDocument, options);
}
export function useGetTimeslotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTimeslotsQuery, GetTimeslotsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTimeslotsQuery, GetTimeslotsQueryVariables>(GetTimeslotsDocument, options);
}
export type GetTimeslotsQueryHookResult = ReturnType<typeof useGetTimeslotsQuery>;
export type GetTimeslotsLazyQueryHookResult = ReturnType<typeof useGetTimeslotsLazyQuery>;
export type GetTimeslotsQueryResult = Apollo.QueryResult<GetTimeslotsQuery, GetTimeslotsQueryVariables>;
export const DeleteTimeslotDocument = gql`
  mutation DeleteTimeslot($timeslotId: ID!) {
    deleteTimeslot(timeslotId: $timeslotId)
  }
`;
export type DeleteTimeslotMutationFn = Apollo.MutationFunction<DeleteTimeslotMutation, DeleteTimeslotMutationVariables>;

/**
 * __useDeleteTimeslotMutation__
 *
 * To run a mutation, you first call `useDeleteTimeslotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeslotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeslotMutation, { data, loading, error }] = useDeleteTimeslotMutation({
 *   variables: {
 *      timeslotId: // value for 'timeslotId'
 *   },
 * });
 */
export function useDeleteTimeslotMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTimeslotMutation, DeleteTimeslotMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTimeslotMutation, DeleteTimeslotMutationVariables>(DeleteTimeslotDocument, options);
}
export type DeleteTimeslotMutationHookResult = ReturnType<typeof useDeleteTimeslotMutation>;
export type DeleteTimeslotMutationResult = Apollo.MutationResult<DeleteTimeslotMutation>;
export type DeleteTimeslotMutationOptions = Apollo.BaseMutationOptions<
  DeleteTimeslotMutation,
  DeleteTimeslotMutationVariables
>;
export const GetSnippetsDocument = gql`
  query GetSnippets($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      snippets {
        ...CoreSnippetFields
      }
    }
  }
  ${CoreSnippetFieldsFragmentDoc}
`;

/**
 * __useGetSnippetsQuery__
 *
 * To run a query within a React component, call `useGetSnippetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnippetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnippetsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetSnippetsQuery(baseOptions: Apollo.QueryHookOptions<GetSnippetsQuery, GetSnippetsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSnippetsQuery, GetSnippetsQueryVariables>(GetSnippetsDocument, options);
}
export function useGetSnippetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSnippetsQuery, GetSnippetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSnippetsQuery, GetSnippetsQueryVariables>(GetSnippetsDocument, options);
}
export type GetSnippetsQueryHookResult = ReturnType<typeof useGetSnippetsQuery>;
export type GetSnippetsLazyQueryHookResult = ReturnType<typeof useGetSnippetsLazyQuery>;
export type GetSnippetsQueryResult = Apollo.QueryResult<GetSnippetsQuery, GetSnippetsQueryVariables>;
export const DeleteSnippetDocument = gql`
  mutation DeleteSnippet($snippetId: ID!) {
    deleteSnippet(snippetId: $snippetId)
  }
`;
export type DeleteSnippetMutationFn = Apollo.MutationFunction<DeleteSnippetMutation, DeleteSnippetMutationVariables>;

/**
 * __useDeleteSnippetMutation__
 *
 * To run a mutation, you first call `useDeleteSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSnippetMutation, { data, loading, error }] = useDeleteSnippetMutation({
 *   variables: {
 *      snippetId: // value for 'snippetId'
 *   },
 * });
 */
export function useDeleteSnippetMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSnippetMutation, DeleteSnippetMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteSnippetMutation, DeleteSnippetMutationVariables>(DeleteSnippetDocument, options);
}
export type DeleteSnippetMutationHookResult = ReturnType<typeof useDeleteSnippetMutation>;
export type DeleteSnippetMutationResult = Apollo.MutationResult<DeleteSnippetMutation>;
export type DeleteSnippetMutationOptions = Apollo.BaseMutationOptions<
  DeleteSnippetMutation,
  DeleteSnippetMutationVariables
>;
export const GetNotificationsDocument = gql`
  query GetNotifications($orgId: ID!, $limit: Int, $offset: Int) {
    notifications(organizationId: $orgId) {
      count
      items(limit: $limit, offset: $offset) {
        id
        timestamp
        message
        isRead
        name
      }
    }
  }
`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
}
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
  mutation MarkAllNotificationsAsRead($orgId: ID!) {
    markAllNotificationsAsRead(organizationId: $orgId)
  }
`;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<
  MarkAllNotificationsAsReadMutation,
  MarkAllNotificationsAsReadMutationVariables
>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAllNotificationsAsReadMutation,
    MarkAllNotificationsAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(
    MarkAllNotificationsAsReadDocument,
    options
  );
}
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkAllNotificationsAsReadMutation,
  MarkAllNotificationsAsReadMutationVariables
>;
export const BulkMarkNotificationsAsReadDocument = gql`
  mutation BulkMarkNotificationsAsRead($notificationIds: [ID!]!) {
    bulkMarkNotificationsAsRead(notificationIds: $notificationIds) {
      id
      timestamp
      message
      isRead
      name
    }
  }
`;
export type BulkMarkNotificationsAsReadMutationFn = Apollo.MutationFunction<
  BulkMarkNotificationsAsReadMutation,
  BulkMarkNotificationsAsReadMutationVariables
>;

/**
 * __useBulkMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useBulkMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMarkNotificationsAsReadMutation, { data, loading, error }] = useBulkMarkNotificationsAsReadMutation({
 *   variables: {
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useBulkMarkNotificationsAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkMarkNotificationsAsReadMutation,
    BulkMarkNotificationsAsReadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkMarkNotificationsAsReadMutation, BulkMarkNotificationsAsReadMutationVariables>(
    BulkMarkNotificationsAsReadDocument,
    options
  );
}
export type BulkMarkNotificationsAsReadMutationHookResult = ReturnType<typeof useBulkMarkNotificationsAsReadMutation>;
export type BulkMarkNotificationsAsReadMutationResult = Apollo.MutationResult<BulkMarkNotificationsAsReadMutation>;
export type BulkMarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<
  BulkMarkNotificationsAsReadMutation,
  BulkMarkNotificationsAsReadMutationVariables
>;
export const UpdateCombinedOrganizationSettingsDocument = gql`
  mutation UpdateCombinedOrganizationSettings(
    $input: CombinedOrganizationSettingsInput!
    $organizationId: ID!
    $userId: ID
  ) {
    updateOrganizationSettings(input: $input, organizationId: $organizationId, userId: $userId) {
      userOrganizationSettings {
        id
        timeFormat
        dateFormat
        startOfWeekFormat
      }
      organizationSettings {
        id
        productAnalyticsEnabled
      }
    }
  }
`;
export type UpdateCombinedOrganizationSettingsMutationFn = Apollo.MutationFunction<
  UpdateCombinedOrganizationSettingsMutation,
  UpdateCombinedOrganizationSettingsMutationVariables
>;

/**
 * __useUpdateCombinedOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCombinedOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCombinedOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCombinedOrganizationSettingsMutation, { data, loading, error }] = useUpdateCombinedOrganizationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateCombinedOrganizationSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCombinedOrganizationSettingsMutation,
    UpdateCombinedOrganizationSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCombinedOrganizationSettingsMutation,
    UpdateCombinedOrganizationSettingsMutationVariables
  >(UpdateCombinedOrganizationSettingsDocument, options);
}
export type UpdateCombinedOrganizationSettingsMutationHookResult = ReturnType<
  typeof useUpdateCombinedOrganizationSettingsMutation
>;
export type UpdateCombinedOrganizationSettingsMutationResult =
  Apollo.MutationResult<UpdateCombinedOrganizationSettingsMutation>;
export type UpdateCombinedOrganizationSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateCombinedOrganizationSettingsMutation,
  UpdateCombinedOrganizationSettingsMutationVariables
>;
export const UpdateUserOnlineMarketingDocument = gql`
  mutation UpdateUserOnlineMarketing($onlineMarketing: Boolean!, $userId: ID) {
    updateUserSettings(input: { onlineMarketing: $onlineMarketing }, userId: $userId) {
      id
      onlineMarketing
      notifyFeatureAddedEnabled
      notifyMailingListEnabled
      notifyProductUpdatesEnabled
      notifyReferralCreditsEnabled
    }
  }
`;
export type UpdateUserOnlineMarketingMutationFn = Apollo.MutationFunction<
  UpdateUserOnlineMarketingMutation,
  UpdateUserOnlineMarketingMutationVariables
>;

/**
 * __useUpdateUserOnlineMarketingMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnlineMarketingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnlineMarketingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnlineMarketingMutation, { data, loading, error }] = useUpdateUserOnlineMarketingMutation({
 *   variables: {
 *      onlineMarketing: // value for 'onlineMarketing'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserOnlineMarketingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserOnlineMarketingMutation,
    UpdateUserOnlineMarketingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserOnlineMarketingMutation, UpdateUserOnlineMarketingMutationVariables>(
    UpdateUserOnlineMarketingDocument,
    options
  );
}
export type UpdateUserOnlineMarketingMutationHookResult = ReturnType<typeof useUpdateUserOnlineMarketingMutation>;
export type UpdateUserOnlineMarketingMutationResult = Apollo.MutationResult<UpdateUserOnlineMarketingMutation>;
export type UpdateUserOnlineMarketingMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserOnlineMarketingMutation,
  UpdateUserOnlineMarketingMutationVariables
>;
export const HelpscoutMetadataDocument = gql`
  query HelpscoutMetadata {
    helpscoutMetadata {
      beaconId
      email
      signature
    }
  }
`;

/**
 * __useHelpscoutMetadataQuery__
 *
 * To run a query within a React component, call `useHelpscoutMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpscoutMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpscoutMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useHelpscoutMetadataQuery(
  baseOptions?: Apollo.QueryHookOptions<HelpscoutMetadataQuery, HelpscoutMetadataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HelpscoutMetadataQuery, HelpscoutMetadataQueryVariables>(HelpscoutMetadataDocument, options);
}
export function useHelpscoutMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HelpscoutMetadataQuery, HelpscoutMetadataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HelpscoutMetadataQuery, HelpscoutMetadataQueryVariables>(
    HelpscoutMetadataDocument,
    options
  );
}
export type HelpscoutMetadataQueryHookResult = ReturnType<typeof useHelpscoutMetadataQuery>;
export type HelpscoutMetadataLazyQueryHookResult = ReturnType<typeof useHelpscoutMetadataLazyQuery>;
export type HelpscoutMetadataQueryResult = Apollo.QueryResult<HelpscoutMetadataQuery, HelpscoutMetadataQueryVariables>;
export const GetAdminUserDocument = gql`
  query getAdminUser($userId: ID!) {
    admin_user(userId: $userId) {
      ...AdminUser
    }
  }
  ${AdminUserFragmentDoc}
`;

/**
 * __useGetAdminUserQuery__
 *
 * To run a query within a React component, call `useGetAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAdminUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
}
export function useGetAdminUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
}
export type GetAdminUserQueryHookResult = ReturnType<typeof useGetAdminUserQuery>;
export type GetAdminUserLazyQueryHookResult = ReturnType<typeof useGetAdminUserLazyQuery>;
export type GetAdminUserQueryResult = Apollo.QueryResult<GetAdminUserQuery, GetAdminUserQueryVariables>;
export const GetInvoicesAndBillingDocument = gql`
  query getInvoicesAndBilling($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      invoices {
        ...CoreInvoiceFields
        billingAddressDetails {
          ...CoreBillingAddressDetailsFields
        }
        businessAddressDetails {
          ...CoreBusinessAddressDetailsFields
        }
        vatBusinessDetails {
          ...CoreVatBusinessDetailFields
        }
        creditCard {
          ...CoreCreditCardFields
        }
      }
    }
  }
  ${CoreInvoiceFieldsFragmentDoc}
  ${CoreBillingAddressDetailsFieldsFragmentDoc}
  ${CoreBusinessAddressDetailsFieldsFragmentDoc}
  ${CoreVatBusinessDetailFieldsFragmentDoc}
  ${CoreCreditCardFieldsFragmentDoc}
`;

/**
 * __useGetInvoicesAndBillingQuery__
 *
 * To run a query within a React component, call `useGetInvoicesAndBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesAndBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesAndBillingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvoicesAndBillingQuery(
  baseOptions: Apollo.QueryHookOptions<GetInvoicesAndBillingQuery, GetInvoicesAndBillingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoicesAndBillingQuery, GetInvoicesAndBillingQueryVariables>(
    GetInvoicesAndBillingDocument,
    options
  );
}
export function useGetInvoicesAndBillingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesAndBillingQuery, GetInvoicesAndBillingQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoicesAndBillingQuery, GetInvoicesAndBillingQueryVariables>(
    GetInvoicesAndBillingDocument,
    options
  );
}
export type GetInvoicesAndBillingQueryHookResult = ReturnType<typeof useGetInvoicesAndBillingQuery>;
export type GetInvoicesAndBillingLazyQueryHookResult = ReturnType<typeof useGetInvoicesAndBillingLazyQuery>;
export type GetInvoicesAndBillingQueryResult = Apollo.QueryResult<
  GetInvoicesAndBillingQuery,
  GetInvoicesAndBillingQueryVariables
>;
export const DeleteWorkspaceDocument = gql`
  mutation DeleteWorkspace($workspaceId: ID!) {
    deleteWorkspace(workspaceId: $workspaceId)
  }
`;
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<
  DeleteWorkspaceMutation,
  DeleteWorkspaceMutationVariables
>;

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(
    DeleteWorkspaceDocument,
    options
  );
}
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationResult = Apollo.MutationResult<DeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkspaceMutation,
  DeleteWorkspaceMutationVariables
>;
export const GetEmailNotificationSettingsDocument = gql`
  query GetEmailNotificationSettings($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      name
      settings {
        id
        productAnalyticsEnabled
        notifySubscriptionEnabled
      }
      myUserAssignment {
        id
        role
        settings {
          id
          dateFormat
          timeFormat
          notifyWeeklyStatsEnabled
          notifyQueueEmptyEnabled
          notifyPostProfileErrorEnabled
          notifyInstagramPostEnabled
          notifyAutoRssEnabled
        }
        user {
          id
          firstName
          email
        }
      }
    }
  }
`;

/**
 * __useGetEmailNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetEmailNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailNotificationSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetEmailNotificationSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>(
    GetEmailNotificationSettingsDocument,
    options
  );
}
export function useGetEmailNotificationSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmailNotificationSettingsQuery,
    GetEmailNotificationSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmailNotificationSettingsQuery, GetEmailNotificationSettingsQueryVariables>(
    GetEmailNotificationSettingsDocument,
    options
  );
}
export type GetEmailNotificationSettingsQueryHookResult = ReturnType<typeof useGetEmailNotificationSettingsQuery>;
export type GetEmailNotificationSettingsLazyQueryHookResult = ReturnType<
  typeof useGetEmailNotificationSettingsLazyQuery
>;
export type GetEmailNotificationSettingsQueryResult = Apollo.QueryResult<
  GetEmailNotificationSettingsQuery,
  GetEmailNotificationSettingsQueryVariables
>;
export const UpdateEmailNotificationSettingsDocument = gql`
  mutation UpdateEmailNotificationSettings(
    $input: CombinedOrganizationSettingsInput!
    $organizationId: ID!
    $userId: ID
  ) {
    updateOrganizationSettings(input: $input, organizationId: $organizationId, userId: $userId) {
      userOrganizationSettings {
        id
        timeFormat
        dateFormat
        notifyPostProfileErrorEnabled
        notifyWeeklyStatsEnabled
        notifyQueueEmptyEnabled
        notifyPostProfileErrorEnabled
        notifyInstagramPostEnabled
        notifyAutoRssEnabled
      }
      organizationSettings {
        id
        productAnalyticsEnabled
        notifySubscriptionEnabled
      }
    }
  }
`;
export type UpdateEmailNotificationSettingsMutationFn = Apollo.MutationFunction<
  UpdateEmailNotificationSettingsMutation,
  UpdateEmailNotificationSettingsMutationVariables
>;

/**
 * __useUpdateEmailNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEmailNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailNotificationSettingsMutation, { data, loading, error }] = useUpdateEmailNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateEmailNotificationSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmailNotificationSettingsMutation,
    UpdateEmailNotificationSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEmailNotificationSettingsMutation, UpdateEmailNotificationSettingsMutationVariables>(
    UpdateEmailNotificationSettingsDocument,
    options
  );
}
export type UpdateEmailNotificationSettingsMutationHookResult = ReturnType<
  typeof useUpdateEmailNotificationSettingsMutation
>;
export type UpdateEmailNotificationSettingsMutationResult =
  Apollo.MutationResult<UpdateEmailNotificationSettingsMutation>;
export type UpdateEmailNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmailNotificationSettingsMutation,
  UpdateEmailNotificationSettingsMutationVariables
>;
export const UpdateUserSettingsDocument = gql`
  mutation UpdateUserSettings($userId: ID, $input: UserSettingsInput!) {
    updateUserSettings(userId: $userId, input: $input) {
      id
      onlineMarketing
      notifyFeatureAddedEnabled
      notifyMailingListEnabled
      notifyProductUpdatesEnabled
      notifyReferralCreditsEnabled
    }
  }
`;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(
    UpdateUserSettingsDocument,
    options
  );
}
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;
export const CreateInvitedMemberDocument = gql`
  mutation CreateInvitedMember($organizationId: ID!, $input: UserInvitationInput!) {
    createUserInvitation(organizationId: $organizationId, input: $input) {
      id
      email
      role
      workspaceIds
      token
    }
  }
`;
export type CreateInvitedMemberMutationFn = Apollo.MutationFunction<
  CreateInvitedMemberMutation,
  CreateInvitedMemberMutationVariables
>;

/**
 * __useCreateInvitedMemberMutation__
 *
 * To run a mutation, you first call `useCreateInvitedMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitedMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitedMemberMutation, { data, loading, error }] = useCreateInvitedMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvitedMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateInvitedMemberMutation, CreateInvitedMemberMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateInvitedMemberMutation, CreateInvitedMemberMutationVariables>(
    CreateInvitedMemberDocument,
    options
  );
}
export type CreateInvitedMemberMutationHookResult = ReturnType<typeof useCreateInvitedMemberMutation>;
export type CreateInvitedMemberMutationResult = Apollo.MutationResult<CreateInvitedMemberMutation>;
export type CreateInvitedMemberMutationOptions = Apollo.BaseMutationOptions<
  CreateInvitedMemberMutation,
  CreateInvitedMemberMutationVariables
>;
export const GetBitlyAccountsDocument = gql`
  query GetBitlyAccounts($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      settings {
        id
        campaignTracking
        shouldRemoveUtm
        utm {
          source
          medium
          campaign
          term
          content
        }
        defaultBitly {
          domain
          bitly {
            ...CoreBitlyFields
          }
        }
      }
      bitlyAccounts {
        ...CoreBitlyFields
      }
      socialProfiles {
        ...SocialProfileFields
        customBitly {
          ...CoreCustomBitlyFields
          bitly {
            ...CoreBitlyFields
          }
        }
      }
    }
  }
  ${CoreBitlyFieldsFragmentDoc}
  ${SocialProfileFieldsFragmentDoc}
  ${CoreCustomBitlyFieldsFragmentDoc}
`;

/**
 * __useGetBitlyAccountsQuery__
 *
 * To run a query within a React component, call `useGetBitlyAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBitlyAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBitlyAccountsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetBitlyAccountsQuery(
  baseOptions: Apollo.QueryHookOptions<GetBitlyAccountsQuery, GetBitlyAccountsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBitlyAccountsQuery, GetBitlyAccountsQueryVariables>(GetBitlyAccountsDocument, options);
}
export function useGetBitlyAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBitlyAccountsQuery, GetBitlyAccountsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBitlyAccountsQuery, GetBitlyAccountsQueryVariables>(GetBitlyAccountsDocument, options);
}
export type GetBitlyAccountsQueryHookResult = ReturnType<typeof useGetBitlyAccountsQuery>;
export type GetBitlyAccountsLazyQueryHookResult = ReturnType<typeof useGetBitlyAccountsLazyQuery>;
export type GetBitlyAccountsQueryResult = Apollo.QueryResult<GetBitlyAccountsQuery, GetBitlyAccountsQueryVariables>;
export const ConnectBitlyDocument = gql`
  mutation ConnectBitly($workspaceId: ID!, $socialAuthToken: String!) {
    connectBitly(workspaceId: $workspaceId, socialAuthToken: $socialAuthToken) {
      ...CoreBitlyFields
    }
  }
  ${CoreBitlyFieldsFragmentDoc}
`;
export type ConnectBitlyMutationFn = Apollo.MutationFunction<ConnectBitlyMutation, ConnectBitlyMutationVariables>;

/**
 * __useConnectBitlyMutation__
 *
 * To run a mutation, you first call `useConnectBitlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectBitlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectBitlyMutation, { data, loading, error }] = useConnectBitlyMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      socialAuthToken: // value for 'socialAuthToken'
 *   },
 * });
 */
export function useConnectBitlyMutation(
  baseOptions?: Apollo.MutationHookOptions<ConnectBitlyMutation, ConnectBitlyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConnectBitlyMutation, ConnectBitlyMutationVariables>(ConnectBitlyDocument, options);
}
export type ConnectBitlyMutationHookResult = ReturnType<typeof useConnectBitlyMutation>;
export type ConnectBitlyMutationResult = Apollo.MutationResult<ConnectBitlyMutation>;
export type ConnectBitlyMutationOptions = Apollo.BaseMutationOptions<
  ConnectBitlyMutation,
  ConnectBitlyMutationVariables
>;
export const ReconnectBitlyDocument = gql`
  mutation ReconnectBitly($bitlyId: ID!, $socialAuthToken: String!) {
    reconnectBitly(bitlyId: $bitlyId, socialAuthToken: $socialAuthToken) {
      ...CoreBitlyFields
    }
  }
  ${CoreBitlyFieldsFragmentDoc}
`;
export type ReconnectBitlyMutationFn = Apollo.MutationFunction<ReconnectBitlyMutation, ReconnectBitlyMutationVariables>;

/**
 * __useReconnectBitlyMutation__
 *
 * To run a mutation, you first call `useReconnectBitlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconnectBitlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconnectBitlyMutation, { data, loading, error }] = useReconnectBitlyMutation({
 *   variables: {
 *      bitlyId: // value for 'bitlyId'
 *      socialAuthToken: // value for 'socialAuthToken'
 *   },
 * });
 */
export function useReconnectBitlyMutation(
  baseOptions?: Apollo.MutationHookOptions<ReconnectBitlyMutation, ReconnectBitlyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReconnectBitlyMutation, ReconnectBitlyMutationVariables>(ReconnectBitlyDocument, options);
}
export type ReconnectBitlyMutationHookResult = ReturnType<typeof useReconnectBitlyMutation>;
export type ReconnectBitlyMutationResult = Apollo.MutationResult<ReconnectBitlyMutation>;
export type ReconnectBitlyMutationOptions = Apollo.BaseMutationOptions<
  ReconnectBitlyMutation,
  ReconnectBitlyMutationVariables
>;
export const RemoveBitlyDocument = gql`
  mutation RemoveBitly($bitlyId: ID!) {
    removeBitly(bitlyId: $bitlyId)
  }
`;
export type RemoveBitlyMutationFn = Apollo.MutationFunction<RemoveBitlyMutation, RemoveBitlyMutationVariables>;

/**
 * __useRemoveBitlyMutation__
 *
 * To run a mutation, you first call `useRemoveBitlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBitlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBitlyMutation, { data, loading, error }] = useRemoveBitlyMutation({
 *   variables: {
 *      bitlyId: // value for 'bitlyId'
 *   },
 * });
 */
export function useRemoveBitlyMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveBitlyMutation, RemoveBitlyMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveBitlyMutation, RemoveBitlyMutationVariables>(RemoveBitlyDocument, options);
}
export type RemoveBitlyMutationHookResult = ReturnType<typeof useRemoveBitlyMutation>;
export type RemoveBitlyMutationResult = Apollo.MutationResult<RemoveBitlyMutation>;
export type RemoveBitlyMutationOptions = Apollo.BaseMutationOptions<RemoveBitlyMutation, RemoveBitlyMutationVariables>;
export const UpdateCustomBitlySettingsDocument = gql`
  mutation UpdateCustomBitlySettings($input: [UpdateCustomBitlySettingsInput!]!) {
    bulkUpdateCustomBitlySettings(input: $input) {
      id
      customBitly {
        ...CoreCustomBitlyFields
        bitly {
          ...CoreBitlyFields
        }
      }
    }
  }
  ${CoreCustomBitlyFieldsFragmentDoc}
  ${CoreBitlyFieldsFragmentDoc}
`;
export type UpdateCustomBitlySettingsMutationFn = Apollo.MutationFunction<
  UpdateCustomBitlySettingsMutation,
  UpdateCustomBitlySettingsMutationVariables
>;

/**
 * __useUpdateCustomBitlySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomBitlySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomBitlySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomBitlySettingsMutation, { data, loading, error }] = useUpdateCustomBitlySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomBitlySettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomBitlySettingsMutation,
    UpdateCustomBitlySettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCustomBitlySettingsMutation, UpdateCustomBitlySettingsMutationVariables>(
    UpdateCustomBitlySettingsDocument,
    options
  );
}
export type UpdateCustomBitlySettingsMutationHookResult = ReturnType<typeof useUpdateCustomBitlySettingsMutation>;
export type UpdateCustomBitlySettingsMutationResult = Apollo.MutationResult<UpdateCustomBitlySettingsMutation>;
export type UpdateCustomBitlySettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomBitlySettingsMutation,
  UpdateCustomBitlySettingsMutationVariables
>;
export const ChangeNameEmailDocument = gql`
  mutation ChangeNameEmail($name: String!, $email: String!, $userId: ID) {
    updateUser(input: { name: $name, email: $email }, userId: $userId) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type ChangeNameEmailMutationFn = Apollo.MutationFunction<
  ChangeNameEmailMutation,
  ChangeNameEmailMutationVariables
>;

/**
 * __useChangeNameEmailMutation__
 *
 * To run a mutation, you first call `useChangeNameEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeNameEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeNameEmailMutation, { data, loading, error }] = useChangeNameEmailMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChangeNameEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangeNameEmailMutation, ChangeNameEmailMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangeNameEmailMutation, ChangeNameEmailMutationVariables>(
    ChangeNameEmailDocument,
    options
  );
}
export type ChangeNameEmailMutationHookResult = ReturnType<typeof useChangeNameEmailMutation>;
export type ChangeNameEmailMutationResult = Apollo.MutationResult<ChangeNameEmailMutation>;
export type ChangeNameEmailMutationOptions = Apollo.BaseMutationOptions<
  ChangeNameEmailMutation,
  ChangeNameEmailMutationVariables
>;
export const CreateWorkspaceDocument = gql`
  mutation CreateWorkspace($organizationId: ID!, $input: WorkspaceInput!) {
    createWorkspace(organizationId: $organizationId, input: $input) {
      id
      name
      timezone
      users {
        id
        firstName
        email
        appRole
      }
      organization {
        id
      }
    }
  }
`;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<
  CreateWorkspaceMutation,
  CreateWorkspaceMutationVariables
>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(
    CreateWorkspaceDocument,
    options
  );
}
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkspaceMutation,
  CreateWorkspaceMutationVariables
>;
export const UpdateWorkspaceDocument = gql`
  mutation UpdateWorkspace($workspaceId: ID!, $input: WorkspaceInput!) {
    updateWorkspace(workspaceId: $workspaceId, input: $input) {
      id
      name
      timezone
      users {
        id
        firstName
        email
        appRole
      }
      organization {
        id
      }
    }
  }
`;
export type UpdateWorkspaceMutationFn = Apollo.MutationFunction<
  UpdateWorkspaceMutation,
  UpdateWorkspaceMutationVariables
>;

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>(
    UpdateWorkspaceDocument,
    options
  );
}
export type UpdateWorkspaceMutationHookResult = ReturnType<typeof useUpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationResult = Apollo.MutationResult<UpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkspaceMutation,
  UpdateWorkspaceMutationVariables
>;
export const ChangePasswordDocument = gql`
  mutation ChangePassword($oldPassword: String!, $newPassword: String!, $userId: ID) {
    updateUser(input: { oldPassword: $oldPassword, newPassword: $newPassword }, userId: $userId) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const SetPasswordDocument = gql`
  mutation SetPassword($newPassword: String!, $userId: ID) {
    updateUser(input: { newPassword: $newPassword }, userId: $userId) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
}
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const UpdatePauseSettingsDocument = gql`
  mutation UpdatePauseSettings($workspaceId: ID!, $input: UpdateWorkspaceSettingsInput!) {
    updateWorkspaceSettings(workspaceId: $workspaceId, input: $input) {
      id
      queuesPaused
      autoImportsPaused
    }
  }
`;
export type UpdatePauseSettingsMutationFn = Apollo.MutationFunction<
  UpdatePauseSettingsMutation,
  UpdatePauseSettingsMutationVariables
>;

/**
 * __useUpdatePauseSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePauseSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePauseSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePauseSettingsMutation, { data, loading, error }] = useUpdatePauseSettingsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePauseSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePauseSettingsMutation, UpdatePauseSettingsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePauseSettingsMutation, UpdatePauseSettingsMutationVariables>(
    UpdatePauseSettingsDocument,
    options
  );
}
export type UpdatePauseSettingsMutationHookResult = ReturnType<typeof useUpdatePauseSettingsMutation>;
export type UpdatePauseSettingsMutationResult = Apollo.MutationResult<UpdatePauseSettingsMutation>;
export type UpdatePauseSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdatePauseSettingsMutation,
  UpdatePauseSettingsMutationVariables
>;
export const UpdatePauseSettingsPerProfileCategoryDocument = gql`
  mutation updatePauseSettingsPerProfileCategory($workspaceId: ID!, $input: [QueueMetaInput!]!) {
    bulkUpdateQueueMeta(workspaceId: $workspaceId, input: $input) {
      socialProfile {
        id
      }
      category {
        id
      }
      paused
    }
  }
`;
export type UpdatePauseSettingsPerProfileCategoryMutationFn = Apollo.MutationFunction<
  UpdatePauseSettingsPerProfileCategoryMutation,
  UpdatePauseSettingsPerProfileCategoryMutationVariables
>;

/**
 * __useUpdatePauseSettingsPerProfileCategoryMutation__
 *
 * To run a mutation, you first call `useUpdatePauseSettingsPerProfileCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePauseSettingsPerProfileCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePauseSettingsPerProfileCategoryMutation, { data, loading, error }] = useUpdatePauseSettingsPerProfileCategoryMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePauseSettingsPerProfileCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePauseSettingsPerProfileCategoryMutation,
    UpdatePauseSettingsPerProfileCategoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePauseSettingsPerProfileCategoryMutation,
    UpdatePauseSettingsPerProfileCategoryMutationVariables
  >(UpdatePauseSettingsPerProfileCategoryDocument, options);
}
export type UpdatePauseSettingsPerProfileCategoryMutationHookResult = ReturnType<
  typeof useUpdatePauseSettingsPerProfileCategoryMutation
>;
export type UpdatePauseSettingsPerProfileCategoryMutationResult =
  Apollo.MutationResult<UpdatePauseSettingsPerProfileCategoryMutation>;
export type UpdatePauseSettingsPerProfileCategoryMutationOptions = Apollo.BaseMutationOptions<
  UpdatePauseSettingsPerProfileCategoryMutation,
  UpdatePauseSettingsPerProfileCategoryMutationVariables
>;
export const GetQueueMetadataDocument = gql`
  query GetQueueMetadata($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      queueMeta {
        socialProfile {
          id
        }
        category {
          id
        }
        paused
      }
    }
  }
`;

/**
 * __useGetQueueMetadataQuery__
 *
 * To run a query within a React component, call `useGetQueueMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueMetadataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetQueueMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<GetQueueMetadataQuery, GetQueueMetadataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQueueMetadataQuery, GetQueueMetadataQueryVariables>(GetQueueMetadataDocument, options);
}
export function useGetQueueMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetQueueMetadataQuery, GetQueueMetadataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQueueMetadataQuery, GetQueueMetadataQueryVariables>(GetQueueMetadataDocument, options);
}
export type GetQueueMetadataQueryHookResult = ReturnType<typeof useGetQueueMetadataQuery>;
export type GetQueueMetadataLazyQueryHookResult = ReturnType<typeof useGetQueueMetadataLazyQuery>;
export type GetQueueMetadataQueryResult = Apollo.QueryResult<GetQueueMetadataQuery, GetQueueMetadataQueryVariables>;
export const GetSocialProfilesDocument = gql`
  query GetSocialProfiles($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      socialProfiles {
        ...SocialProfileFields
      }
    }
  }
  ${SocialProfileFieldsFragmentDoc}
`;

/**
 * __useGetSocialProfilesQuery__
 *
 * To run a query within a React component, call `useGetSocialProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialProfilesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetSocialProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<GetSocialProfilesQuery, GetSocialProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSocialProfilesQuery, GetSocialProfilesQueryVariables>(GetSocialProfilesDocument, options);
}
export function useGetSocialProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSocialProfilesQuery, GetSocialProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSocialProfilesQuery, GetSocialProfilesQueryVariables>(
    GetSocialProfilesDocument,
    options
  );
}
export type GetSocialProfilesQueryHookResult = ReturnType<typeof useGetSocialProfilesQuery>;
export type GetSocialProfilesLazyQueryHookResult = ReturnType<typeof useGetSocialProfilesLazyQuery>;
export type GetSocialProfilesQueryResult = Apollo.QueryResult<GetSocialProfilesQuery, GetSocialProfilesQueryVariables>;
export const ConnectMainSocialProfileDocument = gql`
  mutation ConnectMainSocialProfile($workspaceId: ID!, $socialAuthToken: String!) {
    connectMainSocialProfile(workspaceId: $workspaceId, socialAuthToken: $socialAuthToken) {
      connected
      reconnected
      socialProfile {
        ...SocialProfileFields
      }
      additionalReconnection
      error
      __typename
    }
  }
  ${SocialProfileFieldsFragmentDoc}
`;
export type ConnectMainSocialProfileMutationFn = Apollo.MutationFunction<
  ConnectMainSocialProfileMutation,
  ConnectMainSocialProfileMutationVariables
>;

/**
 * __useConnectMainSocialProfileMutation__
 *
 * To run a mutation, you first call `useConnectMainSocialProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectMainSocialProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectMainSocialProfileMutation, { data, loading, error }] = useConnectMainSocialProfileMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      socialAuthToken: // value for 'socialAuthToken'
 *   },
 * });
 */
export function useConnectMainSocialProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<ConnectMainSocialProfileMutation, ConnectMainSocialProfileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConnectMainSocialProfileMutation, ConnectMainSocialProfileMutationVariables>(
    ConnectMainSocialProfileDocument,
    options
  );
}
export type ConnectMainSocialProfileMutationHookResult = ReturnType<typeof useConnectMainSocialProfileMutation>;
export type ConnectMainSocialProfileMutationResult = Apollo.MutationResult<ConnectMainSocialProfileMutation>;
export type ConnectMainSocialProfileMutationOptions = Apollo.BaseMutationOptions<
  ConnectMainSocialProfileMutation,
  ConnectMainSocialProfileMutationVariables
>;
export const ReconnectSocialProfileDocument = gql`
  mutation ReconnectSocialProfile($socialAuthToken: String!, $profileId: ID!) {
    reconnectSocialProfile(socialAuthToken: $socialAuthToken, profileId: $profileId) {
      connected
      reconnected
      socialProfile {
        ...SocialProfileFields
        workspace {
          id
        }
      }
      additionalReconnection
      error
      __typename
    }
  }
  ${SocialProfileFieldsFragmentDoc}
`;
export type ReconnectSocialProfileMutationFn = Apollo.MutationFunction<
  ReconnectSocialProfileMutation,
  ReconnectSocialProfileMutationVariables
>;

/**
 * __useReconnectSocialProfileMutation__
 *
 * To run a mutation, you first call `useReconnectSocialProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconnectSocialProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconnectSocialProfileMutation, { data, loading, error }] = useReconnectSocialProfileMutation({
 *   variables: {
 *      socialAuthToken: // value for 'socialAuthToken'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useReconnectSocialProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<ReconnectSocialProfileMutation, ReconnectSocialProfileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReconnectSocialProfileMutation, ReconnectSocialProfileMutationVariables>(
    ReconnectSocialProfileDocument,
    options
  );
}
export type ReconnectSocialProfileMutationHookResult = ReturnType<typeof useReconnectSocialProfileMutation>;
export type ReconnectSocialProfileMutationResult = Apollo.MutationResult<ReconnectSocialProfileMutation>;
export type ReconnectSocialProfileMutationOptions = Apollo.BaseMutationOptions<
  ReconnectSocialProfileMutation,
  ReconnectSocialProfileMutationVariables
>;
export const AppInstalledDocument = gql`
  query AppInstalled($id: ID!) {
    socialProfile(socialProfileId: $id) {
      ... on FacebookSocialProfile {
        id
        groupAppInstalled
      }
    }
  }
`;

/**
 * __useAppInstalledQuery__
 *
 * To run a query within a React component, call `useAppInstalledQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInstalledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInstalledQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppInstalledQuery(
  baseOptions: Apollo.QueryHookOptions<AppInstalledQuery, AppInstalledQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AppInstalledQuery, AppInstalledQueryVariables>(AppInstalledDocument, options);
}
export function useAppInstalledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AppInstalledQuery, AppInstalledQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AppInstalledQuery, AppInstalledQueryVariables>(AppInstalledDocument, options);
}
export type AppInstalledQueryHookResult = ReturnType<typeof useAppInstalledQuery>;
export type AppInstalledLazyQueryHookResult = ReturnType<typeof useAppInstalledLazyQuery>;
export type AppInstalledQueryResult = Apollo.QueryResult<AppInstalledQuery, AppInstalledQueryVariables>;
export const ExternalSecondaryProfilesDocument = gql`
  query ExternalSecondaryProfiles(
    $socialAuthToken: String!
    $type: SecondaryProfileType!
    $profileNetwork: Network!
    $workspaceId: ID!
  ) {
    externalSecondaryProfiles(
      socialAuthToken: $socialAuthToken
      type: $type
      profileNetwork: $profileNetwork
      workspaceId: $workspaceId
    ) {
      externalId
      displayName
      organizationId
      workspaceId
      photoUrl
      availablePostAsProfiles {
        externalId
        displayName
      }
    }
  }
`;

/**
 * __useExternalSecondaryProfilesQuery__
 *
 * To run a query within a React component, call `useExternalSecondaryProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalSecondaryProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalSecondaryProfilesQuery({
 *   variables: {
 *      socialAuthToken: // value for 'socialAuthToken'
 *      type: // value for 'type'
 *      profileNetwork: // value for 'profileNetwork'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useExternalSecondaryProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<ExternalSecondaryProfilesQuery, ExternalSecondaryProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExternalSecondaryProfilesQuery, ExternalSecondaryProfilesQueryVariables>(
    ExternalSecondaryProfilesDocument,
    options
  );
}
export function useExternalSecondaryProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExternalSecondaryProfilesQuery, ExternalSecondaryProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExternalSecondaryProfilesQuery, ExternalSecondaryProfilesQueryVariables>(
    ExternalSecondaryProfilesDocument,
    options
  );
}
export type ExternalSecondaryProfilesQueryHookResult = ReturnType<typeof useExternalSecondaryProfilesQuery>;
export type ExternalSecondaryProfilesLazyQueryHookResult = ReturnType<typeof useExternalSecondaryProfilesLazyQuery>;
export type ExternalSecondaryProfilesQueryResult = Apollo.QueryResult<
  ExternalSecondaryProfilesQuery,
  ExternalSecondaryProfilesQueryVariables
>;
export const UpdateSocialProfileDirectPublishingDocument = gql`
  mutation UpdateSocialProfileDirectPublishing($socialProfileId: ID!, $enabled: Boolean!) {
    updateSocialProfileDirectPublishing(socialProfileId: $socialProfileId, enabled: $enabled) {
      id
      directPublishEnabled
    }
  }
`;
export type UpdateSocialProfileDirectPublishingMutationFn = Apollo.MutationFunction<
  UpdateSocialProfileDirectPublishingMutation,
  UpdateSocialProfileDirectPublishingMutationVariables
>;

/**
 * __useUpdateSocialProfileDirectPublishingMutation__
 *
 * To run a mutation, you first call `useUpdateSocialProfileDirectPublishingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialProfileDirectPublishingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialProfileDirectPublishingMutation, { data, loading, error }] = useUpdateSocialProfileDirectPublishingMutation({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateSocialProfileDirectPublishingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSocialProfileDirectPublishingMutation,
    UpdateSocialProfileDirectPublishingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSocialProfileDirectPublishingMutation,
    UpdateSocialProfileDirectPublishingMutationVariables
  >(UpdateSocialProfileDirectPublishingDocument, options);
}
export type UpdateSocialProfileDirectPublishingMutationHookResult = ReturnType<
  typeof useUpdateSocialProfileDirectPublishingMutation
>;
export type UpdateSocialProfileDirectPublishingMutationResult =
  Apollo.MutationResult<UpdateSocialProfileDirectPublishingMutation>;
export type UpdateSocialProfileDirectPublishingMutationOptions = Apollo.BaseMutationOptions<
  UpdateSocialProfileDirectPublishingMutation,
  UpdateSocialProfileDirectPublishingMutationVariables
>;
export const GetWorkspaceDocument = gql`
  query GetWorkspace($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      name
      settings {
        id
        evergreenRecycling
        attributionInstagram
        minimumRecycleTime
        multiMediaAttachMode
        defaultQueuePosition
        fbLinkPreview
        importMediaBehavior
      }
    }
  }
`;

/**
 * __useGetWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkspaceQuery, GetWorkspaceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
}
export function useGetWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceQuery, GetWorkspaceQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
}
export type GetWorkspaceQueryHookResult = ReturnType<typeof useGetWorkspaceQuery>;
export type GetWorkspaceLazyQueryHookResult = ReturnType<typeof useGetWorkspaceLazyQuery>;
export type GetWorkspaceQueryResult = Apollo.QueryResult<GetWorkspaceQuery, GetWorkspaceQueryVariables>;
export const UpdateWorkspaceSettingsDocument = gql`
  mutation UpdateWorkspaceSettings($input: UpdateWorkspaceSettingsInput!, $workspaceId: ID!) {
    updateWorkspaceSettings(input: $input, workspaceId: $workspaceId) {
      workspace {
        id
        settings {
          id
          campaignTracking
          shouldRemoveUtm
          evergreenRecycling
          attributionInstagram
          minimumRecycleTime
          multiMediaAttachMode
          defaultQueuePosition
          fbLinkPreview
          importMediaBehavior
          defaultBitly {
            domain
            bitly {
              ...CoreBitlyFields
            }
          }
        }
      }
    }
  }
  ${CoreBitlyFieldsFragmentDoc}
`;
export type UpdateWorkspaceSettingsMutationFn = Apollo.MutationFunction<
  UpdateWorkspaceSettingsMutation,
  UpdateWorkspaceSettingsMutationVariables
>;

/**
 * __useUpdateWorkspaceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceSettingsMutation, { data, loading, error }] = useUpdateWorkspaceSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateWorkspaceSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceSettingsMutation, UpdateWorkspaceSettingsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateWorkspaceSettingsMutation, UpdateWorkspaceSettingsMutationVariables>(
    UpdateWorkspaceSettingsDocument,
    options
  );
}
export type UpdateWorkspaceSettingsMutationHookResult = ReturnType<typeof useUpdateWorkspaceSettingsMutation>;
export type UpdateWorkspaceSettingsMutationResult = Apollo.MutationResult<UpdateWorkspaceSettingsMutation>;
export type UpdateWorkspaceSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkspaceSettingsMutation,
  UpdateWorkspaceSettingsMutationVariables
>;
export const DeleteInvitedMemberDocument = gql`
  mutation DeleteInvitedMember($userInvitationId: ID!) {
    deleteUserInvitation(userInvitationId: $userInvitationId)
  }
`;
export type DeleteInvitedMemberMutationFn = Apollo.MutationFunction<
  DeleteInvitedMemberMutation,
  DeleteInvitedMemberMutationVariables
>;

/**
 * __useDeleteInvitedMemberMutation__
 *
 * To run a mutation, you first call `useDeleteInvitedMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitedMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitedMemberMutation, { data, loading, error }] = useDeleteInvitedMemberMutation({
 *   variables: {
 *      userInvitationId: // value for 'userInvitationId'
 *   },
 * });
 */
export function useDeleteInvitedMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteInvitedMemberMutation, DeleteInvitedMemberMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteInvitedMemberMutation, DeleteInvitedMemberMutationVariables>(
    DeleteInvitedMemberDocument,
    options
  );
}
export type DeleteInvitedMemberMutationHookResult = ReturnType<typeof useDeleteInvitedMemberMutation>;
export type DeleteInvitedMemberMutationResult = Apollo.MutationResult<DeleteInvitedMemberMutation>;
export type DeleteInvitedMemberMutationOptions = Apollo.BaseMutationOptions<
  DeleteInvitedMemberMutation,
  DeleteInvitedMemberMutationVariables
>;
export const RemoveUserOrganizationAssignmentDocument = gql`
  mutation RemoveUserOrganizationAssignment($organizationId: ID!, $userId: ID!) {
    removeUserOrganizationAssignment(organizationId: $organizationId, userId: $userId)
  }
`;
export type RemoveUserOrganizationAssignmentMutationFn = Apollo.MutationFunction<
  RemoveUserOrganizationAssignmentMutation,
  RemoveUserOrganizationAssignmentMutationVariables
>;

/**
 * __useRemoveUserOrganizationAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveUserOrganizationAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserOrganizationAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserOrganizationAssignmentMutation, { data, loading, error }] = useRemoveUserOrganizationAssignmentMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserOrganizationAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveUserOrganizationAssignmentMutation,
    RemoveUserOrganizationAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveUserOrganizationAssignmentMutation,
    RemoveUserOrganizationAssignmentMutationVariables
  >(RemoveUserOrganizationAssignmentDocument, options);
}
export type RemoveUserOrganizationAssignmentMutationHookResult = ReturnType<
  typeof useRemoveUserOrganizationAssignmentMutation
>;
export type RemoveUserOrganizationAssignmentMutationResult =
  Apollo.MutationResult<RemoveUserOrganizationAssignmentMutation>;
export type RemoveUserOrganizationAssignmentMutationOptions = Apollo.BaseMutationOptions<
  RemoveUserOrganizationAssignmentMutation,
  RemoveUserOrganizationAssignmentMutationVariables
>;
export const GetOrganizationDocument = gql`
  query GetOrganization($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      userAssignments {
        id
        role
        user {
          id
          firstName
          email
        }
      }
      userInvitations {
        id
        email
        role
        workspaceIds
        token
      }
      workspaces {
        id
        name
        timezone
        users {
          id
          firstName
        }
        socialProfiles {
          id
          connected
          photoUrl
          displayName
          onboardingContent
          workspace {
            id
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
}
export function useGetOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const UpdateUserInvitationDocument = gql`
  mutation UpdateUserInvitation($userInvitationId: ID!, $input: UserInvitationInput!) {
    updateUserInvitation(userInvitationId: $userInvitationId, input: $input) {
      id
      email
      role
      workspaceIds
    }
  }
`;
export type UpdateUserInvitationMutationFn = Apollo.MutationFunction<
  UpdateUserInvitationMutation,
  UpdateUserInvitationMutationVariables
>;

/**
 * __useUpdateUserInvitationMutation__
 *
 * To run a mutation, you first call `useUpdateUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInvitationMutation, { data, loading, error }] = useUpdateUserInvitationMutation({
 *   variables: {
 *      userInvitationId: // value for 'userInvitationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserInvitationMutation, UpdateUserInvitationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserInvitationMutation, UpdateUserInvitationMutationVariables>(
    UpdateUserInvitationDocument,
    options
  );
}
export type UpdateUserInvitationMutationHookResult = ReturnType<typeof useUpdateUserInvitationMutation>;
export type UpdateUserInvitationMutationResult = Apollo.MutationResult<UpdateUserInvitationMutation>;
export type UpdateUserInvitationMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserInvitationMutation,
  UpdateUserInvitationMutationVariables
>;
export const UpdateUserOrganizationAssignmentDocument = gql`
  mutation UpdateUserOrganizationAssignment(
    $userId: ID!
    $organizationId: ID!
    $input: UserOrganizationAssignmentInput!
  ) {
    updateUserOrganizationAssignment(input: $input, userId: $userId, organizationId: $organizationId) {
      id
      role
    }
  }
`;
export type UpdateUserOrganizationAssignmentMutationFn = Apollo.MutationFunction<
  UpdateUserOrganizationAssignmentMutation,
  UpdateUserOrganizationAssignmentMutationVariables
>;

/**
 * __useUpdateUserOrganizationAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateUserOrganizationAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOrganizationAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOrganizationAssignmentMutation, { data, loading, error }] = useUpdateUserOrganizationAssignmentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserOrganizationAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserOrganizationAssignmentMutation,
    UpdateUserOrganizationAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserOrganizationAssignmentMutation,
    UpdateUserOrganizationAssignmentMutationVariables
  >(UpdateUserOrganizationAssignmentDocument, options);
}
export type UpdateUserOrganizationAssignmentMutationHookResult = ReturnType<
  typeof useUpdateUserOrganizationAssignmentMutation
>;
export type UpdateUserOrganizationAssignmentMutationResult =
  Apollo.MutationResult<UpdateUserOrganizationAssignmentMutation>;
export type UpdateUserOrganizationAssignmentMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserOrganizationAssignmentMutation,
  UpdateUserOrganizationAssignmentMutationVariables
>;
export const CreateUserWorkspaceAssignmentDocument = gql`
  mutation CreateUserWorkspaceAssignment($userId: ID!, $workspaceId: ID!) {
    createUserWorkspaceAssignment(userId: $userId, workspaceId: $workspaceId) {
      id
      name
      users {
        id
        firstName
        email
      }
      organization {
        id
      }
    }
  }
`;
export type CreateUserWorkspaceAssignmentMutationFn = Apollo.MutationFunction<
  CreateUserWorkspaceAssignmentMutation,
  CreateUserWorkspaceAssignmentMutationVariables
>;

/**
 * __useCreateUserWorkspaceAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateUserWorkspaceAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserWorkspaceAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserWorkspaceAssignmentMutation, { data, loading, error }] = useCreateUserWorkspaceAssignmentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateUserWorkspaceAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserWorkspaceAssignmentMutation,
    CreateUserWorkspaceAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserWorkspaceAssignmentMutation, CreateUserWorkspaceAssignmentMutationVariables>(
    CreateUserWorkspaceAssignmentDocument,
    options
  );
}
export type CreateUserWorkspaceAssignmentMutationHookResult = ReturnType<
  typeof useCreateUserWorkspaceAssignmentMutation
>;
export type CreateUserWorkspaceAssignmentMutationResult = Apollo.MutationResult<CreateUserWorkspaceAssignmentMutation>;
export type CreateUserWorkspaceAssignmentMutationOptions = Apollo.BaseMutationOptions<
  CreateUserWorkspaceAssignmentMutation,
  CreateUserWorkspaceAssignmentMutationVariables
>;
export const RemoveUserWorkspaceAssignmentDocument = gql`
  mutation RemoveUserWorkspaceAssignment($userId: ID!, $workspaceId: ID!) {
    removeUserWorkspaceAssignment(userId: $userId, workspaceId: $workspaceId)
  }
`;
export type RemoveUserWorkspaceAssignmentMutationFn = Apollo.MutationFunction<
  RemoveUserWorkspaceAssignmentMutation,
  RemoveUserWorkspaceAssignmentMutationVariables
>;

/**
 * __useRemoveUserWorkspaceAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveUserWorkspaceAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserWorkspaceAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserWorkspaceAssignmentMutation, { data, loading, error }] = useRemoveUserWorkspaceAssignmentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useRemoveUserWorkspaceAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveUserWorkspaceAssignmentMutation,
    RemoveUserWorkspaceAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveUserWorkspaceAssignmentMutation, RemoveUserWorkspaceAssignmentMutationVariables>(
    RemoveUserWorkspaceAssignmentDocument,
    options
  );
}
export type RemoveUserWorkspaceAssignmentMutationHookResult = ReturnType<
  typeof useRemoveUserWorkspaceAssignmentMutation
>;
export type RemoveUserWorkspaceAssignmentMutationResult = Apollo.MutationResult<RemoveUserWorkspaceAssignmentMutation>;
export type RemoveUserWorkspaceAssignmentMutationOptions = Apollo.BaseMutationOptions<
  RemoveUserWorkspaceAssignmentMutation,
  RemoveUserWorkspaceAssignmentMutationVariables
>;
export const ResendUserInvitationDocument = gql`
  mutation ResendUserInvitation($userInvitationId: ID!) {
    resendUserInvitation(userInvitationId: $userInvitationId)
  }
`;
export type ResendUserInvitationMutationFn = Apollo.MutationFunction<
  ResendUserInvitationMutation,
  ResendUserInvitationMutationVariables
>;

/**
 * __useResendUserInvitationMutation__
 *
 * To run a mutation, you first call `useResendUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInvitationMutation, { data, loading, error }] = useResendUserInvitationMutation({
 *   variables: {
 *      userInvitationId: // value for 'userInvitationId'
 *   },
 * });
 */
export function useResendUserInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>(
    ResendUserInvitationDocument,
    options
  );
}
export type ResendUserInvitationMutationHookResult = ReturnType<typeof useResendUserInvitationMutation>;
export type ResendUserInvitationMutationResult = Apollo.MutationResult<ResendUserInvitationMutation>;
export type ResendUserInvitationMutationOptions = Apollo.BaseMutationOptions<
  ResendUserInvitationMutation,
  ResendUserInvitationMutationVariables
>;
export const GetUnreadNotificationsDocument = gql`
  query GetUnreadNotifications($orgId: ID!) {
    unreadNotificationCount(organizationId: $orgId)
  }
`;

/**
 * __useGetUnreadNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetUnreadNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>(
    GetUnreadNotificationsDocument,
    options
  );
}
export function useGetUnreadNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUnreadNotificationsQuery, GetUnreadNotificationsQueryVariables>(
    GetUnreadNotificationsDocument,
    options
  );
}
export type GetUnreadNotificationsQueryHookResult = ReturnType<typeof useGetUnreadNotificationsQuery>;
export type GetUnreadNotificationsLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationsLazyQuery>;
export type GetUnreadNotificationsQueryResult = Apollo.QueryResult<
  GetUnreadNotificationsQuery,
  GetUnreadNotificationsQueryVariables
>;
export const GetUnreadSiteNewsDocument = gql`
  query GetUnreadSiteNews {
    unreadSiteNews {
      text
      title
      id
      date
    }
  }
`;

/**
 * __useGetUnreadSiteNewsQuery__
 *
 * To run a query within a React component, call `useGetUnreadSiteNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadSiteNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadSiteNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadSiteNewsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUnreadSiteNewsQuery, GetUnreadSiteNewsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnreadSiteNewsQuery, GetUnreadSiteNewsQueryVariables>(GetUnreadSiteNewsDocument, options);
}
export function useGetUnreadSiteNewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadSiteNewsQuery, GetUnreadSiteNewsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUnreadSiteNewsQuery, GetUnreadSiteNewsQueryVariables>(
    GetUnreadSiteNewsDocument,
    options
  );
}
export type GetUnreadSiteNewsQueryHookResult = ReturnType<typeof useGetUnreadSiteNewsQuery>;
export type GetUnreadSiteNewsLazyQueryHookResult = ReturnType<typeof useGetUnreadSiteNewsLazyQuery>;
export type GetUnreadSiteNewsQueryResult = Apollo.QueryResult<GetUnreadSiteNewsQuery, GetUnreadSiteNewsQueryVariables>;
export const UpdateLastReadSiteNewsDocument = gql`
  mutation UpdateLastReadSiteNews($siteNewsId: ID!) {
    updateLastReadSiteNews(siteNewsId: $siteNewsId)
  }
`;
export type UpdateLastReadSiteNewsMutationFn = Apollo.MutationFunction<
  UpdateLastReadSiteNewsMutation,
  UpdateLastReadSiteNewsMutationVariables
>;

/**
 * __useUpdateLastReadSiteNewsMutation__
 *
 * To run a mutation, you first call `useUpdateLastReadSiteNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastReadSiteNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastReadSiteNewsMutation, { data, loading, error }] = useUpdateLastReadSiteNewsMutation({
 *   variables: {
 *      siteNewsId: // value for 'siteNewsId'
 *   },
 * });
 */
export function useUpdateLastReadSiteNewsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateLastReadSiteNewsMutation, UpdateLastReadSiteNewsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLastReadSiteNewsMutation, UpdateLastReadSiteNewsMutationVariables>(
    UpdateLastReadSiteNewsDocument,
    options
  );
}
export type UpdateLastReadSiteNewsMutationHookResult = ReturnType<typeof useUpdateLastReadSiteNewsMutation>;
export type UpdateLastReadSiteNewsMutationResult = Apollo.MutationResult<UpdateLastReadSiteNewsMutation>;
export type UpdateLastReadSiteNewsMutationOptions = Apollo.BaseMutationOptions<
  UpdateLastReadSiteNewsMutation,
  UpdateLastReadSiteNewsMutationVariables
>;
export const GetAllSiteNewsDocument = gql`
  query GetAllSiteNews {
    allSiteNews {
      text
      title
      id
      date
    }
  }
`;

/**
 * __useGetAllSiteNewsQuery__
 *
 * To run a query within a React component, call `useGetAllSiteNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSiteNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSiteNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSiteNewsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAllSiteNewsQuery, GetAllSiteNewsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllSiteNewsQuery, GetAllSiteNewsQueryVariables>(GetAllSiteNewsDocument, options);
}
export function useGetAllSiteNewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllSiteNewsQuery, GetAllSiteNewsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllSiteNewsQuery, GetAllSiteNewsQueryVariables>(GetAllSiteNewsDocument, options);
}
export type GetAllSiteNewsQueryHookResult = ReturnType<typeof useGetAllSiteNewsQuery>;
export type GetAllSiteNewsLazyQueryHookResult = ReturnType<typeof useGetAllSiteNewsLazyQuery>;
export type GetAllSiteNewsQueryResult = Apollo.QueryResult<GetAllSiteNewsQuery, GetAllSiteNewsQueryVariables>;
export const GetCategoriesUsageDocument = gql`
  query GetCategoriesUsage($workspaceId: ID!, $startDate: String!, $endDate: String!, $selectedProfilesIds: [ID!]!) {
    workspace(workspaceId: $workspaceId) {
      categories {
        ...CategoryFields
      }
    }
    analyticsPostStats(
      socialProfileIds: $selectedProfilesIds
      rangeStartDate: $startDate
      rangeEndDate: $endDate
      groupByType: CATEGORY
      groupByDate: false
    ) {
      postStatsByCategory {
        categoryId
        postStats {
          postCount
          rangeStartDate
          rangeEndDate
          likes
          comments
          shares
        }
      }
    }
  }
  ${CategoryFieldsFragmentDoc}
`;

/**
 * __useGetCategoriesUsageQuery__
 *
 * To run a query within a React component, call `useGetCategoriesUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesUsageQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      selectedProfilesIds: // value for 'selectedProfilesIds'
 *   },
 * });
 */
export function useGetCategoriesUsageQuery(
  baseOptions: Apollo.QueryHookOptions<GetCategoriesUsageQuery, GetCategoriesUsageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCategoriesUsageQuery, GetCategoriesUsageQueryVariables>(
    GetCategoriesUsageDocument,
    options
  );
}
export function useGetCategoriesUsageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesUsageQuery, GetCategoriesUsageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCategoriesUsageQuery, GetCategoriesUsageQueryVariables>(
    GetCategoriesUsageDocument,
    options
  );
}
export type GetCategoriesUsageQueryHookResult = ReturnType<typeof useGetCategoriesUsageQuery>;
export type GetCategoriesUsageLazyQueryHookResult = ReturnType<typeof useGetCategoriesUsageLazyQuery>;
export type GetCategoriesUsageQueryResult = Apollo.QueryResult<
  GetCategoriesUsageQuery,
  GetCategoriesUsageQueryVariables
>;
export const GetPostStatsDocument = gql`
  query GetPostStats($startDate: String!, $endDate: String!, $selectedProfilesIds: [ID!]!) {
    analyticsPostStats(
      socialProfileIds: $selectedProfilesIds
      rangeStartDate: $startDate
      rangeEndDate: $endDate
      groupByType: PROFILE
      groupByDate: true
    ) {
      postStatsByProfile {
        socialProfileId
        postStats {
          postCount
          rangeStartDate
          rangeEndDate
          likes
          comments
          shares
        }
      }
    }
  }
`;

/**
 * __useGetPostStatsQuery__
 *
 * To run a query within a React component, call `useGetPostStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      selectedProfilesIds: // value for 'selectedProfilesIds'
 *   },
 * });
 */
export function useGetPostStatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPostStatsQuery, GetPostStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPostStatsQuery, GetPostStatsQueryVariables>(GetPostStatsDocument, options);
}
export function useGetPostStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPostStatsQuery, GetPostStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPostStatsQuery, GetPostStatsQueryVariables>(GetPostStatsDocument, options);
}
export type GetPostStatsQueryHookResult = ReturnType<typeof useGetPostStatsQuery>;
export type GetPostStatsLazyQueryHookResult = ReturnType<typeof useGetPostStatsLazyQuery>;
export type GetPostStatsQueryResult = Apollo.QueryResult<GetPostStatsQuery, GetPostStatsQueryVariables>;
export const GetAnalyticsOverviewDataDocument = gql`
  query GetAnalyticsOverviewData($startDate: String!, $endDate: String!, $selectedProfilesIds: [ID!]!) {
    analyticsFollowers(
      socialProfileIds: $selectedProfilesIds
      groupByDate: true
      rangeStartDate: $startDate
      rangeEndDate: $endDate
    ) {
      socialProfileId
      previousPeriodStats {
        rangeStartDate
        rangeEndDate
        followers
      }
      followersStats {
        rangeStartDate
        rangeEndDate
        followers
      }
    }
    analyticsPostStats(
      socialProfileIds: $selectedProfilesIds
      rangeStartDate: $startDate
      rangeEndDate: $endDate
      groupByType: PROFILE
      groupByDate: false
    ) {
      postStatsByProfile {
        socialProfileId
        postStats {
          postCount
          rangeStartDate
          rangeEndDate
          likes
          comments
          shares
          impressions
        }
      }
    }
  }
`;

/**
 * __useGetAnalyticsOverviewDataQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsOverviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsOverviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsOverviewDataQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      selectedProfilesIds: // value for 'selectedProfilesIds'
 *   },
 * });
 */
export function useGetAnalyticsOverviewDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetAnalyticsOverviewDataQuery, GetAnalyticsOverviewDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAnalyticsOverviewDataQuery, GetAnalyticsOverviewDataQueryVariables>(
    GetAnalyticsOverviewDataDocument,
    options
  );
}
export function useGetAnalyticsOverviewDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsOverviewDataQuery, GetAnalyticsOverviewDataQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAnalyticsOverviewDataQuery, GetAnalyticsOverviewDataQueryVariables>(
    GetAnalyticsOverviewDataDocument,
    options
  );
}
export type GetAnalyticsOverviewDataQueryHookResult = ReturnType<typeof useGetAnalyticsOverviewDataQuery>;
export type GetAnalyticsOverviewDataLazyQueryHookResult = ReturnType<typeof useGetAnalyticsOverviewDataLazyQuery>;
export type GetAnalyticsOverviewDataQueryResult = Apollo.QueryResult<
  GetAnalyticsOverviewDataQuery,
  GetAnalyticsOverviewDataQueryVariables
>;
export const CreateAutoImportDocument = gql`
  mutation CreateAutoImport($workspaceId: ID!, $input: CreateAutoImportInput!) {
    createAutoImport(input: $input, workspaceId: $workspaceId) {
      ...AutoImportFields
      category {
        ...CategoryFields
      }
      socialProfiles {
        ...SocialProfileFields
        ... on PinterestSocialProfile {
          boards {
            ...CorePinterestBoardFields
          }
        }
      }
    }
  }
  ${AutoImportFieldsFragmentDoc}
  ${CategoryFieldsFragmentDoc}
  ${SocialProfileFieldsFragmentDoc}
  ${CorePinterestBoardFieldsFragmentDoc}
`;
export type CreateAutoImportMutationFn = Apollo.MutationFunction<
  CreateAutoImportMutation,
  CreateAutoImportMutationVariables
>;

/**
 * __useCreateAutoImportMutation__
 *
 * To run a mutation, you first call `useCreateAutoImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutoImportMutation, { data, loading, error }] = useCreateAutoImportMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutoImportMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAutoImportMutation, CreateAutoImportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAutoImportMutation, CreateAutoImportMutationVariables>(
    CreateAutoImportDocument,
    options
  );
}
export type CreateAutoImportMutationHookResult = ReturnType<typeof useCreateAutoImportMutation>;
export type CreateAutoImportMutationResult = Apollo.MutationResult<CreateAutoImportMutation>;
export type CreateAutoImportMutationOptions = Apollo.BaseMutationOptions<
  CreateAutoImportMutation,
  CreateAutoImportMutationVariables
>;
export const EditAutoImportDocument = gql`
  mutation EditAutoImport($autoImportId: ID!, $input: UpdateAutoImportInput!) {
    updateAutoImport(autoImportId: $autoImportId, input: $input) {
      ...AutoImportFields
      category {
        ...CategoryFields
      }
      socialProfiles {
        ...SocialProfileFields
        ... on PinterestSocialProfile {
          boards {
            ...CorePinterestBoardFields
          }
        }
      }
    }
  }
  ${AutoImportFieldsFragmentDoc}
  ${CategoryFieldsFragmentDoc}
  ${SocialProfileFieldsFragmentDoc}
  ${CorePinterestBoardFieldsFragmentDoc}
`;
export type EditAutoImportMutationFn = Apollo.MutationFunction<EditAutoImportMutation, EditAutoImportMutationVariables>;

/**
 * __useEditAutoImportMutation__
 *
 * To run a mutation, you first call `useEditAutoImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAutoImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAutoImportMutation, { data, loading, error }] = useEditAutoImportMutation({
 *   variables: {
 *      autoImportId: // value for 'autoImportId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAutoImportMutation(
  baseOptions?: Apollo.MutationHookOptions<EditAutoImportMutation, EditAutoImportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditAutoImportMutation, EditAutoImportMutationVariables>(EditAutoImportDocument, options);
}
export type EditAutoImportMutationHookResult = ReturnType<typeof useEditAutoImportMutation>;
export type EditAutoImportMutationResult = Apollo.MutationResult<EditAutoImportMutation>;
export type EditAutoImportMutationOptions = Apollo.BaseMutationOptions<
  EditAutoImportMutation,
  EditAutoImportMutationVariables
>;
export const DeleteAutoImportDocument = gql`
  mutation DeleteAutoImport($importId: ID!) {
    deleteAutoImport(autoImportId: $importId)
  }
`;
export type DeleteAutoImportMutationFn = Apollo.MutationFunction<
  DeleteAutoImportMutation,
  DeleteAutoImportMutationVariables
>;

/**
 * __useDeleteAutoImportMutation__
 *
 * To run a mutation, you first call `useDeleteAutoImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutoImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutoImportMutation, { data, loading, error }] = useDeleteAutoImportMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *   },
 * });
 */
export function useDeleteAutoImportMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAutoImportMutation, DeleteAutoImportMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAutoImportMutation, DeleteAutoImportMutationVariables>(
    DeleteAutoImportDocument,
    options
  );
}
export type DeleteAutoImportMutationHookResult = ReturnType<typeof useDeleteAutoImportMutation>;
export type DeleteAutoImportMutationResult = Apollo.MutationResult<DeleteAutoImportMutation>;
export type DeleteAutoImportMutationOptions = Apollo.BaseMutationOptions<
  DeleteAutoImportMutation,
  DeleteAutoImportMutationVariables
>;
export const DeleteAllAutoImportsDocument = gql`
  mutation DeleteAllAutoImports($workspaceId: ID!) {
    deleteAllAutoImports(workspaceId: $workspaceId)
  }
`;
export type DeleteAllAutoImportsMutationFn = Apollo.MutationFunction<
  DeleteAllAutoImportsMutation,
  DeleteAllAutoImportsMutationVariables
>;

/**
 * __useDeleteAllAutoImportsMutation__
 *
 * To run a mutation, you first call `useDeleteAllAutoImportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllAutoImportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllAutoImportsMutation, { data, loading, error }] = useDeleteAllAutoImportsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteAllAutoImportsMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAllAutoImportsMutation, DeleteAllAutoImportsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAllAutoImportsMutation, DeleteAllAutoImportsMutationVariables>(
    DeleteAllAutoImportsDocument,
    options
  );
}
export type DeleteAllAutoImportsMutationHookResult = ReturnType<typeof useDeleteAllAutoImportsMutation>;
export type DeleteAllAutoImportsMutationResult = Apollo.MutationResult<DeleteAllAutoImportsMutation>;
export type DeleteAllAutoImportsMutationOptions = Apollo.BaseMutationOptions<
  DeleteAllAutoImportsMutation,
  DeleteAllAutoImportsMutationVariables
>;
export const CreateImportFolderDocument = gql`
  mutation CreateImportFolder($workspaceId: ID!, $input: CreateImportFolderInput!) {
    createImportFolder(workspaceId: $workspaceId, input: $input) {
      ...CoreImportFolderFields
      importSources {
        ...ImportSourceFields
      }
    }
  }
  ${CoreImportFolderFieldsFragmentDoc}
  ${ImportSourceFieldsFragmentDoc}
`;
export type CreateImportFolderMutationFn = Apollo.MutationFunction<
  CreateImportFolderMutation,
  CreateImportFolderMutationVariables
>;

/**
 * __useCreateImportFolderMutation__
 *
 * To run a mutation, you first call `useCreateImportFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportFolderMutation, { data, loading, error }] = useCreateImportFolderMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateImportFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateImportFolderMutation, CreateImportFolderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateImportFolderMutation, CreateImportFolderMutationVariables>(
    CreateImportFolderDocument,
    options
  );
}
export type CreateImportFolderMutationHookResult = ReturnType<typeof useCreateImportFolderMutation>;
export type CreateImportFolderMutationResult = Apollo.MutationResult<CreateImportFolderMutation>;
export type CreateImportFolderMutationOptions = Apollo.BaseMutationOptions<
  CreateImportFolderMutation,
  CreateImportFolderMutationVariables
>;
export const SearchFacebookPostsDocument = gql`
  query SearchFacebookPosts(
    $socialProfileId: ID!
    $searchType: FacebookSearchType!
    $sortType: FacebookSearchSortType!
    $contentType: FacebookSearchContentType!
    $externalId: String!
    $term: String
    $cursor: String
  ) {
    searchFacebookPosts(
      socialProfileId: $socialProfileId
      searchType: $searchType
      contentType: $contentType
      sortType: $sortType
      externalId: $externalId
      term: $term
      cursor: $cursor
    ) {
      cursor
      items {
        ...ThirdPartyPostFields
      }
    }
  }
  ${ThirdPartyPostFieldsFragmentDoc}
`;

/**
 * __useSearchFacebookPostsQuery__
 *
 * To run a query within a React component, call `useSearchFacebookPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFacebookPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFacebookPostsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      searchType: // value for 'searchType'
 *      sortType: // value for 'sortType'
 *      contentType: // value for 'contentType'
 *      externalId: // value for 'externalId'
 *      term: // value for 'term'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSearchFacebookPostsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchFacebookPostsQuery, SearchFacebookPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchFacebookPostsQuery, SearchFacebookPostsQueryVariables>(
    SearchFacebookPostsDocument,
    options
  );
}
export function useSearchFacebookPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchFacebookPostsQuery, SearchFacebookPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchFacebookPostsQuery, SearchFacebookPostsQueryVariables>(
    SearchFacebookPostsDocument,
    options
  );
}
export type SearchFacebookPostsQueryHookResult = ReturnType<typeof useSearchFacebookPostsQuery>;
export type SearchFacebookPostsLazyQueryHookResult = ReturnType<typeof useSearchFacebookPostsLazyQuery>;
export type SearchFacebookPostsQueryResult = Apollo.QueryResult<
  SearchFacebookPostsQuery,
  SearchFacebookPostsQueryVariables
>;
export const SearchFacebookLikedPagesDocument = gql`
  query SearchFacebookLikedPages($socialProfileId: ID!) {
    searchFacebookLikedPages(socialProfileId: $socialProfileId) {
      ...ThirdPartyProfileFields
    }
  }
  ${ThirdPartyProfileFieldsFragmentDoc}
`;

/**
 * __useSearchFacebookLikedPagesQuery__
 *
 * To run a query within a React component, call `useSearchFacebookLikedPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFacebookLikedPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFacebookLikedPagesQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *   },
 * });
 */
export function useSearchFacebookLikedPagesQuery(
  baseOptions: Apollo.QueryHookOptions<SearchFacebookLikedPagesQuery, SearchFacebookLikedPagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchFacebookLikedPagesQuery, SearchFacebookLikedPagesQueryVariables>(
    SearchFacebookLikedPagesDocument,
    options
  );
}
export function useSearchFacebookLikedPagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchFacebookLikedPagesQuery, SearchFacebookLikedPagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchFacebookLikedPagesQuery, SearchFacebookLikedPagesQueryVariables>(
    SearchFacebookLikedPagesDocument,
    options
  );
}
export type SearchFacebookLikedPagesQueryHookResult = ReturnType<typeof useSearchFacebookLikedPagesQuery>;
export type SearchFacebookLikedPagesLazyQueryHookResult = ReturnType<typeof useSearchFacebookLikedPagesLazyQuery>;
export type SearchFacebookLikedPagesQueryResult = Apollo.QueryResult<
  SearchFacebookLikedPagesQuery,
  SearchFacebookLikedPagesQueryVariables
>;
export const SearchInstagramPostsDocument = gql`
  query SearchInstagramPosts(
    $socialProfileId: ID!
    $externalId: String!
    $searchType: InstagramSearchType!
    $sortType: InstagramSearchSortType!
    $term: String
    $cursor: String
  ) {
    searchInstagramPosts(
      socialProfileId: $socialProfileId
      externalId: $externalId
      searchType: $searchType
      sortType: $sortType
      term: $term
      cursor: $cursor
    ) {
      cursor
      items {
        ...ThirdPartyPostFields
      }
    }
  }
  ${ThirdPartyPostFieldsFragmentDoc}
`;

/**
 * __useSearchInstagramPostsQuery__
 *
 * To run a query within a React component, call `useSearchInstagramPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInstagramPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInstagramPostsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      externalId: // value for 'externalId'
 *      searchType: // value for 'searchType'
 *      sortType: // value for 'sortType'
 *      term: // value for 'term'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSearchInstagramPostsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchInstagramPostsQuery, SearchInstagramPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchInstagramPostsQuery, SearchInstagramPostsQueryVariables>(
    SearchInstagramPostsDocument,
    options
  );
}
export function useSearchInstagramPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchInstagramPostsQuery, SearchInstagramPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchInstagramPostsQuery, SearchInstagramPostsQueryVariables>(
    SearchInstagramPostsDocument,
    options
  );
}
export type SearchInstagramPostsQueryHookResult = ReturnType<typeof useSearchInstagramPostsQuery>;
export type SearchInstagramPostsLazyQueryHookResult = ReturnType<typeof useSearchInstagramPostsLazyQuery>;
export type SearchInstagramPostsQueryResult = Apollo.QueryResult<
  SearchInstagramPostsQuery,
  SearchInstagramPostsQueryVariables
>;
export const SearchLinkedInPostsDocument = gql`
  query SearchLinkedInPosts(
    $socialProfileId: ID!
    $searchType: LinkedInSearchType!
    $contentType: LinkedInSearchContentType!
    $sortType: LinkedInSearchSortType!
    $externalId: String!
    $term: String
    $cursor: String
  ) {
    searchLinkedInPosts(
      socialProfileId: $socialProfileId
      searchType: $searchType
      contentType: $contentType
      sortType: $sortType
      externalId: $externalId
      term: $term
      cursor: $cursor
    ) {
      cursor
      items {
        ...ThirdPartyPostFields
      }
    }
  }
  ${ThirdPartyPostFieldsFragmentDoc}
`;

/**
 * __useSearchLinkedInPostsQuery__
 *
 * To run a query within a React component, call `useSearchLinkedInPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLinkedInPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLinkedInPostsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      searchType: // value for 'searchType'
 *      contentType: // value for 'contentType'
 *      sortType: // value for 'sortType'
 *      externalId: // value for 'externalId'
 *      term: // value for 'term'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSearchLinkedInPostsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchLinkedInPostsQuery, SearchLinkedInPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchLinkedInPostsQuery, SearchLinkedInPostsQueryVariables>(
    SearchLinkedInPostsDocument,
    options
  );
}
export function useSearchLinkedInPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchLinkedInPostsQuery, SearchLinkedInPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchLinkedInPostsQuery, SearchLinkedInPostsQueryVariables>(
    SearchLinkedInPostsDocument,
    options
  );
}
export type SearchLinkedInPostsQueryHookResult = ReturnType<typeof useSearchLinkedInPostsQuery>;
export type SearchLinkedInPostsLazyQueryHookResult = ReturnType<typeof useSearchLinkedInPostsLazyQuery>;
export type SearchLinkedInPostsQueryResult = Apollo.QueryResult<
  SearchLinkedInPostsQuery,
  SearchLinkedInPostsQueryVariables
>;
export const SearchPinterestFollowedBoardsDocument = gql`
  query SearchPinterestFollowedBoards($socialProfileId: ID!) {
    searchPinterestFollowedBoards(socialProfileId: $socialProfileId) {
      ...CorePinterestBoardFields
    }
  }
  ${CorePinterestBoardFieldsFragmentDoc}
`;

/**
 * __useSearchPinterestFollowedBoardsQuery__
 *
 * To run a query within a React component, call `useSearchPinterestFollowedBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPinterestFollowedBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPinterestFollowedBoardsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *   },
 * });
 */
export function useSearchPinterestFollowedBoardsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchPinterestFollowedBoardsQuery, SearchPinterestFollowedBoardsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchPinterestFollowedBoardsQuery, SearchPinterestFollowedBoardsQueryVariables>(
    SearchPinterestFollowedBoardsDocument,
    options
  );
}
export function useSearchPinterestFollowedBoardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchPinterestFollowedBoardsQuery,
    SearchPinterestFollowedBoardsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchPinterestFollowedBoardsQuery, SearchPinterestFollowedBoardsQueryVariables>(
    SearchPinterestFollowedBoardsDocument,
    options
  );
}
export type SearchPinterestFollowedBoardsQueryHookResult = ReturnType<typeof useSearchPinterestFollowedBoardsQuery>;
export type SearchPinterestFollowedBoardsLazyQueryHookResult = ReturnType<
  typeof useSearchPinterestFollowedBoardsLazyQuery
>;
export type SearchPinterestFollowedBoardsQueryResult = Apollo.QueryResult<
  SearchPinterestFollowedBoardsQuery,
  SearchPinterestFollowedBoardsQueryVariables
>;
export const SearchPinterestPostsDocument = gql`
  query SearchPinterestPosts(
    $socialProfileId: ID!
    $searchType: PinterestSearchType!
    $contentType: PinterestSearchContentType!
    $sortType: PinterestSearchSortType!
    $externalId: String!
    $term: String
    $cursor: String
  ) {
    searchPinterestPosts(
      socialProfileId: $socialProfileId
      searchType: $searchType
      contentType: $contentType
      sortType: $sortType
      externalId: $externalId
      term: $term
      cursor: $cursor
    ) {
      items {
        ...ThirdPartyPostFields
      }
      cursor
    }
  }
  ${ThirdPartyPostFieldsFragmentDoc}
`;

/**
 * __useSearchPinterestPostsQuery__
 *
 * To run a query within a React component, call `useSearchPinterestPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPinterestPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPinterestPostsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      searchType: // value for 'searchType'
 *      contentType: // value for 'contentType'
 *      sortType: // value for 'sortType'
 *      externalId: // value for 'externalId'
 *      term: // value for 'term'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSearchPinterestPostsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchPinterestPostsQuery, SearchPinterestPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchPinterestPostsQuery, SearchPinterestPostsQueryVariables>(
    SearchPinterestPostsDocument,
    options
  );
}
export function useSearchPinterestPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchPinterestPostsQuery, SearchPinterestPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchPinterestPostsQuery, SearchPinterestPostsQueryVariables>(
    SearchPinterestPostsDocument,
    options
  );
}
export type SearchPinterestPostsQueryHookResult = ReturnType<typeof useSearchPinterestPostsQuery>;
export type SearchPinterestPostsLazyQueryHookResult = ReturnType<typeof useSearchPinterestPostsLazyQuery>;
export type SearchPinterestPostsQueryResult = Apollo.QueryResult<
  SearchPinterestPostsQuery,
  SearchPinterestPostsQueryVariables
>;
export const SearchRssPostsDocument = gql`
  query SearchRssPosts($workspaceId: ID!, $url: String!, $term: String, $cursor: String) {
    searchRssPosts(workspaceId: $workspaceId, url: $url, term: $term, cursor: $cursor) {
      cursor
      items {
        ...ExternalRssPostFields
      }
    }
  }
  ${ExternalRssPostFieldsFragmentDoc}
`;

/**
 * __useSearchRssPostsQuery__
 *
 * To run a query within a React component, call `useSearchRssPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRssPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRssPostsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      url: // value for 'url'
 *      term: // value for 'term'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSearchRssPostsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchRssPostsQuery, SearchRssPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchRssPostsQuery, SearchRssPostsQueryVariables>(SearchRssPostsDocument, options);
}
export function useSearchRssPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchRssPostsQuery, SearchRssPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchRssPostsQuery, SearchRssPostsQueryVariables>(SearchRssPostsDocument, options);
}
export type SearchRssPostsQueryHookResult = ReturnType<typeof useSearchRssPostsQuery>;
export type SearchRssPostsLazyQueryHookResult = ReturnType<typeof useSearchRssPostsLazyQuery>;
export type SearchRssPostsQueryResult = Apollo.QueryResult<SearchRssPostsQuery, SearchRssPostsQueryVariables>;
export const SearchTwitterListsDocument = gql`
  query SearchTwitterLists($socialProfileId: ID!) {
    searchTwitterLists(socialProfileId: $socialProfileId) {
      externalId
      name
      memberCount
    }
  }
`;

/**
 * __useSearchTwitterListsQuery__
 *
 * To run a query within a React component, call `useSearchTwitterListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTwitterListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTwitterListsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *   },
 * });
 */
export function useSearchTwitterListsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchTwitterListsQuery, SearchTwitterListsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchTwitterListsQuery, SearchTwitterListsQueryVariables>(
    SearchTwitterListsDocument,
    options
  );
}
export function useSearchTwitterListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchTwitterListsQuery, SearchTwitterListsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchTwitterListsQuery, SearchTwitterListsQueryVariables>(
    SearchTwitterListsDocument,
    options
  );
}
export type SearchTwitterListsQueryHookResult = ReturnType<typeof useSearchTwitterListsQuery>;
export type SearchTwitterListsLazyQueryHookResult = ReturnType<typeof useSearchTwitterListsLazyQuery>;
export type SearchTwitterListsQueryResult = Apollo.QueryResult<
  SearchTwitterListsQuery,
  SearchTwitterListsQueryVariables
>;
export const SearchTwitterPostsDocument = gql`
  query SearchTwitterPosts(
    $socialProfileId: ID!
    $searchType: TwitterSearchType!
    $contentType: TwitterSearchContentType!
    $sortType: TwitterSearchSortType!
    $includeRetweets: Boolean
    $includeReplies: Boolean
    $term: String
    $externalId: String
    $cursor: String
  ) {
    searchTwitterPosts(
      socialProfileId: $socialProfileId
      searchType: $searchType
      contentType: $contentType
      sortType: $sortType
      includeRetweets: $includeRetweets
      includeReplies: $includeReplies
      term: $term
      externalId: $externalId
      cursor: $cursor
    ) {
      cursor
      items {
        ...ThirdPartyPostFields
      }
    }
  }
  ${ThirdPartyPostFieldsFragmentDoc}
`;

/**
 * __useSearchTwitterPostsQuery__
 *
 * To run a query within a React component, call `useSearchTwitterPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTwitterPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTwitterPostsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      searchType: // value for 'searchType'
 *      contentType: // value for 'contentType'
 *      sortType: // value for 'sortType'
 *      includeRetweets: // value for 'includeRetweets'
 *      includeReplies: // value for 'includeReplies'
 *      term: // value for 'term'
 *      externalId: // value for 'externalId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSearchTwitterPostsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchTwitterPostsQuery, SearchTwitterPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchTwitterPostsQuery, SearchTwitterPostsQueryVariables>(
    SearchTwitterPostsDocument,
    options
  );
}
export function useSearchTwitterPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchTwitterPostsQuery, SearchTwitterPostsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchTwitterPostsQuery, SearchTwitterPostsQueryVariables>(
    SearchTwitterPostsDocument,
    options
  );
}
export type SearchTwitterPostsQueryHookResult = ReturnType<typeof useSearchTwitterPostsQuery>;
export type SearchTwitterPostsLazyQueryHookResult = ReturnType<typeof useSearchTwitterPostsLazyQuery>;
export type SearchTwitterPostsQueryResult = Apollo.QueryResult<
  SearchTwitterPostsQuery,
  SearchTwitterPostsQueryVariables
>;
export const DeleteImportFolderDocument = gql`
  mutation DeleteImportFolder($importFolderId: ID!) {
    deleteImportFolder(importFolderId: $importFolderId)
  }
`;
export type DeleteImportFolderMutationFn = Apollo.MutationFunction<
  DeleteImportFolderMutation,
  DeleteImportFolderMutationVariables
>;

/**
 * __useDeleteImportFolderMutation__
 *
 * To run a mutation, you first call `useDeleteImportFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportFolderMutation, { data, loading, error }] = useDeleteImportFolderMutation({
 *   variables: {
 *      importFolderId: // value for 'importFolderId'
 *   },
 * });
 */
export function useDeleteImportFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteImportFolderMutation, DeleteImportFolderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteImportFolderMutation, DeleteImportFolderMutationVariables>(
    DeleteImportFolderDocument,
    options
  );
}
export type DeleteImportFolderMutationHookResult = ReturnType<typeof useDeleteImportFolderMutation>;
export type DeleteImportFolderMutationResult = Apollo.MutationResult<DeleteImportFolderMutation>;
export type DeleteImportFolderMutationOptions = Apollo.BaseMutationOptions<
  DeleteImportFolderMutation,
  DeleteImportFolderMutationVariables
>;
export const DeleteImportSourceDocument = gql`
  mutation DeleteImportSource($importSourceId: ID!) {
    deleteImportSource(importSourceId: $importSourceId)
  }
`;
export type DeleteImportSourceMutationFn = Apollo.MutationFunction<
  DeleteImportSourceMutation,
  DeleteImportSourceMutationVariables
>;

/**
 * __useDeleteImportSourceMutation__
 *
 * To run a mutation, you first call `useDeleteImportSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportSourceMutation, { data, loading, error }] = useDeleteImportSourceMutation({
 *   variables: {
 *      importSourceId: // value for 'importSourceId'
 *   },
 * });
 */
export function useDeleteImportSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteImportSourceMutation, DeleteImportSourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteImportSourceMutation, DeleteImportSourceMutationVariables>(
    DeleteImportSourceDocument,
    options
  );
}
export type DeleteImportSourceMutationHookResult = ReturnType<typeof useDeleteImportSourceMutation>;
export type DeleteImportSourceMutationResult = Apollo.MutationResult<DeleteImportSourceMutation>;
export type DeleteImportSourceMutationOptions = Apollo.BaseMutationOptions<
  DeleteImportSourceMutation,
  DeleteImportSourceMutationVariables
>;
export const RssOpmlUploadDocument = gql`
  mutation RssOpmlUpload($workspaceId: ID!, $file: Upload!) {
    rssOpmlUpload(workspaceId: $workspaceId, file: $file) {
      importFolders {
        ...CoreImportFolderFields
      }
      importSources {
        ...ImportSourceFields
      }
    }
  }
  ${CoreImportFolderFieldsFragmentDoc}
  ${ImportSourceFieldsFragmentDoc}
`;
export type RssOpmlUploadMutationFn = Apollo.MutationFunction<RssOpmlUploadMutation, RssOpmlUploadMutationVariables>;

/**
 * __useRssOpmlUploadMutation__
 *
 * To run a mutation, you first call `useRssOpmlUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRssOpmlUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rssOpmlUploadMutation, { data, loading, error }] = useRssOpmlUploadMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useRssOpmlUploadMutation(
  baseOptions?: Apollo.MutationHookOptions<RssOpmlUploadMutation, RssOpmlUploadMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RssOpmlUploadMutation, RssOpmlUploadMutationVariables>(RssOpmlUploadDocument, options);
}
export type RssOpmlUploadMutationHookResult = ReturnType<typeof useRssOpmlUploadMutation>;
export type RssOpmlUploadMutationResult = Apollo.MutationResult<RssOpmlUploadMutation>;
export type RssOpmlUploadMutationOptions = Apollo.BaseMutationOptions<
  RssOpmlUploadMutation,
  RssOpmlUploadMutationVariables
>;
export const UpdateImportFolderDocument = gql`
  mutation UpdateImportFolder($importFolderId: ID!, $input: UpdateImportFolderInput!) {
    updateImportFolder(importFolderId: $importFolderId, input: $input) {
      ...CoreImportFolderFields
    }
  }
  ${CoreImportFolderFieldsFragmentDoc}
`;
export type UpdateImportFolderMutationFn = Apollo.MutationFunction<
  UpdateImportFolderMutation,
  UpdateImportFolderMutationVariables
>;

/**
 * __useUpdateImportFolderMutation__
 *
 * To run a mutation, you first call `useUpdateImportFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportFolderMutation, { data, loading, error }] = useUpdateImportFolderMutation({
 *   variables: {
 *      importFolderId: // value for 'importFolderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImportFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateImportFolderMutation, UpdateImportFolderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateImportFolderMutation, UpdateImportFolderMutationVariables>(
    UpdateImportFolderDocument,
    options
  );
}
export type UpdateImportFolderMutationHookResult = ReturnType<typeof useUpdateImportFolderMutation>;
export type UpdateImportFolderMutationResult = Apollo.MutationResult<UpdateImportFolderMutation>;
export type UpdateImportFolderMutationOptions = Apollo.BaseMutationOptions<
  UpdateImportFolderMutation,
  UpdateImportFolderMutationVariables
>;
export const UpdateImportSourceDocument = gql`
  mutation UpdateImportSource($importSourceId: ID!, $input: UpdateImportSourceInput!) {
    updateImportSource(importSourceId: $importSourceId, input: $input) {
      ...ImportSourceFields
    }
  }
  ${ImportSourceFieldsFragmentDoc}
`;
export type UpdateImportSourceMutationFn = Apollo.MutationFunction<
  UpdateImportSourceMutation,
  UpdateImportSourceMutationVariables
>;

/**
 * __useUpdateImportSourceMutation__
 *
 * To run a mutation, you first call `useUpdateImportSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportSourceMutation, { data, loading, error }] = useUpdateImportSourceMutation({
 *   variables: {
 *      importSourceId: // value for 'importSourceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImportSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateImportSourceMutation, UpdateImportSourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateImportSourceMutation, UpdateImportSourceMutationVariables>(
    UpdateImportSourceDocument,
    options
  );
}
export type UpdateImportSourceMutationHookResult = ReturnType<typeof useUpdateImportSourceMutation>;
export type UpdateImportSourceMutationResult = Apollo.MutationResult<UpdateImportSourceMutation>;
export type UpdateImportSourceMutationOptions = Apollo.BaseMutationOptions<
  UpdateImportSourceMutation,
  UpdateImportSourceMutationVariables
>;
export const GetThirdPartyProfilesDocument = gql`
  query GetThirdPartyProfiles($socialProfileId: ID!, $method: ThirdPartyProfileSearchType!, $term: String!) {
    searchThirdPartyProfiles(method: $method, socialProfileId: $socialProfileId, term: $term) {
      ...ThirdPartyProfileFields
    }
  }
  ${ThirdPartyProfileFieldsFragmentDoc}
`;

/**
 * __useGetThirdPartyProfilesQuery__
 *
 * To run a query within a React component, call `useGetThirdPartyProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThirdPartyProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThirdPartyProfilesQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *      method: // value for 'method'
 *      term: // value for 'term'
 *   },
 * });
 */
export function useGetThirdPartyProfilesQuery(
  baseOptions: Apollo.QueryHookOptions<GetThirdPartyProfilesQuery, GetThirdPartyProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetThirdPartyProfilesQuery, GetThirdPartyProfilesQueryVariables>(
    GetThirdPartyProfilesDocument,
    options
  );
}
export function useGetThirdPartyProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetThirdPartyProfilesQuery, GetThirdPartyProfilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetThirdPartyProfilesQuery, GetThirdPartyProfilesQueryVariables>(
    GetThirdPartyProfilesDocument,
    options
  );
}
export type GetThirdPartyProfilesQueryHookResult = ReturnType<typeof useGetThirdPartyProfilesQuery>;
export type GetThirdPartyProfilesLazyQueryHookResult = ReturnType<typeof useGetThirdPartyProfilesLazyQuery>;
export type GetThirdPartyProfilesQueryResult = Apollo.QueryResult<
  GetThirdPartyProfilesQuery,
  GetThirdPartyProfilesQueryVariables
>;
export const GetCategoryDocument = gql`
  query GetCategory($categoryId: ID!) {
    category(categoryId: $categoryId) {
      id
      name
      seasonal
      seasonalStartDate
      seasonalEndDate
      seasonallyPaused
      archived
      archivedDate
      archivedAttachedPostCount
      defaultSocialProfiles {
        ...CoreDefaultProfilesFields
      }
    }
  }
  ${CoreDefaultProfilesFieldsFragmentDoc}
`;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
}
export function useGetCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
}
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const CreateCategoryDocument = gql`
  mutation CreateCategory($workspaceId: ID!, $input: CreateCategoryInput!) {
    createCategory(workspaceId: $workspaceId, input: $input) {
      id
      name
      seasonal
      seasonalStartDate
      seasonalEndDate
      seasonallyPaused
      archived
      archivedDate
      archivedAttachedPostCount
      color
      onboardingContent
      defaultSocialProfiles {
        ...CoreDefaultProfilesFields
      }
    }
  }
  ${CoreDefaultProfilesFieldsFragmentDoc}
`;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
}
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<
  CreateCategoryMutation,
  CreateCategoryMutationVariables
>;
export const UpdateCategoryDocument = gql`
  mutation UpdateCategory($categoryId: ID!, $input: UpdateCategoryInput!) {
    updateCategory(categoryId: $categoryId, input: $input) {
      id
      name
      seasonal
      seasonalStartDate
      seasonalEndDate
      seasonallyPaused
      archived
      archivedDate
      archivedAttachedPostCount
      color
      defaultSocialProfiles {
        ...CoreDefaultProfilesFields
      }
    }
  }
  ${CoreDefaultProfilesFieldsFragmentDoc}
`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
}
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<
  UpdateCategoryMutation,
  UpdateCategoryMutationVariables
>;
export const DeleteCategoryDocument = gql`
  mutation DeleteCategory($categoryId: ID!) {
    deleteCategory(categoryId: $categoryId)
  }
`;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
}
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<
  DeleteCategoryMutation,
  DeleteCategoryMutationVariables
>;
export const SearchPixabayDocument = gql`
  query SearchPixabay($input: PixabaySearchInput!) {
    searchPixabay(input: $input) {
      ...CoreThirdPartySearchFields
    }
  }
  ${CoreThirdPartySearchFieldsFragmentDoc}
`;

/**
 * __useSearchPixabayQuery__
 *
 * To run a query within a React component, call `useSearchPixabayQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPixabayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPixabayQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchPixabayQuery(
  baseOptions: Apollo.QueryHookOptions<SearchPixabayQuery, SearchPixabayQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchPixabayQuery, SearchPixabayQueryVariables>(SearchPixabayDocument, options);
}
export function useSearchPixabayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchPixabayQuery, SearchPixabayQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchPixabayQuery, SearchPixabayQueryVariables>(SearchPixabayDocument, options);
}
export type SearchPixabayQueryHookResult = ReturnType<typeof useSearchPixabayQuery>;
export type SearchPixabayLazyQueryHookResult = ReturnType<typeof useSearchPixabayLazyQuery>;
export type SearchPixabayQueryResult = Apollo.QueryResult<SearchPixabayQuery, SearchPixabayQueryVariables>;
export const SearchGiphyDocument = gql`
  query SearchGiphy($input: GiphySearchInput!) {
    searchGiphy(input: $input) {
      ...CoreThirdPartySearchFields
    }
  }
  ${CoreThirdPartySearchFieldsFragmentDoc}
`;

/**
 * __useSearchGiphyQuery__
 *
 * To run a query within a React component, call `useSearchGiphyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGiphyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGiphyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchGiphyQuery(baseOptions: Apollo.QueryHookOptions<SearchGiphyQuery, SearchGiphyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchGiphyQuery, SearchGiphyQueryVariables>(SearchGiphyDocument, options);
}
export function useSearchGiphyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchGiphyQuery, SearchGiphyQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchGiphyQuery, SearchGiphyQueryVariables>(SearchGiphyDocument, options);
}
export type SearchGiphyQueryHookResult = ReturnType<typeof useSearchGiphyQuery>;
export type SearchGiphyLazyQueryHookResult = ReturnType<typeof useSearchGiphyLazyQuery>;
export type SearchGiphyQueryResult = Apollo.QueryResult<SearchGiphyQuery, SearchGiphyQueryVariables>;
export const SearchUnsplashDocument = gql`
  query SearchUnsplash($input: UnsplashSearchInput!) {
    searchUnsplash(input: $input) {
      ...CoreThirdPartySearchFields
    }
  }
  ${CoreThirdPartySearchFieldsFragmentDoc}
`;

/**
 * __useSearchUnsplashQuery__
 *
 * To run a query within a React component, call `useSearchUnsplashQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUnsplashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUnsplashQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchUnsplashQuery(
  baseOptions: Apollo.QueryHookOptions<SearchUnsplashQuery, SearchUnsplashQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchUnsplashQuery, SearchUnsplashQueryVariables>(SearchUnsplashDocument, options);
}
export function useSearchUnsplashLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchUnsplashQuery, SearchUnsplashQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchUnsplashQuery, SearchUnsplashQueryVariables>(SearchUnsplashDocument, options);
}
export type SearchUnsplashQueryHookResult = ReturnType<typeof useSearchUnsplashQuery>;
export type SearchUnsplashLazyQueryHookResult = ReturnType<typeof useSearchUnsplashLazyQuery>;
export type SearchUnsplashQueryResult = Apollo.QueryResult<SearchUnsplashQuery, SearchUnsplashQueryVariables>;
export const CreateTimeslotDocument = gql`
  mutation CreateTimeslot($workspaceId: ID!, $input: TimeslotInput!) {
    createTimeslot(workspaceId: $workspaceId, input: $input) {
      ...CoreTimeslotFields
      category {
        id
        name
        color
      }
      socialProfiles {
        id
      }
    }
  }
  ${CoreTimeslotFieldsFragmentDoc}
`;
export type CreateTimeslotMutationFn = Apollo.MutationFunction<CreateTimeslotMutation, CreateTimeslotMutationVariables>;

/**
 * __useCreateTimeslotMutation__
 *
 * To run a mutation, you first call `useCreateTimeslotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeslotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeslotMutation, { data, loading, error }] = useCreateTimeslotMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimeslotMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTimeslotMutation, CreateTimeslotMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTimeslotMutation, CreateTimeslotMutationVariables>(CreateTimeslotDocument, options);
}
export type CreateTimeslotMutationHookResult = ReturnType<typeof useCreateTimeslotMutation>;
export type CreateTimeslotMutationResult = Apollo.MutationResult<CreateTimeslotMutation>;
export type CreateTimeslotMutationOptions = Apollo.BaseMutationOptions<
  CreateTimeslotMutation,
  CreateTimeslotMutationVariables
>;
export const UpdateTimeslotDocument = gql`
  mutation UpdateTimeslot($timeslotId: ID!, $input: TimeslotInput!) {
    updateTimeslot(timeslotId: $timeslotId, input: $input) {
      ...CoreTimeslotFields
      category {
        id
      }
      socialProfiles {
        id
      }
    }
  }
  ${CoreTimeslotFieldsFragmentDoc}
`;
export type UpdateTimeslotMutationFn = Apollo.MutationFunction<UpdateTimeslotMutation, UpdateTimeslotMutationVariables>;

/**
 * __useUpdateTimeslotMutation__
 *
 * To run a mutation, you first call `useUpdateTimeslotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeslotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeslotMutation, { data, loading, error }] = useUpdateTimeslotMutation({
 *   variables: {
 *      timeslotId: // value for 'timeslotId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeslotMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTimeslotMutation, UpdateTimeslotMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTimeslotMutation, UpdateTimeslotMutationVariables>(UpdateTimeslotDocument, options);
}
export type UpdateTimeslotMutationHookResult = ReturnType<typeof useUpdateTimeslotMutation>;
export type UpdateTimeslotMutationResult = Apollo.MutationResult<UpdateTimeslotMutation>;
export type UpdateTimeslotMutationOptions = Apollo.BaseMutationOptions<
  UpdateTimeslotMutation,
  UpdateTimeslotMutationVariables
>;
export const BulkDeleteTimeslotsDocument = gql`
  mutation BulkDeleteTimeslots($timeslotIds: [ID!]!) {
    bulkDeleteTimeslots(timeslotIds: $timeslotIds)
  }
`;
export type BulkDeleteTimeslotsMutationFn = Apollo.MutationFunction<
  BulkDeleteTimeslotsMutation,
  BulkDeleteTimeslotsMutationVariables
>;

/**
 * __useBulkDeleteTimeslotsMutation__
 *
 * To run a mutation, you first call `useBulkDeleteTimeslotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteTimeslotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteTimeslotsMutation, { data, loading, error }] = useBulkDeleteTimeslotsMutation({
 *   variables: {
 *      timeslotIds: // value for 'timeslotIds'
 *   },
 * });
 */
export function useBulkDeleteTimeslotsMutation(
  baseOptions?: Apollo.MutationHookOptions<BulkDeleteTimeslotsMutation, BulkDeleteTimeslotsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkDeleteTimeslotsMutation, BulkDeleteTimeslotsMutationVariables>(
    BulkDeleteTimeslotsDocument,
    options
  );
}
export type BulkDeleteTimeslotsMutationHookResult = ReturnType<typeof useBulkDeleteTimeslotsMutation>;
export type BulkDeleteTimeslotsMutationResult = Apollo.MutationResult<BulkDeleteTimeslotsMutation>;
export type BulkDeleteTimeslotsMutationOptions = Apollo.BaseMutationOptions<
  BulkDeleteTimeslotsMutation,
  BulkDeleteTimeslotsMutationVariables
>;
export const CreateSnippetDocument = gql`
  mutation CreateSnippet($workspaceId: ID!, $input: CreateSnippetInput!) {
    createSnippet(workspaceId: $workspaceId, input: $input) {
      ...CoreSnippetFields
    }
  }
  ${CoreSnippetFieldsFragmentDoc}
`;
export type CreateSnippetMutationFn = Apollo.MutationFunction<CreateSnippetMutation, CreateSnippetMutationVariables>;

/**
 * __useCreateSnippetMutation__
 *
 * To run a mutation, you first call `useCreateSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSnippetMutation, { data, loading, error }] = useCreateSnippetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSnippetMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSnippetMutation, CreateSnippetMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSnippetMutation, CreateSnippetMutationVariables>(CreateSnippetDocument, options);
}
export type CreateSnippetMutationHookResult = ReturnType<typeof useCreateSnippetMutation>;
export type CreateSnippetMutationResult = Apollo.MutationResult<CreateSnippetMutation>;
export type CreateSnippetMutationOptions = Apollo.BaseMutationOptions<
  CreateSnippetMutation,
  CreateSnippetMutationVariables
>;
export const UpdateSnippetDocument = gql`
  mutation UpdateSnippet($snippetId: ID!, $input: UpdateSnippetInput!) {
    updateSnippet(snippetId: $snippetId, input: $input) {
      ...CoreSnippetFields
    }
  }
  ${CoreSnippetFieldsFragmentDoc}
`;
export type UpdateSnippetMutationFn = Apollo.MutationFunction<UpdateSnippetMutation, UpdateSnippetMutationVariables>;

/**
 * __useUpdateSnippetMutation__
 *
 * To run a mutation, you first call `useUpdateSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSnippetMutation, { data, loading, error }] = useUpdateSnippetMutation({
 *   variables: {
 *      snippetId: // value for 'snippetId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSnippetMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSnippetMutation, UpdateSnippetMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSnippetMutation, UpdateSnippetMutationVariables>(UpdateSnippetDocument, options);
}
export type UpdateSnippetMutationHookResult = ReturnType<typeof useUpdateSnippetMutation>;
export type UpdateSnippetMutationResult = Apollo.MutationResult<UpdateSnippetMutation>;
export type UpdateSnippetMutationOptions = Apollo.BaseMutationOptions<
  UpdateSnippetMutation,
  UpdateSnippetMutationVariables
>;
export const GetAdminUsersDocument = gql`
  query getAdminUsers {
    admin_users {
      ...AdminUser
    }
  }
  ${AdminUserFragmentDoc}
`;

/**
 * __useGetAdminUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
}
export function useGetAdminUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
}
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const UpdateUtmSettingsDocument = gql`
  mutation UpdateUtmSettings($workspaceId: ID!, $input: UpdateWorkspaceSettingsInput!) {
    updateWorkspaceSettings(workspaceId: $workspaceId, input: $input) {
      id
      campaignTracking
      utm {
        source
        medium
        campaign
        term
        content
      }
    }
  }
`;
export type UpdateUtmSettingsMutationFn = Apollo.MutationFunction<
  UpdateUtmSettingsMutation,
  UpdateUtmSettingsMutationVariables
>;

/**
 * __useUpdateUtmSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUtmSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUtmSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUtmSettingsMutation, { data, loading, error }] = useUpdateUtmSettingsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUtmSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUtmSettingsMutation, UpdateUtmSettingsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUtmSettingsMutation, UpdateUtmSettingsMutationVariables>(
    UpdateUtmSettingsDocument,
    options
  );
}
export type UpdateUtmSettingsMutationHookResult = ReturnType<typeof useUpdateUtmSettingsMutation>;
export type UpdateUtmSettingsMutationResult = Apollo.MutationResult<UpdateUtmSettingsMutation>;
export type UpdateUtmSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUtmSettingsMutation,
  UpdateUtmSettingsMutationVariables
>;
export const ConnectSecondarySocialProfilesDocument = gql`
  mutation ConnectSecondarySocialProfiles(
    $workspaceId: ID!
    $socialAuthToken: String!
    $profilesNetwork: Network!
    $profiles: [SecondaryProfileConnectionInput!]!
  ) {
    connectSecondarySocialProfiles(
      workspaceId: $workspaceId
      socialAuthToken: $socialAuthToken
      profilesNetwork: $profilesNetwork
      profiles: $profiles
    ) {
      connected
      reconnected
      socialProfile {
        ...SocialProfileFields
      }
      additionalReconnection
      error
    }
  }
  ${SocialProfileFieldsFragmentDoc}
`;
export type ConnectSecondarySocialProfilesMutationFn = Apollo.MutationFunction<
  ConnectSecondarySocialProfilesMutation,
  ConnectSecondarySocialProfilesMutationVariables
>;

/**
 * __useConnectSecondarySocialProfilesMutation__
 *
 * To run a mutation, you first call `useConnectSecondarySocialProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectSecondarySocialProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectSecondarySocialProfilesMutation, { data, loading, error }] = useConnectSecondarySocialProfilesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      socialAuthToken: // value for 'socialAuthToken'
 *      profilesNetwork: // value for 'profilesNetwork'
 *      profiles: // value for 'profiles'
 *   },
 * });
 */
export function useConnectSecondarySocialProfilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConnectSecondarySocialProfilesMutation,
    ConnectSecondarySocialProfilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConnectSecondarySocialProfilesMutation, ConnectSecondarySocialProfilesMutationVariables>(
    ConnectSecondarySocialProfilesDocument,
    options
  );
}
export type ConnectSecondarySocialProfilesMutationHookResult = ReturnType<
  typeof useConnectSecondarySocialProfilesMutation
>;
export type ConnectSecondarySocialProfilesMutationResult =
  Apollo.MutationResult<ConnectSecondarySocialProfilesMutation>;
export type ConnectSecondarySocialProfilesMutationOptions = Apollo.BaseMutationOptions<
  ConnectSecondarySocialProfilesMutation,
  ConnectSecondarySocialProfilesMutationVariables
>;
export const RemoveSocialProfileDocument = gql`
  mutation RemoveSocialProfile($socialProfileId: ID!) {
    removeSocialProfile(socialProfileId: $socialProfileId)
  }
`;
export type RemoveSocialProfileMutationFn = Apollo.MutationFunction<
  RemoveSocialProfileMutation,
  RemoveSocialProfileMutationVariables
>;

/**
 * __useRemoveSocialProfileMutation__
 *
 * To run a mutation, you first call `useRemoveSocialProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSocialProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSocialProfileMutation, { data, loading, error }] = useRemoveSocialProfileMutation({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *   },
 * });
 */
export function useRemoveSocialProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveSocialProfileMutation, RemoveSocialProfileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveSocialProfileMutation, RemoveSocialProfileMutationVariables>(
    RemoveSocialProfileDocument,
    options
  );
}
export type RemoveSocialProfileMutationHookResult = ReturnType<typeof useRemoveSocialProfileMutation>;
export type RemoveSocialProfileMutationResult = Apollo.MutationResult<RemoveSocialProfileMutation>;
export type RemoveSocialProfileMutationOptions = Apollo.BaseMutationOptions<
  RemoveSocialProfileMutation,
  RemoveSocialProfileMutationVariables
>;
export const GetBestTimePostStatsDocument = gql`
  query GetBestTimePostStats($socialProfileId: ID!) {
    analyticsBestTimeToPostStats(socialProfileId: $socialProfileId) {
      postEngagementByDayOfWeek {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
      postEngagementByHourOfDay {
        hour0
        hour1
        hour2
        hour3
        hour4
        hour5
        hour6
        hour7
        hour8
        hour9
        hour10
        hour11
        hour12
        hour13
        hour14
        hour15
        hour16
        hour17
        hour18
        hour19
        hour20
        hour21
        hour22
        hour23
      }
    }
  }
`;

/**
 * __useGetBestTimePostStatsQuery__
 *
 * To run a query within a React component, call `useGetBestTimePostStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBestTimePostStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBestTimePostStatsQuery({
 *   variables: {
 *      socialProfileId: // value for 'socialProfileId'
 *   },
 * });
 */
export function useGetBestTimePostStatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetBestTimePostStatsQuery, GetBestTimePostStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBestTimePostStatsQuery, GetBestTimePostStatsQueryVariables>(
    GetBestTimePostStatsDocument,
    options
  );
}
export function useGetBestTimePostStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBestTimePostStatsQuery, GetBestTimePostStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBestTimePostStatsQuery, GetBestTimePostStatsQueryVariables>(
    GetBestTimePostStatsDocument,
    options
  );
}
export type GetBestTimePostStatsQueryHookResult = ReturnType<typeof useGetBestTimePostStatsQuery>;
export type GetBestTimePostStatsLazyQueryHookResult = ReturnType<typeof useGetBestTimePostStatsLazyQuery>;
export type GetBestTimePostStatsQueryResult = Apollo.QueryResult<
  GetBestTimePostStatsQuery,
  GetBestTimePostStatsQueryVariables
>;

// Type map of Generated Type Name : Generated Type
export type GraphQLTypeMap = {
  SocialProfile: SocialProfile;
  TikTokSocialProfile: TikTokSocialProfile;
  TwitterSocialProfile: TwitterSocialProfile;
  FacebookSocialProfile: FacebookSocialProfile;
  GoogleSocialProfile: GoogleSocialProfile;
  PinterestSocialProfile: PinterestSocialProfile;
  LinkedInSocialProfile: LinkedInSocialProfile;
  InstagramSocialProfile: InstagramSocialProfile;
  GenericSocialProfile: GenericSocialProfile;
  InstagramGridType: InstagramGridType;
  Post: Post;
  Photo: Photo;
  Workspace: Workspace;
  AutoImport: AutoImport;
  Category: Category;
  SocialProfileTokenOwner: SocialProfileTokenOwner;
  CustomBitly: CustomBitly;
  Bitly: Bitly;
  AutoImportPinterestBoard: AutoImportPinterestBoard;
  Utm: Utm;
  ImportSource: ImportSource;
  ImportFolder: ImportFolder;
  Timeslot: Timeslot;
  MediaItemsPagination: MediaItemsPagination;
  QueueMetadata: QueueMetadata;
  PostQueueCountResult: PostQueueCountResult;
  PostQueueCountCategory: PostQueueCountCategory;
  PostQueueCountSocialProfile: PostQueueCountSocialProfile;
  PostQueueCountStatus: PostQueueCountStatus;
  PostQueueCountContent: PostQueueCountContent;
  PostQueueCountTiming: PostQueueCountTiming;
  PostQueueCountEvergreen: PostQueueCountEvergreen;
  PostQueueCountSource: PostQueueCountSource;
  QueueItemsPagination: QueueItemsPagination;
  QueueItemsCursorPagination: QueueItemsCursorPagination;
  QueueItemsDateRangePagination: QueueItemsDateRangePagination;
  Organization: Organization;
  UserOrganizationAssignment: UserOrganizationAssignment;
  UserOrganizationSettings: UserOrganizationSettings;
  User: User;
  UserSettings: UserSettings;
  UserOnboardingType: UserOnboardingType;
  UserOnboardingStep: UserOnboardingStep;
  SiteNews: SiteNews;
  UserInvitation: UserInvitation;
  MobileAppOwnerType: MobileAppOwnerType;
  Invoice: Invoice;
  BraintreeCreditCardType: BraintreeCreditCardType;
  InvoiceBillingAddressDetailsType: InvoiceBillingAddressDetailsType;
  InvoiceBusinessAddressDetailsType: InvoiceBusinessAddressDetailsType;
  InvoiceVatBusinessDetailsType: InvoiceVatBusinessDetailsType;
  OrganizationPlanType: OrganizationPlanType;
  PlanLimitsType: PlanLimitsType;
  PlanUsageType: PlanUsageType;
  OrganizationSubscriptionType: OrganizationSubscriptionType;
  OrganizationSettings: OrganizationSettings;
  WorkspaceSettings: WorkspaceSettings;
  DefaultBitly: DefaultBitly;
  Snippet: Snippet;
  Video: Video;
  PostVariationMeta: PostVariationMeta;
  PostCurrentVariation: PostCurrentVariation;
  PostPublishedStats: PostPublishedStats;
  ThirdPartyProfile: ThirdPartyProfile;
  PostTikTok: PostTikTok;
  Link: Link;
  OpenGraph: OpenGraph;
  TwitterCard: TwitterCard;
  PostIterationAggregations: PostIterationAggregations;
  ThirdPartyPost: ThirdPartyPost;
  ThirdPartyPostMedia: ThirdPartyPostMedia;
  ThirdPartyPostMention: ThirdPartyPostMention;
  PorpaginasResult_Notification: PorpaginasResult_Notification;
  Notification: Notification;
  ThirdPartyMediaItem: ThirdPartyMediaItem;
  HelpscoutBeaconMetadata: HelpscoutBeaconMetadata;
  LinkMetadata: LinkMetadata;
  ExternalSecondaryProfileData: ExternalSecondaryProfileData;
  PostAsProfile: PostAsProfile;
  SocialAuthToken: SocialAuthToken;
  AiCaptionGenerationType: AiCaptionGenerationType;
  PinterestBoard: PinterestBoard;
  RssPostSearchResultType: RssPostSearchResultType;
  ExternalRssPost: ExternalRssPost;
  TwitterList: TwitterList;
  ThirdPartyPostSearchResult: ThirdPartyPostSearchResult;
  ProfileFollowersStats: ProfileFollowersStats;
  FollowersStats: FollowersStats;
  PostStatsResult: PostStatsResult;
  PostStatsByProfile: PostStatsByProfile;
  PostStats: PostStats;
  PostStatsByCategory: PostStatsByCategory;
  PostStatsByContentType: PostStatsByContentType;
  BestTimeToPostStatsResult: BestTimeToPostStatsResult;
  PostEngagementByDayOfWeek: PostEngagementByDayOfWeek;
  PostEngagementByHourOfDay: PostEngagementByHourOfDay;
  InvitationDetails: InvitationDetails;
  SocialOAuth: SocialOAuth;
  LoginSuccess: LoginSuccess;
  Token: Token;
  CombinedOrganizationSettings: CombinedOrganizationSettings;
  UploadInstructions: UploadInstructions;
  BulkMediaUploadResult: BulkMediaUploadResult;
  SocialProfileConnectionResult: SocialProfileConnectionResult;
  AiCaptionInitiateType: AiCaptionInitiateType;
  RssOpmlUploadResult: RssOpmlUploadResult;
  AndroidApp: AndroidApp;
  Test: Test;
  CreditCardType: CreditCardType;
  SocialLinkDescription: SocialLinkDescription;
  IosApp: IosApp;
  ImportSourceArgsRss: ImportSourceArgsRss;
  MobileAppImpl: MobileAppImpl;
  ImportSourceArgsTwitter: ImportSourceArgsTwitter;
  ImportSourceArgsLinkedIn: ImportSourceArgsLinkedIn;
  ImportSourceArgsPinterest: ImportSourceArgsPinterest;
  Media: Media;
  ImportSourceArgsInstagram: ImportSourceArgsInstagram;
  ImportSourceArgsFacebook: ImportSourceArgsFacebook;
  BillingDetails: BillingDetails;
  ImportSourceArgsSocialNetwork: ImportSourceArgsSocialNetwork;
  ImportSourceArgs: ImportSourceArgs;
};

// Enum of GQL __typename = Generated Type Name
export enum GraphQLTypes {
  SocialProfile = 'SocialProfile',
  TikTokSocialProfile = 'TikTokSocialProfile',
  TwitterSocialProfile = 'TwitterSocialProfile',
  FacebookSocialProfile = 'FacebookSocialProfile',
  GoogleSocialProfile = 'GoogleSocialProfile',
  PinterestSocialProfile = 'PinterestSocialProfile',
  LinkedInSocialProfile = 'LinkedInSocialProfile',
  InstagramSocialProfile = 'InstagramSocialProfile',
  GenericSocialProfile = 'GenericSocialProfile',
  InstagramGridType = 'InstagramGridType',
  Post = 'Post',
  Photo = 'Photo',
  Workspace = 'Workspace',
  AutoImport = 'AutoImport',
  Category = 'Category',
  SocialProfileTokenOwner = 'SocialProfileTokenOwner',
  CustomBitly = 'CustomBitly',
  Bitly = 'Bitly',
  AutoImportPinterestBoard = 'AutoImportPinterestBoard',
  UTM = 'Utm',
  ImportSource = 'ImportSource',
  ImportFolder = 'ImportFolder',
  Timeslot = 'Timeslot',
  MediaItemsPagination = 'MediaItemsPagination',
  QueueMetadata = 'QueueMetadata',
  PostQueueCountResult = 'PostQueueCountResult',
  PostQueueCountCategory = 'PostQueueCountCategory',
  PostQueueCountSocialProfile = 'PostQueueCountSocialProfile',
  PostQueueCountStatus = 'PostQueueCountStatus',
  PostQueueCountContent = 'PostQueueCountContent',
  PostQueueCountTiming = 'PostQueueCountTiming',
  PostQueueCountEvergreen = 'PostQueueCountEvergreen',
  PostQueueCountSource = 'PostQueueCountSource',
  QueueItemsPagination = 'QueueItemsPagination',
  QueueItemsCursorPagination = 'QueueItemsCursorPagination',
  QueueItemsDateRangePagination = 'QueueItemsDateRangePagination',
  Organization = 'Organization',
  UserOrganizationAssignment = 'UserOrganizationAssignment',
  UserOrganizationSettings = 'UserOrganizationSettings',
  User = 'User',
  UserSettings = 'UserSettings',
  UserOnboardingType = 'UserOnboardingType',
  UserOnboardingStep = 'UserOnboardingStep',
  SiteNews = 'SiteNews',
  UserInvitation = 'UserInvitation',
  MobileAppOwnerType = 'MobileAppOwnerType',
  Invoice = 'Invoice',
  BraintreeCreditCardType = 'BraintreeCreditCardType',
  InvoiceBillingAddressDetailsType = 'InvoiceBillingAddressDetailsType',
  InvoiceBusinessAddressDetailsType = 'InvoiceBusinessAddressDetailsType',
  InvoiceVatBusinessDetailsType = 'InvoiceVatBusinessDetailsType',
  OrganizationPlanType = 'OrganizationPlanType',
  PlanLimitsType = 'PlanLimitsType',
  PlanUsageType = 'PlanUsageType',
  OrganizationSubscriptionType = 'OrganizationSubscriptionType',
  OrganizationSettings = 'OrganizationSettings',
  WorkspaceSettings = 'WorkspaceSettings',
  DefaultBitly = 'DefaultBitly',
  Snippet = 'Snippet',
  Video = 'Video',
  PostVariationMeta = 'PostVariationMeta',
  PostCurrentVariation = 'PostCurrentVariation',
  PostPublishedStats = 'PostPublishedStats',
  ThirdPartyProfile = 'ThirdPartyProfile',
  PostTikTok = 'PostTikTok',
  Link = 'Link',
  OpenGraph = 'OpenGraph',
  TwitterCard = 'TwitterCard',
  PostIterationAggregations = 'PostIterationAggregations',
  ThirdPartyPost = 'ThirdPartyPost',
  ThirdPartyPostMedia = 'ThirdPartyPostMedia',
  ThirdPartyPostMention = 'ThirdPartyPostMention',
  PorpaginasResult_Notification = 'PorpaginasResult_Notification',
  Notification = 'Notification',
  ThirdPartyMediaItem = 'ThirdPartyMediaItem',
  HelpscoutBeaconMetadata = 'HelpscoutBeaconMetadata',
  LinkMetadata = 'LinkMetadata',
  ExternalSecondaryProfileData = 'ExternalSecondaryProfileData',
  PostAsProfile = 'PostAsProfile',
  SocialAuthToken = 'SocialAuthToken',
  AiCaptionGenerationType = 'AiCaptionGenerationType',
  PinterestBoard = 'PinterestBoard',
  RssPostSearchResultType = 'RssPostSearchResultType',
  ExternalRssPost = 'ExternalRssPost',
  TwitterList = 'TwitterList',
  ThirdPartyPostSearchResult = 'ThirdPartyPostSearchResult',
  ProfileFollowersStats = 'ProfileFollowersStats',
  FollowersStats = 'FollowersStats',
  PostStatsResult = 'PostStatsResult',
  PostStatsByProfile = 'PostStatsByProfile',
  PostStats = 'PostStats',
  PostStatsByCategory = 'PostStatsByCategory',
  PostStatsByContentType = 'PostStatsByContentType',
  BestTimeToPostStatsResult = 'BestTimeToPostStatsResult',
  PostEngagementByDayOfWeek = 'PostEngagementByDayOfWeek',
  PostEngagementByHourOfDay = 'PostEngagementByHourOfDay',
  InvitationDetails = 'InvitationDetails',
  SocialOAuth = 'SocialOAuth',
  LoginSuccess = 'LoginSuccess',
  Token = 'Token',
  CombinedOrganizationSettings = 'CombinedOrganizationSettings',
  UploadInstructions = 'UploadInstructions',
  BulkMediaUploadResult = 'BulkMediaUploadResult',
  SocialProfileConnectionResult = 'SocialProfileConnectionResult',
  AiCaptionInitiateType = 'AiCaptionInitiateType',
  RssOpmlUploadResult = 'RssOpmlUploadResult',
  AndroidApp = 'AndroidApp',
  Test = 'Test',
  CreditCardType = 'CreditCardType',
  SocialLinkDescription = 'SocialLinkDescription',
  IosApp = 'IosApp',
  ImportSourceArgsRss = 'ImportSourceArgsRss',
  MobileAppImpl = 'MobileAppImpl',
  ImportSourceArgsTwitter = 'ImportSourceArgsTwitter',
  ImportSourceArgsLinkedIn = 'ImportSourceArgsLinkedIn',
  ImportSourceArgsPinterest = 'ImportSourceArgsPinterest',
  Media = 'Media',
  ImportSourceArgsInstagram = 'ImportSourceArgsInstagram',
  ImportSourceArgsFacebook = 'ImportSourceArgsFacebook',
  BillingDetails = 'BillingDetails',
  ImportSourceArgsSocialNetwork = 'ImportSourceArgsSocialNetwork',
  ImportSourceArgs = 'ImportSourceArgs'
}
